(function(){
  'use strict';
  function orderEmail(id,wall){
    return 'mailto:kontakt@optilean.de?subject='+encodeURIComponent('Bestellung · Angebot '+id)+'&body='+encodeURIComponent('Guten Tag,\n\nwir bestellen die Auswahl gemäß Ihrem Angebot '+id+'.\n\n'+(wall?'Bitte senden Sie uns nach dem Grafikcheck den finalen Entwurf zur Freigabe. Die Produktion startet erst nach unserer Grafikfreigabe.\n\n':'')+'Unsere Bestellnummer:\nRechnungsadresse:\nLieferadresse:\n\nMit freundlichen Grüßen');
  }
  function show(el,data){
    if(!el)return;
    clear(el);
    var wall=data.hasShadowwall===true,id=String(data.offerId||data.leadId||'');
    var box=document.createElement('section');box.setAttribute('aria-label','So geht es weiter');box.style.cssText='margin-top:16px;color:#273445;font-size:14px;line-height:1.6;text-align:left;';
    var title=document.createElement('strong');title.textContent=wall?'Jetzt bestellen. Grafikfreigabe folgt.':'So geht es weiter';box.appendChild(title);
    var list=document.createElement('ol');list.style.cssText='padding-left:20px;margin:10px 0;';
    var steps=['Angebot an Ihren Einkauf weiterleiten. Bestellen Sie die gespeicherte Auswahl im Shop oder per E-Mail mit der Angebotsnummer.'];
    if(wall)steps.push('Nach Auftragseingang führen wir den Grafikcheck durch und senden Ihnen den finalen Entwurf.','Erst nach Ihrer ausdrücklichen Grafikfreigabe starten wir die Produktion.');
    else steps.push('Wir bestätigen Ihren Auftrag und stimmen Lieferung und Zahlungsbedingungen mit Ihnen ab.');
    steps.forEach(function(text){var li=document.createElement('li');li.textContent=text;list.appendChild(li);});box.appendChild(list);
    var note=document.createElement('p');note.textContent='Kauf auf Rechnung ist nach Absprache möglich: kontakt@optilean.de';box.appendChild(note);
    var buy=data.orderUrl||data.resumeUrl;
    function action(label,url,primary){var a=document.createElement('a');a.textContent=label;a.href=url;a.target='_blank';a.rel='noopener';a.style.cssText='display:inline-block;margin:4px 8px 4px 0;padding:10px 14px;border:1px solid #265796;border-radius:6px;text-decoration:none;color:'+(primary?'#fff':'#265796')+';background:'+(primary?'#265796':'#fff')+';';box.appendChild(a);}
    if(buy){try{var u=new URL(buy);if(u.protocol==='https:'&&/^(www\.)?optilean\.shop$/.test(u.hostname))action('Auswahl im Shop bestellen',u.href,true);}catch(_){}}
    if(id)action('Bestellung per E-Mail senden',orderEmail(id,wall),false);
    el.after(box);el._orderJourneyBox=box;
  }
  function clear(el){if(el&&el._orderJourneyBox){el._orderJourneyBox.remove();el._orderJourneyBox=null;}}
  window.optileanOfferOrderJourney={show:show,clear:clear};
})();

/**
 * Shadow Board Configurator – Optilean 10/10
 * Apple-inspired UX · Fabric.js v5.3.1 · 6-Step Wizard
 */

'use strict';

(function () {

  /* ==========================================
     CONFIG
     ========================================== */

  // Config wird aus data-* Attributen des Root-Elements gelesen
  const _root = document.getElementById('sbc-root');
  const _d = _root ? _root.dataset : {};
  const CONFIGURATOR_MODES = ['shadow-board', 'tool-wall'];
  const HAS_WUERTH_ACCESS = _d.wuerthAccess === 'true';
  const TOOL_BRANDS = HAS_WUERTH_ACCESS ? ['gedore', 'wuerth'] : ['gedore'];

  function getInitialConfiguratorMode() {
    try {
      var value = new URLSearchParams(window.location.search).get('configurator');
      return value === 'tool-wall' ? 'tool-wall' : 'shadow-board';
    } catch (e) {
      return 'shadow-board';
    }
  }

  function getInitialToolBrand() {
    try {
      var value = new URLSearchParams(window.location.search).get('tool_brand');
      return TOOL_BRANDS.indexOf(value) !== -1 ? value : '';
    } catch (e) {
      return '';
    }
  }

  const INITIAL_CONFIGURATOR_MODE = getInitialConfiguratorMode();
  const INITIAL_TOOL_BRAND = getInitialToolBrand();

  function getModeStorageKey(baseKey) {
    var bulkRequest = new URLSearchParams(window.sbcBulkContext || window.location.search).get('sbc_bulk_request');
    if (bulkRequest && window.parent !== window) return baseKey + '_bulk_' + bulkRequest;
    return INITIAL_CONFIGURATOR_MODE === 'tool-wall' ? baseKey + '_tool_wall' : baseKey;
  }

  const CFG = {
    backendUrl: _d.backendUrl || 'https://api.optilean.shop',
    toolsApiUrl: _d.toolsApiUrl || 'https://api.optilean.shop/api/tools',
    customerId: _d.customerId || null, // Shopify Customer ID
    customerEmail: _d.customerEmail || '',
    boardBg: _d.boardBg || '',
    customBoardLogoWhite: _d.customBoardLogoWhite || '',
    customBoardLogoBlack: _d.customBoardLogoBlack || '',
    boardWidthMm: parseFloat(_d.boardWidthMm) || 700,
    boardHeightMm: parseFloat(_d.boardHeightMm) || 500,
  };
  const INITIAL_BOARD_WIDTH_MM = CFG.boardWidthMm;
  const INITIAL_BOARD_HEIGHT_MM = CFG.boardHeightMm;

  // Produkt-Daten aus dem JSON-Block (4 Produkte mit Farbvarianten)
  var PRODUCTS = [];
  try {
    var pdEl = document.getElementById('sbc-products-data');
    if (pdEl) PRODUCTS = JSON.parse(pdEl.textContent);
  } catch (e) { console.warn('[SBC] Produkt-Daten konnten nicht geladen werden:', e); }
  console.log('[SBC] Produkte geladen:', PRODUCTS.length);

  var MOUNTING_DATA = {};
  try {
    var mdEl = document.getElementById('sbc-mounting-data');
    if (mdEl) MOUNTING_DATA = JSON.parse(mdEl.textContent);
  } catch (e) {
    console.warn('[SBC] Montage-Daten konnten nicht geladen werden:', e);
  }

  var FINALIZE_PRODUCTS = { holders: [], addons: [] };
  try {
    var fpEl = document.getElementById('sbc-finalize-products-data');
    if (fpEl) FINALIZE_PRODUCTS = JSON.parse(fpEl.textContent);
  } catch (e) {
    console.warn('[SBC] Finalisieren-Produkte konnten nicht geladen werden:', e);
  }

  const CHUNK_SIZE = 900;   // Salami Taktik
  const SNAP_PX = 10;    // Snapping distance
  const GUIDE_COLOR = '#007aff';
  const MEASURE_GRID_MM = 100;
  const RECOVERABLE_VISIBLE_PX = 28;
  const TEXT_MIN_FONT_SIZE = 18;
  const TEXT_FIT_PADDING = 12;
  const TEXT_PT_TO_MM = 0.3527777778;
  const DRAFT_AUTOSAVE_KEY = getModeStorageKey('sbc_draft_autosave');
  const DRAFT_AUTOSAVE_BACKUP_KEY = getModeStorageKey('sbc_draft_autosave_backup');
  const PENDING_SAVE_KEY = getModeStorageKey('sbc_pending_save');
  const PENDING_LOGIN_SAVE_KEY = getModeStorageKey('sbc_pending_login_save');
  const PENDING_LOGIN_SAVE_TTL_MS = 24 * 60 * 60 * 1000;
  const CANVAS_RENDER_QUALITY = 1.5;
  const CANVAS_MAX_RETINA_SCALE = 3;
  const TOOL_OVERLAP_ALPHA_THRESHOLD = 24;
  const TOOL_OVERLAP_MIN_PIXELS = 8;
  const TOOL_TARGET_TOLERANCE_DESKTOP = 4;
  const TOOL_TARGET_TOLERANCE_TOUCH = 10;
  const TOOL_SMALLER_TARGET_AREA_RATIO = 0.8;
  const PDF_RASTER_TOOL_PX_PER_MM = 300 / 25.4;
  const STANDARD_FONTS = [
    { id: 'standard-inter', name: 'Inter', family: 'Inter, sans-serif', type: 'standard' },
    { id: 'standard-arial', name: 'Arial', family: 'Arial, Helvetica, sans-serif', type: 'standard' },
    { id: 'standard-helvetica', name: 'Helvetica', family: 'Helvetica, Arial, sans-serif', type: 'standard' },
    { id: 'standard-verdana', name: 'Verdana', family: 'Verdana, Geneva, sans-serif', type: 'standard' },
    { id: 'standard-georgia', name: 'Georgia', family: 'Georgia, serif', type: 'standard' },
    { id: 'standard-times', name: 'Times New Roman', family: '"Times New Roman", Times, serif', type: 'standard' },
    { id: 'standard-courier', name: 'Courier New', family: '"Courier New", Courier, monospace', type: 'standard' }
  ];
  const CONFIGURATOR_TEXT_DEFAULTS = {
    boundsBlocked: 'Alle Werkzeuge müssen vollständig innerhalb der Schattenwand liegen.',
    overlapBlocked: 'Werkzeuge dürfen sich nicht sichtbar überdecken. Bitte verschiebe die Werkzeugflächen auseinander.',
    surfaceStepTitle: 'Oberfläche wählen',
    surfaceStepDescription: 'Wähle die passende Oberflächenart für deine Schattenwand.',
    surfaceBasicTitle: 'Basic',
    surfaceBasicBadge: 'Standard',
    surfacePremiumTitle: 'Premium',
    surfacePremiumBadge: 'Empfohlen',
    surfacePriceLabel: 'Preis',
    surfacePriceLoading: 'wird geladen',
    surfacePriceUnavailable: 'nicht konfiguriert',
    surfaceBasicFeatureSurfaceTitle: 'Oberfläche',
    surfaceBasicFeatureSurfaceText: 'Nicht beständig gegen Desinfektionsmittel und Aceton',
    surfaceBasicFeaturePrintTitle: 'UV-Direktdruck',
    surfaceBasicFeaturePrintText: 'Hochwertiger UV-Druck direkt auf die Aluverbundplatte',
    surfaceBasicFeatureUseTitle: 'Einsatzmöglichkeiten',
    surfaceBasicFeatureUseText: 'Geeignet für den allgemeinen Gebrauch',
    surfacePremiumFeatureSurfaceTitle: 'Oberfläche',
    surfacePremiumFeatureSurfaceText: 'Beständig gegen Desinfektionsmittel und Aceton',
    surfacePremiumFeatureFinishTitle: 'Oberflächenveredelung',
    surfacePremiumFeatureFinishText: 'UV-Druck mit zusätzlicher Oberflächenveredelung',
    surfacePremiumFeatureUseTitle: 'Einsatzmöglichkeiten',
    surfacePremiumFeatureUseText: 'Geeignet für den Einsatz in der Lebensmittelindustrie',
    surfaceUnavailableTooltip: 'Produkt für diese Oberfläche im Theme Editor ergänzen.',
    surfaceUnavailableToast: 'Für diese Oberfläche ist noch kein passendes Produkt konfiguriert',
    surfaceNextUnavailableTitle: 'Bitte Produkt für diese Oberfläche im Theme Editor ergänzen.',
    finalizeStepTitle: 'Finalisieren',
    finalizeStepDescription: 'Wähle die passende Halterung und optionales Wandmontage-Material.',
    finalizeSummaryLabel: 'Auswahl',
    finalizeSummaryLoading: 'wird geladen',
    finalizeHolderGroupTitle: 'Halterung',
    finalizeAddonGroupTitle: 'Wandmontage',
    finalizeHolderStainlessTitle: 'Edelstahlhalterung',
    finalizeHolderStainlessDescription: 'Hochwertige Halterung für eine dauerhafte Wandmontage.',
    finalizeHolderRubberTitle: 'Gummihalterung',
    finalizeHolderRubberDescription: 'Schonende Halterung mit Gummi-Auflage für flexible Befestigung.',
    finalizeAddonDowelTitle: 'Schrauben und Dübel',
    finalizeAddonDowelDescription: 'Schrauben- und Dübel-Set für eine Schattenwand.',
    finalizeAddonAdhesiveTitle: 'Zum Kleben',
    finalizeAddonAdhesiveDescription: 'Klebe-Set für Wandmontage ohne Bohren mit flacher/gesenkter Verarbeitung.',
    finalizeAddonSpacersTitle: 'Abstandshalter',
    finalizeAddonSpacersDescription: 'Abstandshalter-Set für Wandmontage mit Abstand zur Wand.',
    finalizeAddonMagnetsTitle: 'Magnet Trockenraum',
    finalizeAddonMagnetsDescription: 'Magnet-Set für trockene Innenbereiche.',
    finalizeAddonSiliconeTitle: 'Magnet Feuchtraum',
    finalizeAddonSiliconeDescription: 'Magnet-Set für Feuchträume und feuchte Einsatzbereiche.',
    finalizePriceLoading: 'wird geladen',
    finalizePriceUnavailable: 'Bitte Produkt im Theme Editor hinterlegen',
    finalizePriceSuffix: '/ Wand',
    finalizeUnavailableTooltip: 'Bitte Produkt im Theme Editor hinterlegen',
    finalizeNoAddonsSelected: 'Keine Zusatzartikel ausgewählt',
    finalizeMissingHolderValidation: 'Bitte im Theme Editor eine Edelstahl- oder Gummihalterung für Schritt 6 hinterlegen.',
    finalizeProfessionalCheckNotice: '✅ Persönlicher Profi-Check inklusive. Jede Gestaltung wird vor der Produktion von unserem Team geprüft.',
    finalizeNote: 'Ausgewählte Zusatzartikel werden beim Warenkorb automatisch mit der Wandmenge hinzugefügt.',
    finalizeBackButton: 'Zurück zum Gestalten'
  };
  const FINALIZE_ADDON_DEFAULT_ORDER = ['dowels', 'adhesive', 'spacers', 'magnets', 'silicone'];
  const SIZE_OPTION_DEFAULTS = [
    { key: '700x500', widthMm: 700, heightMm: 500, label: '700 × 500', unit: 'mm', visible: true },
    { key: '500x700', widthMm: 500, heightMm: 700, label: '500 × 700', unit: 'mm', visible: true },
    { key: '800x1900', widthMm: 800, heightMm: 1900, label: '800 × 1900', unit: 'mm', visible: true },
    { key: '1000x1900', widthMm: 1000, heightMm: 1900, label: '1000 × 1900', unit: 'mm', visible: true },
    { key: '1210x1900', widthMm: 1210, heightMm: 1900, label: '1210 × 1900', unit: 'mm', visible: true },
    { key: '1600x1900', widthMm: 1600, heightMm: 1900, label: '1600 × 1900', unit: 'mm', visible: true }
  ];
  const CUSTOM_SIZE_PRICE_TIERS = [
    { key: '500x700', widthMm: 500, heightMm: 700, label: '500 × 700 mm' },
    { key: '700x500', widthMm: 700, heightMm: 500, label: '700 × 500 mm' },
    { key: '800x1900', widthMm: 800, heightMm: 1900, label: '800 × 1900 mm' },
    { key: '1000x1900', widthMm: 1000, heightMm: 1900, label: '1000 × 1900 mm' },
    { key: '1210x1900', widthMm: 1210, heightMm: 1900, label: '1210 × 1900 mm' },
    { key: '1600x1900', widthMm: 1600, heightMm: 1900, label: '1600 × 1900 mm' }
  ];
  const MOUNTING_OPTION_DEFAULTS = [
    { key: 'wall', eyebrow: 'Wandmontage', title: 'An der Wand', description: 'inklusive', meta: ['inklusive', '1 Seite'], visible: true },
    { key: 'stand', eyebrow: 'Standgestell', title: 'Freistehend', description: 'steht frei im Raum', meta: ['steht frei im Raum'], visible: true },
    { key: 'trolley', eyebrow: 'Rollwagen', title: 'Mobil', description: 'mit Rollen verschiebbar', meta: ['mit Rollen verschiebbar'], visible: true }
  ];

  const COLOR_MAP = {
    'white': { label: 'Weiß', hex: '#ffffff', border: '#cbd5e1' },
    'black': { label: 'Schwarz', hex: '#1a1919', border: '#1a1919' },
    'blue': { label: 'Blau', hex: '#233d7b', border: '#233d7b' },
    'red': { label: 'Rot', hex: '#b93139', border: '#b93139' },
    'green': { label: 'Grün', hex: '#12785a', border: '#12785a' },
    'yellow': { label: 'Gelb', hex: '#f3b536', border: '#f3b536' },
    'custom': { label: 'Spezial', hex: '#e2e8f0', border: '#cbd5e0' }
  };
  const LEGACY_DEFAULT_COLOR_HEX = {
    white: ['#ffffff'],
    black: ['#000000', '#1a1a1a'],
    blue: ['#3182ce', '#0047ab', '#0021f7'],
    red: ['#e53e3e', '#cc0000', '#d20c27', '#d30c27'],
    green: ['#38a169', '#228b22', '#1da63d'],
    yellow: ['#ecc94b', '#ffd700', '#d6a400', '#ffb50f']
  };
  const TEXT_COLOR_DEFAULTS = [
    { key: 'black', label: 'Schwarz', hex: '#000000', cmyk: { c: 0, m: 0, y: 0, k: 100 }, visible: true, order: 0 },
    { key: 'white', label: 'Weiß', hex: '#ffffff', cmyk: { c: 0, m: 0, y: 0, k: 0 }, visible: true, order: 1 }
  ];
  const QUANTITY_DISCOUNT_DEFAULTS = [
    { key: 'qty-5', label: 'ab 5 Stück', minQuantity: 5, percent: 5, discountCode: 'menge5', visible: false, order: 0 },
    { key: 'qty-10', label: 'ab 10 Stück', minQuantity: 10, percent: 10, discountCode: 'menge10', visible: false, order: 1 }
  ];
  const QUANTITY_DISCOUNTS_ENABLED = false;
  const CUSTOM_BOARD_BRAND_ASPECT_RATIO = 315 / 180;
  const CUSTOM_BOARD_BRAND_MIN_WIDTH_MM = 42;
  const CUSTOM_BOARD_BRAND_MAX_WIDTH_MM = 70;
  const CUSTOM_BOARD_BRAND_MARGIN_MM = 20;
  const SVG_LOGO_TRIM_ALPHA_THRESHOLD = 8;
  const SVG_LOGO_TRIM_RENDER_MAX = 1200;
  const SVG_LOGO_TRIM_PADDING_PX = 2;

  /* ==========================================
     ANALYTICS
     ========================================== */

  // Eindeutige Session-ID für diesen Tab (bleibt bei Reload erhalten)
  let _sessionId = sessionStorage.getItem('sbc_session_id');
  if (!_sessionId) {
    _sessionId = 's-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
    sessionStorage.setItem('sbc_session_id', _sessionId);
    trackEvent('session_start');
  }

  function trackEvent(eventName, payload) {
    if (!CFG.backendUrl) return;

    const data = {
      event: eventName,
      sessionId: _sessionId,
      payload: payload || {}
    };

    // Fire & Forget
    fetch(CFG.backendUrl.replace(/\/+$/, '') + '/api/analytics/event', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true, // Garantiert Senden auch bei Page Unload
      body: JSON.stringify(data)
    }).catch(err => console.warn('[SBC] Analytics Error:', err));
  }

  /* ==========================================
     STATE
     ========================================== */

  let canvas = null;
  let bgImage = null;
  let snapLines = [];
  let measurementGridLines = [];
  let measurementGridVisible = false;
  let customBoardBrandMark = null;
  let customBoardBrandVariant = '';
  let customBoardBrandLoadToken = 0;
  let pxPerMm = 1;
  let designId = null;
  let currentStep = 1;
  let configuratorMode = INITIAL_CONFIGURATOR_MODE;
  let selectedToolBrand = configuratorMode === 'tool-wall' ? INITIAL_TOOL_BRAND : '';
  let selectedSize = null;
  let selectedSizeIsCustom = false;
  let selectedColor = 'white';
  let selectedBackColor = 'white';
  let selectedBackColorCustomized = false;
  let activeColorSide = 'front';
  let selectedProduct = null;  // { size, productId, title, variants }
  let selectedVariant = null;  // { id, title, option1, price, available }
  let selectedMounting = 'wall'; // 'wall', 'stand', 'trolley'
  let selectedMountingSides = 1; // 1 or 2
  let selectedSurfaceType = 'premium';
  let selectedQuantity = 1;
  let selectedHolderType = 'stainless';
  let selectedFinalizeAddons = { dowels: false, adhesive: false, spacers: false, magnets: false, silicone: false };
  let loadedDraftSpecialInfo = '';
  let activeDraftIds = { front: null, back: null };

  let planningSavedSignature = null;
  let planningSavedAt = '';
  let planningDraftName = '';
  let planningSaveInProgress = false;
  let planningStatusTimer = null;

  function planningSignature() {
    var payloads = collectCurrentSavePayloads();
    var state = buildDesignSaveState(cloneSummaryWithAvailableSources(payloads.dataF), cloneSummaryWithAvailableSources(payloads.dataB), payloads.isTwoSides);
    ['draftId', 'frontDraftId', 'backDraftId', 'cw', 'ch'].forEach(function(key) { delete state[key]; });
    return JSON.stringify(state);
  }

  function publishPlanningStatus(state) {
    if (window.parent !== window) return;
    window.sbcPlanningStatus = { state: state, name: planningDraftName, savedAt: planningSavedAt };
    window.dispatchEvent(new CustomEvent('sbc:planning-status', { detail: window.sbcPlanningStatus }));
  }

  function refreshPlanningStatus() {
    if (window.parent !== window || isHydratingDesign || planningSaveInProgress || !canvas) return;
    try {
      var signature = planningSignature();
      publishPlanningStatus(planningSavedSignature === signature ? 'saved' : (planningSavedSignature || getAllUserDesignObjects().length ? 'dirty' : 'new'));
    } catch (_) {}
  }

  function schedulePlanningStatus() {
    clearTimeout(planningStatusTimer);
    planningStatusTimer = setTimeout(refreshPlanningStatus, 350);
  }

  let configuratorSettings = {
    defaults: { surfaceType: 'premium', holderType: 'stainless' },
    texts: Object.assign({}, CONFIGURATOR_TEXT_DEFAULTS),
    categories: [],
    sizes: SIZE_OPTION_DEFAULTS.slice(),
    colors: Object.keys(COLOR_MAP).map(function (key, index) {
      return { key: key, label: COLOR_MAP[key].label, hex: COLOR_MAP[key].hex, border: COLOR_MAP[key].border, visible: true, order: index };
    }),
    textColors: TEXT_COLOR_DEFAULTS.slice(),
    quantityDiscounts: QUANTITY_DISCOUNT_DEFAULTS.slice(),
    mounting: MOUNTING_OPTION_DEFAULTS.slice(),
    finalize: { addonOrder: FINALIZE_ADDON_DEFAULT_ORDER.slice() }
  };
  let configuratorDefaultsApplied = false;
  let cartLoading = false;
  let currentSide = 'front'; // 'front' or 'back'
  let toolsLoaded = false;
  let toolsLoadPromise = null;
  let allToolsCacheConfigurator = []; // Neu für Farb-Filter
  let toolsById = {};   // toolId → { id, name, imageUrl, widthMm?, heightMm?, ... } für Skalierung nach echten Maßen
  let shadowToolColorRefreshToken = 0;
  let backgroundsCache = [];  // Hintergründe von API (size → imageUrl)
  let isHydratingDesign = false;
  let pendingRestoreSaveStr = null;
  let autosaveTimer = null;
  let lastDraftSaveStr = null;
  let leadFunnelOpen = false;
  let customerLogo = null;
  let availableFonts = STANDARD_FONTS.slice();
  let shopifyVariantCache = {};
  let pendingLeadAccessories = [];
  let bottomBarHome = null;
  let leadFunnelHome = null;

  // Undo/Redo
  let undoStack = [];
  let redoStack = [];
  const MAX_UNDO = 30;

  let undoLock = false; // Verhindert Endlos-Speicherung bei undo/redo

  function getCanvasPxPerMm() {
    if (pxPerMm > 0) return pxPerMm;
    if (canvas && CFG.boardWidthMm) return canvas.width / CFG.boardWidthMm;
    return 1;
  }

  function fontPtToCanvasPx(pointSize) {
    var pt = Number(pointSize);
    if (!isFinite(pt) || pt <= 0) pt = 36;
    return Math.max(1, pt * TEXT_PT_TO_MM * getCanvasPxPerMm());
  }

  function getTextPointSize(textObj) {
    if (!textObj) return null;
    var pointSize = Number(textObj.sbcFontPt || textObj.fontPt || textObj.fpt);
    return isFinite(pointSize) && pointSize > 0 ? pointSize : null;
  }

  function getTextPointSizeForInput(textObj) {
    return getTextPointSize(textObj) || Math.round(textObj && textObj.fontSize ? textObj.fontSize : 36);
  }

  function setTextPointSize(textObj, pointSize) {
    if (!textObj) return;
    var pt = Math.max(8, Math.min(180, parseInt(pointSize, 10) || 36));
    textObj.sbcFontPt = pt;
    textObj.fontPt = pt;
    textObj.fpt = pt;
    textObj.set('fontSize', fontPtToCanvasPx(pt));
  }

  function updateMobileViewportBottomOffset() {
    var root = document.documentElement;
    if (!root) return;

    var offset = 0;
    if (window.visualViewport) {
      offset = window.innerHeight - window.visualViewport.height - window.visualViewport.offsetTop;
    }

    offset = Math.max(0, Math.min(420, Math.round(offset || 0)));
    root.style.setProperty('--sbc-mobile-viewport-bottom-offset', offset + 'px');
  }

  function isMobileViewport() {
    return window.matchMedia ? window.matchMedia('(max-width: 768px)').matches : window.innerWidth <= 768;
  }

  function getStoredTextPointSize(objData) {
    if (!objData) return null;
    var pointSize = Number(objData.fpt || objData.fontPt || objData.pt);
    return isFinite(pointSize) && pointSize > 0 ? pointSize : null;
  }

  function getRestoredTextFontSize(objData) {
    var pointSize = getStoredTextPointSize(objData);
    if (pointSize) return fontPtToCanvasPx(pointSize);
    return objData.fs || objData.fontSize || 36;
  }

  function applyRestoredTextPointSize(textObj, objData) {
    var pointSize = getStoredTextPointSize(objData);
    if (!pointSize || !textObj) return;
    textObj.sbcFontPt = pointSize;
    textObj.fontPt = pointSize;
    textObj.fpt = pointSize;
  }

  function rescalePointSizedTextObjects() {
    if (!canvas) return;
    canvas.getObjects().forEach(function (obj) {
      if (!obj || obj.objectType !== 'custom-text') return;
      var pointSize = getTextPointSize(obj);
      if (!pointSize) return;
      obj.set('fontSize', fontPtToCanvasPx(pointSize));
      refreshTextDimensions(obj);
    });
  }

  /* ==========================================
     CURVED TEXT LOGIC
     ========================================== */

  // Helper to apply curvature to an IText object
  function applyTextCurvature(textObj, value) {
    const curvature = parseInt(value, 10);
    textObj.set('curvature', curvature);

    if (Math.abs(curvature) < 5) {
      // Straight (remove path)
      textObj.set('path', null);
    } else {
      // Create an arc path
      // Logic: Symmetrical quadratic curve
      // Width of text (approx)
      const w = textObj.width || 200;

      // Depth of curve (camber)
      // curvature 100 => depth = w / 2 (semicircle-ish)
      const depth = (curvature / 100) * (w / 1.5);

      // Construct Path: M start Q control end
      // Start: -w/2, 0
      // End: w/2, 0
      // Control: 0, -depth * 2

      const pathStr = `M ${-w / 2} 0 Q 0 ${-depth * 2} ${w / 2} 0`;

      const path = new fabric.Path(pathStr, {
        visible: false,
        fill: 'none',
        stroke: 'none'
      });

      textObj.set('path', path);
    }

    // Force render
    textObj.set('dirty', true);
    canvas.requestRenderAll();
  }

  // Zoom
  let zoomLevel = 1.0;
  const ZOOM_MIN = 1;
  const OUTSIDE_ZOOM_MIN = 0.25;
  const ZOOM_MAX = 6;
  const ZOOM_STEP = 0.25;
  const ZOOM_RESET_SNAP_RANGE = ZOOM_STEP / 2;
  const CANVAS_STAGE_COLOR = '#f5f5f7';
  const BOTTOM_OVERHANG_MAX_BOARD_HEIGHT_MM = 700;
  const SMALL_WALL_OVERSIZED_TOOL_TOP_MARGIN_MM = 8;
  let isCanvasPanning = false;
  let canvasPanLastPoint = null;
  let canvasPanSelectionState = true;
  let canvasPanSkipTargetFindState = false;
  const SCALABLE_TOOL_CATEGORY = 'uberschriften und symbole';
  const KEYBOARD_MOVE_STEP_MM = 1;
  const KEYBOARD_MOVE_FAST_STEP_MM = 10;

  // Mobile-Erkennung
  var isMobile = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  var lastMobileMenuPointer = { time: 0, x: 0, y: 0 };
  var expandedToolCategoryKeys = new Set();
  var suppressToolClickUntil = 0;

  function isUserDesignObject(obj) {
    return !!obj && ['shadow-tool', 'logo', 'custom-text'].includes(obj.objectType);
  }

  function getVisibleUserObjects() {
    if (!canvas) return [];
    return canvas.getObjects().filter(function (obj) {
      return isUserDesignObject(obj) && obj.visible !== false;
    });
  }

  function getAllUserDesignObjects() {
    if (!canvas) return [];
    return canvas.getObjects().filter(isUserDesignObject);
  }

  function isSnapGuideObject(obj) {
    return !!obj && (obj.isGuideLine === true || obj.sbcGuideLine === true);
  }

  function isCustomBoardBrandObject(obj) {
    return !!obj && obj.isCustomBoardBrandMark === true;
  }

  function isCanvasHelperObject(obj) {
    return isSnapGuideObject(obj) || isCustomBoardBrandObject(obj);
  }

  function getRelevantDesignObjects() {
    if (!canvas) return [];
    return canvas.getObjects().filter(function (obj) {
      if (!isUserDesignObject(obj)) return false;
      if (selectedMounting !== 'wall' && selectedMountingSides === 2) return true;
      return (obj.sbcSide || 'front') !== 'back';
    });
  }

  function getSizeKey(widthMm, heightMm) {
    return String(widthMm) + 'x' + String(heightMm);
  }

  function allowsBottomToolOverhangForCurrentBoard() {
    var boardHeightMm = Number(CFG.boardHeightMm);
    return boardHeightMm > 0 && boardHeightMm <= BOTTOM_OVERHANG_MAX_BOARD_HEIGHT_MM;
  }

  function getMinZoomForCurrentSize() {
    return (selectedSizeIsCustom || allowsBottomToolOverhangForCurrentBoard()) ? OUTSIDE_ZOOM_MIN : ZOOM_MIN;
  }

  function isObjectWithinBoardBounds(obj, bounds) {
    if (!canvas || !obj || !bounds) return false;

    var tolerance = 2;

    if (
      obj.objectType === 'shadow-tool' &&
      allowsBottomToolOverhangForCurrentBoard()
    ) {
      return isSmallWallFallbackBoundsWithinBoard(obj, bounds, tolerance);
    }

    var leftOk = bounds.left >= -tolerance;
    var topOk = bounds.top >= -tolerance;
    var rightOk = (bounds.left + bounds.width) <= (canvas.width + tolerance);
    var bottomOk = (bounds.top + bounds.height) <= (canvas.height + tolerance);

    if (leftOk && topOk && rightOk && bottomOk) return true;

    return false;
  }

  function markValidationBounds(bounds, source) {
    bounds = ensureBoundsEdges(bounds);
    if (!bounds) return null;
    bounds._sbcBoundsSource = source;
    return bounds;
  }

  function ensureBoundsEdges(bounds) {
    if (!bounds) return null;
    if (bounds.right === undefined && bounds.left !== undefined && bounds.width !== undefined) {
      bounds.right = bounds.left + bounds.width;
    }
    if (bounds.bottom === undefined && bounds.top !== undefined && bounds.height !== undefined) {
      bounds.bottom = bounds.top + bounds.height;
    }
    return bounds;
  }

  function getObjectCenterPoint(obj, bounds) {
    if (obj && typeof obj.getCenterPoint === 'function') {
      return obj.getCenterPoint();
    }

    return {
      x: bounds.left + (bounds.width / 2),
      y: bounds.top + (bounds.height / 2)
    };
  }

  function isSmallWallFallbackBoundsWithinBoard(obj, bounds, tolerance) {
    bounds = ensureBoundsEdges(bounds);
    if (!bounds) return false;

    var visibleWidth = Math.min(bounds.right, canvas.width) - Math.max(bounds.left, 0);
    var visibleHeight = Math.min(bounds.bottom, canvas.height) - Math.max(bounds.top, 0);
    var visibleArea = Math.max(0, visibleWidth) * Math.max(0, visibleHeight);
    var minVisibleSide = Math.max(2, tolerance);

    // Kurze Wände dürfen Werkzeugkörper ausschließlich unten überhängen lassen.
    // Oben und seitlich müssen die echten Werkzeugkonturen innerhalb der Wand bleiben.
    return bounds.left >= -tolerance &&
      bounds.right <= (canvas.width + tolerance) &&
      bounds.top >= -tolerance &&
      visibleWidth >= minVisibleSide &&
      visibleHeight >= minVisibleSide &&
      visibleArea >= 16 &&
      bounds.top <= (canvas.height - minVisibleSide) &&
      bounds.bottom >= minVisibleSide;
  }

  function getValidationBoundsForObject(obj) {
    if (!obj) return null;

    if (obj.objectType === 'shadow-tool') {
      return markValidationBounds(getVisibleShadowSnapBoundsForObject(obj), 'visible-shadow') ||
        markValidationBounds(getCanvasBoundsForObject(obj), 'selection-box') ||
        markValidationBounds(obj.getBoundingRect(), 'selection-box');
    }

    return markValidationBounds(getCanvasBoundsForObject(obj), 'selection-box') ||
      markValidationBounds(obj.getBoundingRect(), 'selection-box');
  }

  function hasBottomOverhangTool() {
    if (!canvas) return false;
    if (!allowsBottomToolOverhangForCurrentBoard()) return false;
    var tolerance = 2;

    return getRelevantDesignObjects().some(function (obj) {
      if (!obj || obj.objectType !== 'shadow-tool' || obj.visible === false) return false;
      // Der Hinweis soll den echten Werkzeugkörper erkennen, nicht die tolerierten Druck-/Validierungsflächen.
      var bounds = getCanvasBoundsForObject(obj) || obj.getBoundingRect();
      if (!bounds) return false;

      var intersectsBoard = bounds.right > 0 &&
        bounds.left < canvas.width &&
        bounds.bottom > 0 &&
        bounds.top < canvas.height;

      return intersectsBoard && bounds.bottom > canvas.height + tolerance;
    });
  }

  function updateBottomOverhangHint() {
    var el = dom.overhangHint();
    if (!el) return;

    var show = (currentStep === 5 || currentStep === 6) && hasBottomOverhangTool();
    el.hidden = !show;
    el.style.display = show ? '' : 'none';
  }

  function isCurrentCustomSize(widthMm, heightMm) {
    return selectedSizeIsCustom === true &&
      Number(widthMm) === Number(CFG.boardWidthMm) &&
      Number(heightMm) === Number(CFG.boardHeightMm);
  }

  function getCustomSizePriceResolution(widthMm, heightMm) {
    var w = Math.round(Number(widthMm));
    var h = Math.round(Number(heightMm));
    if (!(w > 0) || !(h > 0)) return null;

    var tier = CUSTOM_SIZE_PRICE_TIERS.find(function (item) {
      return w <= item.widthMm && h <= item.heightMm;
    });

    if (tier) {
      return Object.assign({ multiplier: 1, oversized: false }, tier);
    }

    var maxTier = CUSTOM_SIZE_PRICE_TIERS[CUSTOM_SIZE_PRICE_TIERS.length - 1];
    return Object.assign({ multiplier: 2, oversized: true }, maxTier);
  }

  function getProductForCustomDimensionsSurface(widthMm, heightMm, surfaceType) {
    var resolution = getCustomSizePriceResolution(widthMm, heightMm);
    if (!resolution) return null;
    return findProductBySizeKeySurface(resolution.key, surfaceType);
  }

  function getCurrentPriceResolution() {
    if (!selectedSizeIsCustom) {
      var key = getSizeKey(CFG.boardWidthMm, CFG.boardHeightMm);
      var fixedTier = CUSTOM_SIZE_PRICE_TIERS.find(function (item) { return item.key === key; });
      return fixedTier ? Object.assign({ multiplier: 1, oversized: false }, fixedTier) : null;
    }
    return getCustomSizePriceResolution(CFG.boardWidthMm, CFG.boardHeightMm);
  }

  function getBoardPriceMultiplier() {
    var resolution = getCurrentPriceResolution();
    return resolution && resolution.multiplier > 1 ? resolution.multiplier : 1;
  }

  function getEffectiveProductSizeKey(widthMm, heightMm) {
    if (isCurrentCustomSize(widthMm, heightMm)) {
      var resolution = getCustomSizePriceResolution(widthMm, heightMm);
      return resolution ? resolution.key : getSizeKey(widthMm, heightMm);
    }
    return getSizeKey(widthMm, heightMm);
  }

  function findProductBySizeKeySurface(sizeKey, surfaceType) {
    var normalizedSurface = surfaceType === 'premium' ? 'premium' : 'basic';
    return PRODUCTS.find(function (product) {
      var productSurface = product.surfaceType === 'premium' ? 'premium' : 'basic';
      return product.size === sizeKey && productSurface === normalizedSurface && product.productId;
    }) || null;
  }

  function getProductForSizeSurface(widthMm, heightMm, surfaceType) {
    var sizeKey = getEffectiveProductSizeKey(widthMm, heightMm);
    var normalizedSurface = surfaceType === 'premium' ? 'premium' : 'basic';
    return findProductBySizeKeySurface(sizeKey, normalizedSurface);
  }

  function getConfiguredProductForSize(widthMm, heightMm) {
    var sizeKey = getEffectiveProductSizeKey(widthMm, heightMm);
    return PRODUCTS.find(function (item) {
      return item.size === sizeKey && item.productId;
    }) || null;
  }

  function getProductForSizeWithSurfaceFallback(widthMm, heightMm) {
    var productForCurrentSurface = getProductForSizeSurface(widthMm, heightMm, selectedSurfaceType);
    var product = productForCurrentSurface
      || getProductForSizeSurface(widthMm, heightMm, 'basic')
      || getProductForSizeSurface(widthMm, heightMm, 'premium')
      || getConfiguredProductForSize(widthMm, heightMm);

    if (!productForCurrentSurface && product) {
      selectedSurfaceType = product.surfaceType === 'premium' ? 'premium' : 'basic';
    }

    return product || null;
  }

  function resolveProductVariantForColor(product, colorKey) {
    if (!product || !product.variants || product.variants.length === 0) return null;
    if (!colorKey) return product.variants[0];
    var directVariant = findProductVariantForColor(product, colorKey);
    if (directVariant) return directVariant;

    // Weiß ist im Konfigurator als Grundfarbe erlaubt, auch wenn Shopify dafür
    // keine eigene Farbvariante am Produkt pflegt. Dann den bestehenden
    // Standardpreis/-artikel verwenden, statt Oberfläche/Fortschritt zu blockieren.
    if (variantNameToBackendColor(colorKey) === 'white') {
      return product.variants.find(function (variant) {
        return variant.available !== false;
      }) || product.variants[0] || null;
    }

    return null;
  }

  function findProductVariantForColor(product, colorKey) {
    if (!product || !product.variants || product.variants.length === 0) return null;
    return product.variants.find(function (variant) {
      return variantNameToBackendColor(variant.option1 || variant.title) === colorKey;
    }) || null;
  }

  function syncSelectedProductForSurface(options) {
    options = options || {};
    selectedProduct = options.fallbackToBasic
      ? getProductForSizeWithSurfaceFallback(CFG.boardWidthMm, CFG.boardHeightMm)
      : getProductForSizeSurface(CFG.boardWidthMm, CFG.boardHeightMm, selectedSurfaceType);
    selectedVariant = selectedProduct ? resolveVariantForColor(selectedColor) : null;
    if (!selectedColor && selectedVariant) {
      selectedColor = variantNameToBackendColor(selectedVariant.option1 || selectedVariant.title);
      if (!selectedBackColorCustomized) selectedBackColor = selectedColor;
    }
    updateSelectedProductTitle();
    updateTotalPrice();
    updateCartButton();
    updateLeadButton();
    return selectedProduct;
  }

  function getMountingEntry(mountingType, sides, surfaceType, widthMm) {
    if (!mountingType || mountingType === 'wall') return null;
    var w = Number(widthMm || CFG.boardWidthMm);
    if (!supportsFreestandingMounting(w)) return null;
    var sizeData = MOUNTING_DATA[w];
    if (!sizeData) return null;

    var baseType = mountingType === 'stand' ? 'standgestell_' + (Number(sides) === 2 ? 2 : 1) : 'rollwagen';
    var premium = surfaceType === 'premium';
    var key = premium ? baseType + '_premium' : baseType;

    if (baseType === 'standgestell_2' && (!sizeData[key] || !sizeData[key].variants || sizeData[key].variants.length === 0)) {
      baseType = 'standgestell_1';
      key = premium ? 'standgestell_1_premium' : 'standgestell_1';
    }

    var entry = sizeData[key];
    if (!entry || !entry.variants || entry.variants.length === 0) return null;
    return entry;
  }

  function isSurfaceSelectionAvailable(surfaceType) {
    if (!getProductForSizeSurface(CFG.boardWidthMm, CFG.boardHeightMm, surfaceType)) return false;
    if (selectedMounting && selectedMounting !== 'wall') {
      return !!getMountingEntry(selectedMounting, selectedMountingSides, surfaceType);
    }
    return true;
  }

  function resolveVariantForColor(colorKey) {
    return resolveProductVariantForColor(selectedProduct, colorKey);
  }

  function getSurfaceUnitPriceCents(surfaceType) {
    if (selectedMounting && selectedMounting !== 'wall') {
      var mountingEntry = getMountingEntry(selectedMounting, selectedMountingSides, surfaceType);
      if (!mountingEntry || !mountingEntry.variants || mountingEntry.variants.length === 0) return null;
      return Math.min.apply(null, mountingEntry.variants.map(function (variant) {
        return Number(variant.price) || 0;
      }));
    }

    var product = getProductForSizeSurface(CFG.boardWidthMm, CFG.boardHeightMm, surfaceType);
    var variant = resolveProductVariantForColor(product, selectedColor);
    return variant ? (Number(variant.price) || 0) * getBoardPriceMultiplier() : null;
  }

  /**
   * Prüft ob eine URL auf eine SVG-Datei zeigt.
   * Funktioniert auch bei Shopify CDN URLs mit Query-Parametern wie ?v=12345
   * z.B. "https://cdn.shopify.com/files/tool.svg?v=1234" wird korrekt erkannt.
   */
  function isSvgUrl(url) {
    if (!url) return false;
    if (url.startsWith('data:image/svg+xml')) return true;
    // URL-Pfad extrahieren (vor dem ? oder #)
    try {
      var path = url.split('?')[0].split('#')[0].toLowerCase();
      return path.endsWith('.svg');
    } catch (e) {
      return url.toLowerCase().includes('.svg');
    }
  }

  function normalizeNestedTspansForFabric(svgText) {
    var normalized = String(svgText || '');

    // Adobe Illustrator kann Text als <text><tspan class="..."><tspan x/y>...</tspan></tspan></text>
    // exportieren. Fabric.js verliert bei dieser Verschachtelung oft die inneren x/y-Werte,
    // wodurch mehrzeiliger Text im Canvas zu einer Zeile zusammenfällt.
    for (var i = 0; i < 6; i++) {
      var next = normalized.replace(/<tspan\b([^>]*)>\s*<tspan\b([^>]*)>([\s\S]*?)<\/tspan>\s*<\/tspan>/gi, function (_, outerAttrs, innerAttrs, content) {
        return '<tspan' + (outerAttrs || '') + (innerAttrs || '') + '>' + content + '</tspan>';
      });
      if (next === normalized) break;
      normalized = next;
    }

    return normalized;
  }

  function collectSvgTspanAttributes(tspan, stopAt) {
    var attrs = [];
    var classes = [];
    var node = tspan;

    while (node && node !== stopAt) {
      if (node.nodeType === 1 && String(node.tagName || '').toLowerCase().replace(/^.*:/, '') === 'tspan') {
        var nodeAttrs = Array.prototype.slice.call(node.attributes || []);
        nodeAttrs.forEach(function (attr) {
          if (!attr || !attr.name) return;
          if (attr.name === 'class') {
            classes.unshift(attr.value || '');
          } else {
            attrs.unshift({ name: attr.name, value: attr.value });
          }
        });
      }
      node = node.parentNode;
    }

    return { attrs: attrs, classes: classes };
  }

  function normalizeSvgTextElementsForFabric(svgText) {
    if (typeof DOMParser === 'undefined' || typeof XMLSerializer === 'undefined') return svgText;

    var parser = new DOMParser();
    var doc = parser.parseFromString(svgText, 'image/svg+xml');
    if (doc.getElementsByTagName('parsererror').length) return svgText;

    var svgNs = 'http://www.w3.org/2000/svg';
    var textNodes = Array.prototype.slice.call(doc.getElementsByTagName('text'));
    var changed = false;

    textNodes.forEach(function (textEl) {
      var parent = textEl.parentNode;
      if (!parent) return;

      var leafTspans = Array.prototype.slice.call(textEl.getElementsByTagName('tspan')).filter(function (tspan) {
        return tspan && tspan.children && tspan.children.length === 0 &&
          (tspan.hasAttribute('x') || tspan.hasAttribute('y') || tspan.hasAttribute('dx') || tspan.hasAttribute('dy'));
      });

      if (leafTspans.length <= 1) return;

      leafTspans.forEach(function (tspan) {
        var newText = doc.createElementNS(svgNs, 'text');
        var textAttrs = Array.prototype.slice.call(textEl.attributes || []);
        var inherited = collectSvgTspanAttributes(tspan, textEl);
        var classNames = [];

        textAttrs.forEach(function (attr) {
          if (!attr || !attr.name) return;
          if (attr.name === 'class') {
            classNames.push(attr.value || '');
          } else {
            newText.setAttribute(attr.name, attr.value);
          }
        });

        inherited.attrs.forEach(function (attr) {
          if (!attr || !attr.name) return;
          newText.setAttribute(attr.name, attr.value);
        });

        classNames = classNames.concat(inherited.classes)
          .join(' ')
          .split(/\s+/)
          .filter(Boolean);
        if (classNames.length) newText.setAttribute('class', classNames.join(' '));
        newText.textContent = tspan.textContent || '';
        parent.insertBefore(newText, textEl);
      });

      parent.removeChild(textEl);
      changed = true;
    });

    return changed ? new XMLSerializer().serializeToString(doc.documentElement) : svgText;
  }

  function normalizeSvgForFabric(svgText) {
    var normalized = normalizeNestedTspansForFabric(svgText);

    try {
      normalized = normalizeSvgTextElementsForFabric(normalized);
    } catch (e) {
      console.warn('[SBC] SVG-Text konnte nicht für Fabric normalisiert werden:', e);
    }

    return normalized;
  }

  function removeClippedSvgPaintRectsForFabric(svgText) {
    var text = String(svgText || '');
    if (!/<clipPath\b|clip-path\s*[:=]|<mask\b|mask\s*[:=]/i.test(text)) return text;
    if (typeof DOMParser === 'undefined' || typeof XMLSerializer === 'undefined') return text;

    try {
      var parser = new DOMParser();
      var doc = parser.parseFromString(text, 'image/svg+xml');
      if (doc.getElementsByTagName('parsererror').length) return text;

      var clippedClasses = {};
      Array.prototype.forEach.call(doc.querySelectorAll('style'), function (styleEl) {
        var css = styleEl.textContent || '';
        var match;
        var classRule = /\.([_a-zA-Z][\w-]*)\s*\{[^}]*\b(?:clip-path|mask)\s*:/gi;
        while ((match = classRule.exec(css))) {
          clippedClasses[match[1]] = true;
        }
      });

      function localName(node) {
        return String((node && (node.localName || node.nodeName)) || '').toLowerCase();
      }

      function isInDefinition(node) {
        var current = node && node.parentNode;
        while (current) {
          var name = localName(current);
          if (name === 'defs' || name === 'clippath' || name === 'mask') return true;
          current = current.parentNode;
        }
        return false;
      }

      function hasClippedClass(node) {
        var className = node.getAttribute && node.getAttribute('class');
        if (!className) return false;
        return className.split(/\s+/).some(function (name) {
          return !!clippedClasses[name];
        });
      }

      var candidates = [];
      Array.prototype.forEach.call(doc.querySelectorAll('[class], [clip-path], [style]'), function (node) {
        if (!node || isInDefinition(node)) return;

        var style = node.getAttribute('style') || '';
        var isClipped = hasClippedClass(node) ||
          node.hasAttribute('clip-path') ||
          /\b(?:clip-path|mask)\s*:/i.test(style);

        if (!isClipped) return;

        var name = localName(node);
        var hasRect = name === 'rect' || !!(node.querySelector && node.querySelector('rect'));
        var hasComplexContent = !!(node.querySelector && node.querySelector('image, text, use'));
        if (hasRect && !hasComplexContent) candidates.push(node);
      });

      candidates.forEach(function (node) {
        if (node.parentNode) node.parentNode.removeChild(node);
      });

      return new XMLSerializer().serializeToString(doc.documentElement);
    } catch (e) {
      console.warn('[SBC] SVG-Clip-Paint konnte nicht für Fabric bereinigt werden:', e);
      return text;
    }
  }

  function prepareShadowToolSvgForFabric(svgText) {
    var prepared = normalizeSvgForFabric(svgText);
    prepared = removeClippedSvgPaintRectsForFabric(prepared);

    // Adobe Illustrator SVG clip-path Fix: Fabric kann die Marker sonst als
    // gefüllte Rechtecke rendern. Die Druck-/Exportdaten bleiben unverändert.
    prepared = prepared.replace(/<clipPath[\s\S]*?<\/clipPath>/gi, '');
    prepared = prepared.replace(/clip-path="[^"]*"/gi, '');
    return prepared;
  }

  function shouldUseRasterToolSvgPreview(svgText, tool) {
    var text = String(svgText || '');
    var meta = [
      tool && tool.name,
      tool && tool.frontendName,
      tool && tool.category,
      tool && tool.imageUrl
    ].filter(Boolean).join(' ');

    // Nur eindeutig erkannte QR-/Produktmarker per Bild-Fallback laden.
    // Viele Werkzeug-SVGs enthalten Clip-Pfade; der pauschale Bild-Fallback kann
    // in Safari sichtbar leere, aber auswählbare Objekte erzeugen.
    return /\bdata-qr-marker\b/i.test(text) ||
      /zum\s*Produkt|QR\s*Code|qrcode|qr-code/i.test(text + ' ' + meta) ||
      hasClippedProductMarkerSvg(text) ||
      shouldUseRasterPreviewForBlackToolSvg(text, tool) ||
      shouldUseRasterPreviewForComplexToolSvg(text, tool);
  }

  function shouldUseRasterPreviewForBlackToolSvg(svgText, tool) {
    var text = String(svgText || '');
    if (!tool || !text) return false;
    if (normalizeBoardColorKey(tool.boardColor, '') !== 'black') return false;

    var meta = [
      tool.name,
      tool.frontendName,
      tool.category
    ].filter(Boolean).join(' ');

    // Einige schwarze Illustrator-SVGs mit Clip-Pfaden werden von Fabric beim
    // Restore als leere Gruppen importiert. Der Bild-Fallback betrifft nur die
    // Browser-Vorschau; Export und gespeicherte Tool-ID bleiben unverändert.
    return /schaufel|kehrblech/i.test(meta) &&
      (/<clipPath\b/i.test(text) || /\bclip-path\s*[:=]/i.test(text));
  }

  function shouldUseRasterPreviewForComplexToolSvg(svgText, tool) {
    var text = String(svgText || '');
    if (!tool || !text) return false;

    var meta = [
      tool.name,
      tool.frontendName,
      tool.category
    ].filter(Boolean).join(' ');

    var normalizedMeta = meta;
    if (typeof normalizedMeta.normalize === 'function') {
      normalizedMeta = normalizedMeta.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    }

    if (/uberschriften|ueberschriften|symbole|symbol/i.test(normalizedMeta)) return false;

    var isKnownComplexTool = /besen|burste|buerste|schaufel|kehrblech|eimer|behalter|behaelter|schrubber|abzieher|spachtel|zubehor|zubehoer|handschuhe|halter|spender|spruhdose|spruehdose/i.test(normalizedMeta);
    if (!isKnownComplexTool) {
      return false;
    }

    var hasClipPath = /<clipPath\b/i.test(text) || /\bclip-path\s*[:=]/i.test(text);
    var hasEmbeddedClassStyle = /<style[\s\S]*?\.st\d+/i.test(text);

    // Einige große Illustrator-Werkzeug-SVGs werden von Fabric als leere Gruppe
    // importiert. Das passiert teils mit Clip-Pfaden, teils nur mit umfangreichen
    // Klassen-Styles. Der Raster-Fallback gilt nur für die Browser-Vorschau.
    var pathCount = (text.match(/<path\b/gi) || []).length;
    return (hasClipPath && (text.length > 20000 || pathCount > 12)) ||
      (hasEmbeddedClassStyle && (text.length > 40000 || pathCount > 12));
  }

  function hasClippedProductMarkerSvg(svgText) {
    var text = String(svgText || '');
    if (/\bdata-qr-marker\b/i.test(text)) return true;
    if (!/<clipPath\b/i.test(text) || !/\bclip-path\s*:\s*url\(#/i.test(text)) return false;

    var hasMarkerRect = /<g\b[^>]*class=["'][^"']+["'][^>]*>\s*<rect\b[^>]*(?:width=["']39(?:\.2)?|height=["']39(?:\.2)?)/i.test(text);
    var hasMarkerPalette = /#(?:009fe3|169cd8|179cd9|010101|010202|1d1d1b|1d1e1b|1d1f1c)\b/i.test(text);
    return hasMarkerRect && hasMarkerPalette;
  }

  function addSvgPreviewIntrinsicSize(svgText) {
    var text = String(svgText || '');
    var openingTagMatch = text.match(/<svg\b[^>]*>/i);
    if (!openingTagMatch) return text;

    var openingTag = openingTagMatch[0];
    if (/\bwidth\s*=/.test(openingTag) && /\bheight\s*=/.test(openingTag)) {
      return text;
    }

    var viewBoxMatch = openingTag.match(/\bviewBox\s*=\s*["']\s*([-\d.]+)[ ,]+([-\d.]+)[ ,]+([-\d.]+)[ ,]+([-\d.]+)\s*["']/i);
    if (!viewBoxMatch) return text;

    var viewBoxWidth = Number(viewBoxMatch[3]);
    var viewBoxHeight = Number(viewBoxMatch[4]);
    if (!isFinite(viewBoxWidth) || !isFinite(viewBoxHeight) || viewBoxWidth <= 0 || viewBoxHeight <= 0) {
      return text;
    }

    return text.replace(/<svg\b/i, '<svg width="' + viewBoxWidth + '" height="' + viewBoxHeight + '"');
  }

  function getSvgPreviewDataUrl(svgText) {
    var text = addSvgPreviewIntrinsicSize(svgText);
    if (window.URL && window.Blob) {
      try {
        return URL.createObjectURL(new Blob([text], { type: 'image/svg+xml;charset=utf-8' }));
      } catch (e) {
        // Fall through to data URL fallback.
      }
    }

    try {
      return 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(text)));
    } catch (e) {
      return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(text);
    }
  }

  function svgTextToDataUrl(svgText) {
    var text = String(svgText || '');
    try {
      return 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(text)));
    } catch (e) {
      return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(text);
    }
  }

  function getSvgTextFromSource(source) {
    if (!source || !isSvgUrl(source)) return Promise.resolve('');

    if (String(source).startsWith('data:image/svg+xml')) {
      return Promise.resolve(decodeSvgDataUrl(source));
    }

    return fetch(source, { headers: { 'ngrok-skip-browser-warning': 'true' } })
      .then(function (res) {
        if (!res.ok) throw new Error('SVG konnte nicht geladen werden');
        return res.text();
      });
  }

  function createSvgBrowserUrl(svgText) {
    var text = String(svgText || '');
    if (window.URL && window.Blob) {
      try {
        return {
          url: URL.createObjectURL(new Blob([text], { type: 'image/svg+xml;charset=utf-8' })),
          revoke: true
        };
      } catch (e) {
        // Fall through to data URL fallback.
      }
    }

    return { url: svgTextToDataUrl(text), revoke: false };
  }

  function loadImageElementFromSvgText(svgText) {
    var browserUrl = createSvgBrowserUrl(addSvgPreviewIntrinsicSize(svgText));
    return loadImageElement(browserUrl.url).finally(function () {
      if (browserUrl.revoke) {
        setTimeout(function () {
          try { URL.revokeObjectURL(browserUrl.url); } catch (e) { }
        }, 0);
      }
    });
  }

  function decodeSvgDataUrl(dataUrl) {
    var raw = String(dataUrl || '');
    if (!raw.startsWith('data:image/svg+xml')) return '';
    var commaIndex = raw.indexOf(',');
    if (commaIndex === -1) return '';

    var meta = raw.slice(0, commaIndex).toLowerCase();
    var payload = raw.slice(commaIndex + 1);
    try {
      if (meta.indexOf(';base64') !== -1) {
        return decodeURIComponent(escape(atob(payload)));
      }
      return decodeURIComponent(payload);
    } catch (e) {
      try {
        return atob(payload);
      } catch (fallbackErr) {
        return '';
      }
    }
  }

  function parseSvgNumericValue(value) {
    var match = String(value || '').trim().match(/^-?\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : NaN;
  }

  function parseSvgViewBox(svgRoot) {
    if (!svgRoot) return null;

    var viewBoxAttr = svgRoot.getAttribute('viewBox') || svgRoot.getAttribute('viewbox') || '';
    var parts = viewBoxAttr.trim().split(/[\s,]+/).map(Number).filter(function (num) {
      return isFinite(num);
    });

    if (parts.length >= 4 && parts[2] > 0 && parts[3] > 0) {
      return { x: parts[0], y: parts[1], width: parts[2], height: parts[3] };
    }

    var width = parseSvgNumericValue(svgRoot.getAttribute('width'));
    var height = parseSvgNumericValue(svgRoot.getAttribute('height'));
    if (isFinite(width) && isFinite(height) && width > 0 && height > 0) {
      return { x: 0, y: 0, width: width, height: height };
    }

    return null;
  }

  function formatSvgNumber(value) {
    var num = Number(value);
    if (!isFinite(num)) return '0';
    return String(Math.round(num * 1000) / 1000);
  }

  function identitySvgLogoNormalization(source) {
    return {
      dataUrl: source,
      trimmed: false,
      trim: {
        leftRatio: 0,
        topRatio: 0,
        widthRatio: 1,
        heightRatio: 1,
        centerOffsetXRatio: 0,
        centerOffsetYRatio: 0
      }
    };
  }

  function normalizeLogoTrimForPayload(trim) {
    if (!trim || typeof trim !== 'object') return null;

    function clampNumber(value, min, max, fallback) {
      var num = Number(value);
      if (!isFinite(num)) return fallback;
      return Math.max(min, Math.min(max, num));
    }

    var leftRatio = clampNumber(trim.leftRatio, 0, 0.9999, 0);
    var topRatio = clampNumber(trim.topRatio, 0, 0.9999, 0);
    var widthRatio = clampNumber(trim.widthRatio, 0.0001, 1, 1);
    var heightRatio = clampNumber(trim.heightRatio, 0.0001, 1, 1);
    var centerOffsetXRatio = clampNumber(trim.centerOffsetXRatio, -1, 1, (leftRatio + (widthRatio / 2)) - 0.5);
    var centerOffsetYRatio = clampNumber(trim.centerOffsetYRatio, -1, 1, (topRatio + (heightRatio / 2)) - 0.5);

    if (leftRatio <= 0.0001 && topRatio <= 0.0001 && widthRatio >= 0.9999 && heightRatio >= 0.9999) {
      return null;
    }

    return {
      leftRatio: leftRatio,
      topRatio: topRatio,
      widthRatio: widthRatio,
      heightRatio: heightRatio,
      centerOffsetXRatio: centerOffsetXRatio,
      centerOffsetYRatio: centerOffsetYRatio
    };
  }

  function getLogoTrimForObject(obj) {
    if (!obj) return null;
    var trim = obj.logoTrim || obj.sbcLogoTrim;
    if (!trim && typeof obj.get === 'function') {
      trim = obj.get('logoTrim') || obj.get('sbcLogoTrim');
    }
    return normalizeLogoTrimForPayload(trim);
  }

  function getLogoTrimFromRestoreData(objData, logoData) {
    return normalizeLogoTrimForPayload(
      (objData && (objData.logoTrim || objData.sbcLogoTrim || objData.lt)) ||
      (logoData && logoData.normalizedLogo && logoData.normalizedLogo.trim) ||
      (logoData && logoData.preview && logoData.preview.trim)
    );
  }

  function loadImageElement(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('Bild konnte nicht geladen werden')); };
      img.src = src;
    });
  }

  function getSvgRenderSize(svgText, img) {
    var width = Number(img && (img.naturalWidth || img.width));
    var height = Number(img && (img.naturalHeight || img.height));

    if ((!isFinite(width) || width <= 0 || !isFinite(height) || height <= 0) &&
      typeof DOMParser !== 'undefined') {
      try {
        var doc = new DOMParser().parseFromString(String(svgText || ''), 'image/svg+xml');
        var viewBox = parseSvgViewBox(doc.documentElement);
        if (viewBox) {
          width = viewBox.width;
          height = viewBox.height;
        }
      } catch (e) { }
    }

    if (!isFinite(width) || width <= 0) width = 300;
    if (!isFinite(height) || height <= 0) height = 150;

    var scale = Math.min(1, SVG_LOGO_TRIM_RENDER_MAX / Math.max(width, height));
    return {
      width: Math.max(1, Math.round(width * scale)),
      height: Math.max(1, Math.round(height * scale))
    };
  }

  function findVisiblePixelBounds(ctx, width, height) {
    var imageData = ctx.getImageData(0, 0, width, height).data;
    var left = width;
    var top = height;
    var right = -1;
    var bottom = -1;

    for (var y = 0; y < height; y++) {
      for (var x = 0; x < width; x++) {
        var alpha = imageData[((y * width + x) * 4) + 3];
        if (alpha <= SVG_LOGO_TRIM_ALPHA_THRESHOLD) continue;
        if (x < left) left = x;
        if (x > right) right = x;
        if (y < top) top = y;
        if (y > bottom) bottom = y;
      }
    }

    if (right < left || bottom < top) return null;
    return { left: left, top: top, right: right, bottom: bottom };
  }

  function createTrimmedSvgLogoPreview(source) {
    if (!source || !isSvgUrl(source)) return Promise.resolve(null);

    return getSvgTextFromSource(source)
      .then(function (svgText) {
        if (!svgText) return null;

        return loadImageElementFromSvgText(svgText).then(function (img) {
          var size = getSvgRenderSize(svgText, img);
          var renderCanvas = document.createElement('canvas');
          renderCanvas.width = size.width;
          renderCanvas.height = size.height;
          var ctx = renderCanvas.getContext('2d', { willReadFrequently: true });
          if (!ctx) return null;
          ctx.clearRect(0, 0, size.width, size.height);
          ctx.drawImage(img, 0, 0, size.width, size.height);

          var bounds = findVisiblePixelBounds(ctx, size.width, size.height);
          if (!bounds) return null;

          var pad = SVG_LOGO_TRIM_PADDING_PX;
          var left = Math.max(0, bounds.left - pad);
          var top = Math.max(0, bounds.top - pad);
          var right = Math.min(size.width - 1, bounds.right + pad);
          var bottom = Math.min(size.height - 1, bounds.bottom + pad);
          var width = Math.max(1, right - left + 1);
          var height = Math.max(1, bottom - top + 1);

          var cropCanvas = document.createElement('canvas');
          cropCanvas.width = width;
          cropCanvas.height = height;
          var cropCtx = cropCanvas.getContext('2d');
          if (!cropCtx) return null;
          cropCtx.clearRect(0, 0, width, height);
          cropCtx.drawImage(renderCanvas, left, top, width, height, 0, 0, width, height);

          var leftRatio = left / size.width;
          var topRatio = top / size.height;
          var widthRatio = width / size.width;
          var heightRatio = height / size.height;

          return {
            dataUrl: cropCanvas.toDataURL('image/png'),
            width: width,
            height: height,
            trim: normalizeLogoTrimForPayload({
              leftRatio: leftRatio,
              topRatio: topRatio,
              widthRatio: widthRatio,
              heightRatio: heightRatio,
              centerOffsetXRatio: (leftRatio + (widthRatio / 2)) - 0.5,
              centerOffsetYRatio: (topRatio + (heightRatio / 2)) - 0.5
            })
          };
        });
      })
      .catch(function (err) {
        console.warn('[SBC] SVG-Logo Preview konnte nicht erzeugt werden:', err.message);
        return null;
      });
  }

  function wrapSvgChildrenForTrim(doc, root, offsetX, offsetY) {
    if (!doc || !root || (!offsetX && !offsetY)) return;

    var svgNs = root.namespaceURI || 'http://www.w3.org/2000/svg';
    var wrapper = doc.createElementNS(svgNs, 'g');
    wrapper.setAttribute('transform', 'translate(' + formatSvgNumber(-offsetX) + ' ' + formatSvgNumber(-offsetY) + ')');

    var moved = false;
    Array.prototype.slice.call(root.childNodes || []).forEach(function (node) {
      if (!node) return;
      if (node.nodeType === 1) {
        var name = String(node.localName || node.nodeName || '').toLowerCase();
        if (name === 'defs' || name === 'style' || name === 'title' || name === 'desc' || name === 'metadata') {
          return;
        }
      } else if (node.nodeType === 3 && !String(node.textContent || '').trim()) {
        return;
      }

      wrapper.appendChild(node);
      moved = true;
    });

    if (moved) root.appendChild(wrapper);
  }

  function removeNonPaintingLogoSvgGeometry(root) {
    if (!root || !root.querySelectorAll) return;

    var classStyles = {};
    Array.prototype.slice.call(root.querySelectorAll('style')).forEach(function (styleEl) {
      var css = styleEl.textContent || '';
      var match;
      var ruleRegex = /\.([_a-zA-Z][\w-]*)\s*\{([^}]*)\}/g;
      while ((match = ruleRegex.exec(css))) {
        classStyles[match[1]] = (classStyles[match[1]] || '') + ';' + match[2];
      }
    });

    function localName(node) {
      return String((node && (node.localName || node.nodeName)) || '').toLowerCase();
    }

    function isInDefinition(node) {
      var current = node && node.parentNode;
      while (current && current !== root) {
        var name = localName(current);
        if (name === 'defs' || name === 'clippath' || name === 'mask' || name === 'symbol' || name === 'pattern') return true;
        current = current.parentNode;
      }
      return false;
    }

    function styleValue(styleText, prop) {
      var regex = new RegExp('(?:^|;)\\s*' + prop + '\\s*:\\s*([^;]+)', 'i');
      var match = String(styleText || '').match(regex);
      return match ? String(match[1] || '').trim().toLowerCase() : '';
    }

    function combinedStyle(node) {
      var out = '';
      var className = node.getAttribute('class') || '';
      className.split(/\s+/).filter(Boolean).forEach(function (name) {
        if (classStyles[name]) out += ';' + classStyles[name];
      });
      return out + ';' + (node.getAttribute('style') || '');
    }

    function isTransparentPaint(value) {
      var paint = String(value || '').trim().toLowerCase();
      return paint === 'none' || paint === 'transparent' || paint === 'rgba(0,0,0,0)' || paint === 'rgba(0, 0, 0, 0)';
    }

    var shapeSelector = 'path,rect,circle,ellipse,polygon,polyline,line';
    Array.prototype.slice.call(root.querySelectorAll(shapeSelector)).forEach(function (node) {
      if (!node || isInDefinition(node)) return;

      var styleText = combinedStyle(node);
      var display = (styleValue(styleText, 'display') || node.getAttribute('display') || '').toLowerCase();
      var visibility = (styleValue(styleText, 'visibility') || node.getAttribute('visibility') || '').toLowerCase();
      var opacity = styleValue(styleText, 'opacity') || node.getAttribute('opacity') || '';

      if (display === 'none' || visibility === 'hidden' || Number(opacity) === 0) {
        if (node.parentNode) node.parentNode.removeChild(node);
        return;
      }

      var fill = styleValue(styleText, 'fill') || node.getAttribute('fill') || '';
      var stroke = styleValue(styleText, 'stroke') || node.getAttribute('stroke') || '';
      var strokeWidth = styleValue(styleText, 'stroke-width') || node.getAttribute('stroke-width') || '';
      var fillOpacity = styleValue(styleText, 'fill-opacity') || node.getAttribute('fill-opacity') || '';
      var strokeOpacity = styleValue(styleText, 'stroke-opacity') || node.getAttribute('stroke-opacity') || '';
      var fillHidden = isTransparentPaint(fill) || Number(fillOpacity) === 0;
      var strokeHidden = !stroke || isTransparentPaint(stroke) || Number(strokeOpacity) === 0 || Number(strokeWidth) === 0;

      if (fillHidden && strokeHidden && node.parentNode) {
        node.parentNode.removeChild(node);
      }
    });
  }

  function normalizeSvgLogoSource(source) {
    if (!source || !isSvgUrl(source)) return Promise.resolve(identitySvgLogoNormalization(source));

    return getSvgTextFromSource(source).then(function (svgText) {
      if (!svgText || typeof DOMParser === 'undefined' || typeof XMLSerializer === 'undefined') {
        return identitySvgLogoNormalization(source);
      }

      var parser = new DOMParser();
      var doc = parser.parseFromString(svgText, 'image/svg+xml');
      if (doc.getElementsByTagName('parsererror').length || !doc.documentElement) {
        return identitySvgLogoNormalization(source);
      }

      var root = doc.documentElement;
      if (!root.getAttribute('xmlns')) root.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      var viewBox = parseSvgViewBox(root);
      if (!viewBox || viewBox.width <= 0 || viewBox.height <= 0) {
        return identitySvgLogoNormalization(source);
      }

      var aspect = viewBox.width / viewBox.height;
      var renderWidth = aspect >= 1 ? SVG_LOGO_TRIM_RENDER_MAX : Math.max(24, Math.round(SVG_LOGO_TRIM_RENDER_MAX * aspect));
      var renderHeight = aspect >= 1 ? Math.max(24, Math.round(SVG_LOGO_TRIM_RENDER_MAX / aspect)) : SVG_LOGO_TRIM_RENDER_MAX;

      var renderDoc = parser.parseFromString(svgText, 'image/svg+xml');
      if (renderDoc.getElementsByTagName('parsererror').length || !renderDoc.documentElement) {
        return identitySvgLogoNormalization(source);
      }
      var renderRoot = renderDoc.documentElement;
      if (!renderRoot.getAttribute('xmlns')) renderRoot.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      renderRoot.setAttribute('viewBox', [
        formatSvgNumber(viewBox.x),
        formatSvgNumber(viewBox.y),
        formatSvgNumber(viewBox.width),
        formatSvgNumber(viewBox.height)
      ].join(' '));
      renderRoot.setAttribute('width', String(renderWidth));
      renderRoot.setAttribute('height', String(renderHeight));
      renderRoot.setAttribute('preserveAspectRatio', 'none');

      return loadImageElementFromSvgText(new XMLSerializer().serializeToString(renderRoot)).then(function (img) {
        var trimCanvas = document.createElement('canvas');
        trimCanvas.width = renderWidth;
        trimCanvas.height = renderHeight;
        var ctx = trimCanvas.getContext('2d', { willReadFrequently: true });
        if (!ctx) return identitySvgLogoNormalization(source);
        ctx.clearRect(0, 0, renderWidth, renderHeight);
        ctx.drawImage(img, 0, 0, renderWidth, renderHeight);

        var bounds = findVisiblePixelBounds(ctx, renderWidth, renderHeight);
        if (!bounds) return identitySvgLogoNormalization(source);

        var pad = SVG_LOGO_TRIM_PADDING_PX;
        var left = Math.max(0, bounds.left - pad);
        var top = Math.max(0, bounds.top - pad);
        var right = Math.min(renderWidth - 1, bounds.right + pad);
        var bottom = Math.min(renderHeight - 1, bounds.bottom + pad);
        var trimmedWidth = right - left + 1;
        var trimmedHeight = bottom - top + 1;

        if (trimmedWidth >= renderWidth - (pad * 2) && trimmedHeight >= renderHeight - (pad * 2)) {
          return identitySvgLogoNormalization(source);
        }

        var leftRatio = left / renderWidth;
        var topRatio = top / renderHeight;
        var widthRatio = trimmedWidth / renderWidth;
        var heightRatio = trimmedHeight / renderHeight;
        var cropX = viewBox.x + (leftRatio * viewBox.width);
        var cropY = viewBox.y + (topRatio * viewBox.height);
        var cropWidth = widthRatio * viewBox.width;
        var cropHeight = heightRatio * viewBox.height;
        if (cropWidth <= 0 || cropHeight <= 0) return identitySvgLogoNormalization(source);

        removeNonPaintingLogoSvgGeometry(root);
        wrapSvgChildrenForTrim(doc, root, cropX, cropY);
        root.setAttribute('viewBox', '0 0 ' + formatSvgNumber(cropWidth) + ' ' + formatSvgNumber(cropHeight));
        root.setAttribute('width', formatSvgNumber(cropWidth));
        root.setAttribute('height', formatSvgNumber(cropHeight));

        var normalizedText = normalizeSvgForFabric(new XMLSerializer().serializeToString(root));
        return {
          dataUrl: svgTextToDataUrl(normalizedText),
          trimmed: true,
          trim: normalizeLogoTrimForPayload({
            leftRatio: leftRatio,
            topRatio: topRatio,
            widthRatio: widthRatio,
            heightRatio: heightRatio,
            centerOffsetXRatio: (leftRatio + (widthRatio / 2)) - 0.5,
            centerOffsetYRatio: (topRatio + (heightRatio / 2)) - 0.5
          })
        };
      }).catch(function (err) {
        console.warn('[SBC] SVG-Logo konnte nicht zugeschnitten werden:', err.message);
        return identitySvgLogoNormalization(source);
      });
    }).catch(function (err) {
      console.warn('[SBC] SVG-Logo konnte nicht normalisiert werden:', err.message);
      return identitySvgLogoNormalization(source);
    });
  }

  function getRestoredLogoPlacement(objData, normalization, intrinsicWidth, intrinsicHeight) {
    var trim = normalization && normalization.trim ? normalization.trim : identitySvgLogoNormalization('').trim;
    var savedWidth = Number(objData.w || objData.width);
    var savedHeight = Number(objData.h || objData.height);
    var scaleX = Number(objData.scaleX || objData.sx || 1);
    var scaleY = Number(objData.scaleY || objData.sy || 1);

    if (!isFinite(savedWidth) || savedWidth <= 0) savedWidth = Math.max(1, intrinsicWidth * scaleX);
    if (!isFinite(savedHeight) || savedHeight <= 0) savedHeight = Math.max(1, intrinsicHeight * scaleY);

    var targetWidth = savedWidth * (trim.widthRatio || 1);
    var targetHeight = savedHeight * (trim.heightRatio || 1);
    var offsetX = savedWidth * (trim.centerOffsetXRatio || 0);
    var offsetY = savedHeight * (trim.centerOffsetYRatio || 0);
    var angle = Number(objData.a !== undefined ? objData.a : objData.angle) || 0;
    var rad = angle * Math.PI / 180;
    var rotatedX = (offsetX * Math.cos(rad)) - (offsetY * Math.sin(rad));
    var rotatedY = (offsetX * Math.sin(rad)) + (offsetY * Math.cos(rad));
    var left = Number(objData.x !== undefined ? objData.x : objData.left) || 0;
    var top = Number(objData.y !== undefined ? objData.y : objData.top) || 0;

    return {
      left: left + rotatedX,
      top: top + rotatedY,
      scaleX: targetWidth / Math.max(1, intrinsicWidth),
      scaleY: targetHeight / Math.max(1, intrinsicHeight)
    };
  }

  function normalizeSvgPreviewHexColor(value) {
    var raw = String(value || '').trim().toLowerCase();
    if (/^#[0-9a-f]{3}$/i.test(raw)) {
      return '#' + raw.slice(1).split('').map(function (char) { return char + char; }).join('');
    }
    if (/^#[0-9a-f]{6}$/i.test(raw)) return raw;
    if (/^#[0-9a-f]{8}$/i.test(raw)) return raw.slice(0, 7);
    return '';
  }

  function getToolMarkerPreviewColor(boardColor) {
    var key = normalizeBoardColorKey(boardColor || getCurrentBoardColor(), '');
    var markerColors = {
      white: '#d0cfd0',
      black: '#1d1d1b',
      blue: '#24388b',
      red: '#ca282d',
      green: '#007d5b',
      yellow: '#fcbc05'
    };
    return markerColors[key] || normalizeSvgPreviewHexColor((getColorMeta(key || boardColor) || {}).hex) || '#ffffff';
  }

  function getToolMarkerPreviewInkColor(boardColor) {
    var key = normalizeBoardColorKey(boardColor || getCurrentBoardColor(), '');
    if (key === 'white' || key === 'yellow') return '#1d1d1b';
    return getToolMarkerPreviewColor(boardColor);
  }

  function isLightSvgPreviewHexColor(color) {
    var normalized = normalizeSvgPreviewHexColor(color);
    if (!normalized) return false;
    var r = parseInt(normalized.slice(1, 3), 16);
    var g = parseInt(normalized.slice(3, 5), 16);
    var b = parseInt(normalized.slice(5, 7), 16);
    if (!isFinite(r) || !isFinite(g) || !isFinite(b)) return false;
    return ((r * 0.299) + (g * 0.587) + (b * 0.114)) >= 180;
  }

  function recolorShadowToolMarkerSvgPreview(svgText, boardColor, tool) {
    var text = String(svgText || '');
    if (!text) return text;

    var targetBoardColor = normalizeBoardColorKey(boardColor || getCurrentBoardColor(), '');
    var authoredBoardColor = normalizeBoardColorKey(tool && tool.boardColor, '');

    // Farbvarianten aus der Werkzeugbibliothek sind bereits fertig aufgebaut.
    // Eine erneute Paletten-Ersetzung würde bei komplexen SVGs mit QR-Clip-Pfaden
    // auch normale dunkle Motivflächen erfassen. Beim weißen Rutschgefahr-Schild
    // wurden dadurch Piktogramm und Schrift grau wie der Schildkörper und verschwanden.
    if (authoredBoardColor && authoredBoardColor !== 'all' && authoredBoardColor === targetBoardColor) {
      return text;
    }

    var hasEmbeddedMarker = /\bdata-qr-marker\b/i.test(text);
    var hasProductMarker = hasClippedProductMarkerSvg(text);
    var target = normalizeSvgPreviewHexColor(getToolMarkerPreviewColor(boardColor));
    var inkTarget = normalizeSvgPreviewHexColor(getToolMarkerPreviewInkColor(boardColor));
    if (!target) return text;

    // Nur bekannte Produktmarker-Farben ersetzen. Weiß bleibt bewusst außen vor,
    // damit die eigentlichen Werkzeug-Schatten nicht versehentlich eingefärbt werden.
    var markerPalette = [
      '#d0cfd0', '#d0cfd1', '#cbd5e1',
      '#233d7b', '#24388b', '#3182ce', '#0047ab', '#0021f7', '#149bd8', '#169cd8', '#179cd9', '#1a9dd9',
      '#ca282d', '#b93139', '#d20c27', '#d30c27', '#e53e3e', '#cc0000',
      '#007d5b', '#12785a', '#38a169', '#228b22', '#1da63d',
      '#fcbc05', '#fbbc10', '#fcbc0b', '#f3b536', '#ffb50f', '#ecc94b', '#ffd700', '#d6a400'
    ].reduce(function (map, color) {
      var normalized = normalizeSvgPreviewHexColor(color);
      if (normalized) map[normalized] = true;
      return map;
    }, {});

    var darkMarkerPalette = {};
    ['#000000', '#010101', '#010202', '#1a1a1a', '#1d1d1b', '#1d1e1b', '#1d1f1c'].forEach(function (color) {
      var normalized = normalizeSvgPreviewHexColor(color);
      if (normalized) darkMarkerPalette[normalized] = true;
    });

    var markerInkPlaceholder = '__SBC_MARKER_INK__';
    if (hasProductMarker) {
      text = markClippedProductMarkerInkFills(text, darkMarkerPalette, markerInkPlaceholder);
      if (!(hasEmbeddedMarker && isLightSvgPreviewHexColor(target))) {
        Object.keys(darkMarkerPalette).forEach(function (color) {
          var normalized = normalizeSvgPreviewHexColor(color);
          if (normalized) markerPalette[normalized] = true;
        });
      }
    }

    text = text.replace(/#[0-9a-fA-F]{3,8}\b/g, function (match) {
      var normalized = normalizeSvgPreviewHexColor(match);
      if (!markerPalette[normalized]) return match;
      return target;
    });

    return text.split(markerInkPlaceholder).join(inkTarget || target);
  }

  function markClippedProductMarkerInkFills(svgText, darkMarkerPalette, placeholder) {
    if (!svgText || !placeholder) return svgText;

    function isDarkMarkerColor(color) {
      return !!darkMarkerPalette[normalizeSvgPreviewHexColor(color)];
    }

    var text = String(svgText);
    text = text.replace(/(\{[^}]*\bclip-path\s*:\s*url\([^)]+\)[^}]*\bfill\s*:\s*)(#[0-9a-fA-F]{3,8})([^}]*\})/gi, function (match, prefix, color, suffix) {
      return isDarkMarkerColor(color) ? prefix + placeholder + suffix : match;
    });
    text = text.replace(/(<(?:path|rect|circle|ellipse|polygon|polyline|line)\b[^>]*\bstyle\s*=\s*["'][^"']*\bclip-path\s*:\s*[^"']*\bfill\s*:\s*)(#[0-9a-fA-F]{3,8})([^"']*["'][^>]*>)/gi, function (match, prefix, color, suffix) {
      return isDarkMarkerColor(color) ? prefix + placeholder + suffix : match;
    });
    text = text.replace(/(<(?:path|rect|circle|ellipse|polygon|polyline|line)\b[^>]*\bstyle\s*=\s*["'][^"']*\bfill\s*:\s*)(#[0-9a-fA-F]{3,8})([^"']*\bclip-path\s*:\s*[^"']*["'][^>]*>)/gi, function (match, prefix, color, suffix) {
      return isDarkMarkerColor(color) ? prefix + placeholder + suffix : match;
    });
    return text;
  }

  function getFabricImageLoadOptions(url) {
    var src = String(url || '');
    return src.indexOf('data:') === 0 || src.indexOf('blob:') === 0 ? {} : { crossOrigin: 'anonymous' };
  }

  function getSizeLabel() {
    if (selectedSizeIsCustom) return 'Sondermaß ' + CFG.boardWidthMm + ' × ' + CFG.boardHeightMm + ' mm';
    var meta = getSizeOptionMeta(CFG.boardWidthMm, CFG.boardHeightMm);
    return meta ? (meta.label + ' ' + (meta.unit || 'mm')) : (CFG.boardWidthMm + ' × ' + CFG.boardHeightMm + ' mm');
  }

  function getBoardDimensionLabel() {
    var widthMm = Math.round(Number(CFG.boardWidthMm) || 0);
    var heightMm = Math.round(Number(CFG.boardHeightMm) || 0);
    if (!widthMm || !heightMm) return '';
    return widthMm + ' × ' + heightMm + ' mm';
  }

  function getPriceSizeLabel() {
    var resolution = getCurrentPriceResolution();
    return resolution ? resolution.label : getSizeLabel();
  }

  function getSelectedColorLabel() {
    return (selectedColor && getColorMeta(selectedColor).label) || 'Spezial';
  }

  function getSelectedBackColorLabel() {
    return (selectedBackColor && getColorMeta(selectedBackColor).label) || getSelectedColorLabel();
  }

  function normalizeBoardColorKey(value, fallback) {
    if (value == null || value === '') return fallback || '';

    var raw = String(value).trim();
    var lower = raw.toLowerCase();
    var labelMap = {
      'weiß': 'white',
      'weiss': 'white',
      'white': 'white',
      'schwarz': 'black',
      'black': 'black',
      'blau': 'blue',
      'blue': 'blue',
      'rot': 'red',
      'red': 'red',
      'grün': 'green',
      'gruen': 'green',
      'green': 'green',
      'gelb': 'yellow',
      'yellow': 'yellow'
    };

    if (isKnownColorKey(lower)) return lower;
    if (labelMap[lower]) return labelMap[lower];

    var compactHex = lower.replace(/\s+/g, '');
    if (/^#[0-9a-f]{6}$/i.test(compactHex)) {
      var hexAliases = {
        '#f5f5f5': 'white',
        '#ffffff': 'white',
        '#fff': 'white',
        '#000000': 'black',
        '#1a1a1a': 'black',
        '#1a1919': 'black',
        '#3182ce': 'blue',
        '#0047ab': 'blue',
        '#0021f7': 'blue',
        '#233d7b': 'blue',
        '#e53e3e': 'red',
        '#cc0000': 'red',
        '#d20c27': 'red',
        '#d30c27': 'red',
        '#b93139': 'red',
        '#38a169': 'green',
        '#228b22': 'green',
        '#1da63d': 'green',
        '#12785a': 'green',
        '#ecc94b': 'yellow',
        '#ffd700': 'yellow',
        '#d6a400': 'yellow',
        '#ffb50f': 'yellow',
        '#f3b536': 'yellow'
      };
      if (hexAliases[compactHex]) return hexAliases[compactHex];

      var exact = getConfiguredColorOptions().find(function (item) {
        return String(item.hex || '').toLowerCase() === compactHex;
      });
      if (exact) return exact.key;
    }

    return fallback || '';
  }

  function resolveRestoredBoardColor(primaryValue, backgroundValue, fallback) {
    var primaryColor = normalizeBoardColorKey(primaryValue, '');
    var backgroundColor = normalizeBoardColorKey(backgroundValue, '');

    if (primaryColor === 'white' && backgroundColor && backgroundColor !== 'white') {
      return backgroundColor;
    }

    return primaryColor || backgroundColor || fallback || '';
  }

  function getRestoredFrontColorFromDesign(design, options) {
    options = options || {};
    design = design || {};
    return resolveRestoredBoardColor(
      options.boardColor ||
      options.frontColor ||
      design.boardColor ||
      design.frontColor ||
      design.color ||
      design.c,
      options.bg || design.bg,
      selectedColor || 'white'
    );
  }

  function getRestoredBackColorFromDesign(design, options, frontColor) {
    options = options || {};
    design = design || {};
    return normalizeBoardColorKey(
      options.backColor ||
      options.boardBackColor ||
      design.backColor ||
      design.boardBackColor ||
      design.bc,
      frontColor || selectedBackColor || selectedColor || 'white'
    );
  }

  function getBoardColorLabelForSide(side) {
    var color = getBoardColorForSide(side);
    return (color && getColorMeta(color).label) || 'Spezial';
  }

  function getColorSummaryLabel() {
    if (isDoubleSidedConfiguration() && getBoardColorForSide('back') !== getBoardColorForSide('front')) {
      return 'Vorderseite ' + getBoardColorLabelForSide('front') + ', Rückseite ' + getBoardColorLabelForSide('back');
    }
    return getSelectedColorLabel();
  }

  function isDoubleSidedConfiguration() {
    return selectedMounting !== 'wall' && selectedMountingSides === 2;
  }

  function getBoardColorForSide(side) {
    return (side === 'back' && isDoubleSidedConfiguration()) ? (selectedBackColor || selectedColor || 'white') : (selectedColor || 'white');
  }

  function getCurrentBoardColor() {
    return getBoardColorForSide(currentSide);
  }

  function normalizeCategoryName(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'u')
      .replace(/ß/g, 'ss')
      .replace(/\s+/g, ' ');
  }

  function normalizeToolVariantBaseName(value) {
    var normalized = normalizeCategoryName(value);
    try {
      normalized = normalized.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    } catch (e) { }
    return normalized
      .replace(/\b(weiss|weis|white|schwarz|black|blau|blue|rot|red|gruen|grun|green|gelb|yellow)\b/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeOptionKey(value) {
    return String(value || '').trim().toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9_-]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
  }

  function normalizeHexColor(value, fallback) {
    var hex = String(value || '').trim();
    return /^#[0-9a-f]{6}$/i.test(hex) ? hex.toLowerCase() : fallback;
  }

  function clampCmykComponent(value) {
    var num = Math.round(Number(value));
    if (!isFinite(num)) return 0;
    return Math.max(0, Math.min(100, num));
  }

  function normalizeCmyk(value, fallback) {
    var source = value && typeof value === 'object' ? value : {};
    var fb = fallback && typeof fallback === 'object' ? fallback : {};
    return {
      c: clampCmykComponent(source.c != null ? source.c : fb.c),
      m: clampCmykComponent(source.m != null ? source.m : fb.m),
      y: clampCmykComponent(source.y != null ? source.y : fb.y),
      k: clampCmykComponent(source.k != null ? source.k : fb.k)
    };
  }

  function cmykToHex(cmyk) {
    var c = clampCmykComponent(cmyk && cmyk.c) / 100;
    var m = clampCmykComponent(cmyk && cmyk.m) / 100;
    var y = clampCmykComponent(cmyk && cmyk.y) / 100;
    var k = clampCmykComponent(cmyk && cmyk.k) / 100;
    var rgb = [
      Math.round(255 * (1 - c) * (1 - k)),
      Math.round(255 * (1 - m) * (1 - k)),
      Math.round(255 * (1 - y) * (1 - k))
    ];
    return '#' + rgb.map(function (component) {
      return component.toString(16).padStart(2, '0');
    }).join('');
  }

  function hexToCmyk(hex) {
    var normalized = normalizeHexColor(hex, '#000000');
    var r = parseInt(normalized.slice(1, 3), 16) / 255;
    var g = parseInt(normalized.slice(3, 5), 16) / 255;
    var b = parseInt(normalized.slice(5, 7), 16) / 255;
    var k = 1 - Math.max(r, g, b);
    if (k >= 1) return { c: 0, m: 0, y: 0, k: 100 };
    return {
      c: clampCmykComponent(((1 - r - k) / (1 - k)) * 100),
      m: clampCmykComponent(((1 - g - k) / (1 - k)) * 100),
      y: clampCmykComponent(((1 - b - k) / (1 - k)) * 100),
      k: clampCmykComponent(k * 100)
    };
  }

  function cmykToLabel(cmyk) {
    cmyk = normalizeCmyk(cmyk);
    return 'CMYK ' + cmyk.c + '/' + cmyk.m + '/' + cmyk.y + '/' + cmyk.k;
  }

  function normalizeOrderedSettingsList(list, fallback, normalizer) {
    var source = Array.isArray(list) && list.length ? list : fallback;
    var seen = {};
    return source.map(function (item, index) {
      return normalizer(item, index);
    }).filter(function (item) {
      if (!item || !item.key || seen[item.key]) return false;
      seen[item.key] = true;
      return true;
    }).sort(function (a, b) {
      return a.order - b.order || String(a.label || a.title || a.key).localeCompare(String(b.label || b.title || b.key), 'de');
    }).map(function (item, index) {
      item.order = index;
      return item;
    });
  }

  function normalizeSizeOptions(list) {
    return normalizeOrderedSettingsList(list, SIZE_OPTION_DEFAULTS, function (item, index) {
      var widthMm = Math.round(Number(item && item.widthMm));
      var heightMm = Math.round(Number(item && item.heightMm));
      var key = normalizeOptionKey(item && item.key) || (widthMm > 0 && heightMm > 0 ? widthMm + 'x' + heightMm : '');
      if (!key || widthMm <= 0 || heightMm <= 0) return null;
      return {
        key: key,
        widthMm: widthMm,
        heightMm: heightMm,
        label: String((item && item.label) || (widthMm + ' × ' + heightMm)).trim(),
        unit: String((item && item.unit) || 'mm').trim() || 'mm',
        visible: !(item && item.visible === false),
        order: Number.isFinite(Number(item && item.order)) ? Number(item.order) : index
      };
    });
  }

  function getSizeOptionKey(item) {
    if (!item) return '';
    return normalizeOptionKey(item.key) || (Math.round(Number(item.widthMm)) + 'x' + Math.round(Number(item.heightMm)));
  }

  function migrateSizeOptionOrder(list, version) {
    if (!Array.isArray(list) || Number(version || 1) >= 7) return list;

    var preferredOrder = ['700x500', '500x700', '800x1900', '1000x1900', '1210x1900', '1600x1900'];
    var source = list.slice();
    preferredOrder.forEach(function (key) {
      var hasSize = source.some(function (item) { return getSizeOptionKey(item) === key; });
      var fallback = SIZE_OPTION_DEFAULTS.find(function (item) { return item.key === key; });
      if (!hasSize && fallback) source.push(Object.assign({}, fallback));
    });

    var used = {};
    var ordered = [];
    preferredOrder.forEach(function (key) {
      var match = source.find(function (item) {
        return !used[getSizeOptionKey(item)] && getSizeOptionKey(item) === key;
      });
      if (match) {
        used[key] = true;
        ordered.push(match);
      }
    });
    source.forEach(function (item) {
      var key = getSizeOptionKey(item);
      if (!used[key]) {
        used[key] = true;
        ordered.push(item);
      }
    });
    return ordered.map(function (item, index) {
      return Object.assign({}, item, { order: index });
    });
  }

  function normalizeColorOptions(list) {
    var colorFallbacks = Object.keys(COLOR_MAP).map(function (key, index) {
      return { key: key, label: COLOR_MAP[key].label, hex: COLOR_MAP[key].hex, border: COLOR_MAP[key].border, visible: true, order: index };
    });
    return normalizeOrderedSettingsList(list, colorFallbacks, function (item, index) {
      var key = normalizeOptionKey(item && item.key);
      if (!key) return null;
      var fallback = colorFallbacks.find(function (color) { return color.key === key; }) || {};
      var normalizedHex = normalizeHexColor(item && item.hex, fallback.hex || '#e2e8f0');
      if (isLegacyDefaultColorHex(key, normalizedHex)) {
        normalizedHex = fallback.hex || normalizedHex;
      }
      var normalizedBorder = normalizeHexColor(item && item.border, fallback.border || fallback.hex || '#cbd5e0');
      if (isLegacyDefaultColorHex(key, normalizedBorder)) {
        normalizedBorder = fallback.border || fallback.hex || normalizedBorder;
      }
      return {
        key: key,
        label: String((item && item.label) || fallback.label || key).trim(),
        hex: normalizedHex,
        border: normalizedBorder,
        visible: !(item && item.visible === false),
        order: Number.isFinite(Number(item && item.order)) ? Number(item.order) : index
      };
    });
  }

  function isLegacyDefaultColorHex(key, hex) {
    var normalized = normalizeHexColor(hex, '').toLowerCase();
    var legacy = LEGACY_DEFAULT_COLOR_HEX[key];
    if (!normalized || !legacy) return false;
    return (Array.isArray(legacy) ? legacy : [legacy]).some(function (item) {
      return normalizeHexColor(item, '').toLowerCase() === normalized;
    });
  }

  function normalizeTextColorOptions(list) {
    return normalizeOrderedSettingsList(list, TEXT_COLOR_DEFAULTS, function (item, index) {
      var key = normalizeOptionKey(item && item.key);
      if (!key) return null;
      var fallback = TEXT_COLOR_DEFAULTS.find(function (color) { return color.key === key; }) || {};
      var cmyk = normalizeCmyk(item && item.cmyk, fallback.cmyk || { c: 0, m: 0, y: 0, k: 100 });
      return {
        key: key,
        label: String((item && item.label) || fallback.label || key).trim(),
        hex: normalizeHexColor(item && item.hex, fallback.hex || cmykToHex(cmyk)),
        cmyk: cmyk,
        visible: !(item && item.visible === false),
        order: Number.isFinite(Number(item && item.order)) ? Number(item.order) : index
      };
    });
  }

  function normalizeQuantityDiscountOptions(list) {
    return normalizeOrderedSettingsList(list, QUANTITY_DISCOUNT_DEFAULTS, function (item, index) {
      var minQuantity = Math.round(Number(item && item.minQuantity));
      var percent = Number(item && item.percent);
      var key = normalizeOptionKey(item && item.key) || (minQuantity > 0 ? 'qty-' + minQuantity : '');
      if (!key || minQuantity < 1 || !isFinite(percent) || percent <= 0) return null;
      var fallback = QUANTITY_DISCOUNT_DEFAULTS.find(function (discount) { return discount.key === key; }) || {};
      return {
        key: key,
        label: String((item && item.label) || fallback.label || ('ab ' + minQuantity + ' Stück')).trim(),
        minQuantity: Math.max(1, Math.min(999, minQuantity)),
        percent: Math.max(0, Math.min(100, percent)),
        discountCode: String((item && item.discountCode) || fallback.discountCode || '').trim(),
        visible: !(item && item.visible === false),
        order: Number.isFinite(Number(item && item.order)) ? Number(item.order) : index
      };
    });
  }

  function normalizeMountingOptions(list) {
    var allowed = MOUNTING_OPTION_DEFAULTS.map(function (item) { return item.key; });
    return normalizeOrderedSettingsList(list, MOUNTING_OPTION_DEFAULTS, function (item, index) {
      var key = normalizeOptionKey(item && item.key);
      if (allowed.indexOf(key) === -1) return null;
      var fallback = MOUNTING_OPTION_DEFAULTS.find(function (mounting) { return mounting.key === key; }) || {};
      var meta = Array.isArray(item && item.meta) ? item.meta : fallback.meta;
      return {
        key: key,
        eyebrow: String((item && item.eyebrow) || fallback.eyebrow || key).trim(),
        title: String((item && item.title) || fallback.title || key).trim(),
        description: String((item && item.description) || fallback.description || '').trim(),
        meta: (meta || []).map(function (text) { return String(text || '').trim(); }).filter(Boolean),
        visible: !(item && item.visible === false),
        order: Number.isFinite(Number(item && item.order)) ? Number(item.order) : index
      };
    });
  }

  function normalizeConfiguratorTextSettings(texts) {
    texts = texts && typeof texts === 'object' ? texts : {};
    return Object.keys(CONFIGURATOR_TEXT_DEFAULTS).reduce(function (result, key) {
      var value = String(texts[key] == null ? CONFIGURATOR_TEXT_DEFAULTS[key] : texts[key]).trim();
      result[key] = value || CONFIGURATOR_TEXT_DEFAULTS[key];
      return result;
    }, {});
  }

  function normalizeCategorySelection(value, allowed, fallback) {
    var source = Array.isArray(value) ? value : fallback;
    return (Array.isArray(source) ? source : []).filter(function (item, index, list) {
      return allowed.indexOf(item) !== -1 && list.indexOf(item) === index;
    });
  }

  function normalizeConfiguratorSettingsPayload(data) {
    data = data && typeof data === 'object' ? data : {};
    var defaults = data.defaults && typeof data.defaults === 'object' ? data.defaults : {};
    var texts = data.texts && typeof data.texts === 'object' ? data.texts : {};
    var finalize = data.finalize && typeof data.finalize === 'object' ? data.finalize : {};
    var categories = Array.isArray(data.categories) ? data.categories : [];
    var addonOrder = Array.isArray(finalize.addonOrder) ? finalize.addonOrder.filter(function (key, index, arr) {
      return FINALIZE_ADDON_DEFAULT_ORDER.indexOf(key) !== -1 && arr.indexOf(key) === index;
    }) : [];

    FINALIZE_ADDON_DEFAULT_ORDER.forEach(function (key) {
      if (addonOrder.indexOf(key) === -1) addonOrder.push(key);
    });

    return {
      defaults: {
        surfaceType: defaults.surfaceType === 'basic' ? 'basic' : 'premium',
        holderType: defaults.holderType === 'rubber' ? 'rubber' : 'stainless'
      },
      texts: normalizeConfiguratorTextSettings(texts),
      categories: categories.map(function (cat, index) {
        var name = String(cat && cat.name || '').trim();
        if (!name) return null;
        return {
          name: name,
          parentName: String(cat && cat.parentName || '').trim() || null,
          order: Number.isFinite(Number(cat.order)) ? Number(cat.order) : index,
          visible: cat.visible !== false,
          scalable: cat.scalable === true,
          configurators: normalizeCategorySelection(cat.configurators, CONFIGURATOR_MODES, ['shadow-board']),
          brands: normalizeCategorySelection(cat.brands, TOOL_BRANDS, TOOL_BRANDS)
        };
      }).filter(Boolean).sort(function (a, b) {
        return a.order - b.order || a.name.localeCompare(b.name, 'de');
      }),
      sizes: normalizeSizeOptions(migrateSizeOptionOrder(data.sizes, data.version)),
      colors: normalizeColorOptions(data.colors),
      textColors: normalizeTextColorOptions(data.textColors),
      quantityDiscounts: normalizeQuantityDiscountOptions(data.quantityDiscounts),
      mounting: normalizeMountingOptions(data.mounting),
      finalize: {
        addonOrder: addonOrder
      }
    };
  }

  function getConfiguredCategoryMeta(category) {
    var normalized = normalizeCategoryName(category);
    if (!normalized || !configuratorSettings || !Array.isArray(configuratorSettings.categories)) return null;
    return configuratorSettings.categories.find(function (cat) {
      return normalizeCategoryName(cat.name) === normalized;
    }) || null;
  }

  function isToolCategoryVisible(category) {
    var meta = getConfiguredCategoryMeta(category);
    if (!meta) return configuratorMode === 'shadow-board';
    if (meta.configurators.indexOf(configuratorMode) === -1) return false;
    if (configuratorMode === 'tool-wall' && (!selectedToolBrand || meta.brands.indexOf(selectedToolBrand) === -1)) {
      return false;
    }

    var visited = {};
    while (meta) {
      var key = normalizeCategoryName(meta.name);
      if (!key || visited[key]) return false;
      visited[key] = true;
      if (meta.visible === false) return false;
      meta = meta.parentName ? getConfiguredCategoryMeta(meta.parentName) : null;
    }
    return true;
  }

  function isToolWallMode() {
    return configuratorMode === 'tool-wall';
  }

  function getToolBrandLabel(brand) {
    return brand === 'wuerth' ? 'Würth' : brand === 'gedore' ? 'Gedore' : '';
  }

  function getToolBrandChoiceLabel() {
    return HAS_WUERTH_ACCESS ? 'Gedore oder Würth' : 'Gedore';
  }

  function canContinueFromSizeStep() {
    return !!selectedSize && !!selectedProduct && (!isToolWallMode() || (
      selectedSizeIsCustom && TOOL_BRANDS.indexOf(selectedToolBrand) !== -1
    ));
  }

  function updateSizeStepNextState() {
    var nextBtn = document.querySelector('#sbc-step-1 .sbc-btn-next');
    if (nextBtn) nextBtn.disabled = !canContinueFromSizeStep();
    if (typeof updateCanvasNextButtonState === 'function') updateCanvasNextButtonState();
  }

  function syncToolBrandPicker() {
    var picker = document.getElementById('sbc-tool-brand-picker');
    if (picker) picker.hidden = !isToolWallMode();

    $$('.sbc-tool-brand-option').forEach(function (button) {
      var selected = isToolWallMode() && button.dataset.toolBrand === selectedToolBrand;
      button.classList.toggle('sbc-tool-brand-option--selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  function applyConfiguratorModeUi() {
    if (_root) _root.dataset.configuratorMode = configuratorMode;

    var eyebrow = document.getElementById('sbc-configurator-eyebrow');
    var title = document.getElementById('sbc-configurator-title');
    var sizeTitle = document.getElementById('sbc-size-step-title');
    var sizeDescription = document.getElementById('sbc-size-step-description');
    var designTitle = document.getElementById('sbc-design-step-title');
    var designDescription = document.getElementById('sbc-design-step-description');
    var switchLabel = document.getElementById('sbc-configurator-switch-label');
    var switchHint = document.getElementById('sbc-configurator-switch-hint');

    if (isToolWallMode()) {
      if (eyebrow) eyebrow.textContent = 'Werkzeugwand-Konfigurator';
      if (title) title.textContent = 'Deine Werkzeugwand nach Maß';
      if (sizeTitle) sizeTitle.textContent = 'Hersteller und Größe wählen';
      if (sizeDescription) sizeDescription.textContent = 'Wähle ' + getToolBrandChoiceLabel() + ' und gib dein individuelles Sondermaß ein.';
      if (designTitle) designTitle.textContent = 'Werkzeugwand gestalten';
      if (designDescription) designDescription.textContent = selectedToolBrand
        ? 'Platziere ' + getToolBrandLabel(selectedToolBrand) + '-Werkzeuge, Logos und Texte.'
        : 'Platziere deine Werkzeuge, Logos und Texte.';
      if (switchLabel) switchLabel.textContent = 'Reinigungswand gestalten';
      if (switchHint) switchHint.textContent = 'Zurück zum normalen Konfigurator';
      selectedMounting = 'wall';
      selectedMountingSides = 1;
    } else {
      if (eyebrow) eyebrow.textContent = '5S-Schattenwand-Konfigurator';
      if (title) title.textContent = 'In unter 3 Minuten zur fertigen Lösung';
      if (sizeTitle) sizeTitle.textContent = 'Größe wählen';
      if (sizeDescription) sizeDescription.textContent = 'Wähle die passende Größe für deine Schattenwand.';
      if (designTitle) designTitle.textContent = 'Gestalten';
      if (designDescription) designDescription.textContent = 'Platziere Werkzeuge, Logos und Texte';
      if (switchLabel) switchLabel.textContent = 'Werkzeugwand gestalten';
      if (switchHint) switchHint.textContent = HAS_WUERTH_ACCESS
        ? 'Sondermaß mit Gedore- oder Würth-Werkzeugen'
        : 'Sondermaß mit Gedore-Werkzeugen';
    }

    $$('.sbc-size-option').forEach(function (button) {
      if (button.dataset.customSize === 'true') return;
      button.hidden = isToolWallMode() || !isSizeOptionVisible(button.dataset.w, button.dataset.h);
    });

    syncToolBrandPicker();
    updateSizeStepNextState();
    if (typeof updateWizardProgressUi === 'function') updateWizardProgressUi(currentStep);
    if (typeof renderToolsFiltered === 'function') renderToolsFiltered();
  }

  function setConfiguratorModeState(mode, toolBrand) {
    configuratorMode = mode === 'tool-wall' ? 'tool-wall' : 'shadow-board';
    selectedToolBrand = configuratorMode === 'tool-wall' && TOOL_BRANDS.indexOf(toolBrand) !== -1 ? toolBrand : '';
    try {
      var url = new URL(window.location.href);
      if (configuratorMode === 'tool-wall') {
        url.searchParams.set('configurator', 'tool-wall');
        if (selectedToolBrand) url.searchParams.set('tool_brand', selectedToolBrand);
        else url.searchParams.delete('tool_brand');
      } else {
        url.searchParams.delete('configurator');
        url.searchParams.delete('tool_brand');
      }
      window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
    } catch (e) { /* URL bleibt notfalls unverändert */ }
    applyConfiguratorModeUi();
  }

  function bindConfiguratorModeControls() {
    var switchButton = document.getElementById('sbc-configurator-switch');
    if (switchButton) {
      switchButton.addEventListener('click', function () {
        var nextMode = isToolWallMode() ? 'shadow-board' : 'tool-wall';
        var url = new URL(window.location.href);
        ['draft', 'sbc_draft', 'designId', 'backDesignId', 'back', 'save', 'sbc_auto_save'].forEach(function (param) {
          url.searchParams.delete(param);
        });
        if (nextMode === 'tool-wall') {
          url.searchParams.set('configurator', 'tool-wall');
          url.searchParams.delete('tool_brand');
        } else {
          url.searchParams.delete('configurator');
          url.searchParams.delete('tool_brand');
        }
        window.location.assign(url.toString());
      });
    }

    $$('.sbc-tool-brand-option').forEach(function (button) {
      button.addEventListener('click', function () {
        var brand = button.dataset.toolBrand;
        if (!isToolWallMode() || TOOL_BRANDS.indexOf(brand) === -1 || brand === selectedToolBrand) return;

        var placedTools = canvas ? canvas.getObjects().filter(function (obj) {
          return obj && obj.objectType === 'shadow-tool';
        }) : [];
        if (placedTools.length && !window.confirm('Beim Wechsel des Herstellers werden die bereits platzierten Werkzeuge entfernt. Fortfahren?')) {
          return;
        }
        placedTools.forEach(function (obj) { canvas.remove(obj); });
        selectedToolBrand = brand;

        try {
          var url = new URL(window.location.href);
          url.searchParams.set('configurator', 'tool-wall');
          url.searchParams.set('tool_brand', brand);
          window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
        } catch (e) { /* URL bleibt notfalls unverändert */ }

        applyConfiguratorModeUi();
        if (canvas) {
          canvas.discardActiveObject();
          canvas.requestRenderAll();
          syncCanvasUi();
          saveState(true);
        }
        trackEvent('tool_brand_selected', { brand: brand });
      });
    });
  }

  function sortToolCategoryNames(categoryNames) {
    var settings = (configuratorSettings && Array.isArray(configuratorSettings.categories)) ? configuratorSettings.categories : [];
    var orderMap = {};
    settings.forEach(function (cat, index) {
      orderMap[normalizeCategoryName(cat.name)] = Number.isFinite(Number(cat.order)) ? Number(cat.order) : index;
    });

    return categoryNames.slice().sort(function (a, b) {
      var aKey = normalizeCategoryName(a);
      var bKey = normalizeCategoryName(b);
      var aOrder = Object.prototype.hasOwnProperty.call(orderMap, aKey) ? orderMap[aKey] : 9999;
      var bOrder = Object.prototype.hasOwnProperty.call(orderMap, bKey) ? orderMap[bKey] : 9999;
      return aOrder - bOrder || a.localeCompare(b, 'de');
    });
  }

  function getConfiguredSizeOptions() {
    return normalizeSizeOptions(configuratorSettings && configuratorSettings.sizes);
  }

  function getSizeOptionMeta(widthMm, heightMm) {
    var key = getSizeKey(widthMm, heightMm);
    return getConfiguredSizeOptions().find(function (size) {
      return size.key === key || (Number(size.widthMm) === Number(widthMm) && Number(size.heightMm) === Number(heightMm));
    }) || null;
  }

  function isSizeOptionVisible(widthMm, heightMm) {
    var meta = getSizeOptionMeta(widthMm, heightMm);
    return meta ? meta.visible !== false : true;
  }

  function sortSizeOptionButtons(buttons) {
    return buttons.slice().sort(function (a, b) {
      var aMeta = getSizeOptionMeta(a.dataset.w, a.dataset.h);
      var bMeta = getSizeOptionMeta(b.dataset.w, b.dataset.h);
      var aOrder = aMeta ? aMeta.order : 9999;
      var bOrder = bMeta ? bMeta.order : 9999;
      return aOrder - bOrder;
    });
  }

  function getConfiguredColorOptions() {
    return normalizeColorOptions(configuratorSettings && configuratorSettings.colors);
  }

  function getConfiguredTextColors() {
    return normalizeTextColorOptions(configuratorSettings && configuratorSettings.textColors)
      .filter(function (color) { return color.visible !== false; });
  }

  function getDefaultTextColorForCurrentBoard() {
    var boardColor = normalizeBoardColorKey(getCurrentBoardColor(), 'white');
    var desiredKey = boardColor === 'white' ? 'black' : 'white';
    var configured = getConfiguredTextColors().find(function (color) {
      return color.key === desiredKey;
    });
    return configured ||
      TEXT_COLOR_DEFAULTS.find(function (color) { return color.key === desiredKey; }) ||
      getConfiguredTextColors()[0] ||
      TEXT_COLOR_DEFAULTS[0];
  }

  function findTextColorByHex(hex) {
    var normalized = normalizeHexColor(hex, '').toLowerCase();
    if (!normalized) return null;
    return getConfiguredTextColors().find(function (color) {
      return normalizeHexColor(color.hex, '').toLowerCase() === normalized;
    }) || null;
  }

  function getColorMeta(color) {
    var key = normalizeOptionKey(color);
    return getConfiguredColorOptions().find(function (item) {
      return item.key === key;
    }) || COLOR_MAP[key] || { label: color || 'Spezial', hex: '#e2e8f0', border: '#cbd5e0', visible: true, order: 9999 };
  }

  function isKnownColorKey(color) {
    var key = normalizeOptionKey(color);
    return !!getConfiguredColorOptions().find(function (item) {
      return item.key === key;
    }) || !!COLOR_MAP[key];
  }

  function isColorOptionVisible(color) {
    var meta = getColorMeta(color);
    return meta ? meta.visible !== false : true;
  }

  function sortColorKeys(colors) {
    return colors.slice().sort(function (a, b) {
      var aMeta = getColorMeta(a);
      var bMeta = getColorMeta(b);
      var aOrder = Number.isFinite(Number(aMeta.order)) ? Number(aMeta.order) : 9999;
      var bOrder = Number.isFinite(Number(bMeta.order)) ? Number(bMeta.order) : 9999;
      return aOrder - bOrder || String(aMeta.label || a).localeCompare(String(bMeta.label || b), 'de');
    });
  }

  function getMountingOptionMeta(key) {
    var normalized = normalizeOptionKey(key);
    var options = normalizeMountingOptions(configuratorSettings && configuratorSettings.mounting);
    return options.find(function (item) { return item.key === normalized; }) || null;
  }

  function isMountingOptionVisible(key) {
    var meta = getMountingOptionMeta(key);
    return meta ? meta.visible !== false : true;
  }

  function sortMountingOptionElements(elements) {
    return elements.slice().sort(function (a, b) {
      var aMeta = getMountingOptionMeta(a.dataset.mounting);
      var bMeta = getMountingOptionMeta(b.dataset.mounting);
      var aOrder = aMeta ? aMeta.order : 9999;
      var bOrder = bMeta ? bMeta.order : 9999;
      return aOrder - bOrder;
    });
  }

  function getConfiguratorText(key, fallback) {
    return (configuratorSettings && configuratorSettings.texts && configuratorSettings.texts[key]) || fallback;
  }

  function applyConfiguratorTextContent() {
    $$('[data-configurator-text]').forEach(function (el) {
      var key = el.dataset.configuratorText;
      if (!key) return;
      el.textContent = getConfiguratorText(key, CONFIGURATOR_TEXT_DEFAULTS[key] || el.textContent || '');
    });
  }

  function getFinalizeAddonOrder() {
    var order = configuratorSettings && configuratorSettings.finalize && Array.isArray(configuratorSettings.finalize.addonOrder)
      ? configuratorSettings.finalize.addonOrder.slice()
      : [];
    FINALIZE_ADDON_DEFAULT_ORDER.forEach(function (key) {
      if (order.indexOf(key) === -1) order.push(key);
    });
    return order.filter(function (key, index, arr) {
      return FINALIZE_ADDON_DEFAULT_ORDER.indexOf(key) !== -1 && arr.indexOf(key) === index;
    });
  }

  function getSelectedFinalizeAddonKeys() {
    return getFinalizeAddonOrder().filter(function (key) {
      return !!(selectedFinalizeAddons && selectedFinalizeAddons[key]);
    });
  }

  function applyFinalizeAddonOrder() {
    var order = getFinalizeAddonOrder();
    var firstCard = document.querySelector('[data-final-addon-card]');
    var parent = firstCard ? firstCard.parentElement : null;
    if (!parent) return;

    order.forEach(function (key) {
      var card = parent.querySelector('[data-final-addon-card="' + key + '"]');
      if (card) parent.appendChild(card);
    });
  }

  function applySizeOptionSettings() {
    var grid = document.querySelector('.sbc-size-grid');
    if (!grid) return;

    getConfiguredSizeOptions().forEach(function (size) {
      var existing = grid.querySelector('.sbc-size-option[data-w="' + size.widthMm + '"][data-h="' + size.heightMm + '"]');
      if (existing) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sbc-size-option';
      btn.dataset.w = String(size.widthMm);
      btn.dataset.h = String(size.heightMm);
      btn.innerHTML =
        '<span class="sbc-size-option__copy">' +
        '<span class="sbc-size-option__dims"></span>' +
        '<span class="sbc-size-option__unit"></span>' +
        '<span class="sbc-size-option__price"></span>' +
        '</span>';
      btn.addEventListener('click', function () { selectSizeOption(btn); });
      grid.appendChild(btn);
    });

    sortSizeOptionButtons(Array.prototype.slice.call(grid.querySelectorAll('.sbc-size-option'))).forEach(function (btn) {
      var meta = getSizeOptionMeta(btn.dataset.w, btn.dataset.h);
      if (meta) {
        var dims = btn.querySelector('.sbc-size-option__dims');
        var unit = btn.querySelector('.sbc-size-option__unit');
        if (dims) dims.textContent = meta.label;
        if (unit) unit.textContent = meta.unit || 'mm';
      }
      btn.hidden = btn.dataset.customSize !== 'true' && (isToolWallMode() || (meta ? meta.visible === false : false));
      grid.appendChild(btn);
    });
  }

  function applyMountingOptionSettings() {
    var grid = document.querySelector('.sbc-mounting-grid');
    if (!grid) return;

    sortMountingOptionElements(Array.prototype.slice.call(grid.querySelectorAll('.sbc-mounting-option'))).forEach(function (option) {
      var key = option.dataset.mounting;
      var meta = getMountingOptionMeta(key);
      if (meta) {
        var eyebrow = option.querySelector('.sbc-mounting-option__eyebrow');
        var title = option.querySelector('.sbc-mounting-option__title');
        var metaEls = option.querySelectorAll('.sbc-mounting-option__meta');
        if (eyebrow) eyebrow.textContent = meta.eyebrow;
        if (title) title.textContent = meta.title;
        metaEls.forEach(function (el, index) {
          el.textContent = meta.meta[index] || meta.description || '';
          el.hidden = !el.textContent;
        });
      }
      grid.appendChild(option);
    });
  }

  async function loadConfiguratorSettings() {
    if (!CFG.backendUrl) return null;
    try {
      var res = await fetch(CFG.backendUrl.replace(/\/+$/, '') + '/api/configurator-settings', {
        headers: { 'ngrok-skip-browser-warning': 'true' }
      });
      if (!res.ok) throw new Error(res.statusText || ('HTTP ' + res.status));
      var data = await res.json();
      configuratorSettings = normalizeConfiguratorSettingsPayload(data);

      if (!configuratorDefaultsApplied) {
        selectedSurfaceType = configuratorSettings.defaults.surfaceType;
        selectedHolderType = configuratorSettings.defaults.holderType;
        configuratorDefaultsApplied = true;
      }

      applyConfiguratorSettings();
      return configuratorSettings;
    } catch (err) {
      console.warn('[SBC] Konfigurator-Einstellungen konnten nicht geladen werden:', err.message);
      configuratorSettings = normalizeConfiguratorSettingsPayload(configuratorSettings);
      return null;
    }
  }

  function applyConfiguratorSettings() {
    applyConfiguratorTextContent();
    applyFinalizeAddonOrder();
    applySizeOptionSettings();
    applyMountingOptionSettings();
    applyConfiguratorModeUi();

    var finalizeNote = document.getElementById('sbc-finalize-note');
    if (finalizeNote) {
      finalizeNote.textContent = getConfiguratorText('finalizeNote', CONFIGURATOR_TEXT_DEFAULTS.finalizeNote);
    }

    if (selectedSize || selectedProduct) {
      syncSelectedProductForSurface({ fallbackToBasic: true });
    }

    if (typeof renderToolsFiltered === 'function') renderToolsFiltered();
    if (typeof renderTextColorSwatches === 'function') renderTextColorSwatches();
    if (typeof updateColorOptions === 'function') updateColorOptions();
    if (typeof updateMountingStepUi === 'function') updateMountingStepUi();
    if (typeof prefillSizePrices === 'function') prefillSizePrices();
    if (canvas && typeof updateSurfaceStepUi === 'function') updateSurfaceStepUi();
    if (canvas && typeof updateFinalizeStepUi === 'function') updateFinalizeStepUi();
    if (canvas && typeof updateTotalPrice === 'function') updateTotalPrice();
  }

  function isScalableToolCategory(category) {
    var meta = getConfiguredCategoryMeta(category);
    if (meta) return meta.scalable === true;
    var normalized = normalizeCategoryName(category);
    return normalized === SCALABLE_TOOL_CATEGORY || normalized === 'ueberschriften und symbole';
  }

  function isScalableShadowTool(obj) {
    if (!obj || obj.objectType !== 'shadow-tool') return false;
    if (obj.sbcScalable === true) return true;
    var category = obj.toolCategory || (getToolById(obj.toolId) || {}).category || '';
    return isScalableToolCategory(category);
  }

  function getMountingLabel() {
    var meta = getMountingOptionMeta(selectedMounting);
    return (meta && meta.title) || (selectedMounting === 'stand' ? 'Standgestell' : selectedMounting === 'trolley' ? 'Rollwagen' : 'Wandmontage');
  }

  function getSidesLabel() {
    return (selectedMounting !== 'wall' && selectedMountingSides === 2) ? 'Beidseitig gestaltet' : '1 Seite gestaltet';
  }

  function getSurfaceLabel() {
    return selectedSurfaceType === 'premium' ? 'Premium' : 'Basic';
  }

  function getSelectedQuantity() {
    var qty = parseInt(selectedQuantity, 10);
    if (!isFinite(qty) || qty < 1) qty = 1;
    if (qty > 999) qty = 999;
    return qty;
  }

  function getPlacedShadowToolCount() {
    return getRelevantDesignObjects().filter(function (obj) {
      return obj && obj.objectType === 'shadow-tool';
    }).length;
  }

  function getFinalizationEntryQuantity(entry) {
    var boardQuantity = getSelectedQuantity();
    if (entry && entry.group === 'holder') {
      if (entry.holderCount != null) return entry.holderCount * boardQuantity;
      return Math.max(1, getPlacedShadowToolCount()) * boardQuantity;
    }
    return boardQuantity;
  }

  function getFinalizeProducts(group) {
    return (FINALIZE_PRODUCTS && Array.isArray(FINALIZE_PRODUCTS[group])) ? FINALIZE_PRODUCTS[group] : [];
  }

  function getFinalizeProduct(group, key) {
    return getFinalizeProducts(group).find(function (item) {
      return item && item.key === key;
    }) || null;
  }

  function getFinalizeVariant(item) {
    if (!item || !item.productId || !Array.isArray(item.variants) || item.variants.length === 0) return null;
    return item.variants.find(function (variant) { return variant.available !== false; }) || item.variants[0];
  }

  function isFinalizeProductAvailable(item) {
    return !!(item && item.productId && getFinalizeVariant(item));
  }

  function getFinalizeProductName(item) {
    if (!item) return '';
    return String(item.label || item.title || 'Zusatzartikel').trim();
  }

  function getFinalizeTextPrefix(itemOrPrefix) {
    var value = typeof itemOrPrefix === 'string' ? itemOrPrefix : (itemOrPrefix && itemOrPrefix.key);
    var map = {
      stainless: 'holder-stainless',
      rubber: 'holder-rubber',
      dowels: 'addon-dowels',
      adhesive: 'addon-adhesive',
      spacers: 'addon-spacers',
      magnets: 'addon-magnets',
      silicone: 'addon-silicone'
    };
    return map[value] || value || '';
  }

  function getFinalizeTextOverride(prefix, field, fallback) {
    var map = {
      'holder-stainless': {
        title: 'finalizeHolderStainlessTitle',
        description: 'finalizeHolderStainlessDescription'
      },
      'holder-rubber': {
        title: 'finalizeHolderRubberTitle',
        description: 'finalizeHolderRubberDescription'
      },
      'addon-dowels': {
        title: 'finalizeAddonDowelTitle',
        description: 'finalizeAddonDowelDescription'
      },
      'addon-adhesive': {
        title: 'finalizeAddonAdhesiveTitle',
        description: 'finalizeAddonAdhesiveDescription'
      },
      'addon-spacers': {
        title: 'finalizeAddonSpacersTitle',
        description: 'finalizeAddonSpacersDescription'
      },
      'addon-magnets': {
        title: 'finalizeAddonMagnetsTitle',
        description: 'finalizeAddonMagnetsDescription'
      },
      'addon-silicone': {
        title: 'finalizeAddonSiliconeTitle',
        description: 'finalizeAddonSiliconeDescription'
      }
    };
    var key = map[prefix] && map[prefix][field];
    return key ? getConfiguratorText(key, fallback) : fallback;
  }

  function getFinalizeProductLabel(item) {
    if (!item) return '';
    var fallback = String(item.label || item.title || 'Zusatzartikel').trim();
    return getFinalizeTextOverride(getFinalizeTextPrefix(item), 'title', fallback);
  }

  function getSelectedHolderProduct() {
    return getFinalizeProduct('holders', selectedHolderType);
  }

  function getSelectedHolderLabel() {
    return getFinalizeProductLabel(getSelectedHolderProduct()) || 'Halterung';
  }

  function getSelectedFinalizeAddonProducts() {
    return getSelectedFinalizeAddonKeys().map(function (key) {
      return selectedFinalizeAddons[key] ? getFinalizeProduct('addons', key) : null;
    }).filter(function (item) {
      return isFinalizeProductAvailable(item);
    });
  }

  function normalizeFinalizeSelection() {
    var selectedHolder = getSelectedHolderProduct();
    if (!isFinalizeProductAvailable(selectedHolder)) {
      var firstAvailableHolder = getFinalizeProducts('holders').find(isFinalizeProductAvailable);
      if (firstAvailableHolder) selectedHolderType = firstAvailableHolder.key;
    }

    getFinalizeAddonOrder().forEach(function (key) {
      if (selectedFinalizeAddons[key] && !isFinalizeProductAvailable(getFinalizeProduct('addons', key))) {
        selectedFinalizeAddons[key] = false;
      }
    });
  }

  function getFinalizationValidationMessage() {
    normalizeFinalizeSelection();
    if (!isFinalizeProductAvailable(getSelectedHolderProduct())) {
      return getConfiguratorText('finalizeMissingHolderValidation', CONFIGURATOR_TEXT_DEFAULTS.finalizeMissingHolderValidation);
    }
    if (selectedHolderType === 'stainless') {
      try { getStainlessHolderEntries(getSelectedHolderProduct()); } catch (error) { return error.message; }
    }
    return '';
  }

  function getShadowHolderKind(obj) {
    var tool = getToolById(obj.toolId) || {};
    var name = String(tool.name || obj.toolName || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    var category = String(tool.category || '').toLowerCase();
    // Kehrschaufeln are dustpans, not the larger shovels with two suspension points.
    if (/kehrblech|kehrschaufel|handfeger|kehrgarnitur/.test(name)) return 'single';
    return /eimer|schaufel|rutschgefahr|warnschild/.test(name) || category === 'schaufel' ? 'double' : 'single';
  }

  function getStainlessHolderEntries(holder) {
    var counts = {single: 0, double: 0};
    getRelevantDesignObjects().filter(function(obj) {return obj && obj.objectType === 'shadow-tool';}).forEach(function(obj) {
      counts[getShadowHolderKind(obj)] += 1;
    });
    if (!counts.single && !counts.double) counts.single = 1;
    return ['single', 'double'].filter(function(kind) {return counts[kind] > 0;}).map(function(kind) {
      var pattern = kind === 'double' ? /zwei|doppel|2\s*haken/i : /ein\s*haken|einzel|1\s*haken/i;
      var variant = holder.variants.find(function(v) {return pattern.test(v.title || '') && v.available !== false;});
      if (!variant && kind === 'single') variant = holder.variants.find(function(v) {return v.title === 'Default Title' && v.available !== false;});
      if (!variant || Number(variant.price) !== 0) throw new Error('Die enthaltene Edelstahlhalterung ist gerade nicht verfügbar. Bitte kontaktiere uns.');
      return {group: 'holder', item: holder, variant: variant, holderKind: kind, holderCount: counts[kind]};
    });
  }

  function getFinalizationEntryLabel(entry) {
    return entry.holderKind ? 'Edelstahlhalterung – ' + (entry.holderKind === 'double' ? 'zwei Haken' : 'ein Haken') : getFinalizeProductLabel(entry.item);
  }

  function getFinalizationSelectedProducts() {
    normalizeFinalizeSelection();
    var items = [];
    var holder = getSelectedHolderProduct();
    if (isFinalizeProductAvailable(holder)) {
      if (selectedHolderType === 'stainless') {
        try { items = getStainlessHolderEntries(holder); } catch (error) { /* Submission validation reports the missing included holder. */ }
      }
      else items.push({ group: 'holder', item: holder, variant: getFinalizeVariant(holder) });
    }
    getSelectedFinalizeAddonProducts().forEach(function (addon) {
      items.push({ group: 'addon', item: addon, variant: getFinalizeVariant(addon) });
    });
    return items;
  }

  function getFinalizationTotalCents() {
    return getFinalizationSelectedProducts().reduce(function (sum, entry) {
      return sum + ((Number(entry.variant && entry.variant.price) || 0) * getFinalizationEntryQuantity(entry));
    }, 0);
  }

  function getQuantityDiscountOptions() {
    if (!QUANTITY_DISCOUNTS_ENABLED) return [];
    return normalizeQuantityDiscountOptions(configuratorSettings && configuratorSettings.quantityDiscounts)
      .filter(function (discount) { return discount.visible !== false; });
  }

  function getActiveQuantityDiscount() {
    var quantity = getSelectedQuantity();
    return getQuantityDiscountOptions().reduce(function (best, discount) {
      if (quantity < discount.minQuantity) return best;
      if (!best || discount.minQuantity > best.minQuantity || (discount.minQuantity === best.minQuantity && discount.percent > best.percent)) {
        return discount;
      }
      return best;
    }, null);
  }

  function getBoardBaseTotalCents() {
    var quantity = getSelectedQuantity();
    if (selectedMounting && selectedMounting !== 'wall') {
      return getMountingCost() * quantity;
    }
    return ((selectedVariant && selectedVariant.price) ? selectedVariant.price : 0) * quantity * getBoardPriceMultiplier();
  }

  function getQuantityDiscountCents() {
    if (!QUANTITY_DISCOUNTS_ENABLED) return 0;
    var discount = getActiveQuantityDiscount();
    if (!discount) return 0;
    return Math.round(getBoardBaseTotalCents() * (discount.percent / 100));
  }

  function getTotalPriceCents() {
    return Math.max(0, getBoardBaseTotalCents() - getQuantityDiscountCents()) + getFinalizationTotalCents();
  }

  function getQuantityDiscountSnapshot() {
    if (!QUANTITY_DISCOUNTS_ENABLED) return null;
    var discount = getActiveQuantityDiscount();
    var discountCents = getQuantityDiscountCents();
    if (!discount || discountCents <= 0) return null;
    return {
      key: discount.key,
      label: discount.label || ('ab ' + discount.minQuantity + ' Stück'),
      minQuantity: discount.minQuantity,
      percent: discount.percent,
      discountCode: discount.discountCode || '',
      amountCents: discountCents,
      amountLabel: formatEuroCents(discountCents, false)
    };
  }

  function formatDiscountPercent(percent) {
    var value = Number(percent || 0);
    return value.toLocaleString('de-DE', {
      minimumFractionDigits: value % 1 === 0 ? 0 : 1,
      maximumFractionDigits: 1
    });
  }

  function renderQuantityDiscountTable() {
    var el = document.getElementById('sbc-quantity-discounts');
    if (!el) return;
    var discounts = getQuantityDiscountOptions();
    if (!discounts.length) {
      el.hidden = true;
      el.innerHTML = '';
      return;
    }

    var active = getActiveQuantityDiscount();
    el.hidden = false;
    el.innerHTML = '<span class="sbc-quantity-discounts__title">Mengenrabatt</span>' +
      '<span class="sbc-quantity-discounts__items">' +
      discounts.map(function (discount) {
        var isActive = active && active.key === discount.key;
        return '<span class="sbc-quantity-discounts__item' + (isActive ? ' sbc-quantity-discounts__item--active' : '') + '">' +
          'ab ' + escapeHtml(discount.minQuantity) + ': -' + escapeHtml(formatDiscountPercent(discount.percent)) + '%' +
          '</span>';
      }).join('') +
      '</span>';
  }

  function getShopifyCartEndpoint(path) {
    var root = '/';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }
    return root.replace(/\/?$/, '/') + String(path || '').replace(/^\/+/, '');
  }

  async function readShopifyErrorResponse(res) {
    var text = '';
    var parsed = null;
    try {
      text = await res.text();
    } catch (err) {
      text = '';
    }
    if (text) {
      try {
        parsed = JSON.parse(text);
      } catch (err) {
        parsed = null;
      }
    }
    var message = '';
    if (parsed) {
      message = parsed.description || parsed.message || parsed.error || '';
    }
    if (!message && text) message = text.replace(/\s+/g, ' ').slice(0, 300);
    if (!message) message = 'HTTP ' + (res && res.status ? res.status : 'Fehler');
    return {
      text: text,
      parsed: parsed,
      message: String(message).trim()
    };
  }

  function normalizeDiscountCode(value) {
    return String(value || '').trim().toLowerCase();
  }

  function cartContainsDiscount(cart, discountCode) {
    if (!cart || !discountCode) return false;
    var expected = normalizeDiscountCode(discountCode);
    var applications = [];

    if (Array.isArray(cart.cart_level_discount_applications)) {
      applications = applications.concat(cart.cart_level_discount_applications);
    }
    if (Array.isArray(cart.discount_applications)) {
      applications = applications.concat(cart.discount_applications);
    }
    if (Array.isArray(cart.items)) {
      cart.items.forEach(function (item) {
        if (Array.isArray(item.discounts)) applications = applications.concat(item.discounts);
        if (Array.isArray(item.line_level_discount_allocations)) {
          item.line_level_discount_allocations.forEach(function (allocation) {
            if (allocation && allocation.discount_application) applications.push(allocation.discount_application);
          });
        }
      });
    }

    var hasMatchingCode = applications.some(function (discount) {
      var title = normalizeDiscountCode(discount && (discount.code || discount.title || discount.name));
      return title && title === expected;
    });

    return hasMatchingCode || Number(cart.total_discount || 0) > 0;
  }

  async function applyQuantityDiscountToCart(discountCode) {
    discountCode = String(discountCode || '').trim();
    if (!discountCode) return { applied: false, skipped: true };

    var res = await fetch(getShopifyCartEndpoint('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: discountCode })
    });

    var cart = null;
    try {
      cart = await res.json();
    } catch (parseErr) {
      cart = null;
    }

    if (!res.ok) {
      console.error('[SBC] Shopify discount response:', cart || await res.text());
      throw new Error('Der Mengenrabatt konnte im Warenkorb nicht angewendet werden.');
    }

    return {
      applied: cartContainsDiscount(cart, discountCode),
      cart: cart
    };
  }

  function buildConfigurationSummary() {
    var tools = 0;
    var logos = 0;
    var texts = 0;

    getRelevantDesignObjects().forEach(function (obj) {
      if (obj.objectType === 'shadow-tool') tools++;
      else if (obj.objectType === 'logo') logos++;
      else if (obj.objectType === 'custom-text' || obj.type === 'textbox' || obj.type === 'i-text') texts++;
    });

    var parts = [];
    if (tools > 0) parts.push(tools + ' Werkzeug' + (tools > 1 ? 'e' : ''));
    if (logos > 0) parts.push(logos + ' Logo' + (logos > 1 ? 's' : ''));
    if (texts > 0) parts.push(texts + ' Text' + (texts > 1 ? 'e' : ''));

    return {
      toolCount: tools,
      logoCount: logos,
      textCount: texts,
      colorLabel: getColorSummaryLabel(),
      frontColor: selectedColor,
      backColor: selectedBackColor,
      surfaceType: selectedSurfaceType,
      surfaceLabel: getSurfaceLabel(),
      quantity: getSelectedQuantity(),
      quantityDiscount: getQuantityDiscountSnapshot(),
      holderType: selectedHolderType,
      holderLabel: getSelectedHolderLabel(),
      mountingAddons: getSelectedFinalizeAddonProducts().map(getFinalizeProductLabel),
      configuratorMode: configuratorMode,
      toolBrand: selectedToolBrand || null,
      configurationLabel: parts.join(', ') || (isToolWallMode() ? 'Leere Werkzeugwand' : 'Leere Schattenwand')
    };
  }

  function getDesignValidationMessage() {
    if (!canvas) return 'Canvas ist noch nicht bereit.';
    if (isToolWallMode() && !selectedSizeIsCustom) {
      return 'Werkzeugwände können nur als individuelles Sondermaß gestaltet werden.';
    }
    if (isToolWallMode() && TOOL_BRANDS.indexOf(selectedToolBrand) === -1) {
      return 'Bitte wähle ' + getToolBrandChoiceLabel() + ' als Werkzeughersteller aus.';
    }
    if (!getProductForSizeSurface(CFG.boardWidthMm, CFG.boardHeightMm, selectedSurfaceType)) {
      return 'Für diese Größe und Oberfläche ist noch kein Shopify-Produkt konfiguriert.';
    }
    if (!selectedVariant || !selectedVariant.id) {
      return 'Bitte wähle eine Farbe aus.';
    }
    if (selectedMounting && selectedMounting !== 'wall' && !getMountingEntry(selectedMounting, selectedMountingSides, selectedSurfaceType)) {
      return 'Für diese Montageart und Oberfläche ist noch kein Shopify-Produkt konfiguriert.';
    }

    var objects = getRelevantDesignObjects();
    if (objects.length === 0) {
      return 'Platziere mindestens ein Werkzeug auf der Schattenwand';
    }

    var boundsMessage = getBoundsValidationMessage(objects);
    if (boundsMessage) return boundsMessage;

    var toolOverlapMessage = getVisibleToolOverlapValidationMessage(objects);
    if (toolOverlapMessage) return toolOverlapMessage;

    return '';
  }

  function getBoundsValidationMessage(objects) {
    if (!canvas) return '';

    var designObjects = objects || getRelevantDesignObjects();
    for (var i = 0; i < designObjects.length; i++) {
      var bounds = getValidationBoundsForObject(designObjects[i]);
      if (!isObjectWithinBoardBounds(designObjects[i], bounds)) {
        return getConfiguratorText('boundsBlocked', CONFIGURATOR_TEXT_DEFAULTS.boundsBlocked);
      }
    }

    return '';
  }

  function updateBoundsErrorBanner() {
    var banner = dom.boundsBanner();
    if (!banner) return;

    var message = (currentStep === 5 || currentStep === 6) ? getBoundsValidationMessage() : '';
    var text = dom.boundsBannerText();
    if (text && message) text.textContent = message;
    banner.hidden = !message;
  }

  function updateLeadButton() {
    var btn = document.getElementById('btn-lead-offer');
    if (!btn) return;

    var validationMessage = getDesignValidationMessage() || getFinalizationValidationMessage();
    btn.disabled = !!validationMessage;
    btn.title = validationMessage;
  }

  function syncCanvasUi() {
    updateCartButton();
    updateLeadButton();
    updateObjectCounter();
    updateEmptyState();
    updateFloatingDeleteButton();
    updateBottomOverhangHint();
    updateBoundsErrorBanner();
  }

  function updateFloatingDeleteButton() {
    var btn = dom.btnDeleteFloating();
    if (!btn) return;
    var obj = canvas && typeof canvas.getActiveObject === 'function' ? canvas.getActiveObject() : null;
    var mobileViewport = window.matchMedia ? window.matchMedia('(max-width: 768px)').matches : window.innerWidth <= 768;
    var show = mobileViewport && currentStep === 5 && obj && !isCanvasHelperObject(obj) && !obj.isBackground;
    btn.hidden = !show;
    btn.disabled = !show;
  }

  function refreshFabricRetinaScale() {
    if (typeof fabric === 'undefined') return 1;

    var dpr = window.devicePixelRatio || 1;
    var scale = Math.min(CANVAS_MAX_RETINA_SCALE, Math.max(1, dpr * CANVAS_RENDER_QUALITY));
    fabric.devicePixelRatio = scale;
    return scale;
  }

  function applyCanvasContextQuality() {
    if (!canvas) return;

    [
      canvas.contextContainer,
      canvas.contextTop,
      canvas.lowerCanvasEl && canvas.lowerCanvasEl.getContext && canvas.lowerCanvasEl.getContext('2d'),
      canvas.upperCanvasEl && canvas.upperCanvasEl.getContext && canvas.upperCanvasEl.getContext('2d')
    ].forEach(function (ctx) {
      if (!ctx) return;
      ctx.imageSmoothingEnabled = true;
      if ('imageSmoothingQuality' in ctx) {
        ctx.imageSmoothingQuality = 'high';
      }
    });
  }

  function applyCrispRendering(obj) {
    if (!obj || typeof obj.set !== 'function') return obj;

    obj.set({
      objectCaching: false,
      noScaleCache: true
    });
    obj.dirty = true;

    if (obj._objects && obj._objects.length) {
      obj._objects.forEach(applyCrispRendering);
    }

    return obj;
  }

  function markCanvasObjectsDirty() {
    if (!canvas) return;

    canvas.getObjects().forEach(function (obj) {
      applyCrispRendering(obj);
    });

    if (canvas.backgroundImage) applyCrispRendering(canvas.backgroundImage);
    if (canvas.overlayImage) applyCrispRendering(canvas.overlayImage);
  }

  function applyShadowToolConstraints(obj) {
    if (!obj || obj.objectType !== 'shadow-tool') return obj;

    applyCrispRendering(obj);
    var canScale = isScalableShadowTool(obj);

    obj.set({
      opacity: 1,
      shadow: null,
      // Safari trifft SVG-/PNG-Schatten mit per-pixel Hit-Testing teils nicht zuverlässig.
      // Die Druck-/Overlap-Prüfung bleibt pixelgenau; nur Auswahl/Drag nutzt die Objektfläche.
      perPixelTargetFind: false,
      subTargetCheck: false,
      targetFindTolerance: isMobile ? TOOL_TARGET_TOLERANCE_TOUCH : TOOL_TARGET_TOLERANCE_DESKTOP,
      lockScalingX: !canScale,
      lockScalingY: !canScale,
      lockUniScaling: false,
      lockScalingFlip: true,
      lockRotation: true,
      hoverCursor: 'move',
      moveCursor: 'move',
      hasControls: canScale,
      hasRotatingPoint: false
    });

    if (typeof obj.setControlsVisibility === 'function') {
      obj.setControlsVisibility({
        tl: canScale,
        tr: canScale,
        br: canScale,
        bl: canScale,
        ml: false,
        mt: false,
        mr: false,
        mb: false,
        mtr: false
      });
    }

    obj.setCoords();
    return obj;
  }

  function getToolTargetArea(obj) {
    if (!obj || typeof obj.getBoundingRect !== 'function') return Number.POSITIVE_INFINITY;
    var bounds = obj.getBoundingRect(true, true);
    return Math.max(1, (bounds.width || 0) * (bounds.height || 0));
  }

  function isSelectableShadowToolAtPointer(obj, pointer) {
    if (!obj || obj.objectType !== 'shadow-tool') return false;
    if (obj.visible === false || obj.evented === false || obj.selectable === false) return false;
    if (!pointer || typeof obj.containsPoint !== 'function') return false;
    return obj.containsPoint(pointer);
  }

  function findPreferredShadowToolTarget(pointer, currentTarget) {
    if (!canvas || !pointer || !currentTarget || currentTarget.__corner) return currentTarget;
    if (currentTarget.objectType !== 'shadow-tool') return currentTarget;

    var objects = canvas.getObjects();
    var currentArea = getToolTargetArea(currentTarget);
    var candidates = objects
      .filter(function (obj) {
        return isSelectableShadowToolAtPointer(obj, pointer);
      })
      .map(function (obj) {
        return {
          obj: obj,
          area: getToolTargetArea(obj),
          z: objects.indexOf(obj)
        };
      });

    if (candidates.length < 2) return currentTarget;

    candidates.sort(function (a, b) {
      if (Math.abs(a.area - b.area) > 1) return a.area - b.area;
      return b.z - a.z;
    });

    var preferred = candidates[0];
    if (!preferred || preferred.obj === currentTarget) return currentTarget;
    if (preferred.area > currentArea * TOOL_SMALLER_TARGET_AREA_RATIO) return currentTarget;
    return preferred.obj;
  }

  function installPreciseToolTargeting() {
    if (!canvas || canvas._sbcPreciseToolTargetingInstalled || typeof canvas.findTarget !== 'function') return;

    var originalFindTarget = canvas.findTarget.bind(canvas);
    canvas.findTarget = function (event, skipGroup) {
      var target = originalFindTarget(event, skipGroup);
      if (!target || !event || target.__corner) return target;

      try {
        var pointer = this.getPointer(event);
        return findPreferredShadowToolTarget(pointer, target);
      } catch (e) {
        return target;
      }
    };

    canvas._sbcPreciseToolTargetingInstalled = true;
  }

  function refreshTextDimensions(textObj) {
    if (!textObj) return;
    textObj.set('dirty', true);
    if (typeof textObj.initDimensions === 'function') {
      textObj.initDimensions();
    }
    textObj.setCoords();
  }

  function keepObjectWithinCanvas(obj, padding) {
    if (!canvas || !obj) return;

    var pad = typeof padding === 'number' ? padding : 0;
    refreshTextDimensions(obj);

    var bounds = obj.getBoundingRect(true, true);
    var maxWidth = Math.max(canvas.width - (pad * 2), 1);
    var maxHeight = Math.max(canvas.height - (pad * 2), 1);

    if (bounds.width > maxWidth) {
      obj.set({ left: canvas.width / 2 });
    } else {
      if (bounds.left < pad) {
        obj.set({ left: obj.left + (pad - bounds.left) });
      }
      if ((bounds.left + bounds.width) > (canvas.width - pad)) {
        obj.set({ left: obj.left - ((bounds.left + bounds.width) - (canvas.width - pad)) });
      }
    }

    refreshTextDimensions(obj);
    bounds = obj.getBoundingRect(true, true);

    if (bounds.height > maxHeight) {
      obj.set({ top: canvas.height / 2 });
    } else {
      if (bounds.top < pad) {
        obj.set({ top: obj.top + (pad - bounds.top) });
      }
      if ((bounds.top + bounds.height) > (canvas.height - pad)) {
        obj.set({ top: obj.top - ((bounds.top + bounds.height) - (canvas.height - pad)) });
      }
    }

    obj.setCoords();
  }

  function constrainSmallWallBottomOverhangTool(obj) {
    if (!canvas || !obj || obj.objectType !== 'shadow-tool') return false;
    if (!allowsBottomToolOverhangForCurrentBoard()) return false;

    obj.setCoords();
    var bounds = ensureBoundsEdges(getCanvasBoundsForObject(obj) || obj.getBoundingRect(true, true));
    if (!bounds || !isFinite(bounds.left) || !isFinite(bounds.top)) return false;

    var nextLeft = Number(obj.left) || 0;
    var nextTop = Number(obj.top) || 0;
    var centerX = bounds.left + (bounds.width / 2);
    var tolerance = 0.5;
    var minVisibleSide = Math.max(2, tolerance);

    if (bounds.width > canvas.width + tolerance) {
      nextLeft += (canvas.width / 2) - centerX;
    } else {
      if (bounds.left < 0) {
        nextLeft += -bounds.left;
      }
      if (bounds.right > canvas.width) {
        nextLeft -= bounds.right - canvas.width;
      }
    }

    if (bounds.top < 0) {
      nextTop += -bounds.top;
    }

    if (bounds.top > canvas.height - minVisibleSide) {
      nextTop -= bounds.top - (canvas.height - minVisibleSide);
    }

    if (Math.abs(nextLeft - (Number(obj.left) || 0)) < 0.01 &&
      Math.abs(nextTop - (Number(obj.top) || 0)) < 0.01) {
      return false;
    }

    obj.set({ left: nextLeft, top: nextTop });
    obj.setCoords();
    return true;
  }

  function keepObjectRecoverableOnCanvas(obj) {
    if (!canvas || !obj || !isUserDesignObject(obj)) return false;

    if (constrainSmallWallBottomOverhangTool(obj)) {
      return true;
    }

    obj.setCoords();
    var bounds = obj.getBoundingRect(true, true);
    if (!bounds || !isFinite(bounds.left) || !isFinite(bounds.top)) return false;

    var minVisibleX = Math.min(RECOVERABLE_VISIBLE_PX, Math.max(8, bounds.width || RECOVERABLE_VISIBLE_PX));
    var minVisibleY = Math.min(RECOVERABLE_VISIBLE_PX, Math.max(8, bounds.height || RECOVERABLE_VISIBLE_PX));
    var nextLeft = obj.left;
    var nextTop = obj.top;

    if (bounds.left + bounds.width < minVisibleX) {
      nextLeft += minVisibleX - (bounds.left + bounds.width);
    } else if (bounds.left > canvas.width - minVisibleX) {
      nextLeft -= bounds.left - (canvas.width - minVisibleX);
    }

    if (bounds.top + bounds.height < minVisibleY) {
      nextTop += minVisibleY - (bounds.top + bounds.height);
    } else if (bounds.top > canvas.height - minVisibleY) {
      nextTop -= bounds.top - (canvas.height - minVisibleY);
    }

    if (nextLeft === obj.left && nextTop === obj.top) return false;

    obj.set({ left: nextLeft, top: nextTop });
    obj.setCoords();
    return true;
  }

  function clearTextCurvature(textObj) {
    if (!textObj) return;
    textObj.set({
      curvature: 0,
      path: null
    });
    refreshTextDimensions(textObj);
  }

  function measureTextContent(text, textObj, fontSize) {
    var probe = new fabric.Text(text || '', {
      fontFamily: textObj.fontFamily || 'Inter, sans-serif',
      fontSize: fontSize || textObj.fontSize || 36,
      fontWeight: textObj.fontWeight || '600',
      fontStyle: textObj.fontStyle || '',
      lineHeight: textObj.lineHeight || 1.16,
      charSpacing: textObj.charSpacing || 0
    });

    return {
      width: probe.width || 0,
      height: probe.height || (fontSize || textObj.fontSize || 36)
    };
  }

  function breakWordToWidth(word, textObj, fontSize, maxWidth) {
    if (!word) return [''];
    if (measureTextContent(word, textObj, fontSize).width <= maxWidth) {
      return [word];
    }

    var pieces = [];
    var current = '';

    word.split('').forEach(function (char) {
      var candidate = current + char;
      if (current && measureTextContent(candidate, textObj, fontSize).width > maxWidth) {
        pieces.push(current);
        current = char;
      } else {
        current = candidate;
      }
    });

    if (current) pieces.push(current);
    return pieces;
  }

  function wrapParagraphToWidth(paragraph, textObj, fontSize, maxWidth) {
    if (!paragraph) return [''];

    var words = paragraph.split(/\s+/).filter(Boolean);
    if (words.length === 0) return [''];

    var lines = [];
    var currentLine = '';

    words.forEach(function (word) {
      var wordParts = breakWordToWidth(word, textObj, fontSize, maxWidth);
      wordParts.forEach(function (part) {
        var candidate = currentLine ? (currentLine + ' ' + part) : part;
        if (currentLine && measureTextContent(candidate, textObj, fontSize).width > maxWidth) {
          lines.push(currentLine);
          currentLine = part;
        } else {
          currentLine = candidate;
        }
      });
    });

    if (currentLine) lines.push(currentLine);
    return lines;
  }

  function wrapTextToBoard(text, textObj, fontSize, maxWidth) {
    return String(text || '')
      .replace(/\r\n/g, '\n')
      .replace(/\r/g, '\n')
      .split('\n')
      .map(function (paragraph) {
        return wrapParagraphToWidth(paragraph, textObj, fontSize, maxWidth).join('\n');
      })
      .join('\n');
  }

  function textFitsBoard(textObj, padding) {
    if (!canvas || !textObj) return true;
    refreshTextDimensions(textObj);
    var bounds = textObj.getBoundingRect(true, true);
    var pad = typeof padding === 'number' ? padding : 0;
    return (
      bounds.width <= (canvas.width - (pad * 2) + 0.5) &&
      bounds.height <= (canvas.height - (pad * 2) + 0.5)
    );
  }

  function fitTextObject(textObj) {
    if (!canvas || !textObj || textObj.objectType !== 'custom-text' || textObj._sbcFitting) return;

    textObj._sbcFitting = true;
    var selectionStart = textObj.selectionStart;
    var selectionEnd = textObj.selectionEnd;
    var rawText = String(textObj.text || '')
      .replace(/\r\n/g, '\n')
      .replace(/\r/g, '\n');
    var fontSize = Math.round(textObj.fontSize || 36);
    var workingText = rawText;
    var maxWidth = Math.max(canvas.width - (TEXT_FIT_PADDING * 2), 80);

    try {
      if (textObj._sbcPreserveLineBreaks === true) {
        textObj.set({
          text: rawText,
          fontSize: fontSize
        });
        refreshTextDimensions(textObj);
        keepObjectWithinCanvas(textObj, TEXT_FIT_PADDING);
        checkBounds(textObj);
        canvas.requestRenderAll();
        return;
      }

      if (workingText.indexOf('\n') !== -1 && textObj.curvature) {
        clearTextCurvature(textObj);
      }

      textObj.set({
        text: workingText,
        fontSize: fontSize
      });
      refreshTextDimensions(textObj);

      if (!textFitsBoard(textObj, TEXT_FIT_PADDING)) {
        if (textObj.curvature) {
          clearTextCurvature(textObj);
        }

        workingText = wrapTextToBoard(rawText, textObj, fontSize, maxWidth);
        textObj.set({
          fontSize: fontSize,
          text: workingText
        });
        refreshTextDimensions(textObj);
      }

      if ((textObj.text || '').indexOf('\n') !== -1 && textObj.curvature) {
        clearTextCurvature(textObj);
      }

      keepObjectWithinCanvas(textObj, TEXT_FIT_PADDING);
      checkBounds(textObj);

      if (textObj.isEditing) {
        textObj.selectionStart = Math.min(selectionStart || 0, textObj.text.length);
        textObj.selectionEnd = Math.min(selectionEnd || textObj.selectionStart, textObj.text.length);
      }

      canvas.requestRenderAll();
    } finally {
      textObj._sbcFitting = false;
    }
  }

  function bindTextObjectEvents(textObj) {
    if (!textObj || textObj.objectType !== 'custom-text' || textObj._sbcTextEventsBound) return textObj;

    textObj._sbcTextEventsBound = true;
    textObj.on('changed', function () {
      textObj._sbcPreserveLineBreaks = false;
      fitTextObject(textObj);
      scheduleDraftAutosave();
      syncCanvasUi();
    });
    textObj.on('editing:exited', function () {
      textObj._sbcPreserveLineBreaks = false;
      fitTextObject(textObj);
      saveState();
    });

    return textObj;
  }

  function getTextFontSpec(textObj, fontSize) {
    return (textObj.fontStyle || 'normal') + ' ' +
      (textObj.fontWeight || '400') + ' ' +
      (fontSize || textObj.fontSize || 36) + 'px ' +
      (textObj.fontFamily || 'Inter');
  }

  function waitForTextFont(textObj, fontSize) {
    if (!document.fonts || typeof document.fonts.load !== 'function') {
      return Promise.resolve();
    }
    var fontLoad = document.fonts.load(getTextFontSpec(textObj, fontSize));
    var timeout = new Promise(function (resolve) {
      setTimeout(resolve, 800);
    });
    return Promise.race([fontLoad, timeout]).catch(function () { });
  }

  function normalizeCanvasObjects() {
    if (!canvas) return;

    canvas.getObjects().forEach(function (obj) {
      applyCrispRendering(obj);
      if (obj.objectType === 'shadow-tool') {
        applyShadowToolConstraints(obj);
      }
      if (obj.objectType === 'custom-text') {
        bindTextObjectEvents(obj);
        if (obj.textColorCmyk) obj.set('textColorCmyk', normalizeCmyk(obj.textColorCmyk));
        if (obj.fontId) {
          var font = findFontById(obj.fontId);
          if (font && font.type === 'custom') installFontFace(font);
        }
        fitTextObject(obj);
      }
      keepObjectRecoverableOnCanvas(obj);
    });

    canvas.requestRenderAll();
  }

  function parseSaveString(saveStr) {
    if (!saveStr) return null;
    var raw = String(saveStr).trim();
    if (!raw) return null;

    try {
      if (raw.charAt(0) === '{') {
        return JSON.parse(raw);
      }
      var decoded = raw;
      try {
        decoded = decodeURIComponent(raw);
      } catch (e) {
        decoded = raw;
      }
      var jsonStr = decodeURIComponent(escape(atob(decoded)));
      return JSON.parse(jsonStr);
    } catch (e) {
      console.warn('[SBC] Fehler beim Parsen des Save-Strings', e);
      return null;
    }
  }

  function setStoredDraftSaveString(saveStr) {
    if (!saveStr) return;
    localStorage.setItem(DRAFT_AUTOSAVE_KEY, saveStr);
    localStorage.setItem(DRAFT_AUTOSAVE_BACKUP_KEY, saveStr);
    lastDraftSaveStr = saveStr;
  }

  function clearStoredDraftSaveString() {
    localStorage.removeItem(DRAFT_AUTOSAVE_KEY);
    localStorage.removeItem(DRAFT_AUTOSAVE_BACKUP_KEY);
    lastDraftSaveStr = null;
  }

  function getStoredDraftSaveString() {
    var primary = localStorage.getItem(DRAFT_AUTOSAVE_KEY);
    if (primary && parseSaveString(primary)) return primary;

    var backup = localStorage.getItem(DRAFT_AUTOSAVE_BACKUP_KEY);
    if (backup && parseSaveString(backup)) {
      localStorage.setItem(DRAFT_AUTOSAVE_KEY, backup);
      lastDraftSaveStr = backup;
      return backup;
    }

    if (primary) localStorage.removeItem(DRAFT_AUTOSAVE_KEY);
    if (backup) localStorage.removeItem(DRAFT_AUTOSAVE_BACKUP_KEY);
    return null;
  }

  function setPendingLoginSaveIntent() {
    try {
      localStorage.setItem(PENDING_LOGIN_SAVE_KEY, JSON.stringify({
        createdAt: Date.now(),
        path: window.location.pathname
      }));
    } catch (e) { }
  }

  function getPendingLoginSaveIntent() {
    var raw = null;
    try {
      raw = localStorage.getItem(PENDING_LOGIN_SAVE_KEY);
    } catch (e) {
      raw = null;
    }
    if (!raw) return null;

    var data = {};
    try {
      data = JSON.parse(raw) || {};
    } catch (e) {
      data = {};
    }

    var createdAt = Number(data.createdAt) || 0;
    if (createdAt && Date.now() - createdAt > PENDING_LOGIN_SAVE_TTL_MS) {
      clearPendingLoginSaveState(true);
      return null;
    }

    return data;
  }

  function clearPendingLoginSaveState(clearPayload) {
    try {
      localStorage.removeItem(PENDING_LOGIN_SAVE_KEY);
      if (clearPayload !== false) localStorage.removeItem(PENDING_SAVE_KEY);
    } catch (e) { }
    try {
      if (clearPayload !== false) sessionStorage.removeItem(PENDING_SAVE_KEY);
    } catch (e) { }
  }

  function getPendingLoginSavePayload() {
    var stores = [localStorage, sessionStorage];
    for (var i = 0; i < stores.length; i++) {
      try {
        var value = stores[i].getItem(PENDING_SAVE_KEY);
        if (value && parseSaveString(value)) return value;
      } catch (e) { }
    }
    return null;
  }

  function storePendingLoginSavePayload(saveStr) {
    if (!saveStr || !parseSaveString(saveStr)) return false;

    var stored = false;
    try {
      localStorage.setItem(PENDING_SAVE_KEY, saveStr);
      stored = true;
    } catch (e) {
      console.warn('[SBC] Pending Save konnte nicht in localStorage gespeichert werden:', e);
    }
    try {
      sessionStorage.setItem(PENDING_SAVE_KEY, saveStr);
      stored = true;
    } catch (e) {
      console.warn('[SBC] Pending Save konnte nicht in sessionStorage gespeichert werden:', e);
    }

    if (stored) {
      setPendingLoginSaveIntent();
    }

    return stored;
  }

  /* ==========================================
     DOM REFS
     ========================================== */

  const $ = (s) => document.querySelector(s);
  const $$ = (s) => document.querySelectorAll(s);

  const dom = {
    stage: () => $('#sbc-canvas-stage'),
    sidebar: () => $('#sbc-sidebar'),
    mobileToggle: () => $('#sbc-mobile-toggle'),
    toolsGrid: () => $('#shadow-tools'),
    btnLogo: () => $('#btn-add-logo'),
    fileInput: () => $('#logo-upload'),
    customerLogoCard: () => $('#sbc-customer-logo'),
    customerLogoPreview: () => $('#sbc-customer-logo-preview'),
    customerLogoMeta: () => $('#sbc-customer-logo-meta'),
    customerLogoHint: () => $('#sbc-customer-logo-hint'),
    btnUseCustomerLogo: () => $('#btn-use-customer-logo'),
    btnText: () => $('#btn-add-text'),
    fontSelect: () => $('#text-font-family-select'),
    btnUploadFont: () => $('#btn-upload-font'),
    fontUpload: () => $('#font-upload'),
    textFontSize: () => $('#text-font-size-input'),
    textColorInput: () => $('#text-color-input'),
    textColorPicker: () => $('#text-color-picker'),
    textColorSwatches: () => $$('#text-color-picker .sbc-color-swatch'),
    textCmykInputs: () => $$('input[data-text-cmyk]'),
    textCmykPreview: () => $('#text-cmyk-preview'),
    textStyleButtons: () => $$('.sbc-style-btn[data-text-style]'),
    textAlignButtons: () => $$('.sbc-align-btn[data-text-align]'),
    quantityInput: () => $('#sbc-board-quantity'),
    finalizeSummary: () => $('#sbc-finalize-summary-value'),
    finalizeMountingGroup: () => $('#sbc-finalize-mounting-group'),
    finalizeMountingButtons: () => $$('.sbc-finalize-mounting-card[data-final-mounting]'),
    finalizeHolderButtons: () => $$('.sbc-finalize-card[data-final-holder]'),
    finalizeAddonInputs: () => $$('input[data-final-addon]'),
    btnReset: () => $('#btn-reset'),
    btnCartWrap: () => $('#btn-add-to-cart-wrap'),
    btnCart: () => $('#btn-add-to-cart'),
    btnCartLabel: () => $('#btn-add-to-cart .sbc-btn__label'),
    btnCartSpinner: () => $('#btn-add-to-cart .sbc-btn__spinner'),
    selectedProductTitle: () => $('#sbc-selected-product-title'),
    overhangHint: () => $('#sbc-overhang-hint'),
    boundsBanner: () => $('#sbc-bounds-banner'),
    boundsBannerText: () => $('#sbc-bounds-banner-text'),
    btnLead: () => $('#btn-lead-offer'),
    leadPanel: () => $('#sbc-lead-funnel'),
    leadForm: () => $('#sbc-lead-form'),
    leadName: () => $('#sbc-lead-name'),
    leadEmail: () => $('#sbc-lead-email'),
    leadPhone: () => $('#sbc-lead-phone'),
    leadComment: () => $('#sbc-lead-comment'),
    leadMessage: () => $('#sbc-lead-message'),
    btnLeadSubmit: () => $('#btn-lead-submit'),
    btnLeadSubmitLabel: () => $('#btn-lead-submit .sbc-btn__label'),
    btnLeadSubmitSpinner: () => $('#btn-lead-submit .sbc-btn__spinner'),
    btnLeadCancel: () => $('#btn-lead-cancel'),
    btnDelete: () => $('#btn-delete-object'),
    btnDeleteFloating: () => $('#btn-delete-selected-floating'),
    panelProps: () => $('#panel-properties'),
    colorSwatches: () => $$('.sbc-color-swatch'),
    toastContainer: () => $('#sbc-toast-container'),
    btnUndo: () => $('#btn-undo'),
    btnRedo: () => $('#btn-redo'),
    objectCounter: () => $('#sbc-object-counter'),
    emptyState: () => $('#sbc-empty-state'),
    measurementGridToggle: () => $('#sbc-measure-grid-toggle'),
    zoomControls: () => $('#sbc-zoom-controls'),
    zoomLevel: () => $('#sbc-zoom-level'),
    confirmResetModal: () => $('#sbc-confirm-reset'),
    customSizeEditButton: () => $('#sbc-design-size-edit'),
    customSizeEditValue: () => $('#sbc-design-size-edit-value'),
    customSizeEditModal: () => $('#sbc-custom-size-edit-modal'),
    customSizeEditWidth: () => $('#sbc-design-custom-width-mm'),
    customSizeEditHeight: () => $('#sbc-design-custom-height-mm'),
    customSizeEditError: () => $('#sbc-custom-size-edit-error'),
    customSizeMountingMeasure: () => $('#sbc-custom-size-mounting-guide-measure'),
    customSizeMountingMessage: () => $('#sbc-custom-size-mounting-guide-message'),
    customSizeMountingStatuses: () => $$('[data-custom-size-mounting-status]'),
    customSizeMountingTableBody: () => $('#sbc-custom-size-mounting-guide-body'),
    customSizeMountingSurface: () => $('#sbc-custom-size-mounting-guide-surface'),
    restoreDraftModal: () => $('#sbc-restore-draft'),
    restoreDraftDiscard: () => $('#btn-restore-draft-discard'),
    restoreDraftLoad: () => $('#btn-restore-draft-load'),
    accessoryModal: () => $('#sbc-accessory-modal'),
    accessoryTitle: () => $('#sbc-accessory-title'),
    accessoryDesc: () => $('#sbc-accessory-desc'),
    accessoryList: () => $('#sbc-accessory-list'),
    accessoryConfirm: () => $('#btn-accessory-confirm'),
    accessorySkip: () => $('#btn-accessory-skip'),
    accessoryCancel: () => $('#btn-accessory-cancel'),
  };

  /* ==========================================
     INIT
     ========================================== */

  function init() {
    // Warte bis Fabric.js verfügbar ist (max 5 Sekunden)
    if (typeof fabric === 'undefined') {
      var attempts = 0;
      var waitForFabric = setInterval(function () {
        attempts++;
        if (typeof fabric !== 'undefined') {
          clearInterval(waitForFabric);
          console.log('[SBC] Fabric.js loaded after ' + attempts + ' attempts');
          startConfigurator();
        } else if (attempts > 50) {
          clearInterval(waitForFabric);
          console.error('[SBC] Fabric.js konnte nicht geladen werden');
        }
      }, 100);
      return;
    }
    startConfigurator();
  }

  function startConfigurator() {
    console.log('[SBC] Initialisierung gestartet...');
    applyConfiguratorModeUi();
    loadConfiguratorSettings();

    // Kurz warten bis Layout fertig gerendert ist
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        initCanvas();

        // Auto-assign side to new objects
        canvas.on('object:added', function (e) {
          if (e.target && !e.target.isBackground && !isCanvasHelperObject(e.target)) {
            if (!e.target.sbcSide) {
              e.target.sbcSide = currentSide;
            }
            if (e.target.objectType === 'shadow-tool') {
              applyShadowToolConstraints(e.target);
              keepObjectRecoverableOnCanvas(e.target);
            }
            if (e.target.objectType === 'custom-text') {
              bindTextObjectEvents(e.target);
              fitTextObject(e.target);
            }
          }
        });

        bindWizard();
        bindConfiguratorModeControls();
        bindCustomSizeControls();
        bindCustomSizeEditor();
        bindSidebar();
        bindPanelToggles();
        bindMobileMenuHitGuards();
        bindLogoUpload();
        bindCustomerLogo();
        bindTextAdd();
        bindFontControls();
        bindDeleteObject();
        bindColorPicker();
        bindColorSideSwitch();
        bindSurfaceOptions();
        bindQuantityControl();
        bindFinalizeOptions();
        bindReset();
        bindAddToCart();
        bindCanvasDrop();
        bindCanvasSelection();
        bindKeyboard();
        bindZoomControls();
        bindMeasurementGridToggle();
        bindConfirmResetModal();
        bindRestoreDraftModal();
        bindDraftAutosaveLifecycle();
        bindStepDotNavigation();
        bindSideToggle();
        bindSaveDraft();
        bindLeadOffer();
        updateMountingStepUi();
        loadFonts();

        // Load User Designs
        if (CFG.customerId) {
          loadUserDesigns();
          loadCustomerLogo();
        }

        // Enable cart button + object counter + empty state on changes
        canvas.on('object:added', function (e) {
          if (e && isCanvasHelperObject(e.target)) return;
          syncCanvasUi();
          saveState();
        });
        canvas.on('object:removed', function (e) {
          if (e && isCanvasHelperObject(e.target)) return;
          syncCanvasUi();
          saveState();
        });
        canvas.on('object:modified', function (e) {
          if (e && e.target && e.target.objectType === 'custom-text') {
            fitTextObject(e.target);
          }
          syncCanvasUi();
          saveState();
        });

        // Preise in Größen-Kacheln anzeigen
        prefillSizePrices();

        // Montagepreise im Auswahl-Schritt ausblenden
        prefillMountingPrices();

        // Check for short draft/design restore parameters, legacy ?save= links, or pending login saves
        var saveStateRes = loadFromSaveHash();

        if (!saveStateRes.loaded) {
          // If no save hash, run default start
          goToStep(1);
          // Initialen Zustand speichern
          saveState();
        } else if (saveStateRes.awaitingRestore) {
          goToStep(1);
          showRestoreDraftModal();
        }

        console.log('[SBC] Konfigurator bereit!');
      });
    });
  }

  /* ==========================================
     CANVAS SETUP
     ========================================== */

  function initCanvas() {
    refreshFabricRetinaScale();

    canvas = new fabric.Canvas('shadow-board-canvas', {
      backgroundColor: CANVAS_STAGE_COLOR,
      backgroundVpt: true,
      preserveObjectStacking: true,
      selection: true,
      uniformScaling: true,
      controlsAboveOverlay: true,
      enableRetinaScaling: true,  // Scharfe Darstellung auf Retina/HiDPI-Bildschirmen
      allowTouchScrolling: true,
      perPixelTargetFind: false,
      targetFindTolerance: isMobile ? TOOL_TARGET_TOLERANCE_TOUCH : TOOL_TARGET_TOLERANCE_DESKTOP,
    });

    // Apple-style selection colors
    fabric.Object.prototype.set({
      borderColor: GUIDE_COLOR,
      cornerColor: GUIDE_COLOR,
      cornerStrokeColor: '#fff',
      cornerSize: 10,
      cornerStyle: 'circle',
      transparentCorners: false,
      borderScaleFactor: 1.6,
      padding: 6,
      objectCaching: false,
      noScaleCache: true
    });

    updateMobileViewportBottomOffset();
    resizeCanvas();
    var handleViewportChange = debounce(function () {
      updateMobileViewportBottomOffset();
      syncBottomBarPortal(currentStep);
      syncLeadFunnelPortal();
      resizeCanvas();
    }, 200);
    window.addEventListener('resize', handleViewportChange);
    window.addEventListener('orientationchange', handleViewportChange);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleViewportChange);
      window.visualViewport.addEventListener('scroll', handleViewportChange);
    }

    if (CFG.boardBg) {
      loadBackground(CFG.boardBg, ++backgroundLoadToken);
    }

    loadBackgroundsFromApi();

    installPreciseToolTargeting();
    setupCanvasEvents();
  }

  function shouldRescaleObjectOnCanvasResize(obj) {
    if (!obj) return false;
    if (isSnapGuideObject(obj) || isCustomBoardBrandObject(obj)) return false;
    return isUserDesignObject(obj);
  }

  function rescaleCanvasObjectsForResize(oldW, oldH, newW, newH) {
    if (!canvas || !(oldW > 0) || !(oldH > 0) || !(newW > 0) || !(newH > 0)) return;
    if (Math.abs(oldW - newW) < 1 && Math.abs(oldH - newH) < 1) return;

    var scaleX = newW / oldW;
    var scaleY = newH / oldH;

    canvas.getObjects().forEach(function (obj) {
      if (!shouldRescaleObjectOnCanvasResize(obj)) return;

      var next = {
        left: (Number(obj.left) || 0) * scaleX,
        top: (Number(obj.top) || 0) * scaleY
      };

      if (obj.objectType === 'custom-text') {
        if (!getTextPointSize(obj)) {
          next.fontSize = (Number(obj.fontSize) || 36) * scaleY;
        }
        obj.set(next);
        refreshTextDimensions(obj);
        return;
      }

      next.scaleX = (Number(obj.scaleX) || 1) * scaleX;
      next.scaleY = (Number(obj.scaleY) || 1) * scaleY;
      obj.set(next);

      if (typeof obj._fixedScaleX === 'number') obj._fixedScaleX *= scaleX;
      if (typeof obj._fixedScaleY === 'number') obj._fixedScaleY *= scaleY;
      obj.setCoords();
    });
  }

  function captureCanvasObjectPhysicalState() {
    if (!canvas) return null;
    var oldPxPerMm = getCanvasPxPerMm();
    if (!(oldPxPerMm > 0)) return null;

    return {
      pxPerMm: oldPxPerMm,
      objects: getAllUserDesignObjects().map(function (obj) {
        var scaleX = Number(obj.scaleX);
        var scaleY = Number(obj.scaleY);
        return {
          obj: obj,
          leftMm: (Number(obj.left) || 0) / oldPxPerMm,
          topMm: (Number(obj.top) || 0) / oldPxPerMm,
          scaleX: isFinite(scaleX) ? scaleX : 1,
          scaleY: isFinite(scaleY) ? scaleY : 1,
          fixedScaleX: typeof obj._fixedScaleX === 'number' ? obj._fixedScaleX : null,
          fixedScaleY: typeof obj._fixedScaleY === 'number' ? obj._fixedScaleY : null,
          fontSize: Number(obj.fontSize) || null,
          usesPointSize: obj.objectType === 'custom-text' && !!getTextPointSize(obj)
        };
      })
    };
  }

  function restoreCanvasObjectPhysicalState(snapshot) {
    if (!canvas || !snapshot || !(snapshot.pxPerMm > 0) || !(pxPerMm > 0)) return;
    var physicalScaleRatio = pxPerMm / snapshot.pxPerMm;

    snapshot.objects.forEach(function (state) {
      var obj = state.obj;
      if (!obj || canvas.getObjects().indexOf(obj) === -1) return;

      var next = {
        left: state.leftMm * pxPerMm,
        top: state.topMm * pxPerMm
      };

      if (state.usesPointSize) {
        next.scaleX = state.scaleX;
        next.scaleY = state.scaleY;
      } else {
        next.scaleX = state.scaleX * physicalScaleRatio;
        next.scaleY = state.scaleY * physicalScaleRatio;
        if (obj.objectType === 'custom-text' && state.fontSize) next.fontSize = state.fontSize;
      }

      obj.set(next);
      var fixedScaleRatio = state.usesPointSize ? 1 : physicalScaleRatio;
      if (state.fixedScaleX !== null) obj._fixedScaleX = state.fixedScaleX * fixedScaleRatio;
      if (state.fixedScaleY !== null) obj._fixedScaleY = state.fixedScaleY * fixedScaleRatio;
      if (obj.objectType === 'custom-text') refreshTextDimensions(obj);
      else obj.setCoords();
    });

    updateSideVisibility();
    canvas.requestRenderAll();
  }

  function getCurrentDesignPhysicalBounds() {
    if (!canvas) return null;
    var currentPxPerMm = getCanvasPxPerMm();
    if (!(currentPxPerMm > 0)) return null;

    var boundsList = getAllUserDesignObjects().map(getValidationBoundsForObject).filter(Boolean);
    if (!boundsList.length) {
      return { minLeft: 0, minTop: 0, maxRight: 0, maxBottom: 0, tolerance: 2, pxPerMm: currentPxPerMm };
    }

    return {
      minLeft: Math.min.apply(null, boundsList.map(function (bounds) { return bounds.left; })),
      minTop: Math.min.apply(null, boundsList.map(function (bounds) { return bounds.top; })),
      maxRight: Math.max.apply(null, boundsList.map(function (bounds) { return bounds.right; })),
      maxBottom: Math.max.apply(null, boundsList.map(function (bounds) { return bounds.bottom; })),
      tolerance: 2,
      pxPerMm: currentPxPerMm
    };
  }

  function resizeCanvas(options) {
    options = options || {};
    const stage = dom.stage();
    if (!stage || !canvas) return;

    refreshFabricRetinaScale();

    const aspectRatio = CFG.boardWidthMm / CFG.boardHeightMm;

    // Weniger Padding auf Mobile (Vertical Stack)
    const isMobile = window.innerWidth <= 768;
    const pad = isMobile ? 8 : 64;

    // Fallback: Mindestens 700x500 wenn Stage noch keine Größe hat
    var stageW = stage.clientWidth || stage.offsetWidth || 800;
    var stageH = stage.clientHeight || stage.offsetHeight || 600;

    // Sicherheitsminimum
    if (stageW < 50) stageW = 800;
    if (stageH < 50) stageH = 600;

    var maxW = stageW - pad;
    var maxH = stageH - pad;

    var w = maxW;
    var h = w / aspectRatio;

    if (h > maxH) {
      h = maxH;
      w = h * aspectRatio;
    }

    // Absolute Minimalwerte
    w = Math.max(Math.round(w), 100);
    h = Math.max(Math.round(h), 70);

    // console.log('[SBC] Canvas resize:', w, 'x', h, '(Stage:', stageW, 'x', stageH, ')');

    var oldW = canvas.width || (typeof canvas.getWidth === 'function' ? canvas.getWidth() : 0);
    var oldH = canvas.height || (typeof canvas.getHeight === 'function' ? canvas.getHeight() : 0);

    canvas.setDimensions({ width: w, height: h });
    applyCanvasContextQuality();
    markCanvasObjectsDirty();
    if (!options.skipObjectRescale) rescaleCanvasObjectsForResize(oldW, oldH, w, h);
    pxPerMm = w / CFG.boardWidthMm;
    rescalePointSizedTextObjects();
    positionCustomBoardBrandMark();

    // Rescale background
    if (bgImage) {
      applyFabricBackground(bgImage);
    }

    // Zoom update
    if (typeof updateZoomLevel === 'function') updateZoomLevel();
    if (zoomLevel !== 1) {
      setZoom(zoomLevel);
    } else {
      var zoomLabel = document.getElementById('sbc-zoom-level');
      if (zoomLabel) zoomLabel.textContent = '100%';
    }

    refreshMeasurementGrid();
  }

  /* ==========================================
     BACKGROUND IMAGE
     ========================================== */

  // ============ PDF.JS PRE-LOADING ============
  // pdf.js sofort laden damit es bereit ist wenn Hintergründe gebraucht werden
  var _pdfJsReady = false;
  var _pdfJsCallbacks = [];
  (function preloadPdfJs() {
    if (typeof pdfjsLib !== 'undefined') { _pdfJsReady = true; return; }
    var script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
    script.onload = function () {
      pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
      _pdfJsReady = true;
      console.log('[SBC] pdf.js geladen und bereit');
      // Wartende Callbacks ausführen
      _pdfJsCallbacks.forEach(function (cb) { cb(); });
      _pdfJsCallbacks = [];
    };
    script.onerror = function () { console.warn('[SBC] pdf.js konnte nicht geladen werden'); };
    document.head.appendChild(script);
  })();

  // ============ BACKGROUND IMAGE CACHE ============
  // Gecachte Fabric.Image-Objekte nach URL → sofortiger Wechsel ohne Neuladen
  var _bgImageCache = {};
  var _bgImageLoadCache = {};
  var _pdfPreviewColorCache = {};
  var _pdfPreviewColorByBoardColor = {};
  var backgroundLoadToken = 0;

  function isCurrentBackgroundLoad(loadToken) {
    return loadToken === undefined || loadToken === backgroundLoadToken;
  }

  function getCurrentBoardColorHex() {
    var color = getCurrentBoardColor();
    if (_pdfPreviewColorByBoardColor[color]) return _pdfPreviewColorByBoardColor[color];
    var colorMeta = getColorMeta(color);
    return (colorMeta && colorMeta.hex) ? colorMeta.hex : '#ffffff';
  }

  function applyImmediateBoardColor(loadToken, options) {
    options = options || {};
    if (!canvas || !isCurrentBackgroundLoad(loadToken)) return false;

    var boardColor = options.colorHex || getCurrentBoardColorHex();
    var boardRect = new fabric.Rect({
      left: 0,
      top: 0,
      originX: 'left',
      originY: 'top',
      width: canvas.width,
      height: canvas.height,
      fill: boardColor,
      strokeWidth: 0,
      selectable: false,
      evented: false,
      objectCaching: false
    });

    // Fabric transformiert ein backgroundImage mit dem Viewport, eine reine
    // backgroundColor-Fläche dagegen nicht. Die Wandfarbe ist deshalb selbst
    // ein Hintergrundobjekt; beim Herauszoomen bleiben Wand und Werkzeuge in
    // derselben Koordinatenbasis und die echten Wandgrenzen sichtbar.
    canvas.setBackgroundColor(CANVAS_STAGE_COLOR, function () {});
    bgImage = boardRect;
    canvas.setBackgroundImage(boardRect, function () {
      if (isCurrentBackgroundLoad(loadToken)) canvas.requestRenderAll();
    });
    return true;
  }

  function loadBackground(url, loadToken) {
    if (!url || !canvas || !isCurrentBackgroundLoad(loadToken)) return Promise.resolve(false);

    // Aus Cache laden? → sofort anzeigen
    if (_bgImageCache[url]) {
      return Promise.resolve(applyFabricBackground(_bgImageCache[url], loadToken));
    }

    // PDF → mit pdf.js rendern
    if (url.toLowerCase().endsWith('.pdf')) {
      console.log('[SBC] PDF-Hintergrund erkannt:', url);
      return loadPdfAsBackground(url, loadToken);
    }

    // SVG → Spezielles Handling für Vektor-Skalierung
    if (isSvgUrl(url)) {
      console.log('[SBC] SVG-Hintergrund erkannt:', url);
      return new Promise(function (resolve) {
        fabric.loadSVGFromURL(url, function (objects, options) {
          if (!objects || objects.length === 0) {
            console.warn('[SBC] SVG leer oder Fehler beim Parsen');
            resolve();
            return;
          }
          var svgGroup = fabric.util.groupSVGElements(objects, options);
          if (!svgGroup) {
            resolve();
            return;
          }

          // Maße ermitteln
          var svgW = options.width;
          var svgH = options.height;

          // Fallback auf viewBox Attribute im options-Objekt (Fabric parsed diese oft)
          if (!svgW && (options.viewBoxWidth || options.viewBoxHeight)) {
            svgW = options.viewBoxWidth;
            svgH = options.viewBoxHeight;
          }

          // Fallback: Group dimensions
          if (!svgW) svgW = svgGroup.width;
          if (!svgH) svgH = svgGroup.height;

          if (!svgW || !svgH || svgW === 0 || svgH === 0) {
            console.warn('[SBC] SVG hat keine gültigen Maße:', svgW, svgH);
            resolve();
            return;
          }

          // Ziel-Maße (Canvas)
          var targetW = canvas.width;
          var targetH = canvas.height;

          // Scale berechnen
          var scX = targetW / svgW;
          var scY = targetH / svgH;

          svgGroup.set({
            originX: 'left',
            originY: 'top',
            left: 0,
            top: 0,
            scaleX: scX,
            scaleY: scY
          });
          applyCrispRendering(svgGroup);

          if (!isCurrentBackgroundLoad(loadToken)) {
            resolve(false);
            return;
          }

          // Als Hintergrund setzen
          canvas.setBackgroundImage(svgGroup, canvas.renderAll.bind(canvas));
          console.log('[SBC] SVG-Hintergrund gesetzt', svgW, 'x', svgH);
          resolve(true);

        }, null, { crossOrigin: 'anonymous' });
      });
    }

    // Normales Bild
    var imageLoad = _bgImageLoadCache[url];
    if (!imageLoad) {
      imageLoad = new Promise(function (resolve) {
        fabric.Image.fromURL(url, function (img) {
          resolve(img || null);
        }, { crossOrigin: 'anonymous' });
      }).then(function (img) {
        delete _bgImageLoadCache[url];
        if (!img) return null;
        _bgImageCache[url] = img; // Cache für nächstes Mal
        return img;
      }, function (err) {
        delete _bgImageLoadCache[url];
        throw err;
      });
      _bgImageLoadCache[url] = imageLoad;
    }

    return imageLoad.then(function (img) {
      if (!img) return false;
      return applyFabricBackground(img, loadToken);
    }).catch(function (err) {
      console.warn('[SBC] Hintergrundbild konnte nicht geladen werden:', err && err.message ? err.message : err);
      applyFallbackColor(loadToken);
      return false;
    });
  }

  /** Fabric.Image als Hintergrund setzen (wiederverwendbare Helfer-Funktion) */
  function applyFabricBackground(img, loadToken) {
    if (!canvas || !img || !isCurrentBackgroundLoad(loadToken)) return false;
    img.set({
      selectable: false,
      evented: false,
      originX: 'left',
      originY: 'top',
      scaleX: canvas.width / img.width,
      scaleY: canvas.height / img.height
    });
    applyCrispRendering(img);
    bgImage = img;
    canvas.setBackgroundColor(CANVAS_STAGE_COLOR, function () {});
    canvas.setBackgroundImage(img, canvas.requestRenderAll.bind(canvas));
    return true;
  }

  function getCustomBoardBrandVariant(colorKey) {
    var key = String(colorKey || '').toLowerCase();
    return key === 'white' ? 'black' : 'white';
  }

  function getCustomBoardBrandLogoUrl(variant) {
    var configuredUrl = variant === 'black' ? CFG.customBoardLogoBlack : CFG.customBoardLogoWhite;
    if (configuredUrl) return configuredUrl;

    var fileName = variant === 'black' ? 'custom-board-logo-black.svg' : 'custom-board-logo-white.svg';
    var script = document.currentScript || document.querySelector('script[src*="shadow-board-configurator.js"]');
    if (script && script.src) {
      try {
        return new URL(fileName, script.src).toString();
      } catch (e) {
        return fileName;
      }
    }
    return fileName;
  }

  function removeCustomBoardBrandMark() {
    customBoardBrandLoadToken += 1;
    if (customBoardBrandMark && canvas) {
      canvas.remove(customBoardBrandMark);
    }
    customBoardBrandMark = null;
    customBoardBrandVariant = '';
  }

  function getCustomBoardBrandWidthMm() {
    return Math.max(
      CUSTOM_BOARD_BRAND_MIN_WIDTH_MM,
      Math.min(CUSTOM_BOARD_BRAND_MAX_WIDTH_MM, CFG.boardWidthMm * 0.11)
    );
  }

  function positionCustomBoardBrandMark() {
    if (!canvas || !customBoardBrandMark || !selectedSizeIsCustom) return;

    if (canvas.getObjects().indexOf(customBoardBrandMark) === -1) {
      canvas.add(customBoardBrandMark);
    }

    var widthMm = getCustomBoardBrandWidthMm();
    var heightMm = widthMm / CUSTOM_BOARD_BRAND_ASPECT_RATIO;
    var widthPx = widthMm * pxPerMm;
    var heightPx = heightMm * pxPerMm;
    var marginPx = CUSTOM_BOARD_BRAND_MARGIN_MM * pxPerMm;
    var naturalW = customBoardBrandMark.width || widthPx;
    var naturalH = customBoardBrandMark.height || heightPx;
    var scaleX = naturalW ? widthPx / naturalW : 1;
    var scaleY = naturalH ? heightPx / naturalH : scaleX;

    customBoardBrandMark.set({
      left: canvas.width - marginPx - (widthPx / 2),
      top: canvas.height - marginPx - (heightPx / 2),
      originX: 'center',
      originY: 'center',
      scaleX: scaleX,
      scaleY: scaleY,
      selectable: false,
      evented: false,
      hasControls: false,
      hasBorders: false,
      hoverCursor: 'default',
      excludeFromExport: false,
      visible: true
    });
    applyCrispRendering(customBoardBrandMark);
    if (typeof canvas.bringToFront === 'function') canvas.bringToFront(customBoardBrandMark);
    canvas.requestRenderAll();
  }

  function loadCustomBoardBrandMark(url) {
    return new Promise(function (resolve) {
      var settled = false;
      var timeout = setTimeout(function () {
        finish(null);
      }, 1800);

      function finish(mark) {
        if (settled) return;
        settled = true;
        clearTimeout(timeout);
        resolve(mark || null);
      }

      if (!url) {
        finish(null);
        return;
      }

      if (isSvgUrl(url)) {
        fetch(url, { credentials: 'same-origin' })
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.text();
          })
          .then(function (svgText) {
            svgText = normalizeSvgForFabric(svgText);
            fabric.loadSVGFromString(svgText, function (objects, options) {
              if (!objects || !objects.length) {
                finish(null);
                return;
              }
              finish(fabric.util.groupSVGElements(objects, options));
            });
          })
          .catch(function (err) {
            console.warn('[SBC] Custom-SVG-Logo konnte nicht geladen werden:', err && err.message ? err.message : err);
            finish(null);
          });
        return;
      }

      fabric.Image.fromURL(url, function (img) {
        finish(img || null);
      }, { crossOrigin: 'anonymous' });
    });
  }

  function updateCustomBoardBrandMark() {
    if (!canvas) return Promise.resolve();
    if (!selectedSizeIsCustom) {
      removeCustomBoardBrandMark();
      return Promise.resolve();
    }

    var variant = getCustomBoardBrandVariant(getCurrentBoardColor());
    var url = getCustomBoardBrandLogoUrl(variant);
    if (!url) {
      removeCustomBoardBrandMark();
      return Promise.resolve();
    }

    if (customBoardBrandMark && customBoardBrandVariant === variant) {
      positionCustomBoardBrandMark();
      return Promise.resolve();
    }

    removeCustomBoardBrandMark();
    var loadToken = ++customBoardBrandLoadToken;
    return loadCustomBoardBrandMark(url).then(function (mark) {
      if (loadToken !== customBoardBrandLoadToken || !canvas || !selectedSizeIsCustom) return;
      if (!mark) mark = createFallbackCustomBoardBrandMark(variant);
      if (!mark) return;
      mark.set({
        objectType: 'custom-board-brand-mark',
        isCustomBoardBrandMark: true,
        sbcSide: currentSide || 'front',
        selectable: false,
        evented: false,
        hasControls: false,
        hasBorders: false
      });
      customBoardBrandMark = mark;
      customBoardBrandVariant = variant;
      canvas.add(mark);
      positionCustomBoardBrandMark();
    }).catch(function (err) {
      console.warn('[SBC] Custom-Logo konnte nicht geladen werden:', err && err.message ? err.message : err);
      if (loadToken !== customBoardBrandLoadToken || !canvas || !selectedSizeIsCustom) return;
      var fallbackMark = createFallbackCustomBoardBrandMark(variant);
      if (!fallbackMark) return;
      fallbackMark.set({
        objectType: 'custom-board-brand-mark',
        isCustomBoardBrandMark: true,
        sbcSide: currentSide || 'front',
        selectable: false,
        evented: false,
        hasControls: false,
        hasBorders: false
      });
      customBoardBrandMark = fallbackMark;
      customBoardBrandVariant = variant;
      positionCustomBoardBrandMark();
    });
  }

  function createFallbackCustomBoardBrandMark(variant) {
    if (typeof fabric === 'undefined') return null;
    var dark = variant === 'black';
    var ink = dark ? '#1d1d1b' : '#ffffff';
    var panelFill = dark ? '#ffffff' : 'transparent';
    var panelStroke = ink;
    var fontStack = 'Arial, Helvetica, sans-serif';

    var qrPanel = new fabric.Rect({
      left: 0,
      top: 0,
      width: 150,
      height: 150,
      rx: 8,
      ry: 8,
      fill: panelFill,
      stroke: panelStroke,
      strokeWidth: 2
    });
    var qrText = new fabric.Text('QR Code\nKonformität &\nBestellung', {
      left: 75,
      top: 73,
      originX: 'center',
      originY: 'center',
      fill: ink,
      fontFamily: fontStack,
      fontSize: 20,
      fontWeight: '700',
      textAlign: 'center',
      lineHeight: 1.16
    });
    var logoPanel = new fabric.Rect({
      left: 165,
      top: 0,
      width: 150,
      height: 150,
      rx: 8,
      ry: 8,
      fill: panelFill,
      stroke: panelStroke,
      strokeWidth: 2
    });
    var optiText = new fabric.Text('opti', {
      left: 240,
      top: 48,
      originX: 'center',
      originY: 'center',
      fill: ink,
      fontFamily: fontStack,
      fontSize: 58,
      fontWeight: '400',
      textAlign: 'center',
      lineHeight: 0.9
    });
    var leanText = new fabric.Text('lean', {
      left: 240,
      top: 103,
      originX: 'center',
      originY: 'center',
      fill: ink,
      fontFamily: fontStack,
      fontSize: 64,
      fontWeight: '700',
      textAlign: 'center',
      lineHeight: 0.9
    });
    var urlText = new fabric.Text('www.optilean.shop', {
      left: 157.5,
      top: 170,
      originX: 'center',
      originY: 'center',
      fill: ink,
      fontFamily: fontStack,
      fontSize: 20,
      fontWeight: '700',
      textAlign: 'center'
    });

    return new fabric.Group([qrPanel, qrText, logoPanel, optiText, leanText, urlText], {
      originX: 'left',
      originY: 'top',
      objectCaching: false
    });
  }

  /** PDF-Datei als Hintergrund laden: Seite 1 → hochauflösendes Bild → Cache */
  function loadPdfAsBackground(pdfUrl, loadToken) {
    if (_pdfJsReady) return renderPdfToBackground(pdfUrl, loadToken);

    return new Promise(function (resolve) {
      // pdf.js noch nicht fertig → in Warteschlange
      _pdfJsCallbacks.push(function () {
        renderPdfToBackground(pdfUrl, loadToken).then(resolve).catch(function () { resolve(false); });
      });
    });
  }

  function renderPdfToBackground(pdfUrl, loadToken) {
    if (!isCurrentBackgroundLoad(loadToken)) return Promise.resolve(false);

    applyImmediateBoardColor(loadToken, { clearImage: true });

    return pdfjsLib.getDocument({ url: pdfUrl, cMapUrl: 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/cmaps/', cMapPacked: true }).promise.then(function (pdf) {
      return pdf.getPage(1);
    }).then(function (page) {
      // Scharfe Auflösung: Ziel-Canvas-Breite × 4 für Retina-Qualität
      var targetWidth = Math.max(canvas.width, 1200) * 2;
      var defaultViewport = page.getViewport({ scale: 1 });
      var scale = targetWidth / defaultViewport.width;
      var viewport = page.getViewport({ scale: scale });

      var tmpCanvas = document.createElement('canvas');
      tmpCanvas.width = viewport.width;
      tmpCanvas.height = viewport.height;
      var ctx = tmpCanvas.getContext('2d');

      return page.render({ canvasContext: ctx, viewport: viewport }).promise.then(function () {
        // Blob statt dataURL für bessere Performance
        return new Promise(function (resolve) {
          tmpCanvas.toBlob(function (blob) {
            var blobUrl = URL.createObjectURL(blob);
            fabric.Image.fromURL(blobUrl, function (img) {
              if (!img) {
                applyFallbackColor(loadToken);
                resolve(false);
                return;
              }
              if (!isCurrentBackgroundLoad(loadToken)) {
                resolve(false);
                return;
              }
              _bgImageCache[pdfUrl] = img; // Cache!
              applyFabricBackground(img, loadToken);
              console.log('[SBC] PDF-Hintergrund gerendert (' + viewport.width + 'x' + viewport.height + 'px)');
              // tmpCanvas Speicher freigeben
              tmpCanvas.width = 1;
              tmpCanvas.height = 1;
              resolve(true);
            });
          }, 'image/png');
        });
      });
    }).catch(function (err) {
      console.warn('[SBC] PDF konnte nicht gerendert werden:', err.message);
      applyFallbackColor(loadToken);
      return false;
    });
  }

  function getReferencePdfForBoardColor(color) {
    var candidates = backgroundsCache.filter(function (background) {
      var url = background && background.imageUrl;
      return background && background.color === color && url && /\.pdf(?:$|\?)/i.test(url);
    });
    candidates.sort(function (a, b) {
      var aPriority = a.size === '700x500' ? 0 : (a.size === '500x700' ? 1 : 2);
      var bPriority = b.size === '700x500' ? 0 : (b.size === '500x700' ? 1 : 2);
      return aPriority - bPriority;
    });
    return candidates.length ? candidates[0].imageUrl : '';
  }

  function samplePdfBoardColor(renderCanvas) {
    var context = renderCanvas && renderCanvas.getContext('2d');
    if (!context || !renderCanvas.width || !renderCanvas.height) return '';

    var centerX = Math.floor(renderCanvas.width / 2);
    var centerY = Math.floor(renderCanvas.height / 2);
    var sampleSize = Math.max(1, Math.min(7, centerX, centerY));
    var imageData = context.getImageData(
      centerX - Math.floor(sampleSize / 2),
      centerY - Math.floor(sampleSize / 2),
      sampleSize,
      sampleSize
    ).data;
    var colors = {};
    var mostCommonColor = '';
    var mostCommonCount = 0;

    for (var index = 0; index < imageData.length; index += 4) {
      if (imageData[index + 3] < 250) continue;
      var hex = '#' + [imageData[index], imageData[index + 1], imageData[index + 2]].map(function (channel) {
        return channel.toString(16).padStart(2, '0');
      }).join('');
      colors[hex] = (colors[hex] || 0) + 1;
      if (colors[hex] > mostCommonCount) {
        mostCommonColor = hex;
        mostCommonCount = colors[hex];
      }
    }
    return mostCommonColor;
  }

  function renderPdfBoardColor(pdfUrl) {
    return pdfjsLib.getDocument({ url: pdfUrl, cMapUrl: 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/cmaps/', cMapPacked: true }).promise.then(function (pdf) {
      return pdf.getPage(1);
    }).then(function (page) {
      var defaultViewport = page.getViewport({ scale: 1 });
      var viewport = page.getViewport({ scale: 160 / defaultViewport.width });
      var renderCanvas = document.createElement('canvas');
      renderCanvas.width = Math.max(1, Math.ceil(viewport.width));
      renderCanvas.height = Math.max(1, Math.ceil(viewport.height));
      var context = renderCanvas.getContext('2d');

      return page.render({ canvasContext: context, viewport: viewport }).promise.then(function () {
        var color = samplePdfBoardColor(renderCanvas);
        renderCanvas.width = 1;
        renderCanvas.height = 1;
        return color;
      });
    });
  }

  function getPdfBoardPreviewColor(pdfUrl) {
    if (!pdfUrl) return Promise.resolve('');
    if (_pdfPreviewColorCache[pdfUrl]) return _pdfPreviewColorCache[pdfUrl];

    _pdfPreviewColorCache[pdfUrl] = new Promise(function (resolve) {
      function render() {
        renderPdfBoardColor(pdfUrl).then(resolve).catch(function (error) {
          console.warn('[SBC] PDF-Farbwert konnte nicht ermittelt werden:', error && error.message ? error.message : error);
          resolve('');
        });
      }

      if (_pdfJsReady) render();
      else _pdfJsCallbacks.push(render);
    });
    return _pdfPreviewColorCache[pdfUrl];
  }

  function applyPdfMatchedCustomBoardColor(color, loadToken) {
    var referencePdfUrl = getReferencePdfForBoardColor(color);
    if (!referencePdfUrl) return Promise.resolve(false);

    return getPdfBoardPreviewColor(referencePdfUrl).then(function (previewColor) {
      if (!previewColor || !selectedSizeIsCustom || !isCurrentBackgroundLoad(loadToken) || getCurrentBoardColor() !== color) {
        return false;
      }
      _pdfPreviewColorByBoardColor[color] = previewColor;
      console.log('[SBC] Sondermaß-Farbe an Produktions-PDF angeglichen:', color, previewColor);
      return applyImmediateBoardColor(loadToken, { colorHex: previewColor });
    });
  }

  function applyFallbackColor(loadToken) {
    return applyImmediateBoardColor(loadToken, { clearImage: true });
  }

  /** Hintergründe von der API laden (nach Größe: 700x500, 800x1900, …). */
  function loadBackgroundsFromApi() {
    if (!CFG.backendUrl || !CFG.backendUrl.trim()) return;
    var url = (CFG.backendUrl.replace(/\/+$/, '')) + '/api/backgrounds?t=' + Date.now();
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (list) {
        backgroundsCache = list || [];
        console.log('[SBC] Hintergründe geladen:', backgroundsCache.length, list);

        // Initiale Farbe setzen (falls nicht vorhanden)
        if (!selectedColor) selectedColor = 'white';

        updateColorOptions(); // UI für Farben rendern

        // WICHTIG: Hintergrund nach Laden anwenden (falls Größe bereits gesetzt)
        if (CFG.boardWidthMm && CFG.boardHeightMm) {
          console.log('[SBC] Wende Hintergrund an für:', CFG.boardWidthMm + 'x' + CFG.boardHeightMm);
          applyBackgroundForCurrentSize();
        }
      })
      .catch(function (e) { console.warn('[SBC] Hintergründe konnten nicht geladen werden:', e.message); });
  }

  /** Verfügbare Farben für die aktuelle Größe ermitteln und UI rendern */
  function updateColorOptions() {
    if (!CFG.boardWidthMm || !CFG.boardHeightMm) return;

    var sizeKey = CFG.boardWidthMm + 'x' + CFG.boardHeightMm;
    if (selectedSizeIsCustom && selectedProduct && Array.isArray(selectedProduct.variants)) {
      var customColors = selectedProduct.variants.map(function (variant) {
        return variantNameToBackendColor(variant.option1 || variant.title);
      }).filter(function (color, index, arr) {
        return color && arr.indexOf(color) === index && isColorOptionVisible(color);
      });
      if (customColors.length === 0) {
        customColors = getConfiguredColorOptions().filter(function (color) {
          return color.visible !== false;
        }).map(function (color) { return color.key; });
      }
      customColors = sortColorKeys(customColors);
      console.log('[SBC] Verfügbare Farben für Sondermaß', sizeKey, ':', customColors);
      renderColorSelector(customColors);
      return;
    }

    var validBgs = backgroundsCache.filter(function (b) {
      // Größe prüfen (mit Toleranz oder String-Vergleich)
      return b.size === sizeKey || (Math.abs(b.widthMm - CFG.boardWidthMm) < 1 && Math.abs(b.heightMm - CFG.boardHeightMm) < 1);
    });

    var colors = [];
    validBgs.forEach(function (b) {
      if (b.color && !colors.includes(b.color)) colors.push(b.color);
    });

    colors = colors.filter(isColorOptionVisible);

    // WICHTIG: Weiß immer als erste Option anzeigen (falls vorhanden im COLOR_MAP)
    if (!colors.includes('white') && validBgs.length > 0 && isColorOptionVisible('white')) {
      colors.unshift('white'); // Am Anfang einfügen
    }

    // Fallback: Wenn gar keine Hintergründe, trotzdem weiß anbieten
    if (colors.length === 0) colors = isColorOptionVisible('white') ? ['white'] : getConfiguredColorOptions().filter(function (color) {
      return color.visible !== false;
    }).map(function (color) { return color.key; }).slice(0, 1);

    colors = sortColorKeys(colors);
    if (colors.length && !selectedColor && activeColorSide === 'front') {
      selectedColor = colors[0];
      if (!selectedBackColorCustomized) selectedBackColor = selectedColor;
    }
    if (colors.length && !selectedBackColor && activeColorSide === 'back') {
      selectedBackColor = colors[0];
    }

    console.log('[SBC] Verfügbare Farben für', sizeKey, ':', colors);
    renderColorSelector(colors);
  }

  function renderColorSelector(colors) {
    var container = document.getElementById('sbc-color-selector');
    if (!container) {
      // Container erstellen falls nicht vorhanden (in Sidebar Step 1)
      var step1 = document.getElementById('step-1');
      if (step1) {
        container = document.createElement('div');
        container.id = 'sbc-color-selector';
        container.style.marginTop = '15px';
        container.style.borderTop = '1px solid #eee';
        container.style.paddingTop = '15px';
        // Nach Größen-Grid einfügen
        var sizeGrid = step1.querySelector('.sbc-size-grid');
        if (sizeGrid && sizeGrid.nextSibling) {
          step1.insertBefore(container, sizeGrid.nextSibling);
        } else {
          step1.appendChild(container);
        }
      } else {
        return;
      }
    }

    if (colors.length === 0) {
      container.style.display = 'none';
      return;
    }

    container.style.display = 'block';

    // Mapping uses global COLOR_MAP

    var html = '<div class="sbc-step__label">Farbe wählen</div><div class="sbc-board-color-grid" style="display:flex;gap:10px;flex-wrap:wrap;">';

    var activeColor = activeColorSide === 'back' ? selectedBackColor : selectedColor;
    colors.forEach(function (c) {
      var meta = getColorMeta(c);
      var activeClass = (activeColor === c) ? ' sbc-color-swatch--active' : '';

      html += '<div class="sbc-color-swatch' + activeClass + '" data-color="' + c + '" ' +
        'style="width:32px;height:32px;border-radius:50%;background:' + meta.hex + ';border:2px solid ' + meta.border + ';cursor:pointer;position:relative;" ' +
        'title="' + meta.label + '">' +
        (activeColor === c ? '<span style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);color:' + (c === 'white' ? '#000' : '#fff') + ';font-size:16px;">✓</span>' : '') +
        '</div>';
    });

    html += '</div>';
    container.innerHTML = html;

    // Click Handler
    var swatches = container.querySelectorAll('.sbc-color-swatch');
    swatches.forEach(function (el) {
      el.addEventListener('click', function () {
        var newColor = this.dataset.color;
        console.log('[SBC] Farbwechsel:', activeColorSide, '->', newColor);
        if (activeColorSide === 'back') {
          selectedBackColor = newColor;
          selectedBackColorCustomized = true;
        } else {
          selectedColor = newColor;
          if (!selectedBackColorCustomized) selectedBackColor = newColor;
        }
        updateColorOptions(); // Re-render für Active State
        applyBackgroundForCurrentSize();
        refreshPlacedShadowToolsForCurrentColors();
        updateSelectedProductTitle();
        updateTotalPrice();
        updateCartButton();
        updateLeadButton();
        scheduleDraftAutosave();
      });
    });
  }

  /** Passenden Hintergrund zur aktuellen Größe UND FARBE setzen. */
  function applyBackgroundForCurrentSize() {
    if (!canvas) return Promise.resolve();
    var loadToken = ++backgroundLoadToken;

    // 1. Größe prüfen
    var w = CFG.boardWidthMm;
    var h = CFG.boardHeightMm;
    var color = getCurrentBoardColor();

    if (selectedSizeIsCustom) {
      console.log('[SBC] Sondermaß: verwende nur Farbfläche als Hintergrund:', w + 'x' + h, color);
      applyFallbackColor(loadToken);
      return Promise.all([
        updateCustomBoardBrandMark(),
        applyPdfMatchedCustomBoardColor(color, loadToken)
      ]).then(function () {
        if (isCurrentBackgroundLoad(loadToken) && typeof renderToolsFiltered === 'function') renderToolsFiltered();
      });
    }

    removeCustomBoardBrandMark();

    // Sofort sichtbare Farbfläche zeigen, während die konkrete Hintergrunddatei lädt.
    applyImmediateBoardColor(loadToken, { clearImage: true });

    console.log('[SBC] Suche Hintergrund:', w + 'x' + h, 'Farbe:', color);

    // 2. Passenden Hintergrund suchen (Größe + Farbe)
    var bg = backgroundsCache.find(function (b) {
      if (!b.imageUrl) return false;
      var matchSize = (Math.abs(b.widthMm - w) < 1 && Math.abs(b.heightMm - h) < 1) || b.size === (w + 'x' + h);
      var matchColor = (b.color || 'white') === color;
      return matchSize && matchColor;
    });

    if (bg && bg.imageUrl) {
      console.log('[SBC] Hintergrund gefunden:', bg.name, bg.color, bg.imageUrl);

      return loadBackground(bg.imageUrl, loadToken).then(function () {
        if (isCurrentBackgroundLoad(loadToken) && typeof renderToolsFiltered === 'function') renderToolsFiltered();
      });
    } else {
      console.warn('[SBC] Kein exaktes Hintergrund-Bild gefunden für:', w + 'x' + h, color);
      applyFallbackColor(loadToken);
    }

    if (isCurrentBackgroundLoad(loadToken) && typeof renderToolsFiltered === 'function') renderToolsFiltered();
    return Promise.resolve();
  }

  /* ==========================================
     CANVAS EVENTS
     ========================================== */

	  function setupCanvasEvents() {
	    canvas.on('object:moving', function (e) {
	      keepObjectRecoverableOnCanvas(e.target);
	      showSnapGuides(e.target);
      checkBounds(e.target);
      checkOverlapVisual(e.target);
      refreshMeasurementGrid();
    });

    canvas.on('object:moved', function (e) {
      clearSnapGuides();
      applySnap(e.target);
      keepObjectRecoverableOnCanvas(e.target);
      if (e.target && e.target.objectType === 'custom-text') {
        keepObjectWithinCanvas(e.target, TEXT_FIT_PADDING);
      }
      checkBounds(e.target);
      checkOverlapVisual(e.target);
      updateCartButton();
      refreshMeasurementGrid();
    });

    canvas.on('object:scaling', function (e) {
      clearSnapGuides();
      const obj = e.target;
      // Normale Schatten-Werkzeuge bleiben maßhaltig; Überschriften/Symbole dürfen skaliert werden.
      if (obj.objectType === 'shadow-tool' && !isScalableShadowTool(obj)) {
        applyShadowToolConstraints(obj);
        obj.set({ scaleX: obj._fixedScaleX || 1, scaleY: obj._fixedScaleY || 1 });
      }
      keepObjectRecoverableOnCanvas(obj);
      checkBounds(obj);
      refreshMeasurementGrid();
    });

    canvas.on('object:rotated', function (e) {
      clearSnapGuides();
      if (e.target && e.target.objectType === 'shadow-tool') {
        applyShadowToolConstraints(e.target);
        e.target.set({ angle: 0 });
      }
      keepObjectRecoverableOnCanvas(e.target);
      checkBounds(e.target);
      refreshMeasurementGrid();
    });

    canvas.on('object:modified', function (e) {
      clearSnapGuides();
      if (e.target) {
        checkBounds(e.target);
        checkOverlapVisual(e.target);
      } else {
        syncCanvasUi();
      }
      refreshMeasurementGrid();
    });

    canvas.on('selection:cleared', function () {
      clearSnapGuides();
      refreshMeasurementGrid();
    });

    canvas.on('mouse:wheel', handleCanvasWheel);
    canvas.on('mouse:down', handleCanvasPanStart);
    canvas.on('mouse:move', handleCanvasPanMove);

    canvas.on('mouse:up', function () {
      endCanvasPan();
      clearSnapGuides();
      refreshMeasurementGrid();
      canvas.requestRenderAll();
    });
  }

  function getClientPointFromCanvasEvent(event) {
    if (!event) return null;
    var touch = event.touches && event.touches[0] ? event.touches[0] :
      (event.changedTouches && event.changedTouches[0] ? event.changedTouches[0] : null);
    if (touch) return { x: touch.clientX, y: touch.clientY };
    if (typeof event.clientX === 'number' && typeof event.clientY === 'number') {
      return { x: event.clientX, y: event.clientY };
    }
    return null;
  }

  function getCanvasCenterPoint() {
    return new fabric.Point(canvas.width / 2, canvas.height / 2);
  }

  function getZoomAnchorPoint() {
    if (!canvas) return null;
    return getCanvasCenterPoint();
  }

  function updateCanvasViewportCursor() {
    if (!canvas || !canvas.upperCanvasEl) return;
    if (isCanvasPanning) {
      canvas.defaultCursor = 'grabbing';
      canvas.upperCanvasEl.style.cursor = 'grabbing';
      return;
    }
    canvas.defaultCursor = zoomLevel !== 1 ? 'grab' : 'default';
    canvas.upperCanvasEl.style.cursor = '';
  }

  function panCanvasBy(deltaX, deltaY) {
    if (!canvas) return;
    var vpt = canvas.viewportTransform || [1, 0, 0, 1, 0, 0];
    vpt[4] += deltaX;
    vpt[5] += deltaY;
    canvas.setViewportTransform(vpt);
    canvas.requestRenderAll();
  }

  function handleCanvasWheel(opt) {
    if (!canvas || !opt || !opt.e) return;
    var event = opt.e;

    if (event.ctrlKey || event.metaKey) {
      var zoomDelta = event.deltaY > 0 ? -ZOOM_STEP : ZOOM_STEP;
      setZoom(Math.round((zoomLevel + zoomDelta) * 100) / 100);
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (zoomLevel !== 1) {
      panCanvasBy(-(event.deltaX || 0), -(event.deltaY || 0));
      event.preventDefault();
      event.stopPropagation();
    }
  }

  function shouldStartCanvasPan(opt) {
    if (!canvas || !opt || !opt.e || zoomLevel === 1) return false;
    var event = opt.e;
    var forcedPan = event.altKey || event.button === 1;
    return forcedPan || !opt.target;
  }

  function handleCanvasPanStart(opt) {
    if (!shouldStartCanvasPan(opt)) return;
    var client = getClientPointFromCanvasEvent(opt.e);
    if (!client) return;

    isCanvasPanning = true;
    canvasPanLastPoint = client;
    canvasPanSelectionState = canvas.selection;
    canvasPanSkipTargetFindState = canvas.skipTargetFind === true;
    canvas.selection = false;
    if (opt.e.altKey || opt.e.button === 1) {
      canvas.skipTargetFind = true;
      canvas.discardActiveObject();
    }
    updateCanvasViewportCursor();
    opt.e.preventDefault();
    opt.e.stopPropagation();
  }

  function handleCanvasPanMove(opt) {
    if (!canvas || !opt || !opt.e) return;

    if (!isCanvasPanning) return;
    var client = getClientPointFromCanvasEvent(opt.e);
    if (!client || !canvasPanLastPoint) return;
    panCanvasBy(client.x - canvasPanLastPoint.x, client.y - canvasPanLastPoint.y);
    canvasPanLastPoint = client;
    opt.e.preventDefault();
    opt.e.stopPropagation();
  }

  function endCanvasPan() {
    if (!canvas || !isCanvasPanning) return;
    isCanvasPanning = false;
    canvasPanLastPoint = null;
    canvas.selection = canvasPanSelectionState;
    canvas.skipTargetFind = canvasPanSkipTargetFindState;
    updateCanvasViewportCursor();
  }

  /* ==========================================
     SNAPPING
     ========================================== */

  function applySnap(obj) {
    if (!obj) return;
    var snap = calculateSnapForObject(obj);
    var snapped = false;

    if (snap.x && Math.abs(snap.x.delta) > 0) {
      obj.set({ left: obj.left + snap.x.delta });
      snapped = true;
    }
    if (snap.y && Math.abs(snap.y.delta) > 0) {
      obj.set({ top: obj.top + snap.y.delta });
      snapped = true;
    }

    if (snapped) {
      obj.setCoords();
      canvas.requestRenderAll();
    }
  }

  function showSnapGuides(obj) {
    clearSnapGuides();
    if (!obj || !isUserDesignObject(obj)) return;

    var snap = calculateSnapForObject(obj);
    var snapped = false;

    if (snap.x) {
      if (Math.abs(snap.x.delta) > 0) {
        obj.set({ left: obj.left + snap.x.delta });
        snapped = true;
      }
      addSnapGuideLine('x', snap.x.value);
    }

    if (snap.y) {
      if (Math.abs(snap.y.delta) > 0) {
        obj.set({ top: obj.top + snap.y.delta });
        snapped = true;
      }
      addSnapGuideLine('y', snap.y.value);
    }

    if (snapped) {
      obj.setCoords();
    }

    canvas.requestRenderAll();
  }

  function clearSnapGuides() {
    if (!canvas || !snapLines.length) return;
    snapLines.forEach(function (line) { canvas.remove(line); });
    snapLines = [];
  }

  function getSnapBoundsForObject(obj) {
    var bounds = getVisibleShadowSnapBoundsForObject(obj) || getCanvasBoundsForObject(obj);
    if (!bounds) return null;
    return Object.assign({}, bounds, {
      centerX: bounds.left + bounds.width / 2,
      centerY: bounds.top + bounds.height / 2
    });
  }

  function getVisibleShadowSnapBoundsForObject(obj) {
    if (!canvas || !obj || obj.objectType !== 'shadow-tool') return null;

    var bounds = getCanvasBoundsForObject(obj);
    if (!bounds || bounds.width <= 0 || bounds.height <= 0) return null;

    var cacheKey = [
      Math.round(bounds.width),
      Math.round(bounds.height),
      Math.round((obj.scaleX || 1) * 10000),
      Math.round((obj.scaleY || 1) * 10000),
      Math.round((obj.angle || 0) * 1000),
      obj.toolId || '',
      Math.round(obj.width || 0),
      Math.round(obj.height || 0)
    ].join('|');

    if (obj._sbcVisibleSnapCache && obj._sbcVisibleSnapCache.key === cacheKey) {
      return offsetBoundsFromCache(bounds, obj._sbcVisibleSnapCache.offsets);
    }

    var rect = {
      left: bounds.left,
      top: bounds.top,
      width: Math.max(1, Math.ceil(bounds.width)),
      height: Math.max(1, Math.ceil(bounds.height))
    };
    var mask = renderObjectAlphaMask(obj, rect);
    if (!mask) return null;

    var minX = rect.width;
    var minY = rect.height;
    var maxX = -1;
    var maxY = -1;

    for (var y = 0; y < rect.height; y++) {
      for (var x = 0; x < rect.width; x++) {
        var index = ((y * rect.width) + x) * 4;
        if (!isVisibleShadowPixel(mask, index)) continue;
        if (x < minX) minX = x;
        if (x > maxX) maxX = x;
        if (y < minY) minY = y;
        if (y > maxY) maxY = y;
      }
    }

    if (maxX < minX || maxY < minY) return null;

    var offsets = {
      left: minX,
      top: minY,
      right: maxX + 1,
      bottom: maxY + 1
    };
    obj._sbcVisibleSnapCache = { key: cacheKey, offsets: offsets };
    return offsetBoundsFromCache(bounds, offsets);
  }

  function offsetBoundsFromCache(bounds, offsets) {
    if (!bounds || !offsets) return null;
    var left = bounds.left + offsets.left;
    var top = bounds.top + offsets.top;
    var right = bounds.left + offsets.right;
    var bottom = bounds.top + offsets.bottom;
    return {
      left: left,
      top: top,
      right: right,
      bottom: bottom,
      width: right - left,
      height: bottom - top
    };
  }

  function isVisibleShadowPixel(mask, index) {
    var alpha = mask[index + 3];
    if (alpha <= TOOL_OVERLAP_ALPHA_THRESHOLD) return false;

    // Hilfslinien sollen auf die echte weiße Schattenform reagieren, nicht auf
    // transparente SVG-/PNG-Ränder oder die Fabric-Auswahlbox.
    var r = mask[index];
    var g = mask[index + 1];
    var b = mask[index + 2];
    return r >= 218 && g >= 218 && b >= 218;
  }

  function getSnapPoints(bounds, axis) {
    if (!bounds) return [];
    if (axis === 'x') {
      return [
        { value: bounds.left, type: 'left' },
        { value: bounds.centerX, type: 'center' },
        { value: bounds.right, type: 'right' }
      ];
    }
    return [
      { value: bounds.top, type: 'top' },
      { value: bounds.centerY, type: 'center' },
      { value: bounds.bottom, type: 'bottom' }
    ];
  }

  function getSnapTargetsForObject(obj, axis) {
    var targets = [];
    var side = (obj && obj.sbcSide) || currentSide || 'front';

    if (axis === 'x') {
      targets.push({ value: canvas.width / 2, type: 'center', source: 'board-center' });
    } else {
      targets.push({ value: canvas.height / 2, type: 'center', source: 'board-center' });
    }

    canvas.getObjects().forEach(function (other) {
      if (other === obj || isSnapGuideObject(other) || !isUserDesignObject(other) || other.visible === false) return;
      if (((other.sbcSide || 'front') !== side)) return;

      var bounds = getSnapBoundsForObject(other);
      getSnapPoints(bounds, axis).forEach(function (point) {
        targets.push(Object.assign({ source: 'object', object: other }, point));
      });
    });

    return targets;
  }

  function isCompatibleSnapPair(axis, activePoint, targetPoint) {
    if (!activePoint || !targetPoint) return false;
    if (targetPoint.source === 'board-center') return activePoint.type === 'center';
    if (activePoint.type === 'center' || targetPoint.type === 'center') {
      return activePoint.type === 'center' && targetPoint.type === 'center';
    }
    if (axis === 'x') {
      return activePoint.type === targetPoint.type ||
        (activePoint.type === 'left' && targetPoint.type === 'right') ||
        (activePoint.type === 'right' && targetPoint.type === 'left');
    }
    return activePoint.type === targetPoint.type;
  }

  function findNearestSnap(activePoints, targetPoints, axis) {
    var best = null;
    activePoints.forEach(function (activePoint) {
      targetPoints.forEach(function (targetPoint) {
        if (!isCompatibleSnapPair(axis, activePoint, targetPoint)) return;
        var delta = targetPoint.value - activePoint.value;
        var distance = Math.abs(delta);
        if (distance > SNAP_PX) return;
        if (!best || distance < best.distance) {
          best = {
            value: targetPoint.value,
            delta: delta,
            distance: distance,
            active: activePoint,
            target: targetPoint
          };
        }
      });
    });
    return best;
  }

  function calculateSnapForObject(obj) {
    if (!canvas || !obj || !isUserDesignObject(obj)) return {};
    obj.setCoords();
    var bounds = getSnapBoundsForObject(obj);
    if (!bounds) return {};

    return {
      x: findNearestSnap(getSnapPoints(bounds, 'x'), getSnapTargetsForObject(obj, 'x'), 'x'),
      y: findNearestSnap(getSnapPoints(bounds, 'y'), getSnapTargetsForObject(obj, 'y'), 'y')
    };
  }

  function addSnapGuideLine(axis, value) {
    if (!canvas || !isFinite(value)) return;
    var points = axis === 'x'
      ? [value, 0, value, canvas.height]
      : [0, value, canvas.width, value];

    var line = new fabric.Line(points, {
      stroke: GUIDE_COLOR,
      strokeWidth: 1.4,
      strokeDashArray: [6, 4],
      selectable: false,
      evented: false,
      opacity: 0.88,
      excludeFromExport: true,
      objectCaching: false,
      isGuideLine: true,
      sbcGuideLine: true,
      sbcSide: currentSide
    });

    canvas.add(line);
    if (typeof canvas.bringToFront === 'function') canvas.bringToFront(line);
    snapLines.push(line);
  }

  /* ==========================================
     MEASUREMENT GRID
     ========================================== */

  function updateMeasurementGridToggleUi() {
    var btn = dom.measurementGridToggle();
    if (!btn) return;
    var labelText = measurementGridVisible ? 'Lineal ausblenden' : 'Lineal einblenden';
    btn.setAttribute('aria-pressed', measurementGridVisible ? 'true' : 'false');
    btn.setAttribute('aria-label', labelText);
    btn.title = labelText;
    var label = btn.querySelector('[data-measure-grid-label]') || btn.querySelector('span:last-child');
    if (label) label.textContent = labelText;
  }

  function clearMeasurementGrid() {
    if (!canvas || !measurementGridLines.length) {
      measurementGridLines = [];
      return;
    }
    measurementGridLines.forEach(function (line) { canvas.remove(line); });
    measurementGridLines = [];
  }

  function getMeasurementGridStyle() {
    var meta = getColorMeta(getCurrentBoardColor());
    var hex = String((meta && meta.hex) || '#ffffff').replace('#', '');
    if (hex.length === 3) {
      hex = hex.split('').map(function (ch) { return ch + ch; }).join('');
    }

    var r = parseInt(hex.slice(0, 2), 16);
    var g = parseInt(hex.slice(2, 4), 16);
    var b = parseInt(hex.slice(4, 6), 16);
    var luminance = (isFinite(r) && isFinite(g) && isFinite(b))
      ? ((0.299 * r) + (0.587 * g) + (0.114 * b))
      : 255;
    var darkBackground = luminance < 150;

    return {
      stroke: darkBackground ? '#ffffff' : GUIDE_COLOR,
      mutedStroke: darkBackground ? 'rgba(255,255,255,0.62)' : 'rgba(0,122,255,0.42)',
      labelFill: darkBackground ? '#102033' : '#ffffff',
      labelBg: darkBackground ? 'rgba(255,255,255,0.92)' : 'rgba(0,122,255,0.92)',
      majorOpacity: darkBackground ? 0.58 : 0.46,
      minorOpacity: darkBackground ? 0.34 : 0.28,
      rulerOpacity: darkBackground ? 0.94 : 0.88,
      mutedOpacity: darkBackground ? 0.72 : 0.58
    };
  }

  function createMeasurementGridLine(points, major) {
    var style = getMeasurementGridStyle();
    var line = new fabric.Line(points, {
      stroke: style.stroke,
      strokeWidth: major ? 1.2 : 0.8,
      strokeDashArray: major ? [7, 5] : [3, 5],
      selectable: false,
      evented: false,
      opacity: major ? style.majorOpacity : style.minorOpacity,
      excludeFromExport: true,
      objectCaching: false,
      isGuideLine: true,
      sbcGuideLine: true,
      sbcMeasurementGrid: true
    });
    return line;
  }

  function addMeasurementHelper(obj) {
    if (!obj || !canvas) return null;
    obj.set({
      selectable: false,
      evented: false,
      excludeFromExport: true,
      objectCaching: false,
      isGuideLine: true,
      sbcGuideLine: true,
      sbcMeasurementGrid: true
    });
    canvas.add(obj);
    if (typeof canvas.bringToFront === 'function') canvas.bringToFront(obj);
    measurementGridLines.push(obj);
    return obj;
  }

  function createMeasurementRulerLine(points, options) {
    options = options || {};
    var style = getMeasurementGridStyle();
    return new fabric.Line(points, {
      stroke: options.muted ? style.mutedStroke : style.stroke,
      strokeWidth: options.muted ? 1 : 1.35,
      strokeDashArray: options.dashed ? [4, 4] : null,
      selectable: false,
      evented: false,
      opacity: options.muted ? style.mutedOpacity : style.rulerOpacity,
      excludeFromExport: true,
      objectCaching: false,
      isGuideLine: true,
      sbcGuideLine: true,
      sbcMeasurementGrid: true
    });
  }

  function createMeasurementLabel(text, left, top, options) {
    options = options || {};
    var style = getMeasurementGridStyle();
    return new fabric.Text(text, {
      left: left,
      top: top,
      originX: 'center',
      originY: 'center',
      angle: options.angle || 0,
      fontFamily: 'Inter, Arial, sans-serif',
      fontSize: options.small ? 10 : 11,
      fontWeight: '700',
      fill: style.labelFill,
      backgroundColor: style.labelBg,
      selectable: false,
      evented: false,
      opacity: 0.96,
      excludeFromExport: true,
      objectCaching: false,
      isGuideLine: true,
      sbcGuideLine: true,
      sbcMeasurementGrid: true
    });
  }

  function clampMeasurementValue(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function formatCentimeterFromPx(px) {
    var cm = Math.max(0, Number(px || 0) / pxPerMm / 10);
    var value = cm >= 20 ? Math.round(cm) : Math.round(cm * 10) / 10;
    return String(value).replace('.', ',') + ' cm';
  }

  function getMeasurementBoundsForObject(obj) {
    if (!obj || !isUserDesignObject(obj)) return null;
    return getSnapBoundsForObject(obj) || getCanvasBoundsForObject(obj);
  }

  function addMeasurementTicks(axis, position, start, end, tickSize, muted) {
    if (axis === 'x') {
      addMeasurementHelper(createMeasurementRulerLine([start, position - tickSize, start, position + tickSize], { muted: muted }));
      addMeasurementHelper(createMeasurementRulerLine([end, position - tickSize, end, position + tickSize], { muted: muted }));
    } else {
      addMeasurementHelper(createMeasurementRulerLine([position - tickSize, start, position + tickSize, start], { muted: muted }));
      addMeasurementHelper(createMeasurementRulerLine([position - tickSize, end, position + tickSize, end], { muted: muted }));
    }
  }

  function addHorizontalMeasurement(x1, x2, y, label, muted) {
    if (!isFinite(x1) || !isFinite(x2) || Math.abs(x2 - x1) < 8) return;
    var lineY = clampMeasurementValue(y, 14, canvas.height - 14);
    addMeasurementHelper(createMeasurementRulerLine([x1, lineY, x2, lineY], { muted: muted, dashed: muted }));
    addMeasurementTicks('x', lineY, x1, x2, 4, muted);
    addMeasurementHelper(createMeasurementLabel(label, (x1 + x2) / 2, clampMeasurementValue(lineY - 10, 10, canvas.height - 10), { small: muted }));
  }

  function addVerticalMeasurement(y1, y2, x, label, muted) {
    if (!isFinite(y1) || !isFinite(y2) || Math.abs(y2 - y1) < 8) return;
    var lineX = clampMeasurementValue(x, 14, canvas.width - 14);
    addMeasurementHelper(createMeasurementRulerLine([lineX, y1, lineX, y2], { muted: muted, dashed: muted }));
    addMeasurementTicks('y', lineX, y1, y2, 4, muted);
    addMeasurementHelper(createMeasurementLabel(label, clampMeasurementValue(lineX + 18, 18, canvas.width - 18), (y1 + y2) / 2, { small: muted }));
  }

  function addSelectedObjectMeasurements(bounds) {
    var left = clampMeasurementValue(bounds.left, 0, canvas.width);
    var right = clampMeasurementValue(bounds.right, 0, canvas.width);
    var top = clampMeasurementValue(bounds.top, 0, canvas.height);
    var bottom = clampMeasurementValue(bounds.bottom, 0, canvas.height);
    var centerX = (left + right) / 2;
    var centerY = (top + bottom) / 2;

    addHorizontalMeasurement(left, right, top - 18, 'B ' + formatCentimeterFromPx(bounds.width), false);
    addVerticalMeasurement(top, bottom, right + 18, 'H ' + formatCentimeterFromPx(bounds.height), false);

    addHorizontalMeasurement(0, left, centerY, formatCentimeterFromPx(Math.max(0, bounds.left)), true);
    addHorizontalMeasurement(right, canvas.width, centerY, formatCentimeterFromPx(Math.max(0, canvas.width - bounds.right)), true);
    addVerticalMeasurement(0, top, centerX, formatCentimeterFromPx(Math.max(0, bounds.top)), true);
    addVerticalMeasurement(bottom, canvas.height, centerX, formatCentimeterFromPx(Math.max(0, canvas.height - bounds.bottom)), true);
  }

  function refreshMeasurementGrid() {
    clearMeasurementGrid();
    updateMeasurementGridToggleUi();

    if (!measurementGridVisible || !canvas || currentStep !== 5 || !(pxPerMm > 0)) {
      if (canvas) canvas.requestRenderAll();
      return;
    }

    var spacingPx = Math.max(8, MEASURE_GRID_MM * pxPerMm);
    var width = canvas.getWidth();
    var height = canvas.getHeight();
    var maxX = Math.floor(CFG.boardWidthMm / MEASURE_GRID_MM);
    var maxY = Math.floor(CFG.boardHeightMm / MEASURE_GRID_MM);

    for (var xIndex = 1; xIndex <= maxX; xIndex++) {
      var x = Math.round(xIndex * spacingPx) + 0.5;
      if (x >= width - 1) continue;
      var vLine = createMeasurementGridLine([x, 0, x, height], xIndex % 5 === 0);
      canvas.add(vLine);
      if (typeof canvas.sendToBack === 'function') canvas.sendToBack(vLine);
      measurementGridLines.push(vLine);
    }

    for (var yIndex = 1; yIndex <= maxY; yIndex++) {
      var y = Math.round(yIndex * spacingPx) + 0.5;
      if (y >= height - 1) continue;
      var hLine = createMeasurementGridLine([0, y, width, y], yIndex % 5 === 0);
      canvas.add(hLine);
      if (typeof canvas.sendToBack === 'function') canvas.sendToBack(hLine);
      measurementGridLines.push(hLine);
    }

    var active = canvas.getActiveObject();
    var activeBounds = getMeasurementBoundsForObject(active);
    if (activeBounds && activeBounds.width > 0 && activeBounds.height > 0) {
      addSelectedObjectMeasurements(activeBounds);
    }

    canvas.requestRenderAll();
  }

  function setMeasurementGridVisible(visible) {
    measurementGridVisible = visible === true;
    refreshMeasurementGrid();
    if (measurementGridVisible && canvas && !getMeasurementBoundsForObject(canvas.getActiveObject())) {
      toast('Wähle ein Objekt aus, um Größe und Abstände in cm zu sehen.');
    }
  }

  function bindMeasurementGridToggle() {
    var btn = dom.measurementGridToggle();
    if (!btn) return;
    updateMeasurementGridToggleUi();
    btn.addEventListener('click', function () {
      setMeasurementGridVisible(!measurementGridVisible);
    });
  }

  /* ==========================================
     COLLISION / BOUNDS CHECK
     ========================================== */

  function checkBounds(obj) {
    if (!obj) return;

    // Die sichtbare Warnung über halbtransparente Werkzeuge war zu fehleranfällig:
    // Fabric bewertet dafür die rechteckige Auswahlbox, nicht die echte Schattenform.
    if (isUserDesignObject(obj)) {
      obj.set({ opacity: 1, shadow: null });
    }

    updateCartButton();
    updateLeadButton();
    updateBottomOverhangHint();
    canvas.requestRenderAll();
  }

  /**
   * Overlap-Prüfung deaktiviert – nur Bounds sind relevant
   */
  function checkOverlapVisual(movedObj) {
    // Nicht verwendet – Überlappung zwischen Objekten ist erlaubt
  }

  function getCanvasBoundsForObject(obj) {
    if (!obj) return null;
    obj.setCoords();

    var coords = obj.aCoords;
    if (!coords) {
      var b = obj.getBoundingRect();
      return {
        left: b.left,
        top: b.top,
        right: b.left + b.width,
        bottom: b.top + b.height,
        width: b.width,
        height: b.height
      };
    }

    var points = [coords.tl, coords.tr, coords.br, coords.bl].filter(Boolean);
    if (!points.length) return null;
    var xs = points.map(function (point) { return point.x; });
    var ys = points.map(function (point) { return point.y; });
    var left = Math.min.apply(null, xs);
    var top = Math.min.apply(null, ys);
    var right = Math.max.apply(null, xs);
    var bottom = Math.max.apply(null, ys);

    return {
      left: left,
      top: top,
      right: right,
      bottom: bottom,
      width: right - left,
      height: bottom - top
    };
  }

  function getBoundsIntersection(a, b) {
    if (!a || !b) return null;
    var left = Math.max(a.left, b.left);
    var top = Math.max(a.top, b.top);
    var right = Math.min(a.right, b.right);
    var bottom = Math.min(a.bottom, b.bottom);
    if (right <= left || bottom <= top) return null;
    return {
      left: left,
      top: top,
      width: right - left,
      height: bottom - top
    };
  }

  function clipRectToCanvas(rect) {
    if (!canvas || !rect) return rect;

    var left = Math.max(0, rect.left);
    var top = Math.max(0, rect.top);
    var right = Math.min(canvas.width, rect.left + rect.width);
    var bottom = Math.min(canvas.height, rect.top + rect.height);

    if (right <= left || bottom <= top) return null;
    return {
      left: left,
      top: top,
      width: right - left,
      height: bottom - top
    };
  }

  function renderObjectAlphaMask(obj, rect) {
    var width = Math.max(1, Math.ceil(rect.width));
    var height = Math.max(1, Math.ceil(rect.height));
    var offscreen = document.createElement('canvas');
    offscreen.width = width;
    offscreen.height = height;

    var ctx = offscreen.getContext('2d', { willReadFrequently: true });
    if (!ctx) return null;

    var previousOpacity = obj.opacity;
    var previousShadow = obj.shadow;
    var previousSkipOffscreen = obj.canvas && obj.canvas.skipOffscreen;

    try {
      if (obj.canvas) obj.canvas.skipOffscreen = false;
      ctx.save();
      ctx.translate(-rect.left, -rect.top);

      // Alte Warnzustände oder Schlagschatten dürfen die Kollisionsmaske nicht verfälschen.
      obj.set({ opacity: 1, shadow: null });
      obj.render(ctx);
      ctx.restore();

      return ctx.getImageData(0, 0, width, height).data;
    } catch (e) {
      console.warn('[SBC] Werkzeug-Kollisionsmaske konnte nicht gelesen werden:', e);
      return null;
    } finally {
      obj.set({ opacity: previousOpacity, shadow: previousShadow });
      if (obj.canvas) obj.canvas.skipOffscreen = previousSkipOffscreen;
    }
  }

  function objectsHaveVisiblePixelOverlap(a, b, intersection) {
    var maskA = renderObjectAlphaMask(a, intersection);
    var maskB = renderObjectAlphaMask(b, intersection);
    if (!maskA || !maskB || maskA.length !== maskB.length) return false;

    var overlappingPixels = 0;
    for (var i = 0; i < maskA.length; i += 4) {
      if (isVisibleShadowPixel(maskA, i) && isVisibleShadowPixel(maskB, i)) {
        overlappingPixels++;
        if (overlappingPixels >= TOOL_OVERLAP_MIN_PIXELS) return true;
      }
    }

    return false;
  }

  function getVisibleToolOverlapValidationMessage(objects) {
    var tools = (objects || []).filter(function (obj) {
      return obj && obj.objectType === 'shadow-tool';
    });

    for (var i = 0; i < tools.length; i++) {
      for (var j = i + 1; j < tools.length; j++) {
        if ((tools[i].sbcSide || 'front') !== (tools[j].sbcSide || 'front')) continue;

        var intersection = getBoundsIntersection(getValidationBoundsForObject(tools[i]), getValidationBoundsForObject(tools[j]));
        if (!intersection) continue;
        if (allowsBottomToolOverhangForCurrentBoard()) {
          intersection = clipRectToCanvas(intersection);
          if (!intersection) continue;
        }

        if (objectsHaveVisiblePixelOverlap(tools[i], tools[j], intersection)) {
          return getConfiguratorText('overlapBlocked', CONFIGURATOR_TEXT_DEFAULTS.overlapBlocked);
        }
      }
    }

    return '';
  }

  /* ==========================================
     TOOLS – Load from Backend
     ========================================== */

  async function loadTools() {
    var hadCachedTools = false;
    try {
      var cached = sessionStorage.getItem('sbc_tools');
      if (cached) {
        var parsed = JSON.parse(cached);
        if (parsed.ts && (Date.now() - parsed.ts) < 300000 && Array.isArray(parsed.data)) {
          allToolsCacheConfigurator = parsed.data;
          toolsLoaded = true;
          hadCachedTools = true;
          renderToolsFiltered();
        }
      }
    } catch (e) { /* ignore */ }

    try {
      const res = await fetch(CFG.toolsApiUrl, {
        headers: { 'ngrok-skip-browser-warning': 'true' }
      });
      if (!res.ok) throw new Error(res.statusText);
      const tools = await res.json();
      console.log('[SBC] Tools geladen:', tools.length);
      allToolsCacheConfigurator = tools;
      toolsLoaded = true;

      // Cache in sessionStorage
      try {
        sessionStorage.setItem('sbc_tools', JSON.stringify({ ts: Date.now(), data: tools }));
      } catch (e) { /* ignore */ }

      renderToolsFiltered();
    } catch (err) {
      console.warn('[SBC] Could not load tools:', err.message);
      if (!hadCachedTools) {
        toolsLoaded = false;
        renderToolsFiltered();
      }
    }
  }

  async function ensureToolsLoaded() {
    if (toolsLoaded) {
      return allToolsCacheConfigurator;
    }
    if (allToolsCacheConfigurator && allToolsCacheConfigurator.length > 0) {
      toolsLoaded = true;
      return allToolsCacheConfigurator;
    }
    if (toolsLoadPromise) return toolsLoadPromise;
    toolsLoadPromise = loadTools()
      .then(function () { return allToolsCacheConfigurator; })
      .finally(function () { toolsLoadPromise = null; });
    return toolsLoadPromise;
  }

  function renderToolsFiltered() {
    if (!allToolsCacheConfigurator || allToolsCacheConfigurator.length === 0) {
      renderTools([]);
      return;
    }

    var currentSizeKey = String(CFG.boardWidthMm || '') + 'x' + String(CFG.boardHeightMm || '');
    var filtered = allToolsCacheConfigurator.filter(function (t) {
      if (t.hidden === true) return false;
      if (!isToolCategoryVisible(t.category || 'Sonstiges')) return false;
      var bc = t.boardColor || 'all';
      var excludedSizes = Array.isArray(t.excludedSizes) ? t.excludedSizes : [];
      if (excludedSizes.indexOf(currentSizeKey) !== -1) return false;
      if (bc === 'all') return true;
      return bc === getCurrentBoardColor();
    });

    var emptyMessage = isToolWallMode()
      ? (selectedToolBrand
        ? 'Für ' + getToolBrandLabel(selectedToolBrand) + ' sind noch keine passenden Werkzeug-Kategorien freigeschaltet.'
        : 'Bitte wähle zuerst ' + getToolBrandChoiceLabel() + ' aus.')
      : 'Keine passenden Schatten für diese Größe/Farbe verfügbar';
    renderTools(filtered, emptyMessage);
  }

  function getToolCategoryStateKey(categoryName) {
    return normalizeCategoryName(categoryName || 'Sonstiges') || 'sonstiges';
  }

  function rememberRenderedToolCategoryState(container) {
    if (!container) return;
    container.querySelectorAll('.sbc-category-toggle[data-category-key]').forEach(function (toggle) {
      var key = toggle.dataset.categoryKey;
      if (!key) return;
      if (toggle.getAttribute('aria-expanded') === 'true') {
        expandedToolCategoryKeys.add(key);
      } else {
        expandedToolCategoryKeys.delete(key);
      }
    });
  }

  function renderTools(tools, emptyMessage) {
    toolsById = {};
    tools.forEach(function (t) { toolsById[t.id] = t; });

    var container = document.getElementById('panel-tools-container');
    if (!container) return;
    rememberRenderedToolCategoryState(container);
    container.innerHTML = '';

    if (tools.length === 0) {
      container.innerHTML = '<p style="text-align:center;color:var(--sbc-text-tertiary);font-size:12px;padding:16px 0;">' + (emptyMessage || 'Keine Werkzeuge geladen') + '</p>';
      return;
    }

    var chevronSvg = '<svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><polyline points="6 9 12 15 18 9"/></svg>';
    var categoryNodes = {};
    var configuredCategories = configuratorSettings && Array.isArray(configuratorSettings.categories)
      ? configuratorSettings.categories
      : [];

    function ensureCategoryNode(categoryName) {
      var name = String(categoryName || 'Sonstiges').trim() || 'Sonstiges';
      var key = normalizeCategoryName(name);
      if (!categoryNodes[key]) {
        var meta = getConfiguredCategoryMeta(name);
        categoryNodes[key] = {
          key: key,
          name: meta ? meta.name : name,
          parentName: meta && meta.parentName ? meta.parentName : null,
          order: meta && Number.isFinite(Number(meta.order)) ? Number(meta.order) : 9999,
          tools: [],
          children: [],
          totalToolCount: 0
        };
      }
      return categoryNodes[key];
    }

    configuredCategories.forEach(function (category) {
      ensureCategoryNode(category.name);
    });
    tools.forEach(function (tool) {
      ensureCategoryNode(tool.category || 'Sonstiges').tools.push(tool);
    });

    function categoryNodeSort(a, b) {
      return a.order - b.order || a.name.localeCompare(b.name, 'de');
    }

    function parentWouldCreateCycle(node, parentNode) {
      var visited = {};
      var cursor = parentNode;
      while (cursor) {
        if (cursor.key === node.key || visited[cursor.key]) return true;
        visited[cursor.key] = true;
        cursor = cursor.parentName ? categoryNodes[normalizeCategoryName(cursor.parentName)] : null;
      }
      return false;
    }

    var rootNodes = [];
    Object.keys(categoryNodes).forEach(function (key) {
      var node = categoryNodes[key];
      var parentNode = node.parentName ? categoryNodes[normalizeCategoryName(node.parentName)] : null;
      if (parentNode && !parentWouldCreateCycle(node, parentNode)) {
        parentNode.children.push(node);
      } else {
        rootNodes.push(node);
      }
    });

    function prepareCategoryNode(node) {
      node.tools.sort(function (a, b) {
        var aOrder = Number.isFinite(Number(a.order)) ? Number(a.order) : 9999;
        var bOrder = Number.isFinite(Number(b.order)) ? Number(b.order) : 9999;
        return aOrder - bOrder || String(a.name || '').localeCompare(String(b.name || ''), 'de');
      });
      node.children = node.children.sort(categoryNodeSort).filter(function (child) {
        return prepareCategoryNode(child) > 0;
      });
      node.totalToolCount = node.tools.length + node.children.reduce(function (total, child) {
        return total + child.totalToolCount;
      }, 0);
      return node.totalToolCount;
    }
    rootNodes = rootNodes.sort(categoryNodeSort).filter(function (node) {
      return prepareCategoryNode(node) > 0;
    });

    function createToolGrid(catTools) {
      var grid = document.createElement('div');
      grid.className = 'sbc-tools-grid';

      catTools.forEach(function (tool) {
        var el = document.createElement('div');
        el.className = 'sbc-tool-item';
        el.draggable = true;
        el.dataset.toolId = tool.id;
        el.dataset.toolUrl = tool.imageUrl;
        el.title = (tool.name || 'Gerät') + ' zur Wand hinzufügen';
        el.tabIndex = 0;
        el.setAttribute('role', 'button');
        el.setAttribute('aria-label', (tool.name || 'Gerät') + ' zur Wand hinzufügen');
        el.addEventListener('keydown', function(event) {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); el.click(); }
        });

        var img = document.createElement('img');
        img.className = 'sbc-tool-item__image';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.src = tool.imageUrl;
        img.alt = tool.name || 'Werkzeug';
        img.crossOrigin = 'anonymous';
        el.appendChild(img);

        el.addEventListener('dragstart', function (e) {
          e.dataTransfer.setData('text/toolUrl', tool.imageUrl);
          e.dataTransfer.setData('text/toolId', tool.id);
        });
        el.addEventListener('dragend', function () {
          suppressToolClickUntil = Date.now() + 700;
        });
        el.addEventListener('click', function (event) {
          if (Date.now() < suppressToolClickUntil) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          if (isLikelyMobileMenuClickLeak(event)) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          requestAddShadowTool(tool.imageUrl, tool.id);
          // Visual feedback
          el.classList.add('sbc-tool-item--just-added');
          setTimeout(function () { el.classList.remove('sbc-tool-item--just-added'); }, 350);
        });

        // Werkzeugname unter dem Bild
        var nameSpan = document.createElement('span');
        nameSpan.className = 'sbc-tool-item__name';
        nameSpan.textContent = tool.name || '';
        el.appendChild(nameSpan);
        var addLabel = document.createElement('span');
        addLabel.className = 'planning-tool-add';
        addLabel.textContent = window.OptileanBristles && window.OptileanBristles.family(tool) ? (window.OptileanBristles.family(tool).kind === 'squeegee' ? '+ Lippen wählen' : '+ Besatz wählen') : '+ Hinzufügen';
        el.appendChild(addLabel);

        if (typeof setupTouchDrag === 'function') {
          setupTouchDrag(el, tool);
        }

        grid.appendChild(el);
      });
      return grid;
    }

    function renderCategoryNode(node, depth) {
      var panel = document.createElement('div');
      panel.className = 'sbc-category-panel' + (depth > 0 ? ' sbc-category-panel--nested' : '');
      panel.style.setProperty('--sbc-category-depth', String(depth));
      var categoryStateKey = getToolCategoryStateKey(node.name);
      var categoryExpanded = expandedToolCategoryKeys.has(categoryStateKey);

      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'sbc-category-toggle';
      toggle.dataset.categoryKey = categoryStateKey;
      toggle.setAttribute('aria-expanded', String(categoryExpanded));
      toggle.setAttribute('aria-label', node.name + ' ein- oder ausklappen');

      var label = document.createElement('span');
      label.className = 'sbc-category-toggle__label';
      label.textContent = node.name;
      toggle.appendChild(label);

      var count = document.createElement('span');
      count.className = 'sbc-category-toggle__count';
      count.textContent = '(' + node.totalToolCount + ')';
      toggle.appendChild(count);

      var chevron = document.createElement('span');
      chevron.className = 'sbc-category-toggle__chevron';
      chevron.innerHTML = chevronSvg;
      toggle.appendChild(chevron);

      var body = document.createElement('div');
      body.className = 'sbc-category-body';
      body.classList.toggle('sbc-category-body--open', categoryExpanded);

      if (node.tools.length) body.appendChild(createToolGrid(node.tools));
      if (node.children.length) {
        var children = document.createElement('div');
        children.className = 'sbc-category-children';
        node.children.forEach(function (child) {
          children.appendChild(renderCategoryNode(child, depth + 1));
        });
        body.appendChild(children);
      }

      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        var nextExpanded = !expanded;
        toggle.setAttribute('aria-expanded', String(nextExpanded));
        body.classList.toggle('sbc-category-body--open', nextExpanded);
        if (nextExpanded) {
          expandedToolCategoryKeys.add(categoryStateKey);
        } else {
          expandedToolCategoryKeys.delete(categoryStateKey);
        }
      });

      panel.appendChild(toggle);
      panel.appendChild(body);
      return panel;
    }

    rootNodes.forEach(function (node) {
      container.appendChild(renderCategoryNode(node, 0));
    });

    // Add Mobile Hint at the bottom of the tool controls, so it does not interrupt the mobile flow.
    var existingHint = document.getElementById('sbc-mobile-tool-hint');
    if (existingHint && existingHint.parentNode) existingHint.parentNode.removeChild(existingHint);

    if (window.innerWidth <= 768) {
      var hint = document.createElement('div');
      hint.id = 'sbc-mobile-tool-hint';
      hint.className = 'sbc-mobile-tool-hint';
      hint.innerHTML = '💡 Tipp: Werkzeug <b>lang drücken zum Ziehen</b><br>oder einfach <b>antippen</b>.';
      container.appendChild(hint);
    }

    console.log('[SBC] Tools hierarchisch gerendert: ' + Object.keys(categoryNodes).length + ' Kategorien, ' + tools.length + ' Werkzeuge');
  }

  // Mobile Touch Drag Implementation
  function setupTouchDrag(el, tool) {
    var ghost = null;
    var isDragging = false;
    var timer = null;
    var startX, startY;

    el.addEventListener('touchstart', function (e) {
      if (e.touches.length > 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;

      // Immediate visual feedback
      el.style.transform = 'scale(0.95)';
      el.style.transition = 'transform 0.1s';

      // Short delay (80ms) for drag trigger - feels almost instant but allows scroll swipe
      timer = setTimeout(function () {
        isDragging = true;
        if (navigator.vibrate) navigator.vibrate(50);

        // Create Ghost
        ghost = el.querySelector('img').cloneNode(true);
        ghost.style.position = 'fixed';
        ghost.style.left = (startX - 40) + 'px';
        ghost.style.top = (startY - 40) + 'px';
        ghost.style.width = '80px';
        ghost.style.height = 'auto';
        ghost.style.opacity = '0.9';
        ghost.style.zIndex = '99999';
        ghost.style.pointerEvents = 'none';
        ghost.style.filter = 'drop-shadow(0 10px 20px rgba(0,0,0,0.3))';
        document.body.appendChild(ghost);
      }, 80);
    }, { passive: false });

    el.addEventListener('touchmove', function (e) {
      if (!isDragging) {
        // Cancel if scrolling
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        if (Math.abs(dx) > 6 || Math.abs(dy) > 6) { // tighter threshold
          clearTimeout(timer);
          el.style.transform = ''; // reset scale
        }
        return;
      }
      e.preventDefault(); // Stop scrolling while dragging
      if (ghost) {
        ghost.style.left = (e.touches[0].clientX - 40) + 'px';
        ghost.style.top = (e.touches[0].clientY - 40) + 'px';
      }
    }, { passive: false });

    el.addEventListener('touchend', function (e) {
      clearTimeout(timer);
      el.style.transform = ''; // reset scale
      if (isDragging && ghost) {
        suppressToolClickUntil = Date.now() + 700;
        // Check Drop Target
        var touch = e.changedTouches[0];
        var target = document.elementFromPoint(touch.clientX, touch.clientY);

        // Allow drop on canvas stage or canvas itself
        if (target && target.closest('.sbc-canvas-stage')) {
          var point = getCanvasPointFromClientPoint(touch.clientX, touch.clientY);
          if (point) {
            requestAddShadowTool(tool.imageUrl, tool.id, point.x, point.y);
          } else {
            requestAddShadowTool(tool.imageUrl, tool.id);
          }
        }

        if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
        ghost = null;
        isDragging = false;
      }
    });
  }

  /* ==========================================
     ADD OBJECTS
     ========================================== */

  function requestAddShadowTool(imageUrl, toolId, x, y) {
    var tool = getToolById(toolId);
    var guide = window.OptileanBristles;
    if (!guide || !guide.family(tool)) { addShadowTool(imageUrl, toolId, x, y); return; }
    guide.pick(tool).then(function (bristle) {
      if (bristle) addShadowTool(imageUrl, toolId, x, y, bristle);
    });
  }

  function renderBristleProperty(obj) {
    var body = document.getElementById('panel-properties-body');
    if (!body) return;
    var existing = body.querySelector('.sbc-bristle-property');
    if (existing) existing.remove();
    var guide = window.OptileanBristles;
    var tool = obj && obj.objectType === 'shadow-tool' && getToolById(obj.toolId);
    if (!guide || !guide.family(tool)) return;
    var panel = document.createElement('div'); panel.className = 'sbc-bristle-property';
    var value = document.createElement('strong');
    value.textContent = tool.name + ' · ' + guide.copyFor(tool).selected + ': ' + guide.label(obj.sbcBristle || guide.defaultKey(tool));
    var button = document.createElement('button'); button.type = 'button'; button.textContent = guide.copyFor(tool).change;
    button.addEventListener('click', function () {
      guide.pick(getToolById(obj.toolId), obj.sbcBristle || guide.defaultKey(tool)).then(function (bristle) {
        if (!bristle || !canvas || canvas.getObjects().indexOf(obj) === -1) return;
        obj.set('sbcBristle', bristle);
        renderBristleProperty(obj);
        saveState();
        toast(guide.copyFor(tool).selected + ': ' + guide.label(bristle) + '. Änderungen bitte speichern.');
      });
    });
    panel.append(value, button); body.prepend(panel);
  }

  function addShadowTool(imageUrl, toolId, x, y, bristle) {
    if (imageUrl && isSvgUrl(imageUrl)) {
      var tool = toolsById[toolId];
      fetch(imageUrl)
        .then(function (res) {
          if (!res.ok) throw new Error('Fetch failed');
          return res.text();
        })
        .then(function (text) {
          text = recolorShadowToolMarkerSvgPreview(text, getBoardColorForSide(currentSide), tool);

          if (shouldUseRasterToolSvgPreview(text, tool)) {
            addShadowToolAsImage(imageUrl, toolId, x, y, getSvgPreviewDataUrl(text), bristle);
            return;
          }

          text = prepareShadowToolSvgForFabric(text);

          fabric.loadSVGFromString(text, function (objects, options) {
            if (!objects || objects.length === 0) {
              addShadowToolAsImage(imageUrl, toolId, x, y, null, bristle);
              return;
            }
            var obj = fabric.util.groupSVGElements(objects, options);
            var svgW = options.width || obj.width;
            var svgH = options.height || obj.height;
            var sourceScale = getShadowToolScaleForSource(tool, svgW, svgH);
            var scaleX = sourceScale.scaleX;
            var scaleY = sourceScale.scaleY;

            var placement = getDefaultShadowToolPlacement(
              tool,
              (obj.height || options.height || 0) * scaleY,
              x,
              y
            );

            obj.set({
              objectType: 'shadow-tool',
              toolId: toolId,
              sbcBristle: bristle || '',
              toolCategory: (tool && tool.category) || '',
              sbcScalable: !!(tool && isScalableToolCategory(tool.category)),
              sbcSide: currentSide, // Ensure correct side
              sbcPreviewColor: getBoardColorForSide(currentSide),
              scaleX: scaleX,
              scaleY: scaleY,
              _fixedScaleX: scaleX,
              _fixedScaleY: scaleY,
              left: placement.left,
              top: placement.top,
              originX: 'center',
              originY: 'center',
              lockScalingX: true,
              lockScalingY: true,
              lockUniScaling: true,
            });
            applyShadowToolConstraints(obj);

            canvas.add(obj);
            canvas.setActiveObject(obj);
            canvas.requestRenderAll();
            syncCanvasUi();
            toast((tool && tool.name || 'Gerät') + ' hinzugefügt. Änderungen bitte speichern.');
          });
        })
        .catch(function (err) {
          console.warn('[SBC] SVG parse/fetch failed, fallback to raster:', err);
          addShadowToolAsImage(imageUrl, toolId, x, y, null, bristle);
        });
      return;
    }

    addShadowToolAsImage(imageUrl, toolId, x, y, null, bristle);
  }

  function getRestoredToolPhysicalSize(objData) {
    var unitPxPerMm = getCanvasPxPerMm();
    var widthPx = Number(objData && (objData.w || objData.width));
    var heightPx = Number(objData && (objData.h || objData.height));

    if (!(unitPxPerMm > 0) || !(widthPx > 0) || !(heightPx > 0)) {
      return null;
    }

    return {
      widthMm: widthPx / unitPxPerMm,
      heightMm: heightPx / unitPxPerMm
    };
  }

  function getToolDimensionMatchScore(tool, physicalSize) {
    if (!hasToolPhysicalDimensions(tool) || !physicalSize) return Infinity;

    var savedWidth = Math.max(1, Number(physicalSize.widthMm) || 0);
    var savedHeight = Math.max(1, Number(physicalSize.heightMm) || 0);
    var toolWidth = getToolDimension(tool, 'widthMm');
    var toolHeight = getToolDimension(tool, 'heightMm');

    if (!(toolWidth > 0) || !(toolHeight > 0)) return Infinity;

    return (Math.abs(toolWidth - savedWidth) / Math.max(toolWidth, savedWidth)) +
      (Math.abs(toolHeight - savedHeight) / Math.max(toolHeight, savedHeight));
  }

  function resolveLegacyShadowToolBySavedShape(toolId, objData, sbcSide) {
    if (!allToolsCacheConfigurator || allToolsCacheConfigurator.length === 0) return null;

    var physicalSize = getRestoredToolPhysicalSize(objData);
    if (!physicalSize) return null;

    var category = normalizeCategoryName(
      (objData && (objData.toolCategory || objData.cat || objData.category)) || ''
    );
    var targetColor = normalizeBoardColorKey(
      getBoardColorForSide(sbcSide || 'front'),
      ''
    );

    var candidates = allToolsCacheConfigurator.filter(function (tool) {
      if (!tool || !tool.id || !tool.imageUrl) return false;
      if (!hasToolPhysicalDimensions(tool)) return false;
      if (!isToolAllowedForCurrentSize(tool)) return false;

      var toolColor = normalizeBoardColorKey(tool.boardColor || 'all', 'all');
      return toolColor === 'all' || !targetColor || toolColor === targetColor;
    });

    var categoryMatches = category ? candidates.filter(function (tool) {
      return normalizeCategoryName(tool.category || '') === category;
    }) : [];

    var scored = (categoryMatches.length ? categoryMatches : candidates).map(function (tool) {
      return {
        tool: tool,
        score: getToolDimensionMatchScore(tool, physicalSize)
      };
    }).filter(function (entry) {
      return isFinite(entry.score);
    }).sort(function (a, b) {
      if (a.score !== b.score) return a.score - b.score;
      var aColor = normalizeBoardColorKey(a.tool.boardColor || 'all', 'all');
      var bColor = normalizeBoardColorKey(b.tool.boardColor || 'all', 'all');
      if (aColor === targetColor && bColor !== targetColor) return -1;
      if (bColor === targetColor && aColor !== targetColor) return 1;
      return (a.tool.order || 0) - (b.tool.order || 0);
    });

    var best = scored[0];
    if (!best || best.score > 0.35) return null;

    console.warn('[SBC] Legacy-Werkzeug-ID ersetzt:', toolId || '(ohne ID)', '→', best.tool.id, best.tool.name || '', 'Score:', best.score.toFixed(3));
    return best.tool;
  }

  function getShadowToolSource(toolId, fallbackSrc, objData, sbcSide) {
    var tool = toolsById[toolId] || (allToolsCacheConfigurator && allToolsCacheConfigurator.find(function (entry) {
      return entry.id === toolId;
    }));

    if (!tool) {
      tool = resolveLegacyShadowToolBySavedShape(toolId, objData, sbcSide);
    }

    return {
      tool: tool || null,
      imageUrl: (tool && tool.imageUrl) || fallbackSrc || null,
      resolvedToolId: (tool && tool.id) || toolId || ''
    };
  }

  function getToolDimension(tool, key) {
    var value = Number(tool && tool[key]);
    return isFinite(value) ? value : 0;
  }

  function toolDimensionsMatch(a, b) {
    return Math.abs(getToolDimension(a, 'widthMm') - getToolDimension(b, 'widthMm')) < 0.5 &&
      Math.abs(getToolDimension(a, 'heightMm') - getToolDimension(b, 'heightMm')) < 0.5;
  }

  function hasToolPhysicalDimensions(tool) {
    return tool && Number(tool.widthMm) > 0 && Number(tool.heightMm) > 0;
  }

  function isPdfRasterToolWithoutDimensions(tool) {
    if (!tool || hasToolPhysicalDimensions(tool)) return false;
    var source = String(tool.originalUrl || tool.originalFilename || '');
    return /\.pdf(?:$|[?#])/i.test(source);
  }

  function getShadowToolScaleForSource(tool, intrinsicWidth, intrinsicHeight) {
    var sourceWidth = Math.max(1, Number(intrinsicWidth) || 1);
    var sourceHeight = Math.max(1, Number(intrinsicHeight) || 1);
    var unitPxPerMm = getCanvasPxPerMm();

    if (hasToolPhysicalDimensions(tool) && unitPxPerMm > 0) {
      return {
        scaleX: (Number(tool.widthMm) * unitPxPerMm) / sourceWidth,
        scaleY: (Number(tool.heightMm) * unitPxPerMm) / sourceHeight
      };
    }

    if (isPdfRasterToolWithoutDimensions(tool) && unitPxPerMm > 0) {
      var pdfScale = unitPxPerMm / PDF_RASTER_TOOL_PX_PER_MM;
      return {
        scaleX: pdfScale,
        scaleY: pdfScale
      };
    }

    return {
      scaleX: unitPxPerMm || pxPerMm || 1,
      scaleY: unitPxPerMm || pxPerMm || 1
    };
  }

  function shouldNormalizeLegacyPdfRasterToolScale(tool, objData, intrinsicWidth, intrinsicHeight, targetScale) {
    if (!isPdfRasterToolWithoutDimensions(tool) || !targetScale) return false;

    var restoredScaleX = Number(objData && objData.w) > 0
      ? Number(objData.w) / Math.max(1, Number(intrinsicWidth) || 1)
      : Number(objData && objData.scaleX);
    var restoredScaleY = Number(objData && objData.h) > 0
      ? Number(objData.h) / Math.max(1, Number(intrinsicHeight) || 1)
      : Number(objData && objData.scaleY);

    var targetScaleX = Math.max(0.0001, Number(targetScale.scaleX) || 0.0001);
    var targetScaleY = Math.max(0.0001, Number(targetScale.scaleY) || 0.0001);

    return (isFinite(restoredScaleX) && restoredScaleX > targetScaleX * 4) ||
      (isFinite(restoredScaleY) && restoredScaleY > targetScaleY * 4);
  }

  function getSavedCanvasScale(savedCanvasWidth, savedCanvasHeight) {
    var savedW = Number(savedCanvasWidth);
    var savedH = Number(savedCanvasHeight);
    return {
      x: canvas && savedW > 0 && canvas.width > 0 ? canvas.width / savedW : 1,
      y: canvas && savedH > 0 && canvas.height > 0 ? canvas.height / savedH : 1
    };
  }

  function scaleSavedCanvasObject(objData, savedCanvasWidth, savedCanvasHeight) {
    var scale = getSavedCanvasScale(savedCanvasWidth, savedCanvasHeight);
    if (!objData || (Math.abs(scale.x - 1) < 0.0001 && Math.abs(scale.y - 1) < 0.0001)) {
      return objData;
    }

    var out = Object.assign({}, objData);
    ['x', 'left', 'w'].forEach(function (key) {
      if (out[key] !== undefined && isFinite(Number(out[key]))) out[key] = Number(out[key]) * scale.x;
    });
    ['y', 'top', 'h'].forEach(function (key) {
      if (out[key] !== undefined && isFinite(Number(out[key]))) out[key] = Number(out[key]) * scale.y;
    });
    if (out.t === 'text' || out.t === 'custom-text' || out.objectType === 'custom-text' || out.objectType === 'text') {
      var textScale = (scale.x > 0 && scale.y > 0) ? ((scale.x + scale.y) / 2) : (scale.x || scale.y || 1);
      ['fs', 'fontSize'].forEach(function (key) {
        if (out[key] !== undefined && isFinite(Number(out[key]))) out[key] = Number(out[key]) * textScale;
      });
    }
    return out;
  }

  function isToolAllowedForCurrentSize(tool) {
    var excludedSizes = Array.isArray(tool && tool.excludedSizes) ? tool.excludedSizes : [];
    var currentSizeKey = String(CFG.boardWidthMm || '') + 'x' + String(CFG.boardHeightMm || '');
    return excludedSizes.indexOf(currentSizeKey) === -1;
  }

  function hasExplicitPlacementCoordinate(value) {
    return value !== undefined && value !== null && isFinite(Number(value));
  }

  function getDefaultShadowToolPlacement(tool, scaledHeight, x, y) {
    var hasX = hasExplicitPlacementCoordinate(x);
    var hasY = hasExplicitPlacementCoordinate(y);
    var left = hasX ? Number(x) : (canvas.width / 2);
    var top = hasY ? Number(y) : (canvas.height / 2);

    if (!hasX && !hasY && allowsBottomToolOverhangForCurrentBoard() && Number(scaledHeight) > canvas.height) {
      var topMarginPx = Math.max(0, SMALL_WALL_OVERSIZED_TOOL_TOP_MARGIN_MM * getCanvasPxPerMm());
      top = (Number(scaledHeight) || 0) / 2 + topMarginPx;
    }

    return { left: left, top: top };
  }

  function findToolVariantForBoardColor(sourceTool, targetColor) {
    if (!sourceTool || !targetColor || !allToolsCacheConfigurator || allToolsCacheConfigurator.length === 0) {
      return null;
    }

    var sourceColor = sourceTool.boardColor || 'all';
    if (sourceColor === targetColor) {
      return sourceTool;
    }

    var sourceName = normalizeToolVariantBaseName(sourceTool.name || '');
    var sourceCategory = normalizeCategoryName(sourceTool.category || '');
    var colorCandidates = allToolsCacheConfigurator.filter(function (tool) {
      if (!tool || (tool.boardColor || 'all') !== targetColor) return false;
      if (sourceTool.hidden !== true && tool.hidden === true) return false;
      if (!isToolAllowedForCurrentSize(tool)) return false;
      return true;
    });
    var candidates = colorCandidates.filter(function (tool) {
      if (normalizeCategoryName(tool.category || '') !== sourceCategory) return false;
      if (normalizeToolVariantBaseName(tool.name || '') !== sourceName) return false;
      return true;
    });

    var exactMatch = candidates.find(function (tool) {
      return toolDimensionsMatch(tool, sourceTool);
    }) || candidates[0];
    if (exactMatch) return exactMatch;

    // Kategorie-Namen werden im Admin gepflegt. Wenn eine Kategorie umbenannt wurde,
    // ist der Werkzeugname plus Abmessung der stabilere Schlüssel für die Farbvariante.
    var sameNameCandidates = colorCandidates.filter(function (tool) {
      return normalizeToolVariantBaseName(tool.name || '') === sourceName;
    });
    var sameNameMatch = sameNameCandidates.find(function (tool) {
      return toolDimensionsMatch(tool, sourceTool);
    }) || sameNameCandidates[0];
    if (sameNameMatch) return sameNameMatch;

    return sourceColor === 'all' ? sourceTool : null;
  }

  function loadShadowToolObjectForReplacement(imageUrl, tool, previewBoardColor) {
    return new Promise(function (resolve, reject) {
      function loadAsImage(previewUrl) {
        var loadUrl = previewUrl || imageUrl;
        fabric.Image.fromURL(loadUrl, function (img) {
          if (!img) {
            reject(new Error('Image load failed'));
            return;
          }

          var imgWidth = img.width || (img._element && img._element.naturalWidth) || 1;
          var imgHeight = img.height || (img._element && img._element.naturalHeight) || 1;
          resolve({ object: img, intrinsicWidth: imgWidth, intrinsicHeight: imgHeight });
        }, getFabricImageLoadOptions(loadUrl));
      }

      if (!imageUrl) {
        reject(new Error('Missing tool image URL'));
        return;
      }

      if (!isSvgUrl(imageUrl)) {
        loadAsImage();
        return;
      }

      fetch(imageUrl)
        .then(function (res) {
          if (!res.ok) throw new Error('Fetch failed');
          return res.text();
        })
        .then(function (text) {
          text = recolorShadowToolMarkerSvgPreview(text, previewBoardColor || (tool && tool.boardColor) || getCurrentBoardColor(), tool);

          if (shouldUseRasterToolSvgPreview(text, tool)) {
            loadAsImage(getSvgPreviewDataUrl(text));
            return;
          }

          text = prepareShadowToolSvgForFabric(text);

          fabric.loadSVGFromString(text, function (objects, options) {
            if (!objects || objects.length === 0) {
              loadAsImage();
              return;
            }

            var obj = fabric.util.groupSVGElements(objects, options);
            resolve({
              object: obj,
              intrinsicWidth: options.width || obj.width || 1,
              intrinsicHeight: options.height || obj.height || 1
            });
          });
        })
        .catch(function () {
          loadAsImage();
        });
    });
  }

  function replaceShadowToolWithColorVariant(obj, targetTool, refreshToken, targetColor) {
    if (!obj || !targetTool || !targetTool.imageUrl) {
      return Promise.resolve(false);
    }

    var previewColor = normalizeBoardColorKey(targetColor || targetTool.boardColor || getBoardColorForSide(obj.sbcSide || 'front'), getBoardColorForSide(obj.sbcSide || 'front'));
    var sameTool = obj.toolId === targetTool.id;
    var needsPreviewRefresh = sameTool &&
      isSvgUrl(targetTool.imageUrl) &&
      previewColor &&
      obj.sbcPreviewColor !== previewColor;

    if (sameTool && !needsPreviewRefresh) {
      return Promise.resolve(false);
    }

    return loadShadowToolObjectForReplacement(targetTool.imageUrl, targetTool, previewColor)
      .then(function (loaded) {
        if (refreshToken !== shadowToolColorRefreshToken || !canvas || canvas.getObjects().indexOf(obj) === -1) {
          return false;
        }

        var replacement = loaded.object;
        var side = obj.sbcSide || 'front';
        var previousIndex = canvas.getObjects().indexOf(obj);
        var wasActive = canvas.getActiveObject() === obj;
        var previousWidth = (typeof obj.getScaledWidth === 'function') ? obj.getScaledWidth() : ((obj.width || 0) * (obj.scaleX || 1));
        var previousHeight = (typeof obj.getScaledHeight === 'function') ? obj.getScaledHeight() : ((obj.height || 0) * (obj.scaleY || 1));
        var replacementWidth = replacement.width || loaded.intrinsicWidth || 1;
        var replacementHeight = replacement.height || loaded.intrinsicHeight || 1;
        var scaleX = previousWidth > 0 && replacementWidth > 0 ? previousWidth / replacementWidth : (obj.scaleX || 1);
        var scaleY = previousHeight > 0 && replacementHeight > 0 ? previousHeight / replacementHeight : (obj.scaleY || 1);

        replacement.set({
          objectType: 'shadow-tool',
          toolId: targetTool.id,
          sbcBristle: obj.sbcBristle || '',
          toolCategory: targetTool.category || obj.toolCategory || '',
          sbcScalable: !!isScalableToolCategory(targetTool.category || obj.toolCategory || ''),
          src: targetTool.imageUrl,
          imageData: targetTool.imageUrl,
          sbcSide: side,
          sbcPreviewColor: previewColor,
          left: obj.left,
          top: obj.top,
          angle: obj.angle || 0,
          scaleX: scaleX,
          scaleY: scaleY,
          originX: obj.originX || 'center',
          originY: obj.originY || 'center',
          flipX: obj.flipX || false,
          flipY: obj.flipY || false,
          _fixedScaleX: scaleX,
          _fixedScaleY: scaleY,
          visible: side === currentSide
        });

        applyShadowToolConstraints(replacement);
        canvas.remove(obj);
        if (previousIndex >= 0 && typeof canvas.insertAt === 'function') {
          canvas.insertAt(replacement, previousIndex, false);
        } else {
          canvas.add(replacement);
        }
        if (wasActive) canvas.setActiveObject(replacement);
        replacement.setCoords();
        return true;
      })
      .catch(function (err) {
        console.warn('[SBC] Werkzeug konnte nicht auf Farbvariante gewechselt werden:', obj.toolId, targetTool.id, err);
        return false;
      });
  }

  function refreshPlacedShadowToolsForCurrentColors() {
    if (!canvas) return Promise.resolve(false);

    var refreshToken = ++shadowToolColorRefreshToken;
    return ensureToolsLoaded()
      .then(function () {
        var replacements = canvas.getObjects().filter(function (obj) {
          return obj && obj.objectType === 'shadow-tool' && obj.toolId;
        }).map(function (obj) {
          var sourceTool = getToolById(obj.toolId);
          var targetColor = getBoardColorForSide(obj.sbcSide || 'front');
          var targetTool = findToolVariantForBoardColor(sourceTool, targetColor);
          if (!targetTool) {
            console.warn('[SBC] Keine Werkzeug-Farbvariante gefunden:', obj.toolId, '→', targetColor);
            targetTool = sourceTool;
          }
          return replaceShadowToolWithColorVariant(obj, targetTool, refreshToken, targetColor);
        });

        return Promise.all(replacements);
      })
      .then(function (results) {
        if (refreshToken !== shadowToolColorRefreshToken) return false;
        var changed = results.some(Boolean);
        if (changed) {
          canvas.requestRenderAll();
          syncCanvasUi();
          updateCartButton();
        }
        saveState();
        return changed;
      })
      .catch(function (err) {
        console.warn('[SBC] Platzierte Werkzeuge konnten nicht auf die neue Wandfarbe aktualisiert werden:', err);
        return false;
      });
  }

  function restoreShadowToolObject(objData, currentSideForObject) {
    return new Promise(function (resolve) {
      var source = getShadowToolSource(objData.id || objData.toolId, objData.src, objData, objData.sbcSide || currentSideForObject || 'front');
      var tool = source.tool;
      var imageUrl = source.imageUrl;
      var restoredToolId = source.resolvedToolId || objData.id || objData.toolId;
      var sbcSide = objData.sbcSide || currentSideForObject || 'front';

      if (!imageUrl) {
        console.warn('[SBC] Werkzeug kann nicht wiederhergestellt werden, URL fehlt:', objData.id || objData.toolId);
        resolve();
        return;
      }

      function finalizeToolObject(restoredObj, intrinsicWidth, intrinsicHeight) {
        var scalable = objData.sbcScalable === true || !!(tool && isScalableToolCategory(tool.category));
        var sourceScale = getShadowToolScaleForSource(tool, intrinsicWidth, intrinsicHeight);
        var hasPhysicalSize = !scalable && hasToolPhysicalDimensions(tool) && pxPerMm > 0;
        var normalizeLegacyPdfRaster = !scalable && shouldNormalizeLegacyPdfRasterToolScale(tool, objData, intrinsicWidth, intrinsicHeight, sourceScale);
        var usePdfRasterFallback = !scalable &&
          isPdfRasterToolWithoutDimensions(tool) &&
          !(Number(objData.w) > 0 && Number(objData.h) > 0) &&
          !(Number(objData.scaleX) > 0 && Number(objData.scaleY) > 0);
        var scaleX;
        var scaleY;

        if (hasPhysicalSize) {
          scaleX = sourceScale.scaleX;
          scaleY = sourceScale.scaleY;
        } else if (normalizeLegacyPdfRaster || usePdfRasterFallback) {
          scaleX = sourceScale.scaleX;
          scaleY = sourceScale.scaleY;
        } else if (objData.w && objData.h) {
          scaleX = objData.w / intrinsicWidth;
          scaleY = objData.h / intrinsicHeight;
        } else {
          scaleX = objData.scaleX || 1;
          scaleY = objData.scaleY || 1;
        }

        restoredObj.set({
          objectType: 'shadow-tool',
          toolId: restoredToolId,
          sbcBristle: objData.bristle || objData.sbcBristle || '',
          toolCategory: objData.toolCategory || (tool && tool.category) || '',
          sbcScalable: scalable,
          src: imageUrl,
          imageData: imageUrl,
          sbcSide: sbcSide,
          sbcPreviewColor: getBoardColorForSide(sbcSide),
          left: objData.x !== undefined ? objData.x : objData.left,
          top: objData.y !== undefined ? objData.y : objData.top,
          angle: objData.a !== undefined ? objData.a : (objData.angle || 0),
          scaleX: scaleX,
          scaleY: scaleY,
          originX: objData.originX || 'center',
          originY: objData.originY || 'center',
          _fixedScaleX: scaleX,
          _fixedScaleY: scaleY,
          visible: sbcSide === currentSide
        });

        applyShadowToolConstraints(restoredObj);
        canvas.add(restoredObj);
        resolve();
      }

      if (isSvgUrl(imageUrl)) {
        fetch(imageUrl)
          .then(function (res) {
            if (!res.ok) throw new Error('Fetch failed');
            return res.text();
          })
          .then(function (text) {
            text = recolorShadowToolMarkerSvgPreview(text, getBoardColorForSide(sbcSide), tool);

            if (shouldUseRasterToolSvgPreview(text, tool)) {
              var previewUrl = getSvgPreviewDataUrl(text);
              fabric.Image.fromURL(previewUrl, function (img) {
                if (!img) return resolve();
                var imgWidth = img.width || (img._element && img._element.naturalWidth) || objData.w || 1;
                var imgHeight = img.height || (img._element && img._element.naturalHeight) || objData.h || 1;
                finalizeToolObject(img, imgWidth, imgHeight);
              }, getFabricImageLoadOptions(previewUrl));
              return;
            }

            text = prepareShadowToolSvgForFabric(text);
            fabric.loadSVGFromString(text, function (svgObjects, options) {
              if (!svgObjects || svgObjects.length === 0) {
                fabric.Image.fromURL(imageUrl, function (img) {
                  if (!img) return resolve();
                  var imgWidth = img.width || (img._element && img._element.naturalWidth) || objData.w || 1;
                  var imgHeight = img.height || (img._element && img._element.naturalHeight) || objData.h || 1;
                  finalizeToolObject(img, imgWidth, imgHeight);
                }, { crossOrigin: 'anonymous' });
                return;
              }
              var svgObj = fabric.util.groupSVGElements(svgObjects, options);
              var intrinsicWidth = options.width || svgObj.width || objData.w || 1;
              var intrinsicHeight = options.height || svgObj.height || objData.h || 1;
              finalizeToolObject(svgObj, intrinsicWidth, intrinsicHeight);
            });
          })
          .catch(function (err) {
            console.warn('[SBC] SVG-Werkzeug Restore fällt auf Raster zurück:', err);
            fabric.Image.fromURL(imageUrl, function (img) {
              if (!img) return resolve();
              var imgWidth = img.width || (img._element && img._element.naturalWidth) || objData.w || 1;
              var imgHeight = img.height || (img._element && img._element.naturalHeight) || objData.h || 1;
              finalizeToolObject(img, imgWidth, imgHeight);
            }, { crossOrigin: 'anonymous' });
          });
        return;
      }

      fabric.Image.fromURL(imageUrl, function (img) {
        if (!img) return resolve();
        var imgWidth = img.width || (img._element && img._element.naturalWidth) || objData.w || 1;
        var imgHeight = img.height || (img._element && img._element.naturalHeight) || objData.h || 1;
        finalizeToolObject(img, imgWidth, imgHeight);
      }, { crossOrigin: 'anonymous' });
    });
  }

  // Fallback/Vorschau: Werkzeug als Bild laden, bei SVG-Clip-Pfaden aus unverändertem SVG-Text.
  function addShadowToolAsImage(imageUrl, toolId, x, y, previewUrl, bristle) {
    var loadUrl = previewUrl || imageUrl;
    fabric.Image.fromURL(loadUrl, function (img) {
      if (!img) return;

      var imgW = img.width || (img._element && img._element.naturalWidth) || 300;
      var imgH = img.height || (img._element && img._element.naturalHeight) || 300;
      if (imgW <= 0) imgW = 300;
      if (imgH <= 0) imgH = 300;

      var tool = toolsById[toolId];
      var sourceScale = getShadowToolScaleForSource(tool, imgW, imgH);
      var scaleX = sourceScale.scaleX;
      var scaleY = sourceScale.scaleY;

      var placement = getDefaultShadowToolPlacement(tool, imgH * scaleY, x, y);

      img.set({
        objectType: 'shadow-tool',
        toolId: toolId,
        sbcBristle: bristle || '',
        toolCategory: (tool && tool.category) || '',
        sbcScalable: !!(tool && isScalableToolCategory(tool.category)),
        sbcSide: currentSide, // Ensure correct side
        src: imageUrl,
        imageData: imageUrl,
        sbcPreviewColor: getBoardColorForSide(currentSide),
        scaleX: scaleX,
        scaleY: scaleY,
        _fixedScaleX: scaleX,
        _fixedScaleY: scaleY,
        left: placement.left,
        top: placement.top,
        originX: 'center',
        originY: 'center',
        lockScalingX: true,
        lockScalingY: true,
        lockUniScaling: true,
      });
      applyShadowToolConstraints(img);

      canvas.add(img);
      canvas.setActiveObject(img);
      canvas.requestRenderAll();
      syncCanvasUi();
      toast((tool && tool.name || 'Gerät') + ' hinzugefügt. Änderungen bitte speichern.');
    }, getFabricImageLoadOptions(loadUrl));
  }

  function addLogo(dataUrl, previewUrl) {
    if (dataUrl && isSvgUrl(dataUrl) && !dataUrl.startsWith('data:image/svg+xml')) {
      fetch(dataUrl, { headers: { 'ngrok-skip-browser-warning': 'true' } })
        .then(function (res) {
          if (!res.ok) throw new Error('SVG konnte nicht geladen werden');
          return res.text();
        })
        .then(function (svgText) {
          var svgDataUrl = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgText)));
          addLogo(svgDataUrl, previewUrl);
        })
        .catch(function (err) {
          console.warn('[SBC] SVG-Logo URL konnte nicht geladen werden:', err.message);
          toast('Gespeichertes SVG-Logo konnte nicht geladen werden.', 'error');
        });
      return;
    }

    // Check if it's an SVG
    if (dataUrl && dataUrl.startsWith('data:image/svg+xml')) {
      var previewPromise = previewUrl
        ? createTrimmedSvgLogoPreview(dataUrl).then(function (trimmedPreview) {
          return {
            dataUrl: previewUrl,
            trim: trimmedPreview && trimmedPreview.trim ? trimmedPreview.trim : null
          };
        }).catch(function () {
          return { dataUrl: previewUrl, trim: null };
        })
        : createTrimmedSvgLogoPreview(dataUrl);

      previewPromise.catch(function () {
        return null;
      }).then(function (preview) {
        var logoSource = dataUrl;
        var fabricPreviewUrl = preview && preview.dataUrl ? preview.dataUrl : logoSource;
        var logoTrim = getLogoTrimFromRestoreData(null, { preview: preview });

        function loadSvgLogoImage(loadUrl, didFallback) {
          fabric.Image.fromURL(loadUrl, function (img) {
            if (!img && !didFallback && loadUrl !== logoSource) {
              loadSvgLogoImage(logoSource, true);
              return;
            }
            if (!img) {
              toast('SVG-Logo konnte nicht angezeigt werden.', 'error');
              return;
            }

            // Limit size (similar to raster)
            var maxW = 180;
            var maxH = 180;
            var scale = 1;
            var imgW = img.width || (img._element && img._element.naturalWidth) || 1;
            var imgH = img.height || (img._element && img._element.naturalHeight) || 1;
            if (imgW > maxW || imgH > maxH) {
              scale = Math.min(maxW / imgW, maxH / imgH);
            } else {
              // If very small, scale up? Or keep as is?
              // Let's stick to "fit within 25% of canvas" logic roughly or valid size
              if (canvas.width) {
                scale = Math.min(180, canvas.width * 0.25) / Math.max(imgW, imgH);
              }
            }

            img.set({
              objectType: 'logo',
              left: canvas.width / 2,
              top: canvas.height / 2,
              originX: 'center',
              originY: 'center',
              scaleX: scale,
              scaleY: scale,
              imageData: logoSource,
              src: loadUrl,
              logoTrim: logoTrim,
              sbcLogoTrim: logoTrim
            });
            img.logoTrim = logoTrim;
            img.sbcLogoTrim = logoTrim;
            applyCrispRendering(img);

            canvas.add(img);
            canvas.setActiveObject(img);
            canvas.requestRenderAll();
            toast('Logo (Vektor) hinzugefügt');
          }, getFabricImageLoadOptions(loadUrl));
        }

        loadSvgLogoImage(fabricPreviewUrl, false);
      });
      return;
    }

    // Fallback: Raster Image (JPG/PNG)
    fabric.Image.fromURL(dataUrl, function (img) {
      if (!img) return;
      img.scaleToWidth(Math.min(180, canvas.width * 0.25));
      img.set({
        objectType: 'logo',
        left: canvas.width / 2,
        top: canvas.height / 2,
        originX: 'center',
        originY: 'center',
        imageData: dataUrl,
      });
      applyCrispRendering(img);
      canvas.add(img);
      canvas.setActiveObject(img);
      canvas.requestRenderAll();
      toast('Logo hinzugefügt');
    }, { crossOrigin: 'anonymous' });
  }

  function addText() {
    var defaultFont = findFontById('standard-inter');
    var defaultTextColor = getDefaultTextColorForCurrentBoard();
    var isSmallWall = allowsBottomToolOverhangForCurrentBoard();
    var defaultFontPt = isSmallWall ? 60 : 120;
    var defaultFontSize = fontPtToCanvasPx(defaultFontPt);
    var defaultMarginMm = isSmallWall ? 30 : 50;
    var unitPxPerMm = getCanvasPxPerMm();
    var defaultMarginPx = Math.max(TEXT_FIT_PADDING, defaultMarginMm * unitPxPerMm);

    // 1. Sofort Text erstellen (damit User Feedback hat)
    const text = new fabric.IText('Text eingeben', {
      objectType: 'custom-text',
      left: defaultMarginPx,
      top: defaultMarginPx,
      originX: 'left',
      originY: 'top',
      fontFamily: defaultFont.family, // Fallback, damit es nicht Times New Roman ist
      fontId: defaultFont.id,
      fontSize: defaultFontSize,
      sbcFontPt: defaultFontPt,
      fontPt: defaultFontPt,
      fpt: defaultFontPt,
      fontWeight: '400',
      fontStyle: 'normal',
      underline: false,
      textAlign: 'left',
      fill: defaultTextColor.hex || '#000000',
      textColorKey: defaultTextColor.key || 'black',
      textColorLabel: defaultTextColor.label || 'Schwarz',
      textColorCmyk: normalizeCmyk(defaultTextColor.cmyk, defaultTextColor.key === 'white' ? { c: 0, m: 0, y: 0, k: 0 } : { c: 0, m: 0, y: 0, k: 100 }),
      editable: true,
    });
    bindTextObjectEvents(text);
    applyCrispRendering(text);
    fitTextObject(text);

    canvas.add(text);
    canvas.setActiveObject(text);
    text.enterEditing();
    text.selectAll();
    syncTextPropertiesPanel(text);
    canvas.requestRenderAll();
    toast('Text hinzugefügt — doppelklicken zum Bearbeiten');

    // 2. Sicherstellen, dass Font geladen ist (für korrekte Darstellung)
    const fontSpec = '400 ' + defaultFontSize + 'px Inter';
    document.fonts.load(fontSpec).then(function () {
      // Wenn geladen, explizit neu zeichnen
      text.set('dirty', true);
      fitTextObject(text);
      canvas.requestRenderAll();
    }).catch(function (e) {
      console.warn('[SBC] Font load warning:', e);
    });
  }

  /* ==========================================
     SIDE TOGGLE (VORDERSEITE / RÜCKSEITE)
     ========================================== */

  function updateSideVisibility() {
    if (!canvas) return;
    canvas.getObjects().forEach(function (o) {
      if (o.isBackground) return;
      if (isSnapGuideObject(o)) {
        o.visible = true;
        o.evented = false;
        o.selectable = false;
        return;
      }
      if (isCustomBoardBrandObject(o)) {
        o.visible = selectedSizeIsCustom === true;
        o.evented = false;
        o.selectable = false;
        return;
      }
      var objSide = o.sbcSide || 'front';
      var isVisible = (objSide === currentSide);
      o.visible = isVisible;
      o.evented = isVisible;
      o.selectable = isVisible;
    });
    canvas.requestRenderAll();
  }

  function getDesignObjectCountForSide(side) {
    if (!canvas) return 0;
    return canvas.getObjects().filter(function (obj) {
      return isUserDesignObject(obj) && (obj.sbcSide || 'front') === side;
    }).length;
  }

  function updateSideToggleStatus() {
    var sideToggle = document.getElementById('sbc-side-toggle');
    if (!sideToggle) return;

    var isTwoSided = selectedMounting !== 'wall' && selectedMountingSides === 2;
    sideToggle.classList.toggle('sbc-side-toggle--active', isTwoSided && currentStep === 5);

    ['front', 'back'].forEach(function (side) {
      var count = getDesignObjectCountForSide(side);
      var isActive = currentSide === side;
      var btn = sideToggle.querySelector('.sbc-side-btn[data-side="' + side + '"]');
      var status = sideToggle.querySelector('[data-side-status="' + side + '"]');

      if (btn) {
        btn.classList.toggle('sbc-side-btn--active', isActive);
        btn.classList.toggle('sbc-side-btn--filled', count > 0);
        btn.classList.toggle('sbc-side-btn--empty', count === 0);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }

      if (status) {
        if (isActive) {
          status.textContent = count > 0 ? 'Aktiv · ' + count + ' Element' + (count === 1 ? '' : 'e') : 'Aktiv · noch leer';
        } else {
          status.textContent = count > 0 ? count + ' Element' + (count === 1 ? '' : 'e') : 'Noch leer';
        }
      }
    });
  }

  function switchSide(side) {
    side = side === 'back' ? 'back' : 'front';
    if (side === currentSide) {
      updateSideToggleStatus();
      return;
    }
    currentSide = side;

    $$('.sbc-side-btn').forEach(function (b) {
      if (b.dataset.side === side) {
        b.classList.add('sbc-side-btn--active');
        b.classList.remove('sbc-btn--ghost');
      } else {
        b.classList.remove('sbc-side-btn--active');
      }
    });

    canvas.discardActiveObject();
    updateSideVisibility();
    applyBackgroundForCurrentSize();
    refreshMeasurementGrid();
    updateCartButton();
    updateObjectCounter();
    updateEmptyState();
    updateSideToggleStatus();
  }

  function bindSideToggle() {
    $$('.sbc-side-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        switchSide(btn.dataset.side);
      });
    });
  }

  /* ==========================================
     SIDEBAR BINDINGS
     ========================================== */

  function bindSidebar() {
    const toggle = dom.mobileToggle();
    const sidebar = dom.sidebar();
    if (!sidebar) return;

    // Overlay
    const overlay = document.createElement('div');
    overlay.className = 'sbc-overlay';
    sidebar.parentElement.appendChild(overlay);

    function openSidebar() {
      sidebar.classList.add('sbc-sidebar--open');
      overlay.classList.add('sbc-overlay--visible');
    }

    function closeSidebar() {
      sidebar.classList.remove('sbc-sidebar--open');
      overlay.classList.remove('sbc-overlay--visible');
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (sidebar.classList.contains('sbc-sidebar--open')) {
          closeSidebar();
        } else {
          openSidebar();
        }
      });
    }

    // Mobile Tools-Button im Header
    var toolsBtn = document.getElementById('sbc-mobile-tools-btn');
    if (toolsBtn) {
      toolsBtn.addEventListener('click', function () {
        if (sidebar.classList.contains('sbc-sidebar--open')) {
          closeSidebar();
        } else {
          openSidebar();
        }
      });
    }

    overlay.addEventListener('click', closeSidebar);
  }

  function bindPanelToggles() {
    $$('.sbc-panel__toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        const body = btn.nextElementSibling;
        if (body) body.classList.toggle('sbc-panel__body--open', !expanded);
      });
    });
  }

  function rememberMobileMenuPointer(event) {
    if (!event) return;
    var point = event.touches && event.touches[0] ? event.touches[0] : event;
    lastMobileMenuPointer = {
      time: Date.now(),
      x: Number(point.clientX) || 0,
      y: Number(point.clientY) || 0
    };
  }

  function isLikelyMobileMenuClickLeak(event) {
    if (!isMobile || !event || !lastMobileMenuPointer.time) return false;
    if (Date.now() - lastMobileMenuPointer.time > 450) return false;
    var dx = Math.abs((Number(event.clientX) || 0) - lastMobileMenuPointer.x);
    var dy = Math.abs((Number(event.clientY) || 0) - lastMobileMenuPointer.y);
    return dx < 56 && dy < 56;
  }

  function bindMobileMenuHitGuards() {
    var root = document.querySelector('.sbc');
    if (!root) return;
    var menuSelector = '.sbc-mobile-editor-tab, .sbc-category-toggle, .sbc-panel__toggle, .sbc-side-btn, .sbc-action-btn, .sbc-canvas-back-btn, .sbc-canvas-next-btn';

    ['pointerdown', 'mousedown', 'touchstart'].forEach(function (eventName) {
      root.addEventListener(eventName, function (event) {
        if (event.target && event.target.closest && event.target.closest(menuSelector)) {
          rememberMobileMenuPointer(event);
        }
      }, true);
    });

    root.addEventListener('click', function (event) {
      var tab = event.target && event.target.closest ? event.target.closest('.sbc-mobile-editor-tab') : null;
      if (!tab) return;
      var targetSelector = tab.getAttribute('href');
      var target = targetSelector ? document.querySelector(targetSelector) : null;

      event.preventDefault();
      event.stopPropagation();

      $$('.sbc-mobile-editor-tab').forEach(function (item) {
        item.classList.toggle('sbc-mobile-editor-tab--active', item === tab);
      });

      if (target && target.scrollIntoView) {
        target.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }, true);
  }

  /* ==========================================
     WIZARD – Step Navigation
     ========================================== */

  // Farb-Hex-Werte für Varianten-Namen (Fallback-Mapping)
  var VARIANT_COLOR_MAP = {
    'blau': '#233d7b', 'blue': '#233d7b',
    'rot': '#b93139', 'red': '#b93139',
    'gelb': '#f3b536', 'yellow': '#f3b536',
    'grün': '#12785a', 'gruen': '#12785a', 'green': '#12785a',
    'schwarz': '#1a1919', 'black': '#1a1919',
    'weiß': '#ffffff', 'weiss': '#ffffff', 'white': '#ffffff',
  };

  function colorHexForName(name) {
    if (!name) return '#cccccc';
    var lower = name.toLowerCase().trim();
    return VARIANT_COLOR_MAP[lower] || '#cccccc';
  }

  function getFixedSizeButton(widthMm, heightMm) {
    return Array.from($$('.sbc-size-option')).find(function (btn) {
      return btn.dataset.customSize !== 'true' &&
        parseInt(btn.dataset.w, 10) === Number(widthMm) &&
        parseInt(btn.dataset.h, 10) === Number(heightMm);
    }) || null;
  }

  function setCustomSizeCard(widthMm, heightMm, selected) {
    var card = document.getElementById('sbc-custom-size-option');
    var widthInput = document.getElementById('sbc-custom-width-mm');
    var heightInput = document.getElementById('sbc-custom-height-mm');
    var current = document.getElementById('sbc-custom-size-current');
    if (widthInput && widthMm > 0) widthInput.value = String(widthMm);
    if (heightInput && heightMm > 0) heightInput.value = String(heightMm);
    if (card && widthMm > 0 && heightMm > 0) {
      card.dataset.w = String(widthMm);
      card.dataset.h = String(heightMm);
    }
    if (current) {
      current.textContent = (widthMm > 0 && heightMm > 0) ? ('Aktuell: ' + widthMm + ' × ' + heightMm + ' mm') : '';
      current.hidden = !current.textContent;
    }
    if (card) card.classList.toggle('sbc-size-option--selected', selected === true);
  }

  function readCustomSizeInputValue(input) {
    var value = Math.round(Number(input && input.value));
    if (!Number.isFinite(value)) return 0;
    return value;
  }

  function applyCustomSizeSelection() {
    var widthInput = document.getElementById('sbc-custom-width-mm');
    var heightInput = document.getElementById('sbc-custom-height-mm');
    var widthMm = readCustomSizeInputValue(widthInput);
    var heightMm = readCustomSizeInputValue(heightInput);

    if (heightMm > 3000) {
      toast('Die individuelle Größe kann nicht höher als 3000 mm sein.', 'error');
      return;
    }

    if (widthMm < 100 || widthMm > 5000 || heightMm < 100) {
      toast('Bitte gib eine individuelle Größe mit 100-5000 mm Breite und 100-3000 mm Höhe ein.', 'error');
      return;
    }

    var card = document.getElementById('sbc-custom-size-option');
    if (!card) return;
    setCustomSizeCard(widthMm, heightMm, false);
    selectSizeOption(card);
  }

  function bindCustomSizeControls() {
    var card = document.getElementById('sbc-custom-size-option');
    var applyBtn = document.getElementById('sbc-custom-size-apply');
    var inputs = [document.getElementById('sbc-custom-width-mm'), document.getElementById('sbc-custom-height-mm')].filter(Boolean);
    if (!card || !applyBtn) return;

    applyBtn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      applyCustomSizeSelection();
    });

    inputs.forEach(function (input) {
      input.addEventListener('click', function (event) { event.stopPropagation(); });
      input.addEventListener('keydown', function (event) {
        event.stopPropagation();
        if (event.key === 'Enter') {
          event.preventDefault();
          applyCustomSizeSelection();
        }
      });
    });
  }

  function updateCustomSizeEditButton() {
    var btn = dom.customSizeEditButton();
    if (!btn) return;
    var show = Number(CFG.boardWidthMm) > 0 && Number(CFG.boardHeightMm) > 0;
    btn.hidden = !show;
    var value = dom.customSizeEditValue();
    if (value) value.textContent = show ? getBoardDimensionLabel() + ' · Gestaltung bleibt erhalten' : '';
  }

  function setCustomSizeEditError(message) {
    var error = dom.customSizeEditError();
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function getCustomSizeMountingGuideWidths() {
    var widths = Object.keys(MOUNTING_DATA || {}).map(function (width) {
      return Number(width);
    }).filter(function (width) {
      return Number.isFinite(width) && supportsFreestandingMounting(width);
    });

    [800, 1210].forEach(function (width) {
      if (widths.indexOf(width) === -1) widths.push(width);
    });

    return widths.sort(function (a, b) { return a - b; });
  }

  function getCustomSizeMountingAvailability(widthMm, heightMm) {
    var validDimensions = Number(widthMm) >= 100 && Number(widthMm) <= 5000 && Number(heightMm) >= 100 && Number(heightMm) <= 3000;
    var productAvailable = validDimensions && !!getProductForCustomDimensionsSurface(widthMm, heightMm, selectedSurfaceType);

    return {
      ready: validDimensions,
      product: productAvailable,
      wall: productAvailable && isMountingOptionVisible('wall'),
      stand: productAvailable && isMountingOptionVisible('stand') && !!getMountingEntry('stand', 1, selectedSurfaceType, widthMm),
      trolley: productAvailable && isMountingOptionVisible('trolley') && !!getMountingEntry('trolley', 1, selectedSurfaceType, widthMm)
    };
  }

  function setCustomSizeMountingStatus(statusEl, available, ready) {
    if (!statusEl) return;
    statusEl.classList.remove('sbc-custom-size-mounting-guide__status--available', 'sbc-custom-size-mounting-guide__status--unavailable');
    if (!ready) {
      statusEl.setAttribute('aria-label', statusEl.textContent + ': nach Eingabe verfügbar');
      return;
    }
    statusEl.classList.add(available ? 'sbc-custom-size-mounting-guide__status--available' : 'sbc-custom-size-mounting-guide__status--unavailable');
    statusEl.setAttribute('aria-label', statusEl.textContent + ': ' + (available ? 'verfügbar' : 'nicht verfügbar'));
  }

  function createCustomSizeAvailabilityPill(available) {
    var pill = document.createElement('span');
    pill.className = 'sbc-custom-size-mounting-guide__availability ' + (available
      ? 'sbc-custom-size-mounting-guide__availability--yes'
      : 'sbc-custom-size-mounting-guide__availability--no');
    pill.textContent = available ? 'Ja' : 'Nein';
    return pill;
  }

  function renderCustomSizeMountingGuideTable(currentWidthMm) {
    var body = dom.customSizeMountingTableBody();
    if (!body) return;
    body.textContent = '';

    getCustomSizeMountingGuideWidths().forEach(function (widthMm) {
      var row = document.createElement('tr');
      if (Number(currentWidthMm) === widthMm) row.classList.add('sbc-custom-size-mounting-guide__row--current');

      var widthCell = document.createElement('td');
      widthCell.textContent = widthMm + ' mm Breite';
      row.appendChild(widthCell);

      var wallCell = document.createElement('td');
      wallCell.appendChild(createCustomSizeAvailabilityPill(isMountingOptionVisible('wall')));
      row.appendChild(wallCell);

      ['stand', 'trolley'].forEach(function (mountingType) {
        var cell = document.createElement('td');
        var available = isMountingOptionVisible(mountingType) && !!getMountingEntry(mountingType, 1, selectedSurfaceType, widthMm);
        cell.appendChild(createCustomSizeAvailabilityPill(available));
        row.appendChild(cell);
      });

      body.appendChild(row);
    });
  }

  function updateCustomSizeMountingGuide() {
    var widthMm = readCustomSizeInputValue(dom.customSizeEditWidth());
    var heightMm = readCustomSizeInputValue(dom.customSizeEditHeight());
    var availability = getCustomSizeMountingAvailability(widthMm, heightMm);
    var measure = dom.customSizeMountingMeasure();
    var message = dom.customSizeMountingMessage();

    if (measure) {
      measure.textContent = widthMm > 0 && heightMm > 0
        ? 'Dein Maß: ' + widthMm + ' × ' + heightMm + ' mm'
        : 'Dein Maß wird geprüft';
    }

    dom.customSizeMountingStatuses().forEach(function (statusEl) {
      var mountingType = statusEl.dataset.customSizeMountingStatus;
      setCustomSizeMountingStatus(statusEl, !!availability[mountingType], availability.ready);
    });

    if (message) {
      if (!availability.ready) {
        message.textContent = 'Breite und Höhe innerhalb der zulässigen Grenzen eingeben.';
      } else if (!availability.product) {
        message.textContent = 'Für dieses Maß und die aktuelle Oberfläche ist noch keine Preisgröße konfiguriert.';
      } else {
        var availableLabels = [];
        if (availability.wall) availableLabels.push('Wandmontage');
        if (availability.stand) availableLabels.push('Standgestell');
        if (availability.trolley) availableLabels.push('Rollwagen');

        var currentMountingAvailable = selectedMounting === 'wall'
          ? availability.wall
          : !!availability[selectedMounting];
        if (!currentMountingAvailable) {
          var selectedLabel = selectedMounting === 'stand' ? 'Standgestell' : (selectedMounting === 'trolley' ? 'Rollwagen' : 'Wandmontage');
          message.textContent = 'Deine aktuell gewählte Aufstellung „' + selectedLabel + '“ passt nicht zu dieser Breite. Möglich: ' + availableLabels.join(', ') + '.';
        } else {
          message.textContent = 'Für dieses Maß möglich: ' + availableLabels.join(', ') + '.';
        }
      }
    }

    var surface = dom.customSizeMountingSurface();
    if (surface) {
      surface.textContent = 'Aktuelle Oberfläche: ' + (selectedSurfaceType === 'premium' ? 'Premium' : 'Basic') + '. Die Höhe kann bis 3000 mm variieren; für Standgestell und Rollwagen zählt die Breite.';
    }
    renderCustomSizeMountingGuideTable(widthMm);
  }

  function showCustomSizeEditor() {
    var modal = dom.customSizeEditModal();
    var widthInput = dom.customSizeEditWidth();
    var heightInput = dom.customSizeEditHeight();
    if (!modal || !widthInput || !heightInput) return;

    widthInput.value = String(Math.round(CFG.boardWidthMm));
    heightInput.value = String(Math.round(CFG.boardHeightMm));
    setCustomSizeEditError('');
    updateCustomSizeMountingGuide();
    modal.style.display = 'flex';
    window.setTimeout(function () {
      widthInput.focus();
      widthInput.select();
    }, 0);
  }

  function hideCustomSizeEditor() {
    var modal = dom.customSizeEditModal();
    if (modal) modal.style.display = 'none';
    setCustomSizeEditError('');
  }

  function validateEditedCustomSize(widthMm, heightMm) {
    if (heightMm > 3000) {
      return { error: 'Die individuelle Größe kann nicht höher als 3000 mm sein.' };
    }
    if (widthMm < 100 || widthMm > 5000 || heightMm < 100) {
      return { error: 'Bitte gib 100-5000 mm Breite und 100-3000 mm Höhe ein.' };
    }

    var product = getProductForCustomDimensionsSurface(widthMm, heightMm, selectedSurfaceType);
    if (!product) {
      var priceResolution = getCustomSizePriceResolution(widthMm, heightMm);
      return { error: 'Für die Preisgröße ' + (priceResolution ? priceResolution.label : (widthMm + ' × ' + heightMm + ' mm')) + ' und die gewählte Oberfläche ist kein Produkt konfiguriert.' };
    }

    var variant = resolveProductVariantForColor(product, selectedColor);
    if (!variant || variant.available === false) {
      return { error: 'Die gewählte Farbe ist für dieses Sondermaß nicht verfügbar.' };
    }

    if (selectedMounting !== 'wall' && selectedMountingSides === 2) {
      var backVariant = resolveProductVariantForColor(product, selectedBackColor);
      if (!backVariant || backVariant.available === false) {
        return { error: 'Die gewählte Rückseitenfarbe ist für dieses Sondermaß nicht verfügbar.' };
      }
    }

    if (selectedMounting !== 'wall' && !getMountingEntry(selectedMounting, selectedMountingSides, selectedSurfaceType, widthMm)) {
      return { error: 'Die gewählte Montageart ist für diese Breite nicht verfügbar.' };
    }

    var bounds = getCurrentDesignPhysicalBounds();
    if (bounds) {
      var tolerance = bounds.tolerance || 0;
      if (bounds.minLeft < -tolerance || bounds.minTop < -tolerance) {
        return { error: 'Mindestens ein Element liegt bereits außerhalb der Wand. Bitte platziere zuerst alle Elemente vollständig auf der Fläche.' };
      }

      var widthTooSmall = bounds.maxRight > (widthMm * bounds.pxPerMm) + tolerance;
      var heightTooSmall = bounds.maxBottom > (heightMm * bounds.pxPerMm) + tolerance;
      if (widthTooSmall || heightTooSmall) {
        var requiredWidth = Math.max(100, Math.ceil((bounds.maxRight - tolerance) / bounds.pxPerMm));
        var requiredHeight = Math.max(100, Math.ceil((bounds.maxBottom - tolerance) / bounds.pxPerMm));
        return { error: 'Das neue Maß ist für die aktuelle Gestaltung zu klein. Benötigt werden mindestens ' + requiredWidth + ' × ' + requiredHeight + ' mm.' };
      }
    }

    return { product: product, variant: variant };
  }

  function applyEditedCustomSize() {
    var widthMm = readCustomSizeInputValue(dom.customSizeEditWidth());
    var heightMm = readCustomSizeInputValue(dom.customSizeEditHeight());

    if (widthMm === Number(CFG.boardWidthMm) && heightMm === Number(CFG.boardHeightMm)) {
      hideCustomSizeEditor();
      return;
    }

    var validation = validateEditedCustomSize(widthMm, heightMm);
    if (validation.error) {
      setCustomSizeEditError(validation.error);
      return;
    }

    var physicalState = captureCanvasObjectPhysicalState();
    if (!physicalState) {
      setCustomSizeEditError('Die Gestaltung konnte nicht sicher für die Größenänderung vorbereitet werden. Bitte versuche es erneut.');
      return;
    }

    var previousWidthMm = CFG.boardWidthMm;
    var previousHeightMm = CFG.boardHeightMm;
    var previousProduct = selectedProduct;
    var previousVariant = selectedVariant;
    var previousSelectedSize = selectedSize;
    var previousSelectedSizeIsCustom = selectedSizeIsCustom;
    canvas.discardActiveObject();
    clearSnapGuides();

    try {
      selectedSize = { w: widthMm, h: heightMm, custom: true };
      selectedSizeIsCustom = true;
      CFG.boardWidthMm = widthMm;
      CFG.boardHeightMm = heightMm;
      selectedProduct = validation.product;
      selectedVariant = validation.variant;
      $$('.sbc-size-option').forEach(function (btn) { btn.classList.remove('sbc-size-option--selected'); });
      setCustomSizeCard(widthMm, heightMm, true);

      resizeCanvas({ skipObjectRescale: true });
      restoreCanvasObjectPhysicalState(physicalState);
    } catch (error) {
      console.error('[SBC] Sondermaß konnte nicht sicher angepasst werden:', error);
      selectedSize = previousSelectedSize;
      selectedSizeIsCustom = previousSelectedSizeIsCustom;
      CFG.boardWidthMm = previousWidthMm;
      CFG.boardHeightMm = previousHeightMm;
      selectedProduct = previousProduct;
      selectedVariant = previousVariant;
      $$('.sbc-size-option').forEach(function (btn) { btn.classList.remove('sbc-size-option--selected'); });
      if (previousSelectedSizeIsCustom) {
        setCustomSizeCard(previousWidthMm, previousHeightMm, true);
      } else {
        setCustomSizeCard(0, 0, false);
        var previousFixedSizeButton = getFixedSizeButton(previousWidthMm, previousHeightMm);
        if (previousFixedSizeButton) previousFixedSizeButton.classList.add('sbc-size-option--selected');
      }
      resizeCanvas({ skipObjectRescale: true });
      restoreCanvasObjectPhysicalState(physicalState);
      applyBackgroundForCurrentSize();
      setCustomSizeEditError('Die Größe konnte nicht sicher geändert werden. Die bisherige Gestaltung wurde wiederhergestellt.');
      return;
    }

    applyBackgroundForCurrentSize();
    updateMountingStepUi();
    updateSurfaceStepUi();
    renderColorOptions();
    updateSelectedProductTitle();
    updateTotalPrice();
    updateMockupBackground();
    refreshMeasurementGrid();
    syncCanvasUi();
    updateCanvasNextButtonState();

    // Alte Undo-Zustände beziehen sich auf die vorherige Canvas-Geometrie.
    // Ein neuer Ausgangspunkt verhindert, dass ein Undo die Gestaltung verzerrt.
    undoStack = [];
    redoStack = [];
    saveState(true);
    updateUndoRedoButtons();

    hideCustomSizeEditor();
    trackEvent('custom_size_updated_in_design', {
      previousWidthMm: previousWidthMm,
      previousHeightMm: previousHeightMm,
      widthMm: widthMm,
      heightMm: heightMm,
      objectCount: physicalState.objects.length
    });
    toast('Sondermaß angepasst — die Gestaltung wurde beibehalten');
  }

  function bindCustomSizeEditor() {
    var btn = dom.customSizeEditButton();
    var modal = dom.customSizeEditModal();
    var cancelBtn = document.getElementById('sbc-custom-size-edit-cancel');
    var applyBtn = document.getElementById('sbc-custom-size-edit-apply');
    var inputs = [dom.customSizeEditWidth(), dom.customSizeEditHeight()].filter(Boolean);

    if (btn) btn.addEventListener('click', showCustomSizeEditor);
    if (cancelBtn) cancelBtn.addEventListener('click', hideCustomSizeEditor);
    if (applyBtn) applyBtn.addEventListener('click', applyEditedCustomSize);
    if (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target === modal) hideCustomSizeEditor();
      });
    }

    inputs.forEach(function (input) {
      input.addEventListener('input', function () {
        setCustomSizeEditError('');
        updateCustomSizeMountingGuide();
      });
      input.addEventListener('keydown', function (event) {
        event.stopPropagation();
        if (event.key === 'Enter') {
          event.preventDefault();
          applyEditedCustomSize();
        }
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && modal.style.display !== 'none') {
        hideCustomSizeEditor();
      }
    });
    updateCustomSizeEditButton();
  }

  function selectSizeOption(btn) {
    if (!btn) return;
    var isCustom = btn.dataset.customSize === 'true';
    if (isToolWallMode() && !isCustom) return;
    var w = parseInt(btn.dataset.w, 10);
    var h = parseInt(btn.dataset.h, 10);
    if (!(w > 0) || !(h > 0)) {
      if (isCustom) toast('Bitte gib zuerst Breite und Höhe für das Sondermaß ein.', 'error');
      return;
    }
    if (btn.hidden || (!isCustom && !isSizeOptionVisible(w, h))) return;
    var isSameSize = (CFG.boardWidthMm === w && CFG.boardHeightMm === h && selectedSizeIsCustom === isCustom);

    var hasUserObjects = false;
    if (canvas) {
      var objs = canvas.getObjects();
      hasUserObjects = objs.some(function (o) { return isUserDesignObject(o); });
    }

    if (hasUserObjects && !isSameSize && !isHydratingDesign) {
      var confirmed = window.confirm("Achtung: Wenn du die Größe der Schattenwand änderst, werden alle bisher platzierten Werkzeuge und Texte gelöscht, da sich die Proportionen ändern.\n\nMöchtest du fortfahren und die Wand leeren?");
      if (!confirmed) return;
      if (canvas) {
        canvas.clear();
        customBoardBrandMark = null;
        customBoardBrandVariant = '';
        canvas.backgroundColor = '#ffffff';
        saveState();
      }
    }

    $$('.sbc-size-option').forEach(function (b) { b.classList.remove('sbc-size-option--selected'); });
    btn.classList.add('sbc-size-option--selected');

    selectedSize = { w: w, h: h, custom: isCustom };
    selectedSizeIsCustom = isCustom;
    CFG.boardWidthMm = w;
    CFG.boardHeightMm = h;
    if (isCustom) setCustomSizeCard(w, h, true);

    if (!isSameSize) {
      resizeCanvas();
      applyBackgroundForCurrentSize();
    }

    var sizeKey = isCustom ? 'custom' : getSizeKey(w, h);
    selectedVariant = null;
    selectedProduct = getProductForSizeWithSurfaceFallback(w, h);

    if (!selectedProduct) {
      console.warn('[SBC] Kein Produkt für Größe', sizeKey, 'konfiguriert');
    } else {
      console.log('[SBC] Produkt für', sizeKey, '/', selectedProduct.surfaceType || 'basic', ':', selectedProduct.title, '(' + selectedProduct.variants.length + ' Varianten)', selectedSizeIsCustom ? 'Preisgröße: ' + getPriceSizeLabel() + ' Faktor: ' + getBoardPriceMultiplier() : '');
      var priceEl = btn.querySelector('.sbc-size-option__price');
      if (priceEl && selectedProduct.variants.length > 0) priceEl.textContent = '';
      if (!isCustom) {
        btn.style.opacity = '';
        btn.title = '';
      }
    }

    var nextBtn = btn.closest('.sbc-step') ? btn.closest('.sbc-step').querySelector('.sbc-btn-next') : null;
    if (nextBtn) nextBtn.disabled = !canContinueFromSizeStep();

    if (!selectedProduct) {
      toast(isCustom ? 'Für die berechnete Preisgröße ' + getPriceSizeLabel() + ' ist noch kein Shopify-Produkt im Theme Editor konfiguriert.' : 'Dieses Produkt ist noch nicht im Customizer konfiguriert', 'error');
    }
    updateSelectedProductTitle();
    selectedVariant = selectedProduct ? resolveVariantForColor(selectedColor) : null;

    if (!supportsFreestandingMounting(w)) {
      selectedMounting = 'wall';
      selectedMountingSides = 1;
      activeColorSide = 'front';
      if (currentSide === 'back') switchSide('front');
    }

    updateMountingStepUi();
    updateSurfaceStepUi();
    updateWizardProgressUi(currentStep);
  }

  function refreshSizeOptionAvailability(btn) {
    if (!btn || btn.dataset.customSize === 'true') return;

    var w = parseInt(btn.dataset.w, 10);
    var h = parseInt(btn.dataset.h, 10);
    var priceEl = btn.querySelector('.sbc-size-option__price');
    var product = getProductForSizeSurface(w, h, 'basic') || getProductForSizeSurface(w, h, 'premium');

    if (priceEl) priceEl.textContent = '';

    if (product && product.variants && product.variants.length > 0) {
      btn.style.opacity = '';
      btn.title = '';
    } else {
      btn.style.opacity = '0.45';
      btn.title = 'Produkt nicht konfiguriert';
    }
  }

  function syncSizeStepState() {
    $$('.sbc-size-option').forEach(function (btn) {
      if (btn.dataset.customSize === 'true') {
        btn.style.opacity = '';
        btn.title = '';
        return;
      }
      refreshSizeOptionAvailability(btn);
    });

    var currentSizeBtn = selectedSizeIsCustom ? null : getFixedSizeButton(CFG.boardWidthMm, CFG.boardHeightMm);
    $$('.sbc-size-option').forEach(function (btn) {
      btn.classList.toggle('sbc-size-option--selected', btn === currentSizeBtn);
    });
    if (selectedSizeIsCustom) {
      setCustomSizeCard(CFG.boardWidthMm, CFG.boardHeightMm, true);
    } else {
      setCustomSizeCard(0, 0, false);
    }

    selectedProduct = getProductForSizeWithSurfaceFallback(CFG.boardWidthMm, CFG.boardHeightMm);
    selectedVariant = selectedProduct ? resolveVariantForColor(selectedColor) : null;

    updateSizeStepNextState();

    updateSelectedProductTitle();
    updateSurfaceStepUi();
    updateTotalPrice();
  }

  function bindWizard() {
    // --- Size options (Step 1) ---
    $$('.sbc-size-option').forEach(function (btn) {
      if (btn.dataset.customSize === 'true') return;
      btn.addEventListener('click', function () {
        selectSizeOption(btn);
      });
    });

    // --- Mounting options (Step 2) ---
    var mountingGrid = document.querySelector('.sbc-mounting-grid');
    if (mountingGrid && !mountingGrid.dataset.boundMountingClick) {
      mountingGrid.dataset.boundMountingClick = 'true';
      mountingGrid.addEventListener('click', function (event) {
        var option = event.target && event.target.closest ? event.target.closest('.sbc-mounting-option') : null;
        if (!option || !mountingGrid.contains(option)) return;
        if (event.target && event.target.closest && event.target.closest('.sbc-stand-option')) return;
        selectMountingOption(option);
      });
    }

    $$('.sbc-mounting-option').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.stopPropagation();
        selectMountingOption(btn);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          btn.click();
        }
      });
    });

    // --- Stand Gestell Sides options (Step 2) ---
    $$('.sbc-stand-option').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        selectedMountingSides = parseInt(btn.dataset.sides, 10);
        if (selectedMountingSides !== 2) activeColorSide = 'front';
        if (selectedMountingSides === 2 && !selectedBackColorCustomized) selectedBackColor = selectedColor || selectedBackColor || 'white';
        updateMountingStepUi();
        updateSurfaceStepUi();
      });
    });

    // --- Next buttons ---
    $$('.sbc-btn-next').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var nextStep = normalizeWizardTargetStep(parseInt(btn.dataset.next, 10), 1);

        if (nextStep && !btn.disabled) goToStep(nextStep);
      });
    });

    // --- Prev buttons ---
    $$('.sbc-btn-prev').forEach(function (btn) {
      if (btn.classList.contains('sbc-canvas-back-btn')) return;
      btn.addEventListener('click', function () {
        var prevStep = normalizeWizardTargetStep(parseInt(btn.dataset.prev, 10), -1);

        if (prevStep) goToStep(prevStep);
      });
    });

    var canvasBackBtn = document.querySelector('.sbc-canvas-back-btn');
    if (canvasBackBtn) {
      canvasBackBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        var prevStep = getPreviousVisibleWizardStep(currentStep);
        if (prevStep) goToStep(prevStep);
      });
    }

    var canvasNextBtn = document.querySelector('.sbc-canvas-next-btn');
    if (canvasNextBtn) {
      canvasNextBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (canvasNextBtn.disabled) return;

        var stepNextBtn = getCurrentStepNextButton(currentStep);
        if (stepNextBtn && stepNextBtn.disabled) return;

        var nextStep = getNextVisibleWizardStep(currentStep);
        if (nextStep) goToStep(nextStep);
      });
    }
  }

  /**
   * Baut die Farbauswahl in Step 3 dynamisch aus den Varianten des gewählten Produkts auf.
   */

  // Mapping von Varianten-Farbnamen → Backend-Farbschlüssel
  var VARIANT_TO_BACKEND_COLOR = {
    'weiß': 'white', 'weiss': 'white', 'white': 'white',
    'schwarz': 'black', 'black': 'black',
    'blau': 'blue', 'blue': 'blue',
    'rot': 'red', 'red': 'red',
    'grün': 'green', 'gruen': 'green', 'green': 'green',
    'gelb': 'yellow', 'yellow': 'yellow',
  };

  function variantNameToBackendColor(name) {
    if (!name) return 'white';
    var normalized = name.toLowerCase().trim();
    if (VARIANT_TO_BACKEND_COLOR[normalized]) return VARIANT_TO_BACKEND_COLOR[normalized];
    var key = normalizeOptionKey(normalized);
    var configured = getConfiguredColorOptions().find(function (color) {
      return color.key === key || normalizeOptionKey(color.label) === key;
    });
    return configured ? configured.key : 'custom';
  }

  function isMountingStepAvailable(widthMm) {
    if (isToolWallMode()) return false;
    var width = Number(widthMm || CFG.boardWidthMm);
    return width === 800 || width === 1210;
  }

  function supportsFreestandingMounting(widthMm) {
    return isMountingStepAvailable(widthMm);
  }

  function getVisibleWizardSteps() {
    if (isToolWallMode()) return [1, 3, 5, 6];
    return isMountingStepAvailable() ? [1, 2, 3, 4, 5, 6] : [1, 3, 4, 5, 6];
  }

  function getVisibleStepCount() {
    return getVisibleWizardSteps().length;
  }

  function getVisibleStepIndex(step) {
    var index = getVisibleWizardSteps().indexOf(Number(step));
    return index >= 0 ? index + 1 : 0;
  }

  function normalizeWizardTargetStep(step, direction) {
    var targetStep = Number(step) || 1;
    var visibleSteps = getVisibleWizardSteps();
    if (visibleSteps.indexOf(targetStep) !== -1) return targetStep;
    if (direction < 0) {
      return visibleSteps.slice().reverse().find(function (visibleStep) {
        return visibleStep < targetStep;
      }) || visibleSteps[0];
    }
    return visibleSteps.find(function (visibleStep) {
      return visibleStep > targetStep;
    }) || visibleSteps[visibleSteps.length - 1];
  }

  function getPreviousVisibleWizardStep(step) {
    var visibleSteps = getVisibleWizardSteps();
    var current = Number(step) || currentStep || visibleSteps[0];
    var index = visibleSteps.indexOf(current);
    if (index > 0) return visibleSteps[index - 1];
    return null;
  }

  function getNextVisibleWizardStep(step) {
    var visibleSteps = getVisibleWizardSteps();
    var current = Number(step) || currentStep || visibleSteps[0];
    var index = visibleSteps.indexOf(current);
    if (index >= 0 && index < visibleSteps.length - 1) return visibleSteps[index + 1];
    return null;
  }

  function updateCanvasNextButtonState() {
    var canvasNextBtn = document.querySelector('.sbc-canvas-next-btn');
    if (!canvasNextBtn) return;

    var nextStep = getNextVisibleWizardStep(currentStep);
    var stepNextBtn = getCurrentStepNextButton(currentStep);
    canvasNextBtn.disabled = !nextStep || !stepNextBtn || stepNextBtn.disabled;
  }

  function getCurrentStepNextButton(step) {
    if (Number(step) === 5) return document.getElementById('btn-finalize-step');
    return document.querySelector('#sbc-step-' + step + ' .sbc-btn-next');
  }

  function getWizardStepTitle(step) {
    var stepTitles = {
      1: isToolWallMode() ? 'Hersteller und Größe wählen' : 'Größe wählen',
      2: 'Wie soll sie stehen?',
      3: 'Farbe wählen',
      4: getConfiguratorText('surfaceStepTitle', CONFIGURATOR_TEXT_DEFAULTS.surfaceStepTitle),
      5: 'Gestalten',
      6: getConfiguratorText('finalizeStepTitle', CONFIGURATOR_TEXT_DEFAULTS.finalizeStepTitle)
    };
    return stepTitles[step] || '';
  }

  function updateWizardProgressUi(activeStep) {
    var visibleSteps = getVisibleWizardSteps();
    if (visibleSteps.indexOf(Number(activeStep)) === -1) activeStep = visibleSteps[0];
    var activeVisibleIndex = Math.max(0, visibleSteps.indexOf(Number(activeStep)));
    var lineIndexes = visibleSteps.slice(0, -1).map(function (step) { return step - 1; });

    $$('.sbc-step-dot[data-step]').forEach(function (dot) {
      var step = parseInt(dot.dataset.step, 10);
      var visibleIndex = visibleSteps.indexOf(step);
      var show = visibleIndex !== -1;
      dot.hidden = !show;
      dot.style.display = show ? '' : 'none';
      dot.classList.remove('sbc-step-dot--active', 'sbc-step-dot--completed', 'sbc-step-dot--disabled');

      if (!show) return;

      var num = dot.querySelector('.sbc-step-dot__num');
      if (num) num.textContent = String(visibleIndex + 1);

      if (step === activeStep) {
        dot.classList.add('sbc-step-dot--active');
      } else if (visibleIndex < activeVisibleIndex) {
        dot.classList.add('sbc-step-dot--completed');
      }
    });

    $$('.sbc-step-dot__line').forEach(function (line, index) {
      var visibleLineIndex = lineIndexes.indexOf(index);
      var show = visibleLineIndex !== -1;
      line.hidden = !show;
      line.style.display = show ? '' : 'none';
      line.classList.toggle('sbc-step-dot__line--completed', show && visibleLineIndex < activeVisibleIndex);
    });

    var mobileStepLabel = document.getElementById('sbc-mobile-step-label');
    var mobileStepTitle = document.getElementById('sbc-mobile-step-title');
    if (mobileStepLabel) mobileStepLabel.textContent = 'Schritt ' + getVisibleStepIndex(activeStep) + ' / ' + getVisibleStepCount();
    if (mobileStepTitle) mobileStepTitle.textContent = getWizardStepTitle(activeStep);
  }

  function selectMountingOption(option) {
    if (!option) return;
    var mounting = option.dataset.mounting;
    if (!mounting || option.hidden || !isMountingOptionVisible(mounting)) return;
    var isFreestandingOption = mounting === 'stand' || mounting === 'trolley';
    if (isFreestandingOption && !supportsFreestandingMounting()) return;

    selectedMounting = mounting;
    if (selectedMounting === 'wall') {
      selectedMountingSides = 1;
      activeColorSide = 'front';
      if (currentSide === 'back') {
        switchSide('front');
      }
    }

    updateMountingStepUi();
    updateSurfaceStepUi();
  }

  function formatEuroCents(cents, includePlus) {
    if (typeof cents !== 'number' || isNaN(cents)) return 'Preis auf Anfrage';
    if (cents <= 0) return 'inklusive';
    return (includePlus ? '+ ' : '') + (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function getMountingOptionPriceCents(mountingType) {
    if (!mountingType || mountingType === 'wall') return 0;
    var entry = getMountingEntry(mountingType, 1, selectedSurfaceType);
    if (!entry || !entry.variants || entry.variants.length === 0) return null;

    return Math.min.apply(null, entry.variants.map(function (v) { return v.price; }));
  }

  function updateMountingStepUi() {
    var freestandingAvailable = supportsFreestandingMounting();
    var availableMountingOptions = Array.prototype.slice.call($$('.sbc-mounting-option')).filter(function (option) {
      var mounting = option.dataset.mounting;
      var isFreestandingOption = mounting === 'stand' || mounting === 'trolley';
      return isMountingOptionVisible(mounting) && !(isFreestandingOption && !freestandingAvailable);
    });

    if (!availableMountingOptions.some(function (option) { return option.dataset.mounting === selectedMounting; })) {
      selectedMounting = availableMountingOptions[0] ? availableMountingOptions[0].dataset.mounting : 'wall';
      selectedMountingSides = 1;
    }

    $$('.sbc-mounting-option').forEach(function (option) {
      var mounting = option.dataset.mounting;
      var isFreestandingOption = mounting === 'stand' || mounting === 'trolley';
      var isSelected = mounting === selectedMounting;
      var isConfiguredVisible = isMountingOptionVisible(mounting);

      option.classList.toggle('sbc-mounting-option--selected', isSelected);
      option.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      option.hidden = !isConfiguredVisible || (isFreestandingOption && !freestandingAvailable);
    });

    $$('[data-mounting-sides-for]').forEach(function (panel) {
      var belongsTo = panel.dataset.mountingSidesFor;
      panel.hidden = !(freestandingAvailable && belongsTo === selectedMounting);
    });

    $$('.sbc-stand-option').forEach(function (btn) {
      var isSelected = parseInt(btn.dataset.sides, 10) === selectedMountingSides;
      btn.classList.toggle('sbc-stand-option--selected', isSelected);
      btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    prefillMountingPrices();
    updateMockupBackground();
    updateTotalPrice();
  }

  function updateSurfaceStepUi() {
    $$('.sbc-surface-option').forEach(function (btn) {
      var surfaceType = btn.dataset.surfaceType === 'premium' ? 'premium' : 'basic';
      var isSelected = surfaceType === selectedSurfaceType;
      var isAvailable = isSurfaceSelectionAvailable(surfaceType);
      var priceValue = btn.querySelector('.sbc-surface-price__value');
      var priceCents = getSurfaceUnitPriceCents(surfaceType);

      btn.classList.toggle('sbc-surface-option--selected', isSelected);
      btn.classList.toggle('sbc-surface-option--disabled', !isAvailable);
      btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      btn.disabled = !isAvailable;
      btn.title = isAvailable ? '' : getConfiguratorText('surfaceUnavailableTooltip', CONFIGURATOR_TEXT_DEFAULTS.surfaceUnavailableTooltip);

      if (priceValue) {
        priceValue.textContent = isAvailable && typeof priceCents === 'number'
          ? formatEuroCents(priceCents, false)
          : getConfiguratorText('surfacePriceUnavailable', CONFIGURATOR_TEXT_DEFAULTS.surfacePriceUnavailable);
      }
    });

    var nextBtn = document.querySelector('#sbc-step-4 .sbc-btn-next');
    if (nextBtn) {
      var hasSelectedSurfaceProduct = isSurfaceSelectionAvailable(selectedSurfaceType);
      nextBtn.disabled = !hasSelectedSurfaceProduct;
      nextBtn.title = hasSelectedSurfaceProduct ? '' : getConfiguratorText('surfaceNextUnavailableTitle', CONFIGURATOR_TEXT_DEFAULTS.surfaceNextUnavailableTitle);
    }
    updateCanvasNextButtonState();
  }

  function bindSurfaceOptions() {
    $$('.sbc-surface-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var nextSurface = btn.dataset.surfaceType === 'premium' ? 'premium' : 'basic';
        if (!isSurfaceSelectionAvailable(nextSurface)) {
          toast(getConfiguratorText('surfaceUnavailableToast', CONFIGURATOR_TEXT_DEFAULTS.surfaceUnavailableToast), 'error');
          updateSurfaceStepUi();
          return;
        }
        selectedSurfaceType = nextSurface;
        selectedProduct = getProductForSizeSurface(CFG.boardWidthMm, CFG.boardHeightMm, selectedSurfaceType);
        selectedVariant = resolveVariantForColor(selectedColor);
        if (!selectedColor && selectedVariant) {
          selectedColor = variantNameToBackendColor(selectedVariant.option1 || selectedVariant.title);
          if (!selectedBackColorCustomized) selectedBackColor = selectedColor;
        }
        applyBackgroundForCurrentSize();
        updateSurfaceStepUi();
        updateSelectedProductTitle();
        updateTotalPrice();
        updateCartButton();
        updateLeadButton();
        scheduleDraftAutosave();
      });
    });
  }

  function setSelectedQuantity(value) {
    var qty = parseInt(value, 10);
    if (!isFinite(qty) || qty < 1) qty = 1;
    if (qty > 999) qty = 999;
    selectedQuantity = qty;
    var input = dom.quantityInput();
    if (input && String(input.value) !== String(qty)) input.value = qty;
    updateTotalPrice();
    scheduleDraftAutosave();
    return qty;
  }

  function bindQuantityControl() {
    var input = dom.quantityInput();
    if (!input) return;
    input.addEventListener('input', function () {
      setSelectedQuantity(input.value);
    });
    input.addEventListener('change', function () {
      setSelectedQuantity(input.value);
      saveState();
    });
  }

  function hasActiveDraftContext() {
    return !!(activeDraftIds && (activeDraftIds.front || activeDraftIds.back));
  }

  function updateSaveAsNewDraftButton() {
    var bottomBar = document.getElementById('sbc-bottombar');
    var btn = document.getElementById('btn-save-as-new-draft');
    var show = currentStep === 5 && !!CFG.customerId && hasActiveDraftContext();
    var saveButton = document.getElementById('btn-save');
    var saveLabel = saveButton && saveButton.querySelector('.sbc-btn__label');
    var saveText = hasActiveDraftContext() ? 'Änderungen speichern' : 'Entwurf speichern';
    if (saveLabel) {
      var labelNode = Array.from(saveLabel.childNodes).find(function (node) { return node.nodeType === 3 && node.textContent.trim(); });
      if (labelNode) labelNode.textContent = ' ' + saveText;
    }
    if (saveButton) saveButton.setAttribute('aria-label', saveText);


    if (bottomBar) {
      bottomBar.classList.toggle('sbc-bottombar--draft-context', show);
    }

    if (!btn) return;
    btn.hidden = !show;
    btn.style.display = show ? '' : 'none';
  }

  function updateBottomBarForStep(step) {
    var bottomBar = document.getElementById('sbc-bottombar');
    if (!bottomBar) return;

    syncBottomBarPortal(step);

    var visible = (step === 5 || step === 6);
    bottomBar.style.display = visible ? '' : 'none';
    bottomBar.classList.toggle('sbc-bottombar--design', step === 5);
    bottomBar.classList.toggle('sbc-bottombar--finalize', step === 6);

    bottomBar.querySelectorAll('[data-bottombar-mode]').forEach(function (el) {
      var mode = el.dataset.bottombarMode;
      var show = (step === 5 && mode === 'design') || (step === 6 && mode === 'finalize');
      el.hidden = !show;
      el.style.display = show ? '' : 'none';
    });

    updateBottomOverhangHint();
    updateBoundsErrorBanner();
    updateSaveAsNewDraftButton();
  }

  function syncBottomBarPortal(step) {
    var bottomBar = document.getElementById('sbc-bottombar');
    if (!bottomBar) return;

    if (!bottomBarHome && bottomBar.parentNode) {
      bottomBarHome = {
        parent: bottomBar.parentNode,
        nextSibling: bottomBar.nextSibling
      };
    }

    var stepNumber = Number(step || currentStep);
    var shouldPortal = (stepNumber === 5 || stepNumber === 6) && isMobileViewport();
    if (shouldPortal) {
      if (bottomBar.parentNode !== document.body) {
        document.body.appendChild(bottomBar);
      }
      bottomBar.classList.add('sbc-bottombar--mobile-portal');
      document.body.classList.add('sbc-mobile-bottombar-active');
      return;
    }

    bottomBar.classList.remove('sbc-bottombar--mobile-portal');
    document.body.classList.remove('sbc-mobile-bottombar-active');

    if (bottomBarHome && bottomBarHome.parent && bottomBar.parentNode !== bottomBarHome.parent) {
      if (bottomBarHome.nextSibling && bottomBarHome.nextSibling.parentNode === bottomBarHome.parent) {
        bottomBarHome.parent.insertBefore(bottomBar, bottomBarHome.nextSibling);
      } else {
        bottomBarHome.parent.appendChild(bottomBar);
      }
    }
  }

  function syncLeadFunnelPortal() {
    var panel = dom.leadPanel();
    if (!panel) return;

    if (!leadFunnelHome && panel.parentNode) {
      leadFunnelHome = {
        parent: panel.parentNode,
        nextSibling: panel.nextSibling
      };
    }

    var shouldPortal = leadFunnelOpen && isMobileViewport();
    if (shouldPortal) {
      if (panel.parentNode !== document.body) {
        document.body.appendChild(panel);
      }
      panel.classList.add('sbc-lead-funnel--mobile-portal');
      document.body.classList.add('sbc-lead-funnel-mobile-active');
      return;
    }

    panel.classList.remove('sbc-lead-funnel--mobile-portal');
    document.body.classList.remove('sbc-lead-funnel-mobile-active');

    if (leadFunnelHome && leadFunnelHome.parent && panel.parentNode !== leadFunnelHome.parent) {
      if (leadFunnelHome.nextSibling && leadFunnelHome.nextSibling.parentNode === leadFunnelHome.parent) {
        leadFunnelHome.parent.insertBefore(panel, leadFunnelHome.nextSibling);
      } else {
        leadFunnelHome.parent.appendChild(panel);
      }
    }
  }

  function setFinalizeProductContent(prefix, item) {
    var titleEl = document.querySelector('[data-final-title="' + prefix + '"]');
    var textEl = document.querySelector('[data-final-text="' + prefix + '"]');
    var priceEl = document.querySelector('[data-final-price="' + prefix + '"]');
    var imageEl = document.querySelector('[data-final-image="' + prefix + '"]');
    var variant = getFinalizeVariant(item);

    if (titleEl) titleEl.textContent = getFinalizeTextOverride(prefix, 'title', getFinalizeProductLabel(item) || 'Zusatzartikel');
    if (textEl) textEl.textContent = getFinalizeTextOverride(prefix, 'description', (item && item.description) || '');
    if (priceEl) {
      priceEl.textContent = isFinalizeProductAvailable(item)
        ? formatEuroCents(Number(variant.price) || 0, true) + ' ' + getConfiguratorText('finalizePriceSuffix', CONFIGURATOR_TEXT_DEFAULTS.finalizePriceSuffix)
        : getConfiguratorText('finalizePriceUnavailable', CONFIGURATOR_TEXT_DEFAULTS.finalizePriceUnavailable);
    }
    if (imageEl) {
      var imageUrl = item && item.imageUrl ? String(item.imageUrl) : '';
      if (imageUrl) {
        imageEl.src = imageUrl;
        imageEl.hidden = false;
      } else {
        imageEl.removeAttribute('src');
        imageEl.hidden = true;
      }
    }
  }

  function getFinalizeMountingSummaryLabel() {
    if (selectedMounting === 'stand') return 'Standgestell · freistehend';
    if (selectedMounting === 'trolley') return 'Rollwagen · mobil';
    return 'Wandmontage';
  }

  function getFinalizeMountingPriceData(mountingType) {
    if (mountingType === 'wall') {
      var wallPrice = selectedVariant && selectedVariant.available !== false
        ? (Number(selectedVariant.price) || 0) * getBoardPriceMultiplier()
        : null;
      return { available: wallPrice !== null, price: wallPrice };
    }

    var sides = mountingType === selectedMounting ? selectedMountingSides : 1;
    var entry = getMountingEntry(mountingType, sides, selectedSurfaceType);
    var variant = entry && Array.isArray(entry.variants)
      ? entry.variants.find(function (item) { return item && item.available !== false && item.id; })
      : null;

    return {
      available: !!variant,
      price: variant ? Number(variant.price) || 0 : null
    };
  }

  function updateFinalizeMountingOptions() {
    var group = dom.finalizeMountingGroup();
    if (!group) return;

    var showGroup = !isToolWallMode() && supportsFreestandingMounting();
    group.hidden = !showGroup;
    group.style.display = showGroup ? '' : 'none';

    dom.finalizeMountingButtons().forEach(function (btn) {
      var mountingType = btn.dataset.finalMounting || 'wall';
      var visible = mountingType === 'wall' || isMountingOptionVisible(mountingType);
      var priceData = getFinalizeMountingPriceData(mountingType);
      var selected = mountingType === selectedMounting;
      var priceEl = btn.querySelector('[data-final-mounting-price]');

      btn.hidden = !visible;
      btn.disabled = !priceData.available;
      btn.classList.toggle('sbc-finalize-card--selected', selected);
      btn.classList.toggle('sbc-finalize-card--disabled', !priceData.available);
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      btn.title = priceData.available ? '' : 'Für diese Größe und Oberfläche ist diese Aufstellung nicht konfiguriert.';

      if (priceEl) {
        priceEl.textContent = priceData.available
          ? formatEuroCents(priceData.price, false) + ' / Wand'
          : getConfiguratorText('finalizePriceUnavailable', CONFIGURATOR_TEXT_DEFAULTS.finalizePriceUnavailable);
      }
    });
  }

  function updateFinalizeStepUi() {
    normalizeFinalizeSelection();
    updateFinalizeMountingOptions();

    dom.finalizeHolderButtons().forEach(function (btn) {
      var key = btn.dataset.finalHolder;
      var item = getFinalizeProduct('holders', key);
      var selected = key === selectedHolderType;
      var available = isFinalizeProductAvailable(item);
      setFinalizeProductContent('holder-' + key, item);
      btn.classList.toggle('sbc-finalize-card--selected', selected);
      btn.classList.toggle('sbc-finalize-card--disabled', !available);
      btn.disabled = !available;
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      btn.title = available ? '' : getConfiguratorText('finalizeUnavailableTooltip', CONFIGURATOR_TEXT_DEFAULTS.finalizeUnavailableTooltip);
    });

    dom.finalizeAddonInputs().forEach(function (input) {
      var key = input.dataset.finalAddon;
      var item = getFinalizeProduct('addons', key);
      var available = isFinalizeProductAvailable(item);
      var selected = !!selectedFinalizeAddons[key] && available;
      var card = input.closest('[data-final-addon-card]');
      setFinalizeProductContent('addon-' + key, item);
      input.checked = selected;
      input.disabled = !available;
      if (card) {
        card.classList.toggle('sbc-finalize-card--selected', selected);
        card.classList.toggle('sbc-finalize-card--disabled', !available);
        card.title = available ? '' : getConfiguratorText('finalizeUnavailableTooltip', CONFIGURATOR_TEXT_DEFAULTS.finalizeUnavailableTooltip);
      }
    });

    var summary = dom.finalizeSummary();
    if (summary) {
      var selectedLabels = (isToolWallMode() ? [] : [getFinalizeMountingSummaryLabel()]).concat(getFinalizationSelectedProducts().map(function (entry) {
        return getFinalizationEntryLabel(entry);
      }));
      summary.textContent = selectedLabels.length ? selectedLabels.join(', ') : getConfiguratorText('finalizeNoAddonsSelected', CONFIGURATOR_TEXT_DEFAULTS.finalizeNoAddonsSelected);
    }

    updateTotalPrice();
    updateCartButton();
    updateLeadButton();
  }

  function bindFinalizeOptions() {
    dom.finalizeMountingButtons().forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;

        var mountingType = btn.dataset.finalMounting || 'wall';
        var previousMounting = selectedMounting;
        if (mountingType === previousMounting) return;

        if (mountingType !== 'wall') selectedMountingSides = 1;
        var mountingOption = document.querySelector('.sbc-mounting-option[data-mounting="' + mountingType + '"]');
        if (!mountingOption) return;

        selectMountingOption(mountingOption);
        updateFinalizeStepUi();
        scheduleDraftAutosave();
        saveState();
        trackEvent('finalize_mounting_changed', {
          from: previousMounting,
          to: selectedMounting,
          sides: selectedMountingSides
        });

        if (selectedMounting === 'stand') {
          toast('Standgestell ergänzt – deine fertige Gestaltung bleibt erhalten.');
        } else if (selectedMounting === 'trolley') {
          toast('Rollwagen ergänzt – deine fertige Gestaltung bleibt erhalten.');
        } else {
          toast('Wandmontage ausgewählt – deine Gestaltung bleibt erhalten.');
        }
      });
    });

    dom.finalizeHolderButtons().forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        selectedHolderType = btn.dataset.finalHolder || 'stainless';
        updateFinalizeStepUi();
        scheduleDraftAutosave();
      });
    });

    dom.finalizeAddonInputs().forEach(function (input) {
      input.addEventListener('change', function () {
        var key = input.dataset.finalAddon;
        selectedFinalizeAddons[key] = !!input.checked;
        updateFinalizeStepUi();
        scheduleDraftAutosave();
      });
    });

    updateFinalizeStepUi();
  }

  function getMountingCost() {
    if (!selectedMounting || selectedMounting === 'wall') return 0;
    var entry = getMountingEntry(selectedMounting, selectedMountingSides, selectedSurfaceType);
    if (!entry || !entry.variants || entry.variants.length === 0) return 0;

    // Nimm den günstigsten Preis (meistens gibt es ohnehin nur eine Variante)
    return Math.min.apply(null, entry.variants.map(function (v) { return v.price; }));
  }

  function syncColorStepMode() {
    var isTwoSides = isDoubleSidedConfiguration();
    var switcher = document.getElementById('sbc-color-side-switch');
    var desc = document.querySelector('#sbc-step-3 .sbc-step__desc');

    if (!isTwoSides) {
      activeColorSide = 'front';
      selectedBackColor = selectedColor || selectedBackColor || 'white';
      selectedBackColorCustomized = false;
    }

    if (switcher) {
      switcher.hidden = !isTwoSides;
      switcher.querySelectorAll('[data-color-side]').forEach(function (btn) {
        var side = btn.dataset.colorSide === 'back' ? 'back' : 'front';
        btn.classList.toggle('sbc-color-side-switch__btn--active', side === activeColorSide);
        btn.classList.toggle('sbc-color-side-switch__btn--custom', side === 'back' && selectedBackColorCustomized);
        btn.setAttribute('aria-pressed', side === activeColorSide ? 'true' : 'false');
      });
      updateColorSideSwitchStatus();
    }
    if (desc) {
      desc.textContent = isTwoSides
        ? 'Wähle die Hintergrundfarbe für Vorder- und Rückseite.'
        : 'Wähle die Hintergrundfarbe';
    }
  }

  function updateColorSideSwitchStatus() {
    var switcher = document.getElementById('sbc-color-side-switch');
    if (!switcher) return;

    ['front', 'back'].forEach(function (side) {
      var colorKey = getBoardColorForSide(side);
      var meta = getColorMeta(colorKey);
      var label = meta.label || 'Spezial';
      var isActive = activeColorSide === side;
      var status = switcher.querySelector('[data-color-side-status="' + side + '"]');
      var swatch = switcher.querySelector('[data-color-side-swatch="' + side + '"]');

      if (status) {
        if (side === 'back' && !selectedBackColorCustomized) {
          status.textContent = isActive ? 'Aktiv · übernimmt ' + label : 'Übernimmt Vorderseite';
        } else {
          status.textContent = (isActive ? 'Aktiv · ' : '') + label;
        }
      }

      if (swatch) {
        swatch.style.background = meta.hex || '#ffffff';
        swatch.style.borderColor = meta.border || (colorKey === 'white' || colorKey === 'yellow' ? '#cbd5e1' : (meta.hex || '#cbd5e1'));
      }
    });
  }

  function bindColorSideSwitch() {
    document.querySelectorAll('[data-color-side]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        activeColorSide = btn.dataset.colorSide === 'back' ? 'back' : 'front';
        syncColorStepMode();
        renderColorOptions();
      });
    });
  }

  function renderColorOptions() {
    var grid = document.querySelector('.sbc-board-color-grid');
    if (!grid) return;
    syncColorStepMode();
    grid.innerHTML = '';

    var activeProduct = getProductForSizeSurface(CFG.boardWidthMm, CFG.boardHeightMm, selectedSurfaceType);
    if (activeProduct && activeProduct !== selectedProduct) {
      selectedProduct = activeProduct;
      selectedVariant = resolveVariantForColor(selectedColor);
      if (!selectedColor && selectedVariant) {
        selectedColor = variantNameToBackendColor(selectedVariant.option1 || selectedVariant.title);
        if (!selectedBackColorCustomized) selectedBackColor = selectedColor;
        applyBackgroundForCurrentSize();
      }
      updateSelectedProductTitle();
    }

    if (!selectedProduct || selectedProduct.variants.length === 0) {
      grid.innerHTML = '<p style="grid-column:1/-1;text-align:center;color:var(--sbc-text-tertiary);font-size:12px;">Keine Farbvarianten verfügbar</p>';
      return;
    }

    // Varianten-Liste aufbauen – Weiß immer als erste Option sicherstellen
    var variants = selectedProduct.variants.slice(); // Kopie
    var hasWhite = variants.some(function (v) {
      var name = (v.option1 || v.title || '').toLowerCase().trim();
      return name === 'weiß' || name === 'weiss' || name === 'white';
    });

    if (!hasWhite) {
      // Weiß als synthetische Variante hinzufügen (gleicher Preis wie erste Variante)
      var firstVariant = variants[0];
      var whiteVariant = {
        id: firstVariant.id, // gleiche Variant-ID als Fallback
        option1: 'Weiß',
        title: 'Weiß',
        price: firstVariant.price,
        available: true,
        _synthetic: true
      };
      variants.unshift(whiteVariant);
    } else {
      // Weiß nach vorne sortieren
      variants.sort(function (a, b) {
        var aName = (a.option1 || a.title || '').toLowerCase().trim();
        var bName = (b.option1 || b.title || '').toLowerCase().trim();
        var aIsWhite = aName === 'weiß' || aName === 'weiss' || aName === 'white';
        var bIsWhite = bName === 'weiß' || bName === 'weiss' || bName === 'white';
        if (aIsWhite && !bIsWhite) return -1;
        if (!aIsWhite && bIsWhite) return 1;
        return 0;
      });
    }

    var overrideCost = getMountingCost();
    var activeBoardColor = getBoardColorForSide(activeColorSide);

    variants = variants.filter(function (variant) {
      return isColorOptionVisible(variantNameToBackendColor(variant.option1 || variant.title));
    }).sort(function (a, b) {
      var aMeta = getColorMeta(variantNameToBackendColor(a.option1 || a.title));
      var bMeta = getColorMeta(variantNameToBackendColor(b.option1 || b.title));
      var aOrder = Number.isFinite(Number(aMeta.order)) ? Number(aMeta.order) : 9999;
      var bOrder = Number.isFinite(Number(bMeta.order)) ? Number(bMeta.order) : 9999;
      return aOrder - bOrder;
    });

    if (variants.length === 0) {
      grid.innerHTML = '<p style="grid-column:1/-1;text-align:center;color:var(--sbc-text-tertiary);font-size:12px;">Keine sichtbaren Farbvarianten verfügbar</p>';
      return;
    }

    var availableVariants = variants.filter(function (variant) {
      return variant.available !== false;
    });
    var activeVariant = availableVariants.find(function (variant) {
      return variantNameToBackendColor(variant.option1 || variant.title) === activeBoardColor;
    }) || null;
    var frontVariant = availableVariants.find(function (variant) {
      return variantNameToBackendColor(variant.option1 || variant.title) === selectedColor;
    }) || null;

    if (activeColorSide === 'front') {
      selectedVariant = activeVariant || frontVariant || null;
      if (!selectedColor && selectedVariant) {
        selectedColor = variantNameToBackendColor(selectedVariant.option1 || selectedVariant.title);
        if (!selectedBackColorCustomized) selectedBackColor = selectedColor;
        activeBoardColor = selectedColor;
      }
    } else if (!selectedVariant) {
      selectedVariant = frontVariant || null;
    }

    var colorStepNextBtn = document.querySelector('#sbc-step-3 .sbc-btn-next');
    if (colorStepNextBtn) colorStepNextBtn.disabled = !selectedVariant;
    updateCanvasNextButtonState();

    variants.forEach(function (variant) {
      var colorName = variant.option1 || variant.title;
      var backendColorKey = variantNameToBackendColor(colorName);
      var colorMeta = getColorMeta(backendColorKey);
      var colorHex = colorMeta.hex || colorHexForName(colorName);

      // If a mounting is selected (overrideCost > 0), use that price instead of the board's base price.
      var effectivePrice = overrideCost > 0 ? overrideCost : ((Number(variant.price) || 0) * getBoardPriceMultiplier());
      var price = (effectivePrice / 100).toFixed(2).replace('.', ',');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sbc-board-color-option';
      btn.dataset.variantId = variant.id;
      btn.dataset.color = colorHex;
      btn.dataset.backendColor = backendColorKey;
      btn.dataset.name = colorName;

      var normalizedSwatchHex = String(colorHex || '').toLowerCase();
      var isLightSwatch = backendColorKey === 'white' ||
        backendColorKey === 'yellow' ||
        ['#ffffff', '#fff', '#f5f5f5', '#ffd700', '#ecc94b', '#ffb50f', '#f3b536'].indexOf(normalizedSwatchHex) !== -1;
      var swatchBorder = colorMeta.border || (isLightSwatch ? '#cbd5e1' : colorHex);
      var swatchStyle = 'background:' + colorHex +
        ';border:' + (isLightSwatch ? '2px' : '1px') + ' solid ' + swatchBorder +
        ';box-shadow:inset 0 0 0 1px rgba(255,255,255,.5),0 6px 14px rgba(15,23,42,.14)';

      btn.innerHTML =
        '<span class="sbc-board-color-option__swatch" style="' + swatchStyle + '"></span>' +
        '<span class="sbc-board-color-option__name">' + (colorMeta.label || colorName) + '</span>';
      // Preis absichtlich versteckt: '<span class="sbc-board-color-option__price">' + price + ' €</span>';

      if (variant.available === false) {
        btn.disabled = true;
        btn.style.opacity = '0.4';
        btn.title = 'Nicht verfügbar';
      }

      // Preserve previously selected state
      if (activeBoardColor === backendColorKey) {
        btn.classList.add('sbc-board-color-option--selected');
      }

      btn.addEventListener('click', function () {
        if (variant.available === false) return;
        $$('.sbc-board-color-option').forEach(function (b) { b.classList.remove('sbc-board-color-option--selected'); });
        btn.classList.add('sbc-board-color-option--selected');

        if (activeColorSide === 'back' && isDoubleSidedConfiguration()) {
          selectedBackColor = backendColorKey;
          selectedBackColorCustomized = true;
        } else {
          selectedColor = backendColorKey;
          selectedVariant = variant;
          if (!selectedBackColorCustomized) selectedBackColor = backendColorKey;
        }
        updateSelectedProductTitle();

        console.log('[SBC] Farbe/Variante gewählt:', activeColorSide, colorName, '→ Backend-Farbe:', backendColorKey, '→ Variant-ID:', variant.id, '(' + price + ' €)');

        // Hintergrund aus Backend laden (statt nur canvas.backgroundColor)
        applyBackgroundForCurrentSize();
        refreshPlacedShadowToolsForCurrentColors();
        renderColorOptions();
        updateSelectedProductTitle();
        updateTotalPrice();
        updateCartButton();
        updateLeadButton();
        scheduleDraftAutosave();

        // Enable "Weiter"
        var nextBtn = document.querySelector('#sbc-step-3 .sbc-btn-next');
        if (nextBtn) nextBtn.disabled = false;
        updateCanvasNextButtonState();
      });

      grid.appendChild(btn);
    });
  }

  function goToStep(step) {
    var prevStep = currentStep;
    step = normalizeWizardTargetStep(step, Number(step) < prevStep ? -1 : 1);

    // State Update
    currentStep = step;
    dom.stage().dataset.step = step;
    var configuratorRoot = document.querySelector('.sbc');
    if (configuratorRoot) configuratorRoot.setAttribute('data-current-step', String(step));

    // ANALYTICS: Step View Tracken
    trackEvent('step_view', { step: step });

    // UI Updates
    var forward = step > prevStep;

    // Update step containers with direction animation
    $$('.sbc-step').forEach(function (el) {
      var s = parseInt(el.dataset.step);
      el.classList.remove('sbc-step--active', 'sbc-step--slide-forward', 'sbc-step--slide-backward');
      if (s === step) {
        el.classList.add('sbc-step--active');
        if (prevStep !== step) {
          el.classList.add(forward ? 'sbc-step--slide-forward' : 'sbc-step--slide-backward');
        }
      }
    });

    updateWizardProgressUi(step);

    // Show/hide bottom bar, zoom controls, empty state
    updateBottomBarForStep(step);
    updateBoundsErrorBanner();
    if (step !== 6) {
      setLeadFunnelOpen(false);
    }

    var zoomCtrl = dom.zoomControls();
    if (zoomCtrl) zoomCtrl.style.display = (step === 5) ? '' : 'none';

    updateEmptyState();
    updateFloatingDeleteButton();

    // Mobile: Sidebar Mode (inline für Steps 1/2, slide-out für Step 3)
    if (isMobile) {
      var sidebar = dom.sidebar();
      var toggle = dom.mobileToggle();
      var toolsBtn = document.getElementById('sbc-mobile-tools-btn');
      var toolsLabel = document.getElementById('sbc-mobile-tools-label');
      if (toolsLabel) toolsLabel.textContent = step === 6 ? 'Finalisieren' : 'Werkzeuge';
      if (toggle) toggle.setAttribute('aria-label', step === 6 ? 'Finalisieren öffnen' : 'Werkzeuge öffnen');

      if (step <= 2) {
        // Inline-Modus: Sidebar ist normaler Seiteninhalt
        if (sidebar) {
          sidebar.classList.add('sbc-sidebar--inline');
          sidebar.classList.remove('sbc-sidebar--open');
        }
        if (toggle) toggle.style.display = 'none';
        if (toolsBtn) toolsBtn.style.display = 'none';
      } else {
        // Slide-out-Modus: Sidebar ist Fixed-Overlay
        if (sidebar) {
          sidebar.classList.remove('sbc-sidebar--inline');
        }
        if (toggle) toggle.style.display = '';
        if (toolsBtn) toolsBtn.style.display = '';
      }
    }

    // Step 3: Farboptionen dynamisch aus Produkt-Varianten rendern
    if (step === 1) {
      syncSizeStepState();
    }

    if (step === 2) {
      updateMountingStepUi();
    }

    if (step === 3) {
      syncSelectedProductForSurface({ fallbackToBasic: true });
      renderColorOptions();
      // Reset "Weiter" in Step 3 (Farbe muss neu gew\u00e4hlt werden)
      var nextBtn3 = document.querySelector('#sbc-step-3 .sbc-btn-next');
      if (nextBtn3 && !selectedVariant) nextBtn3.disabled = true;
      updateCanvasNextButtonState();
    }

    if (step === 4) {
      updateSurfaceStepUi();
    }

    // Step 5: Tools laden wenn noch nicht geschehen
    if (step === 5 && !toolsLoaded) {
      ensureToolsLoaded();
    }

    // Step 5/6: Canvas + Hintergrund aktualisieren (wichtig für Desktop + Mobile!).
    // Beim Wechsel zwischen Gestalten und Finalisieren die Canvas-Geometrie behalten,
    // sonst verschieben sich bereits platzierte Werkzeuge relativ zur Wand leicht.
    if (step === 5 || step === 6) {
      if (prevStep !== 5 && prevStep !== 6) {
        resizeCanvas();
      } else if (canvas) {
        canvas.calcOffset();
        canvas.requestRenderAll();
      }
      applyBackgroundForCurrentSize();
      updateTotalPrice();
      updateMockupBackground();
    }
    refreshMeasurementGrid();
    updateCanvasNextButtonState();

    var sideToggle = document.getElementById('sbc-side-toggle');
    if (step === 5) {
      // Side Toggle anzeigen, wenn "Beidseitig" gewählt wurde

      if (sideToggle) {
        if (selectedMountingSides === 2 && selectedMounting !== 'wall') {
          sideToggle.style.display = 'flex';
          // Immer mit Vorderseite starten, wenn Step 5 neu betreten wird
          switchSide('front');
          updateSideToggleStatus();
        } else {
          sideToggle.style.display = 'none';
          sideToggle.classList.remove('sbc-side-toggle--active');
        }
      }
    } else if (sideToggle) {
      sideToggle.style.display = 'none';
      sideToggle.classList.remove('sbc-side-toggle--active');
    }

    if (step === 6) {
      updateFinalizeStepUi();
      if (prevStep !== 6) {
        showProfessionalCheckPopup();
      }
    }

    console.log('[SBC] \u2192 Step', step, forward ? '(vorw\u00e4rts)' : '(r\u00fcckw\u00e4rts)');
  }
  /**
   * Preise direkt beim Laden in die Größen-Kacheln schreiben.
   */
  function prefillSizePrices() {
    $$('.sbc-size-option').forEach(function (btn) {
      if (btn.dataset.customSize === 'true') {
        btn.style.opacity = '';
        btn.title = '';
        return;
      }
      var w = parseInt(btn.dataset.w);
      var h = parseInt(btn.dataset.h);
      var meta = getSizeOptionMeta(w, h);
      var priceEl = btn.querySelector('.sbc-size-option__price');
      btn.hidden = isToolWallMode() || (meta ? meta.visible === false : false);
      if (meta) {
        var dimsEl = btn.querySelector('.sbc-size-option__dims');
        var unitEl = btn.querySelector('.sbc-size-option__unit');
        if (dimsEl) dimsEl.textContent = meta.label;
        if (unitEl) unitEl.textContent = meta.unit || 'mm';
      }
      if (!priceEl) return;

      var product = getProductForSizeSurface(w, h, 'basic') || getProductForSizeSurface(w, h, 'premium');

      if (product && product.variants.length > 0) {
        // var minPrice = Math.min.apply(null, product.variants.map(function (v) { return v.price; }));
        // priceEl.textContent = 'ab ' + (minPrice / 100).toFixed(2).replace('.', ',') + ' €';
        priceEl.textContent = ''; // Preis versteckt
        btn.style.opacity = '';
        btn.title = '';
      } else {
        priceEl.textContent = '';
        // Visuell als nicht verfügbar markieren
        btn.style.opacity = '0.45';
        btn.title = 'Produkt nicht konfiguriert';
      }
    });
  }

  /**
   * Montagepreise bleiben im Auswahl-Schritt bewusst ausgeblendet.
   */
  function prefillMountingPrices() {
    $$('.sbc-mounting-price').forEach(function (el) {
      el.textContent = '';
      el.hidden = true;
    });
  }

  function updateMockupBackground() {
    var bgStand = document.getElementById('sbc-mockup-bg-stand');
    var bgTrolley = document.getElementById('sbc-mockup-bg-trolley');
    var canvasStage = document.getElementById('sbc-canvas-stage');
    var previewCanvas = document.getElementById('sbc-stand-sides-preview-canvas');

    if (bgStand) bgStand.style.opacity = '0';
    if (bgTrolley) bgTrolley.style.opacity = '0';
    if (canvasStage) canvasStage.classList.remove('has-mockup');

    if (selectedMounting === 'stand') {
      if (bgStand) bgStand.style.opacity = '1';
      if (canvasStage) canvasStage.classList.add('has-mockup');
    } else if (selectedMounting === 'trolley') {
      if (bgTrolley) bgTrolley.style.opacity = '1';
      if (canvasStage) canvasStage.classList.add('has-mockup');
    }

    if (previewCanvas) {
      if (currentStep === 5 && (selectedMounting === 'stand' || selectedMounting === 'trolley') && selectedMountingSides === 2) {
        var previewImg = document.getElementById('sbc-stand-sides-preview-img');
        if (previewImg && window.SBC_PREVIEW_URLS) {
          previewImg.src = selectedMounting === 'stand' ? window.SBC_PREVIEW_URLS.stand : window.SBC_PREVIEW_URLS.trolley;
        }

        previewCanvas.style.display = 'block';
        setTimeout(function () { previewCanvas.style.opacity = '1'; }, 10);
      } else {
        previewCanvas.style.opacity = '0';
        setTimeout(function () { previewCanvas.style.display = 'none'; }, 300);
      }
    }
  }

  /* ==========================================
     LOGO UPLOAD
     ========================================== */

  function customerLogoApiUrl(customerId) {
    return CFG.backendUrl.replace(/\/+$/, '') + '/api/customer-logos' + (customerId ? '/' + encodeURIComponent(customerId) : '');
  }

  function logoConvertApiUrl() {
    return CFG.backendUrl.replace(/\/+$/, '') + '/api/customer-logos/convert';
  }

  function fontsApiUrl() {
    return CFG.backendUrl.replace(/\/+$/, '') + '/api/fonts';
  }

  function normalizeFontList(list) {
    var seen = {};
    return (list || []).filter(function (font) {
      if (!font || !font.id || seen[font.id]) return false;
      seen[font.id] = true;
      return true;
    });
  }

  function installFontFace(font) {
    if (!font || font.type !== 'custom' || !font.url || !font.family || !document.fonts || typeof FontFace === 'undefined') return;
    try {
      var face = new FontFace(font.family, 'url("' + font.url + '")');
      face.load().then(function (loadedFace) {
        document.fonts.add(loadedFace);
        if (canvas) canvas.requestRenderAll();
      }).catch(function (err) {
        console.warn('[SBC] Custom Font konnte nicht geladen werden:', err.message);
      });
    } catch (err) {
      console.warn('[SBC] FontFace Fehler:', err.message);
    }
  }

  function renderFontOptions(selectedFontId) {
    var select = dom.fontSelect();
    if (!select) return;

    select.innerHTML = availableFonts.map(function (font) {
      return '<option value="' + escapeHtml(font.id) + '">' + escapeHtml(font.name) + '</option>';
    }).join('');

    var preferred = selectedFontId || 'standard-inter';
    if (availableFonts.some(function (font) { return font.id === preferred; })) {
      select.value = preferred;
    }
  }

  function findFontById(fontId) {
    return availableFonts.find(function (font) { return font.id === fontId; }) || availableFonts[0] || STANDARD_FONTS[0];
  }

  function findFontByFamily(fontFamily) {
    return availableFonts.find(function (font) { return font.family === fontFamily; }) || null;
  }

  function applyFontToTextObject(obj, font) {
    if (!obj || obj.objectType !== 'custom-text' || !font) return;
    obj._sbcPreserveLineBreaks = false;
    obj.set({
      fontFamily: font.family,
      fontId: font.id,
      fontUrl: font.url || ''
    });
    if (font.type === 'custom') installFontFace(font);
    fitTextObject(obj);
    canvas.requestRenderAll();
    scheduleDraftAutosave();
  }

  function loadFonts() {
    availableFonts = STANDARD_FONTS.slice();
    renderFontOptions();

    if (!CFG.backendUrl) return Promise.resolve(availableFonts);
    var url = fontsApiUrl();
    if (CFG.customerId) url += '?customerId=' + encodeURIComponent(CFG.customerId);

    return fetch(url, { headers: { 'ngrok-skip-browser-warning': 'true' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Fonts konnten nicht geladen werden');
        return res.json();
      })
      .then(function (data) {
        var remoteFonts = Array.isArray(data.fonts) ? data.fonts : [];
        availableFonts = normalizeFontList(remoteFonts.length ? remoteFonts : STANDARD_FONTS);
        availableFonts.forEach(installFontFace);
        renderFontOptions();
        return availableFonts;
      })
      .catch(function (err) {
        console.warn('[SBC] Fonts API nicht verfügbar:', err.message);
        availableFonts = STANDARD_FONTS.slice();
        renderFontOptions();
        return availableFonts;
      });
  }

  function uploadFont(file) {
    if (!CFG.backendUrl || !file) return Promise.resolve(null);

    var name = String(file.name || '').toLowerCase();
    if (!name.endsWith('.ttf') && !name.endsWith('.otf')) {
      toast('Bitte TTF oder OTF als Schriftart hochladen.', 'error');
      return Promise.resolve(null);
    }

    var formData = new FormData();
    formData.append('font', file);
    if (CFG.customerId) formData.append('customerId', CFG.customerId);
    if (CFG.customerEmail) formData.append('customerEmail', CFG.customerEmail);

    return fetch(fontsApiUrl(), {
      method: 'POST',
      headers: { 'ngrok-skip-browser-warning': 'true' },
      body: formData
    })
      .then(function (res) {
        return res.text().then(function (body) {
          var data = {};
          try {
            data = body ? JSON.parse(body) : {};
          } catch (err) {
            data = {};
          }
          if (!res.ok) {
            var plainBody = body ? body.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim() : '';
            var message = data.message || data.error || plainBody || 'Schrift konnte nicht gespeichert werden.';
            if (res.status === 404) {
              message = 'Der Schriftart-Upload ist auf dem Backend noch nicht aktiv. Bitte Backend neu deployen.';
            }
            throw new Error(message);
          }
          return data.font;
        });
      })
      .then(function (font) {
        if (!font) return null;
        availableFonts = normalizeFontList(availableFonts.concat([font]));
        installFontFace(font);
        renderFontOptions(font.id);
        var obj = canvas && canvas.getActiveObject();
        if (obj && obj.objectType === 'custom-text') {
          applyFontToTextObject(obj, font);
          saveState();
        }
        toast('Schriftart hochgeladen', 'success');
        return font;
      })
      .catch(function (err) {
        console.warn('[SBC] Font Upload Fehler:', err.message);
        toast(err.message || 'Schriftart konnte nicht hochgeladen werden', 'error');
        return null;
      });
  }

  function renderCustomerLogoUi() {
    var card = dom.customerLogoCard();
    var preview = dom.customerLogoPreview();
    var meta = dom.customerLogoMeta();
    var hint = dom.customerLogoHint();
    var useBtn = dom.btnUseCustomerLogo();

    if (!CFG.customerId) {
      if (card) card.hidden = true;
      if (hint) hint.hidden = true;
      return;
    }

    if (customerLogo && customerLogo.imageUrl) {
      if (card) card.hidden = false;
      if (preview) {
        preview.src = customerLogo.previewUrl || customerLogo.imageUrl;
        preview.crossOrigin = 'anonymous';
      }
      if (meta) meta.textContent = 'Für dein Konto verfügbar';
      if (useBtn) useBtn.disabled = false;
      if (hint) {
        hint.hidden = false;
        hint.textContent = 'Du kannst dein gespeichertes Logo verwenden oder durch einen neuen Upload ersetzen.';
      }
      return;
    }

    if (card) card.hidden = true;
    if (hint) {
      hint.hidden = false;
      hint.textContent = 'Eingeloggt: Dein nächster Logo-Upload wird für dein Konto gespeichert.';
    }
  }

  function bindCustomerLogo() {
    var useBtn = dom.btnUseCustomerLogo();
    if (!useBtn) return;

    useBtn.addEventListener('click', function () {
      if (!customerLogo || !customerLogo.imageUrl) {
        toast('Noch kein Firmenlogo gespeichert.', 'error');
        return;
      }

      addLogo(customerLogo.imageUrl, customerLogo.previewUrl);
    });
  }

  function loadCustomerLogo() {
    if (!CFG.backendUrl || !CFG.customerId) return;

    fetch(customerLogoApiUrl(CFG.customerId), {
      headers: { 'ngrok-skip-browser-warning': 'true' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Logo konnte nicht geladen werden');
        return res.json();
      })
      .then(function (data) {
        customerLogo = data && data.logo ? data.logo : null;
        renderCustomerLogoUi();
      })
      .catch(function (err) {
        console.warn('[SBC] Kundenlogo konnte nicht geladen werden:', err.message);
        renderCustomerLogoUi();
      });
  }

  function uploadCustomerLogo(file) {
    if (!CFG.backendUrl || !CFG.customerId || !file) return Promise.resolve(null);

    var hint = dom.customerLogoHint();
    if (hint) {
      hint.hidden = false;
      hint.textContent = 'Firmenlogo wird für dein Konto gespeichert...';
    }

    var formData = new FormData();
    formData.append('customerId', CFG.customerId);
    formData.append('customerEmail', CFG.customerEmail || '');
    formData.append('logo', file);

    return fetch(customerLogoApiUrl(), {
      method: 'POST',
      body: formData
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok) throw new Error(data.message || 'Logo konnte nicht gespeichert werden.');
          return data;
        });
      })
      .then(function (data) {
        customerLogo = data && data.logo ? data.logo : null;
        renderCustomerLogoUi();
        toast('Firmenlogo gespeichert', 'success');
        return customerLogo;
      })
      .catch(function (err) {
        console.warn('[SBC] Kundenlogo Upload Fehler:', err.message);
        renderCustomerLogoUi();
        toast('Logo wurde platziert, aber nicht im Konto gespeichert: ' + (err.message || 'Upload fehlgeschlagen'), 'error');
        return null;
      });
  }

  function uploadAndConvertLogo(file) {
    if (!CFG.backendUrl || !file) {
      toast('EPS benötigt die Backend-Verbindung zur Konvertierung.', 'error');
      return Promise.resolve(null);
    }

    var formData = new FormData();
    if (CFG.customerId) formData.append('customerId', CFG.customerId);
    if (CFG.customerEmail) formData.append('customerEmail', CFG.customerEmail || '');
    formData.append('logo', file);

    toast('EPS-Logo wird konvertiert...');

    return fetch(logoConvertApiUrl(), {
      method: 'POST',
      body: formData
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok) throw new Error(data.message || 'Logo konnte nicht konvertiert werden.');
          return data;
        });
      })
      .then(function (data) {
        if (data && data.logo) {
          customerLogo = CFG.customerId ? data.logo : customerLogo;
          renderCustomerLogoUi();
        }
        var imageUrl = data && data.logo && data.logo.imageUrl;
        if (imageUrl) {
          addLogo(imageUrl, data.logo.previewUrl);
          toast('EPS-Logo konvertiert', 'success');
        }
        return data && data.logo;
      })
      .catch(function (err) {
        console.warn('[SBC] EPS Logo Fehler:', err.message);
        toast(err.message || 'EPS-Logo konnte nicht konvertiert werden', 'error');
        return null;
      });
  }

  function bindLogoUpload() {
    const btn = dom.btnLogo();
    const input = dom.fileInput();
    if (!btn || !input) return;

    btn.addEventListener('click', function () { input.click(); });

    input.addEventListener('change', function () {
      const file = input.files[0];
      if (!file) return;

      // Validate file extension
      const name = file.name.toLowerCase();
      if (name.endsWith('.eps')) {
        uploadAndConvertLogo(file);
        input.value = '';
        return;
      }

      const validExtensions = ['.svg', '.png', '.jpg', '.jpeg', '.gif', '.webp'];
      const isValid = validExtensions.some(ext => name.endsWith(ext));

      if (!isValid) {
        toast('Bitte ein gültiges Bildformat (SVG, PNG, JPG, EPS) hochladen', 'error');
        input.value = '';
        return;
      }

      const reader = new FileReader();
      reader.onload = function (e) { addLogo(e.target.result); };
      reader.readAsDataURL(file);
      if (CFG.customerId) uploadCustomerLogo(file);
      input.value = ''; // Allow re-upload of same file
    });
  }

  /* ==========================================
     TEXT ADD
     ========================================== */

  function bindTextAdd() {
    const btn = dom.btnText();
    if (!btn) return;
    btn.addEventListener('click', addText);
  }

  function normalizeTextAlignment(value) {
    var align = String(value || 'left').toLowerCase();
    return align === 'center' || align === 'right' ? align : 'left';
  }

  function getTextOriginXForAlignment(value) {
    var align = normalizeTextAlignment(value);
    if (align === 'center') return 'center';
    if (align === 'right') return 'right';
    return 'left';
  }

  function getTextAlignmentMarginPx() {
    var marginMm = allowsBottomToolOverhangForCurrentBoard() ? 30 : 50;
    return Math.max(TEXT_FIT_PADDING, marginMm * getCanvasPxPerMm());
  }

  function getTextLeftForAlignment(value) {
    if (!canvas) return 0;
    var align = normalizeTextAlignment(value);
    var margin = getTextAlignmentMarginPx();
    if (align === 'center') return canvas.width / 2;
    if (align === 'right') return canvas.width - margin;
    return margin;
  }

  function applyTextAlignmentToObject(obj, value) {
    if (!canvas || !obj || obj.objectType !== 'custom-text') return;
    var align = normalizeTextAlignment(value);
    obj._sbcPreserveLineBreaks = true;
    obj.set({
      textAlign: align,
      originX: getTextOriginXForAlignment(align),
      left: getTextLeftForAlignment(align)
    });
    refreshTextDimensions(obj);
    keepObjectWithinCanvas(obj, TEXT_FIT_PADDING);
    obj.setCoords();
  }

  function bindFontControls() {
    var select = dom.fontSelect();
    var btnUpload = dom.btnUploadFont();
    var input = dom.fontUpload();
    var sizeInput = dom.textFontSize();

    if (select) {
      select.addEventListener('change', function () {
        var obj = canvas.getActiveObject();
        var font = findFontById(select.value);
        if (obj && obj.objectType === 'custom-text') {
          applyFontToTextObject(obj, font);
          saveState();
        }
      });
    }

    if (btnUpload && input) {
      btnUpload.addEventListener('click', function () { input.click(); });
      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        if (file) uploadFont(file);
        input.value = '';
      });
    }

    if (sizeInput) {
      sizeInput.addEventListener('input', function () {
        var obj = canvas.getActiveObject();
        if (!obj || obj.objectType !== 'custom-text') return;
        var size = Math.max(8, Math.min(180, parseInt(sizeInput.value, 10) || 36));
        obj._sbcPreserveLineBreaks = false;
        setTextPointSize(obj, size);
        fitTextObject(obj);
        canvas.requestRenderAll();
        scheduleDraftAutosave();
      });
      sizeInput.addEventListener('change', function () { saveState(); });
    }

    dom.textStyleButtons().forEach(function (btn) {
      btn.addEventListener('click', function () {
        var obj = canvas.getActiveObject();
        if (!obj || obj.objectType !== 'custom-text') return;
        var style = btn.dataset.textStyle;
        obj._sbcPreserveLineBreaks = false;
        if (style === 'bold') {
          obj.set('fontWeight', String(obj.fontWeight || '') === '700' || obj.fontWeight === 'bold' ? '400' : '700');
        } else if (style === 'italic') {
          obj.set('fontStyle', obj.fontStyle === 'italic' ? 'normal' : 'italic');
        } else if (style === 'underline') {
          obj.set('underline', !obj.underline);
        }
        fitTextObject(obj);
        canvas.requestRenderAll();
        syncTextPropertiesPanel(obj);
        scheduleDraftAutosave();
        saveState();
      });
    });

    dom.textAlignButtons().forEach(function (btn) {
      btn.addEventListener('click', function () {
        var obj = canvas.getActiveObject();
        if (!obj || obj.objectType !== 'custom-text') return;
        applyTextAlignmentToObject(obj, btn.dataset.textAlign);
        canvas.requestRenderAll();
        syncTextPropertiesPanel(obj);
        scheduleDraftAutosave();
        saveState();
      });
    });
  }

  /* ==========================================
     DELETE OBJECT
     ========================================== */

  function removeActiveObject() {
    if (!canvas || typeof canvas.getActiveObject !== 'function') return;
    const obj = canvas.getActiveObject();
    if (!obj || isCanvasHelperObject(obj) || obj.isBackground) return;

    canvas.remove(obj);
    canvas.discardActiveObject();
    canvas.requestRenderAll();
    showPropertiesPanel(false);
    refreshMeasurementGrid();
    syncCanvasUi();
    toast('Objekt entfernt');
  }

  function bindDeleteObject() {
    [dom.btnDelete(), dom.btnDeleteFloating()].filter(Boolean).forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        if (event) event.preventDefault();
        removeActiveObject();
      });
    });
  }

  /* ==========================================
     COLOR PICKER
     ========================================== */

  function syncTextCmykInputs(cmyk) {
    var normalized = normalizeCmyk(cmyk, { c: 0, m: 0, y: 0, k: 100 });
    dom.textCmykInputs().forEach(function (input) {
      var component = input.dataset.textCmyk;
      if (component && normalized[component] != null) input.value = normalized[component];
    });
    var preview = dom.textCmykPreview();
    if (preview) preview.textContent = normalized.c + ' / ' + normalized.m + ' / ' + normalized.y + ' / ' + normalized.k;
  }

  function getTextCmykFromInputs() {
    var values = {};
    dom.textCmykInputs().forEach(function (input) {
      if (input.dataset.textCmyk) values[input.dataset.textCmyk] = input.value;
    });
    return normalizeCmyk(values, { c: 0, m: 0, y: 0, k: 100 });
  }

  function applyTextColorToActiveObject(color, colorMeta) {
    var colorInput = dom.textColorInput();
    var normalizedColor = normalizeHexColor(color, '#000000');
    var cmyk = colorMeta && colorMeta.cmyk
      ? normalizeCmyk(colorMeta.cmyk)
      : hexToCmyk(normalizedColor);
    const obj = canvas.getActiveObject();
    if (obj && (obj.objectType === 'custom-text' || obj.type === 'i-text')) {
      obj.set('fill', normalizedColor);
      if (colorMeta) {
        obj.set('textColorKey', colorMeta.key || '');
        obj.set('textColorLabel', colorMeta.label || '');
        obj.set('textColorCmyk', cmyk);
      } else {
        obj.set('textColorKey', 'custom-cmyk');
        obj.set('textColorLabel', cmykToLabel(cmyk));
        obj.set('textColorCmyk', cmyk);
      }
      canvas.requestRenderAll();
      scheduleDraftAutosave();
    }
    if (colorInput) colorInput.value = normalizedColor;
    syncTextCmykInputs(cmyk);
    renderTextColorSwatches(normalizedColor);
  }

  function renderTextColorSwatches(activeColor) {
    var picker = dom.textColorPicker();
    if (!picker) return;
    var colors = getConfiguredTextColors();
    var normalizedActive = normalizeHexColor(activeColor || (canvas && canvas.getActiveObject() && canvas.getActiveObject().fill), '#000000');

    picker.innerHTML = colors.map(function (color) {
      var cmyk = normalizeCmyk(color.cmyk);
      var hex = normalizeHexColor(color.hex, '#000000');
      var label = color.label || color.key || hex;
      var isActive = hex.toLowerCase() === normalizedActive.toLowerCase();
      var border = hex.toLowerCase() === '#ffffff' ? 'border:1px solid #d5dde7;' : '';
      var escapedHex = escapeHtml(hex);
      var escapedKey = escapeHtml(color.key || '');
      var escapedLabel = escapeHtml(label);
      var escapedCmykLabel = escapeHtml(cmykToLabel(cmyk));
      return '<button type="button" class="sbc-color-swatch' + (isActive ? ' sbc-color-swatch--active' : '') + '"' +
        ' data-color="' + escapedHex + '"' +
        ' data-color-key="' + escapedKey + '"' +
        ' data-color-label="' + escapedLabel + '"' +
        ' data-cmyk-c="' + cmyk.c + '"' +
        ' data-cmyk-m="' + cmyk.m + '"' +
        ' data-cmyk-y="' + cmyk.y + '"' +
        ' data-cmyk-k="' + cmyk.k + '"' +
        ' title="' + escapedLabel + ' - ' + escapedCmykLabel + '"' +
        ' style="background:' + escapedHex + ';' + border + '">' +
        '<span class="sr-only">' + escapedLabel + '</span>' +
        '</button>';
    }).join('');
  }

  function bindColorPicker() {
    var colorInput = dom.textColorInput();
    var picker = dom.textColorPicker();

    renderTextColorSwatches('#000000');

    if (picker) {
      picker.addEventListener('click', function (event) {
        var swatch = event.target.closest('.sbc-color-swatch');
        if (!swatch || !picker.contains(swatch)) return;
        const color = swatch.dataset.color;
        var meta = {
          key: swatch.dataset.colorKey || '',
          label: swatch.dataset.colorLabel || '',
          hex: color,
          cmyk: {
            c: swatch.dataset.cmykC,
            m: swatch.dataset.cmykM,
            y: swatch.dataset.cmykY,
            k: swatch.dataset.cmykK
          }
        };
        applyTextColorToActiveObject(color, meta);
        saveState();
      });
    }

    if (colorInput) {
      colorInput.addEventListener('input', function () {
        var meta = findTextColorByHex(colorInput.value);
        applyTextColorToActiveObject(colorInput.value, meta);
      });
      colorInput.addEventListener('change', function () { saveState(); });
    }

    dom.textCmykInputs().forEach(function (input) {
      input.addEventListener('input', function () {
        var cmyk = getTextCmykFromInputs();
        var hex = cmykToHex(cmyk);
        applyTextColorToActiveObject(hex, {
          key: 'custom-cmyk',
          label: cmykToLabel(cmyk),
          hex: hex,
          cmyk: cmyk
        });
      });
      input.addEventListener('change', function () {
        input.value = clampCmykComponent(input.value);
        var cmyk = getTextCmykFromInputs();
        applyTextColorToActiveObject(cmykToHex(cmyk), {
          key: 'custom-cmyk',
          label: cmykToLabel(cmyk),
          hex: cmykToHex(cmyk),
          cmyk: cmyk
        });
        saveState();
      });
    });
  }

  /* ==========================================
     TEXT PROPERTIES (Curve, Color, etc.)
     ========================================== */

  function bindTextProperties() {
    const slider = document.getElementById('text-curve-slider');
    const label = document.getElementById('text-curve-value');

    if (slider) {
      slider.addEventListener('input', function (e) {
        const val = e.target.value;
        if (label) label.textContent = val;

        const obj = canvas.getActiveObject();
        if (obj && (obj.objectType === 'custom-text' || obj.type === 'i-text')) {
          obj._sbcPreserveLineBreaks = false;
          applyTextCurvature(obj, val);
          fitTextObject(obj);
          syncTextPropertiesPanel(obj);
          scheduleDraftAutosave();
        }
      });
      slider.addEventListener('change', function () {
        saveState();
      });
    }
  }

  /* ==========================================
     CANVAS SELECTION → Properties Panel
     ========================================== */

  function bindCanvasSelection() {
    canvas.on('selection:created', function (e) {
      onSelect(e.selected?.[0]);
      updateFloatingDeleteButton();
      refreshMeasurementGrid();
    });
    canvas.on('selection:updated', function (e) {
      onSelect(e.selected?.[0]);
      updateFloatingDeleteButton();
      refreshMeasurementGrid();
    });
    canvas.on('selection:cleared', function () {
      showPropertiesPanel(false);
      updateFloatingDeleteButton();
      refreshMeasurementGrid();
    });
  }

  function syncTextPropertiesPanel(obj) {
    var isText = obj && (obj.objectType === 'custom-text' || obj.type === 'i-text');
    var curveGroup = document.getElementById('text-curve-group');
    var colorGroup = document.getElementById('text-color-group');
    var fontSelect = dom.fontSelect();
    var sizeInput = dom.textFontSize();
    var colorInput = dom.textColorInput();

    if (curveGroup) curveGroup.style.display = isText ? '' : 'none';
    if (colorGroup) colorGroup.style.display = isText ? '' : 'none';
    $$('.sbc-text-property').forEach(function (el) {
      el.style.display = isText ? '' : 'none';
    });

    if (!isText) return;

    var slider = document.getElementById('text-curve-slider');
    var label = document.getElementById('text-curve-value');
    var val = obj.curvature || 0;
    if (slider) slider.value = val;
    if (label) label.textContent = val;

    if (sizeInput) sizeInput.value = Math.round(getTextPointSizeForInput(obj));

    var fontId = obj.fontId || (findFontByFamily(obj.fontFamily || '') || {}).id || 'standard-inter';
    renderFontOptions(fontId);
    if (fontSelect) fontSelect.value = fontId;

    var fill = normalizeHexColor(obj.fill || '#000000', '#000000');
    if (colorInput) colorInput.value = fill;
    syncTextCmykInputs(obj.textColorCmyk || (findTextColorByHex(fill) || {}).cmyk || hexToCmyk(fill));
    renderTextColorSwatches(fill);
    dom.textColorSwatches().forEach(function (swatch) {
      swatch.classList.toggle('sbc-color-swatch--active', normalizeHexColor(swatch.dataset.color, '') === fill);
    });

    dom.textStyleButtons().forEach(function (btn) {
      var style = btn.dataset.textStyle;
      var active = false;
      if (style === 'bold') active = String(obj.fontWeight || '') === '700' || obj.fontWeight === 'bold';
      if (style === 'italic') active = obj.fontStyle === 'italic';
      if (style === 'underline') active = !!obj.underline;
      btn.classList.toggle('sbc-style-btn--active', active);
    });

    var textAlign = normalizeTextAlignment(obj.textAlign || 'left');
    dom.textAlignButtons().forEach(function (btn) {
      var active = normalizeTextAlignment(btn.dataset.textAlign) === textAlign;
      btn.classList.toggle('sbc-align-btn--active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function onSelect(obj) {
    if (!obj) return;
    showPropertiesPanel(true);

    // Enforce shadow-tool locks
    if (obj.objectType === 'shadow-tool') {
      applyShadowToolConstraints(obj);
    }

    syncTextPropertiesPanel(obj);
    renderBristleProperty(obj);
  }

  function showPropertiesPanel(show) {
    const panel = dom.panelProps();
    if (panel) panel.style.display = show ? '' : 'none';
  }

  /* ==========================================
     CANVAS DRAG & DROP
     ========================================== */

  function getCanvasPointFromClientPoint(clientX, clientY) {
    if (!canvas || typeof canvas.getElement !== 'function') return null;

    var canvasEl = canvas.getElement();
    if (!canvasEl || typeof canvasEl.getBoundingClientRect !== 'function') return null;

    var rect = canvasEl.getBoundingClientRect();
    if (!rect.width || !rect.height) return null;

    return {
      x: Math.max(20, Math.min(canvas.width - 20, (clientX - rect.left) * (canvas.width / rect.width))),
      y: Math.max(20, Math.min(canvas.height - 20, (clientY - rect.top) * (canvas.height / rect.height)))
    };
  }

  function bindCanvasDrop() {
    var stage = dom.stage();
    if (!stage) return;

    // Drag-Events auf dem Stage-Wrapper binden (größeres Drop-Ziel als der Canvas allein)
    stage.addEventListener('dragover', function (e) {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
      stage.classList.add('sbc-canvas-stage--dragover');
    });
    stage.addEventListener('dragleave', function (e) {
      // Nur entfernen wenn wirklich den Stage verlässt
      if (!stage.contains(e.relatedTarget)) {
        stage.classList.remove('sbc-canvas-stage--dragover');
      }
    });

    stage.addEventListener('drop', function (e) {
      e.preventDefault();
      stage.classList.remove('sbc-canvas-stage--dragover');
      const toolUrl = e.dataTransfer.getData('text/toolUrl');
      const toolId = e.dataTransfer.getData('text/toolId');
      if (!toolUrl) return;

      var point = getCanvasPointFromClientPoint(e.clientX, e.clientY);
      if (point) {
        requestAddShadowTool(toolUrl, toolId, point.x, point.y);
      } else {
        requestAddShadowTool(toolUrl, toolId);
      }
    });
  }

  /* ==========================================
     KEYBOARD SHORTCUTS
     ========================================== */

  function isEditableKeyboardTarget(target) {
    if (!target) return false;
    var tag = String(target.tagName || '').toLowerCase();
    return target.isContentEditable || ['input', 'textarea', 'select', 'option'].includes(tag);
  }

  function getKeyboardMovableObjects(activeObj) {
    if (!activeObj || activeObj.isEditing || isCanvasHelperObject(activeObj) || activeObj.isBackground) return [];

    if (activeObj.type === 'activeSelection' && typeof activeObj.getObjects === 'function') {
      return activeObj.getObjects().filter(function (obj) {
        return isUserDesignObject(obj) && obj.visible !== false && !isCanvasHelperObject(obj) && !obj.isBackground;
      });
    }

    return isUserDesignObject(activeObj) && activeObj.visible !== false ? [activeObj] : [];
  }

  function moveActiveObjectWithKeyboard(event) {
    if (!canvas || currentStep !== 5 || !event) return false;
    if (event.ctrlKey || event.metaKey || event.altKey || isEditableKeyboardTarget(event.target)) return false;

    var deltas = {
      ArrowLeft: { x: -1, y: 0 },
      ArrowRight: { x: 1, y: 0 },
      ArrowUp: { x: 0, y: -1 },
      ArrowDown: { x: 0, y: 1 }
    };
    var delta = deltas[event.key];
    if (!delta) return false;

    var activeObj = canvas.getActiveObject && canvas.getActiveObject();
    var movableObjects = getKeyboardMovableObjects(activeObj);
    if (!movableObjects.length) return false;

    var stepMm = event.shiftKey ? KEYBOARD_MOVE_FAST_STEP_MM : KEYBOARD_MOVE_STEP_MM;
    var stepPx = stepMm * getCanvasPxPerMm();
    var dx = delta.x * stepPx;
    var dy = delta.y * stepPx;

    event.preventDefault();

    movableObjects.forEach(function (obj) {
      obj.set({
        left: (Number(obj.left) || 0) + dx,
        top: (Number(obj.top) || 0) + dy
      });
      obj.setCoords();
      keepObjectRecoverableOnCanvas(obj);
      if (obj.objectType === 'custom-text') {
        keepObjectWithinCanvas(obj, TEXT_FIT_PADDING);
      }
      checkBounds(obj);
      checkOverlapVisual(obj);
    });

    if (activeObj && typeof activeObj.setCoords === 'function') activeObj.setCoords();
    clearSnapGuides();
    refreshMeasurementGrid();
    canvas.requestRenderAll();
    canvas.fire('object:modified', { target: activeObj || movableObjects[0] });
    return true;
  }

  function bindKeyboard() {
    document.addEventListener('keydown', function (e) {
      if (moveActiveObjectWithKeyboard(e)) return;
      if (isEditableKeyboardTarget(e.target)) return;

      // Ctrl/Cmd+Z → Undo
      if ((e.ctrlKey || e.metaKey) && !e.shiftKey && e.key === 'z') {
        e.preventDefault();
        undo();
        return;
      }
      // Ctrl/Cmd+Y or Ctrl/Cmd+Shift+Z → Redo
      if ((e.ctrlKey || e.metaKey) && (e.key === 'y' || (e.shiftKey && e.key === 'z') || (e.shiftKey && e.key === 'Z'))) {
        e.preventDefault();
        redo();
        return;
      }
      // Delete / Backspace → remove selected (but not while editing text)
      if (canvas && (e.key === 'Delete' || e.key === 'Backspace') && !canvas.getActiveObject()?.isEditing) {
        e.preventDefault();
        removeActiveObject();
      }
    });
  }

  /* ==========================================
     RESET
     ========================================== */

  function bindReset() {
    const btn = dom.btnReset();
    if (!btn) return;

    btn.addEventListener('click', function () {
      if (getAllUserDesignObjects().length === 0) return;
      showConfirmReset();
    });
  }

  function doReset() {
    canvas.getObjects().slice().forEach(function (obj) {
      if (!isCanvasHelperObject(obj)) canvas.remove(obj);
    });
    canvas.discardActiveObject();
    canvas.requestRenderAll();
    updateCustomBoardBrandMark();
    clearStoredDraftSaveString();
    syncCanvasUi();
    showPropertiesPanel(false);
    toast('Alle Objekte entfernt');
  }

  function startNewWallDesign() {
    if (!canvas) return;

    var hasUserObjects = getAllUserDesignObjects().length > 0;
    if (hasUserObjects && !window.confirm('Aktuelle Gestaltung verwerfen und eine neue Wand erstellen?')) {
      return;
    }

    clearTimeout(autosaveTimer);
    pendingRestoreSaveStr = null;
    clearStoredDraftSaveString();
    clearPendingLoginSaveState(true);
    clearUrlRestoreParams(['draft', 'sbc_draft', 'designId', 'save', 'sbc_auto_save']);

    planningSavedSignature = null;
    planningSavedAt = '';
    planningDraftName = '';
    publishPlanningStatus('new');
    designId = null;
    activeDraftIds.front = null;
    activeDraftIds.back = null;
    loadedDraftSpecialInfo = '';
    currentSide = 'front';
    activeColorSide = 'front';
    selectedSize = null;
    selectedSizeIsCustom = false;
    CFG.boardWidthMm = INITIAL_BOARD_WIDTH_MM;
    CFG.boardHeightMm = INITIAL_BOARD_HEIGHT_MM;
    selectedColor = 'white';
    selectedBackColor = 'white';
    selectedBackColorCustomized = false;
    selectedMounting = 'wall';
    selectedMountingSides = 1;
    selectedSurfaceType = configuratorSettings.defaults.surfaceType || 'premium';
    selectedHolderType = configuratorSettings.defaults.holderType || 'stainless';
    selectedFinalizeAddons = { dowels: false, adhesive: false, spacers: false, magnets: false, silicone: false };
    selectedQuantity = 1;
    setSelectedQuantity(1);

    canvas.clear();
    customBoardBrandMark = null;
    customBoardBrandVariant = '';
    canvas.backgroundColor = '#ffffff';
    canvas.discardActiveObject();
    clearSnapGuides();
    undoStack = [];
    redoStack = [];
    updateUndoRedoButtons();

    resizeCanvas();
    selectedProduct = getProductForSizeWithSurfaceFallback(CFG.boardWidthMm, CFG.boardHeightMm);
    selectedVariant = selectedProduct ? resolveVariantForColor(selectedColor) : null;
    applyBackgroundForCurrentSize();
    updateMountingStepUi();
    updateSurfaceStepUi();
    updateFinalizeStepUi();
    renderColorOptions();
    updateSelectedProductTitle();
    syncCanvasUi();
    showPropertiesPanel(false);
    setZoom(1);
    goToStep(1);
    saveState(true);
    toast('Neue Wand gestartet');
  }

  /* ==========================================
     CART BUTTON STATE
     ========================================== */

  function updateCartButton() {
    updateBoundsErrorBanner();

    const btn = dom.btnCart();
    if (!btn) return;

    var validationMessage = getDesignValidationMessage() || getFinalizationValidationMessage();
    btn.disabled = cartLoading || !!validationMessage;
    btn.setAttribute('aria-disabled', validationMessage ? 'true' : 'false');
    btn.classList.toggle('sbc-btn--blocked', !!validationMessage);
    btn.dataset.blockReason = validationMessage || '';
    btn.title = validationMessage;

    var wrap = dom.btnCartWrap();
    if (wrap) {
      wrap.dataset.blockReason = validationMessage || '';
      wrap.classList.toggle('sbc-cart-action-wrap--blocked', !!validationMessage);
      wrap.title = validationMessage;
    }
  }

  /* ==========================================
     UNDO / REDO
     ========================================== */

  var _isAutoSaving = false;

  function scheduleDraftAutosave(force) {
    schedulePlanningStatus();
    clearTimeout(autosaveTimer);
    autosaveTimer = setTimeout(function () {
      persistDraftAutosave(!!force);
    }, 300);
  }

  function persistDraftAutosave(force) {
    if (isHydratingDesign && !force) return;
    if (_isAutoSaving) return;
    _isAutoSaving = true;

    (async function () {
      try {
        var userObjects = getAllUserDesignObjects();
        if (userObjects.length > 0) {
          var saveStr = await generateSaveStringAsync();
          setStoredDraftSaveString(saveStr);
        } else if (force || undoStack.length > 1) {
          clearStoredDraftSaveString();
        }
      } catch (e) {
        console.warn('[SBC] Auto-Save Fehler:', e);
      } finally {
        _isAutoSaving = false;
      }
    })();
  }

  function persistDraftAutosaveSyncFallback() {
    if (!canvas) return;

    try {
      var userObjects = getAllUserDesignObjects();
      if (userObjects.length > 0) {
        var saveStr = generateSaveString();
        if (saveStr) {
          setStoredDraftSaveString(saveStr);
          return;
        }
        if (lastDraftSaveStr) {
          setStoredDraftSaveString(lastDraftSaveStr);
        }
      } else if (undoStack.length > 1) {
        clearStoredDraftSaveString();
      }
    } catch (e) {
      if (lastDraftSaveStr) {
        try {
          setStoredDraftSaveString(lastDraftSaveStr);
        } catch (storageErr) { }
      }
    }
  }

  function bindDraftAutosaveLifecycle() {
    window.addEventListener('pagehide', persistDraftAutosaveSyncFallback);
    window.addEventListener('pageshow', function () {
      if (pendingRestoreSaveStr || getAllUserDesignObjects().length > 0) return;
      var autosave = getStoredDraftSaveString();
      if (!autosave) return;
      pendingRestoreSaveStr = autosave;
      showRestoreDraftModal();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        persistDraftAutosaveSyncFallback();
      }
    });
  }

  function saveState(force) {
    if ((isHydratingDesign && !force) || !canvas || undoLock) return;
    var state = canvas.toJSON(['sbcBristle', 'toolId', 'toolCategory', 'sbcScalable', 'objectType', 'imageData', 'src', 'sbcSide', 'curvature', 'fontId', 'fontUrl', 'lineHeight', 'textAlign', 'textColorKey', 'textColorLabel', 'textColorCmyk', 'sbcFontPt', 'fontPt', 'fpt', 'isGuideLine', 'sbcGuideLine']);
    state.objects = (state.objects || []).filter(function (obj) {
      return obj && ['shadow-tool', 'logo', 'custom-text'].includes(obj.objectType);
    });
    var json = JSON.stringify(state);
    // Duplikate vermeiden
    if (undoStack.length > 0 && undoStack[undoStack.length - 1] === json) {
      scheduleDraftAutosave(force);
      return;
    }
    undoStack.push(json);
    if (undoStack.length > MAX_UNDO) undoStack.shift();
    redoStack = [];
    updateUndoRedoButtons();
    scheduleDraftAutosave(force);
  }

  function undo() {
    if (undoStack.length <= 1) return;
    undoLock = true;
    redoStack.push(undoStack.pop());
    var state = undoStack[undoStack.length - 1];
    canvas.loadFromJSON(state, function () {
      updateSideVisibility(); // Ensure correct side uses visible=true
      normalizeCanvasObjects();
      undoLock = false;
      updateUndoRedoButtons();
      syncCanvasUi();
      refreshMeasurementGrid();
      schedulePlanningStatus();
      toast('Rückgängig');
    });
  }

  function redo() {
    if (redoStack.length === 0) return;
    undoLock = true;
    var state = redoStack[redoStack.length - 1];
    redoStack.pop();
    undoStack.push(state);
    canvas.loadFromJSON(state, function () {
      updateSideVisibility();
      normalizeCanvasObjects();
      undoLock = false;
      updateUndoRedoButtons();
      syncCanvasUi();
      refreshMeasurementGrid();
      schedulePlanningStatus();
      toast('Wiederholt');
    });
  }

  function updateUndoRedoButtons() {
    var btnU = dom.btnUndo();
    var btnR = dom.btnRedo();
    if (btnU) btnU.disabled = undoStack.length <= 1;
    if (btnR) btnR.disabled = redoStack.length === 0;
  }

  /* ==========================================
     ZOOM CONTROLS
     ========================================== */

  function bindZoomControls() {
    var btnZoomIn = document.getElementById('btn-zoom-in');
    var btnZoomOut = document.getElementById('btn-zoom-out');
    var btnZoomReset = document.getElementById('btn-zoom-reset');

    if (btnZoomIn) btnZoomIn.addEventListener('click', function () { zoomBy(ZOOM_STEP); });
    if (btnZoomOut) btnZoomOut.addEventListener('click', function () { zoomBy(-ZOOM_STEP); });
    if (btnZoomReset) btnZoomReset.addEventListener('click', function () { setZoom(1); });
    window.addEventListener('mouseup', endCanvasPan);
    window.addEventListener('touchend', endCanvasPan, { passive: true });
    window.addEventListener('blur', endCanvasPan);

    // Undo/Redo Buttons (die waren hier mit drin)
    var btnU = dom.btnUndo();
    var btnR = dom.btnRedo();
    if (btnU) btnU.addEventListener('click', undo);
    if (btnR) btnR.addEventListener('click', redo);
  }

  function zoomBy(delta) {
    setZoom(Math.round((zoomLevel + delta) * 100) / 100);
  }

  function normalizeZoomLevel(level) {
    var minZoom = getMinZoomForCurrentSize();
    var nextZoom = Math.max(minZoom, Math.min(ZOOM_MAX, Number(level) || 1));
    nextZoom = Math.round(nextZoom * 100) / 100;
    var crossesReset = (zoomLevel > 1 && nextZoom < 1) || (zoomLevel < 1 && nextZoom > 1);
    if (crossesReset || Math.abs(nextZoom - 1) <= ZOOM_RESET_SNAP_RANGE) {
      nextZoom = 1;
    }
    return nextZoom;
  }

  function setZoom(level) {
    if (!canvas) return;
    zoomLevel = normalizeZoomLevel(level);
    canvas.zoomToPoint(getZoomAnchorPoint(), zoomLevel);
    if (zoomLevel === 1) {
      endCanvasPan();
      canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
    } else if (zoomLevel < 1) {
      focusSmallWallOversizedToolBottomForZoom();
    }
    applyCanvasContextQuality();
    markCanvasObjectsDirty();
    canvas.requestRenderAll();
    var el = document.getElementById('sbc-zoom-level');
    if (el) el.textContent = Math.round(zoomLevel * 100) + '%';
    updateCanvasViewportCursor();
  }

  function focusSmallWallOversizedToolBottomForZoom() {
    if (!canvas || !allowsBottomToolOverhangForCurrentBoard()) return;

    var obj = canvas.getActiveObject && canvas.getActiveObject();
    if (!obj || obj.objectType !== 'shadow-tool') return;

    obj.setCoords();
    var bounds = getCanvasBoundsForObject(obj) || obj.getBoundingRect(true, true);
    if (!bounds || !isFinite(bounds.bottom) || bounds.bottom <= canvas.height) return;

    var vpt = canvas.viewportTransform || [zoomLevel, 0, 0, zoomLevel, 0, 0];
    var centerX = bounds.left + (bounds.width / 2);
    vpt[4] = (canvas.width / 2) - (centerX * zoomLevel);
    vpt[5] = (canvas.height * 0.82) - (bounds.bottom * zoomLevel);
    canvas.setViewportTransform(vpt);
  }

  /* ==========================================
     OBJECT COUNTER
     ========================================== */

  function updateObjectCounter() {
    var el = dom.objectCounter();
    if (el) {
      var summary = buildConfigurationSummary();
      el.textContent = summary.configurationLabel;
    }
    updateSideToggleStatus();
  }

  /* ==========================================
     EMPTY STATE
     ========================================== */

  function updateEmptyState() {
    var el = dom.emptyState();
    if (!el) return;
    var hasObjects = getVisibleUserObjects().length > 0;
    var show = currentStep === 5 && !hasObjects;
    el.hidden = !show;
    el.style.display = show ? '' : 'none';
  }

  /* ==========================================
     CONFIRM RESET MODAL
     ========================================== */

  function bindConfirmResetModal() {
    var cancelBtn = document.getElementById('btn-confirm-cancel');
    var confirmBtn = document.getElementById('btn-confirm-reset');
    var overlay = dom.confirmResetModal();

    if (cancelBtn) cancelBtn.addEventListener('click', hideConfirmReset);
    if (confirmBtn) confirmBtn.addEventListener('click', function () {
      hideConfirmReset();
      doReset();
    });
    // Overlay click = cancel
    if (overlay) overlay.addEventListener('click', function (e) {
      if (e.target === overlay) hideConfirmReset();
    });
  }

  function showConfirmReset() {
    var modal = dom.confirmResetModal();
    if (modal) modal.style.display = '';
  }

  function hideConfirmReset() {
    var modal = dom.confirmResetModal();
    if (modal) modal.style.display = 'none';
  }

  function bindRestoreDraftModal() {
    var discardBtn = dom.restoreDraftDiscard();
    var loadBtn = dom.restoreDraftLoad();

    if (discardBtn) {
      discardBtn.addEventListener('click', function () {
        pendingRestoreSaveStr = null;
        clearStoredDraftSaveString();
        clearPendingLoginSaveState(true);
        hideRestoreDraftModal();
        goToStep(1);
        saveState(true);
      });
    }

    if (loadBtn) {
      loadBtn.addEventListener('click', async function () {
        var saveStr = pendingRestoreSaveStr;
        pendingRestoreSaveStr = null;
        hideRestoreDraftModal();
        if (saveStr) {
          var restored = await restoreDesignStateFromSaveString(saveStr, {});
          if (restored) clearPendingLoginSaveState(true);
        }
      });
    }
  }

  function showRestoreDraftModal() {
    var modal = dom.restoreDraftModal();
    if (modal) {
      modal.hidden = false;
      modal.style.display = 'flex';
    }
  }

  function hideRestoreDraftModal() {
    var modal = dom.restoreDraftModal();
    if (modal) {
      modal.hidden = true;
      modal.style.display = 'none';
    }
  }

  /* ==========================================
     STEP-DOT CLICK NAVIGATION
     ========================================== */

  function bindStepDotNavigation() {
    $$('.sbc-step-dot[data-step]').forEach(function (dot) {
      dot.addEventListener('click', function () {
        var targetStep = parseInt(dot.dataset.step);
        // Nur zu bereits abgeschlossenen Steps navigieren
        if (targetStep < currentStep) {
          goToStep(targetStep);
        }
      });
    });
  }

  /* ==========================================
     ADD TO CART FLOW
     ========================================== */

  function updateTotalPrice() {
    var priceEl = document.getElementById('sbc-total-price-val');
    var originalEl = document.getElementById('sbc-total-price-original');
    var discountEl = document.getElementById('sbc-total-price-discount');
    updateSelectedProductTitle();
    renderQuantityDiscountTable();
    if (!priceEl) return;
    var originalTotal = getBoardBaseTotalCents() + getFinalizationTotalCents();
    var discount = getQuantityDiscountSnapshot();
    var total = getTotalPriceCents();
    priceEl.textContent = (total / 100).toFixed(2).replace('.', ',') + ' €';
    if (originalEl) {
      originalEl.hidden = !discount;
      originalEl.textContent = (originalTotal / 100).toFixed(2).replace('.', ',') + ' €';
    }
    if (discountEl) {
      discountEl.hidden = !discount;
      discountEl.textContent = discount ? discount.label + ': -' + discount.amountLabel : '';
    }
  }

  function updateSelectedProductTitle() {
    updateCustomSizeEditButton();
    var els = $$('.sbc-selected-product-title');
    if (!els.length) return;

    var sizeLabel = getBoardDimensionLabel();
    if (!sizeLabel) {
      els.forEach(function (el) {
        el.hidden = true;
        el.textContent = '';
        el.title = '';
      });
      return;
    }

    var displayTitle = (selectedSizeIsCustom ? 'Sondermaß ' : 'Schattenwand ') + sizeLabel + ' / inkl. Werkzeughalterungen';
    els.forEach(function (el) {
      el.hidden = false;
      el.textContent = displayTitle;
      el.title = displayTitle;
    });
  }

  function setLeadFunnelOpen(open) {
    var panel = dom.leadPanel();
    var btn = dom.btnLead();
    if (!panel) return;

    leadFunnelOpen = !!open;
    if (leadFunnelOpen) {
      updateMobileViewportBottomOffset();
    }
    panel.hidden = !leadFunnelOpen;
    syncLeadFunnelPortal();

    if (btn) {
      btn.setAttribute('aria-expanded', leadFunnelOpen ? 'true' : 'false');
    }

    if (leadFunnelOpen) {
      var nameInput = dom.leadName();
      var emailInput = dom.leadEmail();
      if (nameInput && !nameInput.value && _d.customerName) {
        nameInput.value = _d.customerName;
      }
      if (emailInput && !emailInput.value && window.Shopify && Shopify.customer && Shopify.customer.email) {
        emailInput.value = Shopify.customer.email;
      }
      if (!isMobileViewport()) {
        if (nameInput && !nameInput.value) nameInput.focus();
        else if (emailInput) emailInput.focus();
      }
    } else {
      clearLeadMessage();
      pendingLeadAccessories = [];
    }
  }

  function setLeadLoading(loading) {
    var btn = dom.btnLeadSubmit();
    var label = dom.btnLeadSubmitLabel();
    var spinner = dom.btnLeadSubmitSpinner();
    if (!btn) return;

    btn.disabled = !!loading;
    if (label) label.style.display = loading ? 'none' : '';
    if (spinner) spinner.style.display = loading ? '' : 'none';
  }

  function clearLeadMessage() {
    var el = dom.leadMessage();
    if (!el) return;
    el.hidden = true;
    el.textContent = '';
    el.classList.remove('sbc-lead-form__message--success', 'sbc-lead-form__message--error');
  }

  function setLeadMessage(message, type) {
    if(window.optileanOfferOrderJourney)window.optileanOfferOrderJourney.clear(dom.leadMessage());
    var el = dom.leadMessage();
    if (!el) return;
    el.hidden = false;
    el.textContent = message;
    el.classList.remove('sbc-lead-form__message--success', 'sbc-lead-form__message--error');
    el.classList.add(type === 'success' ? 'sbc-lead-form__message--success' : 'sbc-lead-form__message--error');
  }

  function validateLeadEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
  }

  function confirmEmptyBacksideForAction(actionLabel) {
    if (!(selectedMounting !== 'wall' && selectedMountingSides === 2)) return true;

    var backPayload = preparePayload('back');
    if (backPayload.filteredObjects.length > 0) return true;

    var proceed = window.confirm(
      "Du hast 'beidseitig gestaltet' ausgewählt, aber die Rückseite ist noch komplett leer.\n\n" +
      "Möchtest du die leere Rückseite trotzdem für " + actionLabel + " verwenden oder abbrechen und sie jetzt bearbeiten?\n\n" +
      "[OK] = Trotzdem fortfahren\n[Abbrechen] = Rückseite bearbeiten"
    );

    if (!proceed) {
      switchSide('back');
      return false;
    }

    return true;
  }

  function confirmSingleSidedMountingForCart() {
    if (!(selectedMounting !== 'wall' && selectedMountingSides === 1)) return true;

    var mountingLabel = getMountingLabel();
    var proceed = window.confirm(
      mountingLabel + " ist aktuell mit nur 1 Seite ausgewählt.\n\n" +
      "Bist du sicher, dass nur die Vorderseite gestaltet und bestellt werden soll?\n\n" +
      "[OK] = Ja, nur 1 Seite in den Warenkorb\n[Abbrechen] = Zurück und 2 Seiten auswählen"
    );

    if (!proceed) {
      goToStep(2);
      return false;
    }

    return true;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalizeVariantId(value) {
    var cleaned = String(value || '').replace(/[^\d]/g, '');
    return /^\d{8,}$/.test(cleaned) ? cleaned : '';
  }

  function normalizePurchaseImageUrl(value) {
    var url = String(value || '').trim();
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    return /^https?:\/\//i.test(url) ? url : '';
  }

  function getToolById(toolId) {
    if (!toolId) return null;
    return toolsById[toolId] || (allToolsCacheConfigurator || []).find(function (tool) {
      return tool && tool.id === toolId;
    }) || null;
  }

  function getToolPurchaseEntries(tool) {
    if (!tool) return [];
    var entries = [
      {
        variantId: normalizeVariantId(tool.purchaseVariantId || (tool.purchaseVariants && tool.purchaseVariants.all)),
        imageUrl: normalizePurchaseImageUrl(tool.purchaseImageUrl)
      },
      {
        variantId: normalizeVariantId(tool.purchaseVariantId2),
        imageUrl: normalizePurchaseImageUrl(tool.purchaseImageUrl2)
      }
    ];
    var seen = {};
    return entries.filter(function (entry) {
      if (!entry.variantId || seen[entry.variantId]) return false;
      seen[entry.variantId] = true;
      return true;
    });
  }

  // Separate identical shadows by bristles so mixed selections never collapse into one cart variant.
  function getPlacedShadowToolSelections() {
    var selections = {};
    if (!canvas) return [];
    getRelevantDesignObjects().forEach(function (obj) {
      if (!obj || obj.objectType !== 'shadow-tool' || !obj.toolId) return;
      var bristle = obj.sbcBristle || '';
      var key = JSON.stringify([obj.toolId, bristle]);
      if (!selections[key]) selections[key] = { toolId: obj.toolId, bristle: bristle, quantity: 0 };
      selections[key].quantity += 1;
    });
    return Object.keys(selections).map(function (key) { return selections[key]; });
  }

  async function getSelectedToolPurchaseEntries(tool, bristle) {
    var entries = getToolPurchaseEntries(tool);
    if (!bristle) return entries; // Existing designs keep their established product links.
    var guide = window.OptileanBristles;
    var spec = guide && guide.family(tool);
    if (!spec || !entries.length) throw new Error('Bitte die Geräteauswahl im Konfigurator prüfen.');
    var product = await guide.loadProduct(spec.handle);
    var variant = guide.variantFor(product, { color: tool.boardColor, size: spec.size, kind: spec.kind }, bristle);
    if (!variant || variant.available === false) throw new Error('Die gewählte Ausführung für „' + tool.name + '“ ist nicht verfügbar. Bitte die Auswahl im Konfigurator prüfen.');
    // Only the broom head changes. Its matching handle remains the second purchase entry.
    entries[0] = { variantId: String(variant.id), imageUrl: normalizePurchaseImageUrl(getVariantImageUrl(variant)) || entries[0].imageUrl };
    return entries;
  }

  function getPlacedShadowToolCounts() {
    var counts = {};
    if (!canvas) return counts;

    getRelevantDesignObjects().forEach(function (obj) {
      if (!obj || obj.objectType !== 'shadow-tool' || !obj.toolId) return;
      counts[obj.toolId] = (counts[obj.toolId] || 0) + 1;
    });

    return counts;
  }

  async function fetchShopifyVariant(variantId) {
    if (!variantId) return null;
    if (shopifyVariantCache[variantId]) return shopifyVariantCache[variantId];

    shopifyVariantCache[variantId] = fetch('/variants/' + encodeURIComponent(variantId) + '.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Variant fetch failed: ' + res.status);
        return res.json();
      })
      .catch(function (err) {
        console.warn('[SBC] Shopify-Variante konnte nicht geladen werden:', variantId, err);
        return null;
      });

    return shopifyVariantCache[variantId];
  }

  function getVariantImageUrl(variant) {
    if (!variant) return '';
    if (typeof variant.featured_image === 'string') return variant.featured_image;
    if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (variant.featured_image && variant.featured_image.original_src) return variant.featured_image.original_src;
    if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
      return variant.featured_media.preview_image.src;
    }
    if (variant.image) return variant.image;
    return '';
  }

  function getVariantDisplayName(variant, fallback) {
    if (!variant) return fallback;
    return variant.name || variant.product_title || variant.title || fallback;
  }

  function getVariantPriceCents(variant) {
    var value = Number(variant && variant.price);
    return isFinite(value) && value > 0 ? Math.round(value) : 0;
  }

  async function buildAccessoryRecommendations() {
    var selections = getPlacedShadowToolSelections();
    var entries = [];
    var boardQuantity = getSelectedQuantity();

    for (var selection of selections) {
      var toolId = selection.toolId;
      var tool = getToolById(toolId);
      var purchaseEntries = await getSelectedToolPurchaseEntries(tool, selection.bristle);
      if (!tool || purchaseEntries.length === 0) continue;
      purchaseEntries.forEach(function (purchaseEntry, variantIndex) {
        entries.push({
          toolId: toolId,
          bristle: variantIndex === 0 ? selection.bristle : '',
          variantId: purchaseEntry.variantId,
          variantIndex: variantIndex,
          quantity: selection.quantity * boardQuantity,
          shadowName: tool.name || 'Passendes Werkzeug',
          purchaseImageUrl: purchaseEntry.imageUrl || '',
          colorLabel: getColorSummaryLabel()
        });
      });
    }

    var variants = await Promise.all(entries.map(function (entry) {
      return fetchShopifyVariant(entry.variantId);
    }));

    return entries.map(function (entry, index) {
      var variant = variants[index];
      if (!variant || variant.available === false) {
        console.warn('[SBC] Werkzeug-Zubehör wird übersprungen, weil die Shopify-Variante nicht kaufbar ist:', entry.variantId, entry.shadowName);
        return null;
      }
      var priceCents = getVariantPriceCents(variant);
      return Object.assign(entry, {
        name: getVariantDisplayName(variant, entry.shadowName),
        sku: String(variant.sku || '').trim(),
        imageUrl: normalizePurchaseImageUrl(getVariantImageUrl(variant)) || entry.purchaseImageUrl || '',
        unitPriceCents: priceCents,
        unitPriceLabel: priceCents ? formatEuroCents(priceCents, false) : ''
      });
    }).filter(Boolean);
  }

  function buildAccessoryCartItems(recommendations) {
    return (recommendations || []).map(function (item) {
      return {
        id: parseInt(item.variantId, 10),
        quantity: Math.max(1, parseInt(item.quantity, 10) || 1),
        properties: {
          '_SBC_Accessory': 'true',
          '_SBC_Tool_ID': item.toolId,
          'Passend zur Wandfarbe': item.colorLabel,
          'Aus Schatten': item.shadowName || item.name,
          'Shop-Artikel': item.name,
          ...(item.bristle ? window.OptileanBristles.properties(item.bristle) : {})
        }
      };
    }).filter(function (item) {
      return item.id && item.quantity > 0;
    });
  }

  function buildAccessoryOfferItems(recommendations) {
    return (recommendations || []).map(function (item) {
      var quantity = Math.max(1, parseInt(item.quantity, 10) || 1);
      var unitPriceCents = Math.max(0, parseInt(item.unitPriceCents, 10) || 0);
      var linePriceCents = unitPriceCents * quantity;

      return {
        variantId: String(item.variantId || ''),
        sku: String(item.sku || '').trim(),
        toolId: item.toolId || '',
        name: item.name || 'Reinigungswerkzeug',
        shadowName: item.shadowName || item.name || '',
        quantity: quantity,
        unitPriceCents: unitPriceCents,
        unitPriceLabel: unitPriceCents ? formatEuroCents(unitPriceCents, false) : (entry.holderKind ? 'inkl.' : 'auf Anfrage'),
        linePriceCents: linePriceCents,
        linePriceLabel: linePriceCents ? formatEuroCents(linePriceCents, false) : (entry.holderKind ? 'inkl.' : 'auf Anfrage')
      };
    });
  }

  function buildFinalizeCartItems() {
    return getFinalizationSelectedProducts().map(function (entry) {
      var quantity = getFinalizationEntryQuantity(entry);
      return {
        id: parseInt(entry.variant.id, 10),
        quantity: quantity,
        properties: {
          '_SBC_Finalize_Accessory': 'true',
          '_SBC_Finalize_Type': entry.group,
          'Zusatzartikel': getFinalizationEntryLabel(entry),
          'Passend zur Schattenwand': getSizeLabel(),
          'Oberfläche': getSurfaceLabel()
        }
      };
    }).filter(function (item) {
      return item.id && item.quantity > 0;
    });
  }

  function buildFinalizeOfferItems() {
    return getFinalizationSelectedProducts().map(function (entry) {
      var quantity = getFinalizationEntryQuantity(entry);
      var unitPriceCents = Math.max(0, parseInt(entry.variant.price, 10) || 0);
      var linePriceCents = unitPriceCents * quantity;
      return {
        variantId: String(entry.variant.id || ''),
        sku: String(entry.variant.sku || '').trim(),
        toolId: 'finalize-' + entry.item.key,
        type: entry.group === 'holder' ? 'Halterung' : 'Wandmontage',
        holderKind: entry.holderKind || '',
        name: entry.holderKind ? getFinalizationEntryLabel(entry) : getFinalizeProductName(entry.item),
        shadowName: getFinalizationEntryLabel(entry),
        quantity: quantity,
        unitPriceCents: unitPriceCents,
        unitPriceLabel: unitPriceCents ? formatEuroCents(unitPriceCents, false) : (entry.holderKind ? 'inkl.' : 'auf Anfrage'),
        linePriceCents: linePriceCents,
        linePriceLabel: linePriceCents ? formatEuroCents(linePriceCents, false) : (entry.holderKind ? 'inkl.' : 'auf Anfrage')
      };
    });
  }

  function getAccessoryTotalCents(accessories) {
    return (accessories || []).reduce(function (sum, item) {
      return sum + (Math.max(0, parseInt(item.linePriceCents, 10) || 0));
    }, 0);
  }

  function getAccessorySelectionFromModal(recommendations) {
    var modal = dom.accessoryModal();
    if (!modal) return [];

    return (recommendations || []).map(function (item, index) {
      var checked = modal.querySelector('[data-accessory-check="' + index + '"]');
      var qtyInput = modal.querySelector('[data-accessory-qty="' + index + '"]');
      if (!checked || !checked.checked) return null;

      var quantity = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || item.quantity || 1);
      return Object.assign({}, item, { quantity: quantity });
    }).filter(Boolean);
  }

  async function showAccessoryUpsell(flow) {
    var recommendations = await buildAccessoryRecommendations();
    var modal = dom.accessoryModal();
    var list = dom.accessoryList();
    var confirmBtn = dom.accessoryConfirm();
    var skipBtn = dom.accessorySkip();
    var cancelBtn = dom.accessoryCancel();
    var title = dom.accessoryTitle();
    var desc = dom.accessoryDesc();

    if (!modal || !list || recommendations.length === 0) {
      return Promise.resolve({ action: 'skip', items: [] });
    }

    if (title) {
      title.textContent = flow === 'lead'
        ? 'Angebot mit passenden Werkzeugen erhalten?'
        : 'Passende Werkzeuge direkt mitbestellen?';
    }
    if (desc) {
      desc.textContent = 'Zu deinen platzierten Schatten wurden passende Shop-Artikel gefunden. Du kannst Menge und Auswahl anpassen.';
    }
    if (confirmBtn) {
      confirmBtn.textContent = flow === 'lead'
        ? 'Auswahl ins Angebot übernehmen'
        : 'Auswahl übernehmen & in den Warenkorb';
    }

    list.innerHTML = recommendations.map(function (item, index) {
      return '<label class="sbc-accessory-item">' +
        '<input class="sbc-accessory-item__check" type="checkbox" data-accessory-check="' + index + '" checked>' +
        (item.imageUrl
          ? '<img class="sbc-accessory-item__image" src="' + escapeHtml(item.imageUrl) + '" alt="' + escapeHtml(item.name) + '" crossorigin="anonymous">'
          : '<span class="sbc-accessory-item__image" aria-hidden="true"></span>') +
        '<span>' +
        '<strong class="sbc-accessory-item__name">' + escapeHtml(item.name) + '</strong>' +
        '<span class="sbc-accessory-item__meta">Passend zu ' + item.quantity + ' platziertem Schatten' + (item.quantity > 1 ? 'n' : '') + (item.unitPriceLabel ? ' · ' + escapeHtml(item.unitPriceLabel) + ' / Stück' : '') + '</span>' +
        '</span>' +
        '<span class="sbc-accessory-item__qty">' +
        '<span>Menge</span>' +
        '<input type="number" min="1" step="1" value="' + item.quantity + '" data-accessory-qty="' + index + '">' +
        '</span>' +
        '</label>';
    }).join('');

    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'false');

    return new Promise(function (resolve) {
      function cleanup() {
        modal.style.display = 'none';
        modal.setAttribute('aria-hidden', 'true');
        if (confirmBtn) confirmBtn.removeEventListener('click', onConfirm);
        if (skipBtn) skipBtn.removeEventListener('click', onSkip);
        if (cancelBtn) cancelBtn.removeEventListener('click', onCancel);
        modal.removeEventListener('click', onOverlayClick);
        document.removeEventListener('keydown', onKeydown);
      }

      function onConfirm() {
        var selectedItems = getAccessorySelectionFromModal(recommendations);
        cleanup();
        resolve({
          action: 'confirm',
          items: buildAccessoryCartItems(selectedItems),
          accessories: buildAccessoryOfferItems(selectedItems)
        });
      }

      function onSkip() {
        cleanup();
        resolve({ action: 'skip', items: [], accessories: [] });
      }

      function onCancel() {
        cleanup();
        resolve({ action: 'cancel', items: [], accessories: [] });
      }

      function onOverlayClick(event) {
        if (event.target === modal) onCancel();
      }

      function onKeydown(event) {
        if (event.key === 'Escape') onCancel();
      }

      if (confirmBtn) confirmBtn.addEventListener('click', onConfirm);
      if (skipBtn) skipBtn.addEventListener('click', onSkip);
      if (cancelBtn) cancelBtn.addEventListener('click', onCancel);
      modal.addEventListener('click', onOverlayClick);
      document.addEventListener('keydown', onKeydown);
    });
  }

  async function addAccessoryItemsToCart(accessoryItems) {
    if (!accessoryItems || accessoryItems.length === 0) return null;

    var res = await fetch(getShopifyCartEndpoint('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: accessoryItems })
    });

    if (!res.ok) {
      var accessoryCartError = await readShopifyErrorResponse(res);
      console.error('[SBC] Accessory cart response:', accessoryCartError.parsed || accessoryCartError.text);
      throw new Error('Passende Werkzeuge konnten nicht in den Warenkorb gelegt werden: ' + accessoryCartError.message);
    }

    return res.json();
  }

  async function persistCurrentDesigns(options) {
    options = options || {};
    var isDraft = options.isDraft === true;
    var createNewDraft = isDraft && options.createNewDraft === true;
    var isTwoSides = (selectedMounting !== 'wall' && selectedMountingSides === 2);
    var originalSide = currentSide;
    var frontDraftId = createNewDraft ? null : activeDraftIds.front;
    var backDraftId = createNewDraft ? null : activeDraftIds.back;

    if (!CFG.backendUrl) {
      throw new Error('Backend-URL fehlt. Das Design konnte nicht gespeichert werden.');
    }

    try {
      switchSide('front');
      await applyBackgroundForCurrentSize();
      var front = await sendDesignToBackend('front', null, isDraft, isDraft ? frontDraftId : null);
      var back = null;
      if (isDraft && front && front.designId) {
        activeDraftIds.front = normalizeDesignIdForDraft(front.designId);
      }

      if (isTwoSides) {
        switchSide('back');
        await applyBackgroundForCurrentSize();
        back = await sendDesignToBackend('back', front.designId, isDraft, isDraft ? backDraftId : null);
        if (isDraft && back && back.designId) {
          activeDraftIds.back = normalizeDesignIdForDraft(back.designId);
        }
      } else if (isDraft) {
        activeDraftIds.back = null;
      }

      return {
        front: front,
        back: back
      };
    } catch (backendErr) {
      console.error('[SBC] Backend-Fehler:', backendErr);
      throw new Error('Server-Speichern fehlgeschlagen: ' + backendErr.message);
    } finally {
      switchSide(originalSide);
    }
  }

  function buildLeadPriceSnapshot(accessories) {
    accessories = accessories || [];
    var boardTotalCents = getBoardBaseTotalCents();
    var quantityDiscount = getQuantityDiscountSnapshot();
    var discountCents = quantityDiscount ? quantityDiscount.amountCents : 0;
    var discountedBoardTotalCents = Math.max(0, boardTotalCents - discountCents);
    var accessoryTotalCents = getAccessoryTotalCents(accessories);
    var totalCents = discountedBoardTotalCents + accessoryTotalCents;
    return {
      totalCents: totalCents,
      label: formatEuroCents(totalCents, false),
      boardTotalCents: boardTotalCents,
      boardLabel: formatEuroCents(discountedBoardTotalCents, false),
      boardOriginalLabel: formatEuroCents(boardTotalCents, false),
      quantityDiscount: quantityDiscount,
      quantityDiscountCents: discountCents,
      quantityDiscountLabel: quantityDiscount ? quantityDiscount.amountLabel : '',
      accessoryTotalCents: accessoryTotalCents,
      accessoryLabel: accessoryTotalCents ? formatEuroCents(accessoryTotalCents, false) : '',
      sizeLabel: getSizeLabel(),
      priceSizeLabel: getPriceSizeLabel(),
      priceMultiplier: getBoardPriceMultiplier(),
      colorLabel: getColorSummaryLabel(),
      surfaceLabel: getSurfaceLabel(),
      quantity: getSelectedQuantity(),
      mountingLabel: getMountingLabel(),
      sidesLabel: getSidesLabel()
    };
  }

  function buildLeadRequestPayload(frontDesignId, backDesignId) {
    var accessories = (pendingLeadAccessories || []).concat(buildFinalizeOfferItems());
    return {
      name: String((dom.leadName() && dom.leadName().value) || '').trim(),
      email: String((dom.leadEmail() && dom.leadEmail().value) || '').trim(),
      phone: String((dom.leadPhone() && dom.leadPhone().value) || '').trim(),
      comment: String((dom.leadComment() && dom.leadComment().value) || '').trim(),
      sessionId: _sessionId,
      frontDesignId: frontDesignId,
      backDesignId: backDesignId || undefined,
      price: buildLeadPriceSnapshot(accessories),
      summary: buildConfigurationSummary(),
      surfaceType: selectedSurfaceType,
      quantity: getSelectedQuantity(),
      quantityDiscount: getQuantityDiscountSnapshot(),
      accessories: accessories
    };
  }

  async function submitLeadOffer() {
    var nameInput = dom.leadName();
    var emailInput = dom.leadEmail();
    var name = String((nameInput && nameInput.value) || '').trim();
    var email = String((emailInput && emailInput.value) || '').trim();
    var validationMessage = getDesignValidationMessage() || getFinalizationValidationMessage();

    clearLeadMessage();

    if (validationMessage) {
      setLeadMessage(validationMessage, 'error');
      return;
    }

    if (!name) {
      setLeadMessage('Bitte gib deinen Namen an, damit wir das Angebot eindeutig zuordnen können.', 'error');
      if (nameInput) nameInput.focus();
      return;
    }

    if (!validateLeadEmail(email)) {
      setLeadMessage('Bitte gib eine gültige E-Mail-Adresse ein.', 'error');
      if (emailInput) emailInput.focus();
      return;
    }

    if (!confirmEmptyBacksideForAction('das PDF-Angebot')) {
      return;
    }

    setLeadLoading(true);
    trackEvent('lead_submit_started', {
      emailDomain: email.split('@')[1] || '',
      size: getSizeLabel(),
      mounting: getMountingLabel()
    });

    try {
      var savedDesigns = await persistCurrentDesigns({ isDraft: false });
      var payload = buildLeadRequestPayload(
        savedDesigns.front && savedDesigns.front.designId,
        savedDesigns.back && savedDesigns.back.designId
      );

      payload.sourceUrl = location.href;
      if (CFG.customerId && location.hostname === 'optilean.shop') {
        var accountStateResponse = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'apps/address-book/offer-context', {credentials:'same-origin',cache:'no-store'});
        if (!accountStateResponse.ok) throw new Error('Dein Kundenkonto konnte nicht geprüft werden. Bitte lade die Seite neu.');
        var accountState = await accountStateResponse.json();
        if (!accountState.customerContext) throw new Error('Dein Kundenkonto konnte nicht geprüft werden. Bitte lade die Seite neu.');
        payload.customerContext = accountState.customerContext;
      }

      var res = await fetch(CFG.backendUrl.replace(/\/+$/, '') + '/api/leads/offer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      var result = null;
      try {
        result = await res.json();
      } catch (parseErr) {
        result = null;
      }

      if (!res.ok || !result || result.emailStatus !== 'email_sent') {
        var errMsg = (result && result.message)
          ? result.message
          : 'E-Mail-Versand fehlgeschlagen: Der Server hat keine Detailmeldung geliefert (HTTP ' + res.status + ').';

        if (result && result.emailStatus === 'email_failed' && result.pdfStatus !== 'pdf_failed' && result.offerPdfUrl) {
          errMsg += ' Das PDF wurde erzeugt und ist hier abrufbar: ' + result.offerPdfUrl;
        }

        throw new Error(errMsg);
      }

      trackEvent('lead_submit_success', {
        leadId: result.leadId,
        designId: payload.frontDesignId
      });
      setLeadMessage('Das PDF-Angebot wurde an ' + email + ' gesendet.', 'success');
      if(window.optileanOfferOrderJourney)window.optileanOfferOrderJourney.show(dom.leadMessage(),Object.assign({},result,{hasShadowwall:true}));
      toast('PDF-Angebot erfolgreich versendet', 'success');
      if (emailInput) emailInput.value = email;
      window.location.assign('/pages/anfrage-danke?source=pdf');
    } catch (err) {
      console.error('[SBC] Lead-Funnel Fehler:', err);
      trackEvent('lead_submit_failed', {
        reason: err.message
      });
      setLeadMessage(err.message || 'Das PDF-Angebot konnte nicht versendet werden.', 'error');
      toast('PDF-Angebot konnte nicht versendet werden', 'error');
    } finally {
      setLeadLoading(false);
    }
  }

  function bindLeadOffer() {
    var toggleBtn = dom.btnLead();
    var form = dom.leadForm();
    var cancelBtn = dom.btnLeadCancel();

    if (toggleBtn) {
      toggleBtn.addEventListener('click', async function () {
        if (toggleBtn.disabled) return;
        var finalizeValidation = getFinalizationValidationMessage();
        if (finalizeValidation) {
          toast(finalizeValidation, 'error');
          return;
        }
        var nextOpen = !leadFunnelOpen;

        if (nextOpen) {
          pendingLeadAccessories = [];
          var upsell = await showAccessoryUpsell('lead');
          if (upsell.action === 'cancel') return;
          pendingLeadAccessories = upsell.accessories || [];
        }

        setLeadFunnelOpen(nextOpen);
        if (nextOpen) {
          trackEvent('lead_cta_opened', {
            size: getSizeLabel(),
            mounting: getMountingLabel()
          });
        }
      });
    }

    if (cancelBtn) {
      cancelBtn.addEventListener('click', function () {
        setLeadFunnelOpen(false);
      });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        submitLeadOffer();
      });
    }
  }

  function bindAddToCart() {
    const btn = dom.btnCart();
    const actionTarget = dom.btnCartWrap() || btn;
    if (!btn) return;

    actionTarget.addEventListener('click', async function (event) {
      var cartDesignId = null;
      var cartBackDesignId = null;
      var cartFailureTracked = false;
      try {
        var validationMessage = getDesignValidationMessage() || getFinalizationValidationMessage();
        if (validationMessage) {
          if (event) event.preventDefault();
          showCartBlockedToast(validationMessage);
          return;
        }

        if (btn.disabled) return;

        var finalizeValidation = getFinalizationValidationMessage();
        if (finalizeValidation) throw new Error(finalizeValidation);

        if (!confirmSingleSidedMountingForCart()) return;

        var upsell = await showAccessoryUpsell('cart');
        if (upsell.action === 'cancel') return;

        setCartLoading(true);

        var isTwoSides = (selectedMounting !== 'wall' && selectedMountingSides === 2);
        if (!confirmEmptyBacksideForAction('den Warenkorb')) {
          setCartLoading(false);
          return;
        }

        var persisted = await persistCurrentDesigns({ isDraft: false });
        var idF = persisted.front && persisted.front.designId;
        var prevF = persisted.front && persisted.front.previewUrl;
        var idB = persisted.back && persisted.back.designId;
        var prevB = persisted.back && persisted.back.previewUrl;
        cartDesignId = idF || null;
        cartBackDesignId = idB || null;

        if (!idF) {
          throw new Error('Vorderseite konnte nicht gespeichert werden.');
        }
        if (isTwoSides && !idB) {
          throw new Error('Rückseite konnte nicht gespeichert werden.');
        }

        // ANALYTICS: Checkout Tracken
        trackEvent('checkout', { designId: idF, amount: isTwoSides ? 2 : 1 });

        // Zum Shopify-Warenkorb hinzufügen
        trackEvent('cart_add_started', { designId: idF, backDesignId: idB || null, amount: isTwoSides ? 2 : 1 });
        await shopifyAddToCart(idF, prevF, idB, prevB, (upsell.items || []).concat(buildFinalizeCartItems()));

        var cartCheck = await verifyCartContainsDesign(idF, isTwoSides ? idB : null);
        if (!cartCheck.ok) {
          trackEvent('cart_add_failed', {
            designId: idF,
            backDesignId: idB || null,
            reason: cartCheck.reason || 'missing_design_properties',
            itemCount: cartCheck.itemCount || 0
          });
          cartFailureTracked = true;
          throw new Error('Design wurde gespeichert, aber Shopify hat die Design-ID nicht im Warenkorb übernommen. Bitte erneut versuchen. Design-ID: ' + idF);
        }

        trackEvent('cart_add_success', {
          designId: idF,
          backDesignId: idB || null,
          itemCount: cartCheck.itemCount || 0
        });

        var quantityDiscount = getQuantityDiscountSnapshot();
        var discountCode = quantityDiscount && quantityDiscount.discountCode ? String(quantityDiscount.discountCode).trim() : '';
        if (discountCode) {
          var discountResult = await applyQuantityDiscountToCart(discountCode);
          if (!discountResult.applied) {
            toast('Mengenrabatt wurde nicht angewendet. Bitte Shopify-Code im Backend prüfen.', 'error', {
              duration: 6500,
              key: 'quantity-discount-not-applied'
            });
            console.warn('[SBC] Mengenrabatt nicht im Cart gefunden:', discountCode, discountResult.cart);
          }
        } else if (quantityDiscount) {
          toast('Für den Warenkorb fehlt der Shopify-Rabattcode zur Mengenstaffel.', 'error', {
            duration: 6500,
            key: 'quantity-discount-missing-code'
          });
        }
        toast('Design wurde in den Warenkorb gelegt!', 'success');
        setTimeout(function () { window.location.href = getShopifyCartEndpoint('cart'); }, 900);
      } catch (err) {
        console.error('[SBC] Cart error:', err);
        if (!cartFailureTracked) {
          trackEvent('cart_add_failed', {
            designId: cartDesignId,
            backDesignId: cartBackDesignId,
            reason: err && err.message ? err.message : 'unknown'
          });
        }
        var message = 'Fehler beim Hinzufügen zum Warenkorb:\n' + err.message;
        if (cartDesignId) {
          message += '\n\nDas Design wurde im Backend gespeichert.\nDesign-ID: ' + cartDesignId + '\nBitte diese ID notieren, falls du den Vorgang nicht erneut starten möchtest.';
        }
        alert(message);
        toast('Warenkorb konnte nicht korrekt erstellt werden — bitte erneut versuchen', 'error');
        setCartLoading(false);
      }
    });
  }
  function setCartLoading(loading) {
    const btn = dom.btnCart();
    const label = dom.btnCartLabel();
    const spinner = dom.btnCartSpinner();
    if (!btn) return;

    cartLoading = !!loading;
    btn.disabled = cartLoading;
    btn.setAttribute('aria-busy', cartLoading ? 'true' : 'false');
    if (label) label.style.display = loading ? 'none' : '';
    if (spinner) spinner.style.display = loading ? '' : 'none';
    if (!cartLoading) updateCartButton();
  }

  /** Logo-Bild als Data-URL für Backend/SVG: aus imageData, aus Bild-Element oder durch Rendern auf Temp-Canvas. */
  function getLogoDataUrl(fabricLogoObj) {
    if (!fabricLogoObj || fabricLogoObj.objectType !== 'logo') return Promise.resolve(null);
    var dataUrl = getObjectImageSource(fabricLogoObj);
    if (dataUrl && typeof dataUrl === 'string' && /^data:image\//i.test(dataUrl)) return Promise.resolve(dataUrl);
    var el = fabricLogoObj._element || (fabricLogoObj.get && fabricLogoObj.get('_element'));
    if (el && el.src && typeof el.src === 'string' && /^data:image\//i.test(el.src)) return Promise.resolve(el.src);
    return new Promise(function (resolve) {
      fabricLogoObj.clone(function (errOrClone, maybeClone) {
        var clone = maybeClone !== undefined ? maybeClone : errOrClone;
        if (!clone) {
          if (errOrClone) console.warn('[SBC] Logo-Clone fehlgeschlagen:', errOrClone);
          return resolve(null);
        }
        try {
          var w = Math.max(1, Math.ceil(fabricLogoObj.getScaledWidth()));
          var h = Math.max(1, Math.ceil(fabricLogoObj.getScaledHeight()));
          var tmpEl = document.createElement('canvas');
          tmpEl.width = w;
          tmpEl.height = h;
          var tmpCanvas = new fabric.Canvas(tmpEl, { renderOnAddRemove: false });
          tmpCanvas.setDimensions({ width: w, height: h });
          clone.set({ left: w / 2, top: h / 2, originX: 'center', originY: 'center', angle: 0 });
          tmpCanvas.add(clone);
          tmpCanvas.renderAll();
          var out = tmpCanvas.toDataURL({ format: 'png' });
          tmpCanvas.dispose();
          resolve(out && /^data:image\//i.test(out) ? out : null);
        } catch (e) {
          console.warn('[SBC] Logo Data-URL konnte nicht erzeugt werden:', e);
          resolve(null);
        }
      });
    });
  }

  function delay(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function isRetryableDesignSaveError(err) {
    var msg = String((err && err.message) || err || '').toLowerCase();
    return msg.includes('load failed') ||
      msg.includes('failed to fetch') ||
      msg.includes('networkerror') ||
      msg.includes('network request failed') ||
      msg.includes('backend http 413') ||
      msg.includes('backend http 429') ||
      msg.includes('backend http 502') ||
      msg.includes('backend http 503') ||
      msg.includes('backend http 504') ||
      msg.includes('abort');
  }

  async function postDesignRequest(url, bodyStr) {
    var controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var timeoutId = null;

    try {
      if (controller) {
        timeoutId = setTimeout(function () {
          controller.abort();
        }, 45000);
      }

      return await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: bodyStr,
        signal: controller ? controller.signal : undefined,
      });
    } finally {
      if (timeoutId) clearTimeout(timeoutId);
    }
  }

  /* ==========================================
     BACKEND COMMUNICATION
     ========================================== */

  async function sendDesignToBackend(sideFilter, siblingId, isDraft, draftId) {
    sideFilter = sideFilter || 'front';
    var payload = preparePayload(sideFilter);
    var sideColor = getBoardColorForSide(sideFilter);

    // Canvas als Base64 für hochauflösendes Preview
    var canvasExport = null;
    var previousZoom = zoomLevel;
    var previousViewport = canvas && canvas.viewportTransform ? canvas.viewportTransform.slice() : null;
    try {
      // Selektion entfernen damit keine blauen Handles im Bild landen
      canvas.discardActiveObject();
      if (zoomLevel !== 1) setZoom(1);
      canvas.renderAll(); // SYNCHRON – muss fertig sein bevor getElement()

      var fabricEl = canvas.getElement();
      var tempCanvas = document.createElement('canvas');
      tempCanvas.width = Math.min(fabricEl.width, 1400);
      var ratio = fabricEl.height / fabricEl.width;
      tempCanvas.height = Math.round(tempCanvas.width * ratio);
      var ctx = tempCanvas.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
      ctx.drawImage(fabricEl, 0, 0, tempCanvas.width, tempCanvas.height);
      canvasExport = tempCanvas.toDataURL('image/jpeg', 0.9);
      console.log('[SBC] Canvas-Export OK:', Math.round(canvasExport.length / 1024), 'KB');
    } catch (e) {
      console.warn('[SBC] Canvas-Export fehlgeschlagen (CORS?):', e.message);
      // Kein canvasExport → Backend generiert Preview aus SVG
    } finally {
      if (previousViewport && previousZoom !== 1) {
        zoomLevel = previousZoom;
        canvas.setViewportTransform(previousViewport);
        var zoomEl = document.getElementById('sbc-zoom-level');
        if (zoomEl) zoomEl.textContent = Math.round(zoomLevel * 100) + '%';
        canvas.requestRenderAll();
      }
    }

    // Objektliste für Backend; Logos behalten mindestens ihre URL und werden serverseitig eingebettet.
    var objectsForBackend = [];
    for (var idx = 0; idx < payload.filteredObjects.length; idx++) {
      var item = payload.summary[idx];
      var obj = payload.filteredObjects[idx];
      if (!obj || item.t !== 'logo') {
        objectsForBackend.push(item);
        continue;
      }
      var out = { t: item.t, x: item.x, y: item.y, w: item.w, h: item.h, a: item.a, id: item.id };
      var logoDataUrl = await getLogoDataUrl(obj);
      var logoSource = logoDataUrl || getObjectImageSource(obj) || item.src || '';
      if (logoSource) out.src = logoSource;
      var logoTrim = item.logoTrim || getLogoTrimForObject(obj);
      if (logoTrim) out.logoTrim = logoTrim;
      objectsForBackend.push(out);
    }

    var designObj = {
      v: 1,
      bw: CFG.boardWidthMm,
      bh: CFG.boardHeightMm,
      configuratorMode: configuratorMode,
      toolBrand: selectedToolBrand || null,
      customSize: selectedSizeIsCustom === true,
      priceSizeKey: getEffectiveProductSizeKey(CFG.boardWidthMm, CFG.boardHeightMm),
      priceMultiplier: getBoardPriceMultiplier(),
      cw: canvas.width,
      ch: canvas.height,
      o: objectsForBackend,
      bg: sideColor ? getColorMeta(sideColor).hex : (canvas.backgroundColor || '#ffffff'),
      boardColor: sideColor, // Send color key to backend
      frontColor: selectedColor,
      backColor: selectedBackColor,
      surfaceType: selectedSurfaceType,
      quantity: getSelectedQuantity(),
      quantityDiscount: getQuantityDiscountSnapshot(),
      holderType: selectedHolderType,
      mountingAddons: getSelectedFinalizeAddonKeys(),
      m: selectedMounting,
      ms: selectedMountingSides,
      customerId: CFG.customerId, // Send Customer ID
      side: sideFilter,
      isDraft: isDraft === true,
      draftId: isDraft === true ? normalizeDesignIdForDraft(draftId) : null,
      specialInfo: loadedDraftSpecialInfo || '',
      siblingId: siblingId || null
    };

    var url = CFG.backendUrl.replace(/\/+$/, '') + '/api/designs';
    console.log('[SBC] Sende Design an:', url);

    var baseBodyData = {
      design: designObj,
      boardWidth: CFG.boardWidthMm,
      boardHeight: CFG.boardHeightMm,
      customerId: CFG.customerId,
      isDraft: isDraft === true,
      draftId: isDraft === true ? normalizeDesignIdForDraft(draftId) : null,
      specialInfo: loadedDraftSpecialInfo || '',
    };
    var requestVariants = [];

    if (canvasExport) {
      requestVariants.push({
        label: 'mit Canvas-Preview',
        body: Object.assign({}, baseBodyData, { canvasExport: canvasExport })
      });
    }
    requestVariants.push({
      label: 'ohne Canvas-Preview',
      body: Object.assign({}, baseBodyData)
    });

    var lastErr = null;

    for (var variantIndex = 0; variantIndex < requestVariants.length; variantIndex++) {
      var variant = requestVariants[variantIndex];
      var bodyStr = JSON.stringify(variant.body);
      console.log('[SBC] Request-Body Größe (' + variant.label + '):', Math.round(bodyStr.length / 1024), 'KB');

      for (var attempt = 1; attempt <= 2; attempt++) {
        try {
          var res = await postDesignRequest(url, bodyStr);

          if (!res.ok) {
            var errBody = '';
            try { errBody = await res.text(); } catch (e) { }
            console.error('[SBC] Backend Antwort:', res.status, errBody);
            throw new Error('Backend HTTP ' + res.status + ': ' + errBody);
          }

          if (variantIndex > 0 || attempt > 1) {
            console.warn('[SBC] Design-Save erfolgreich nach Retry/Fallback:', variant.label, 'Versuch', attempt);
          }
          return await res.json();
        } catch (err) {
          lastErr = err;
          var shouldRetry = isRetryableDesignSaveError(err);
          var hasMoreAttempts = attempt < 2;
          if (shouldRetry && hasMoreAttempts) {
            console.warn('[SBC] Retry Design-Save:', variant.label, 'Versuch', attempt, 'Fehler:', err.message);
            await delay(400 * attempt);
            continue;
          }
          break;
        }
      }
    }

    throw lastErr || new Error('Design konnte nicht gespeichert werden');
  }

  /* ==========================================
     SALAMI TAKTIK – Chunking
     ========================================== */

  function preparePayload(sideFilter) {
    sideFilter = sideFilter || 'front';
    var sideColor = getBoardColorForSide(sideFilter);
    // Kompaktes Format: nur essentielle Daten pro Objekt
    var objects = canvas.getObjects();
    var compactObjects = [];
    var filteredObjects = [];

    objects.forEach(function (obj) {
      if (obj.isBackground || isCanvasHelperObject(obj)) return;
      var objSide = obj.sbcSide || 'front';
      if (objSide !== sideFilter) return;

      filteredObjects.push(obj);

      var item = {
        t: obj.objectType || 'unknown',   // type
        x: Math.round(obj.left),           // position x
        y: Math.round(obj.top),            // position y
        w: Math.round(obj.getScaledWidth()),  // actual width
        h: Math.round(obj.getScaledHeight()), // actual height
        a: Math.round(obj.angle || 0),     // angle
      };

      // Typ-spezifische Daten
      if (obj.objectType === 'shadow-tool' && obj.toolId) {
        item.id = obj.toolId;
        if (obj.sbcBristle) item.bristle = obj.sbcBristle;
        item.cat = obj.toolCategory || '';
        item.sc = isScalableShadowTool(obj) === true;
      }
      if (obj.objectType === 'text' || obj.objectType === 'custom-text' || obj.type === 'i-text') {
        item.txt = obj.text || '';
        item.fs = Math.round(obj.fontSize || 20);
        var textPointSize = getTextPointSize(obj);
        if (textPointSize) {
          item.fpt = Math.round(textPointSize);
          item.fontPt = item.fpt;
        }
        item.ff = obj.fontFamily || 'Inter, sans-serif';
        item.fontFamily = obj.fontFamily || 'Inter, sans-serif';
        item.fontId = obj.fontId || '';
        item.fontUrl = obj.fontUrl || '';
        item.fw = obj.fontWeight || '400';
        item.fst = obj.fontStyle || 'normal';
        item.ul = obj.underline === true;
        item.lh = Number(obj.lineHeight || 1.16);
        item.ta = normalizeTextAlignment(obj.textAlign || 'left');
        item.fc = obj.fill || '#000000';
        item.fckey = obj.textColorKey || '';
        item.fclabel = obj.textColorLabel || '';
        if (obj.textColorCmyk) item.fcmyk = normalizeCmyk(obj.textColorCmyk);
	        item.c = obj.curvature || 0; // Curvature
	        item.sx = Number(obj.scaleX || 1);
	        item.sy = Number(obj.scaleY || 1);
	        item.originX = obj.originX || 'left';
	        item.originY = obj.originY || 'top';
	      }
      if (obj.objectType === 'logo') {
        item.id = obj.toolId || uid();
        var logoTrim = getLogoTrimForObject(obj);
        if (logoTrim) item.logoTrim = logoTrim;
        // Logo-Bilder werden NICHT im Warenkorb gespeichert (zu groß)
        // Stattdessen nur Referenz – Bilder kommen später per Backend
      }

      compactObjects.push(item);
    });

    console.log('[SBC] Prepared Payload Objects:', compactObjects);

    var payload = {
      v: 1,                          // Version
      bw: CFG.boardWidthMm,          // Board-Breite mm
      bh: CFG.boardHeightMm,         // Board-Höhe mm
      cs: selectedSizeIsCustom === true, // Sondermaß aktiv
      customSize: selectedSizeIsCustom === true,
      cm: configuratorMode,
      configuratorMode: configuratorMode,
      tb: selectedToolBrand || null,
      toolBrand: selectedToolBrand || null,
      priceSizeKey: getEffectiveProductSizeKey(CFG.boardWidthMm, CFG.boardHeightMm),
      priceMultiplier: getBoardPriceMultiplier(),
      cw: canvas.width,              // Canvas-Breite px
      ch: canvas.height,             // Canvas-Höhe px
      bg: sideColor ? getColorMeta(sideColor).hex : '#ffffff', // Hintergrundfarbe Hex
      boardColor: sideColor,     // Color Key
      frontColor: selectedColor,
      backColor: selectedBackColor,
      surfaceType: selectedSurfaceType,
      quantity: getSelectedQuantity(),
      quantityDiscount: getQuantityDiscountSnapshot(),
      holderType: selectedHolderType,
      mountingAddons: getSelectedFinalizeAddonKeys(),
      o: compactObjects              // Objekte
    };

    // Chunk the compact JSON string
    var str = JSON.stringify(payload);
    var chunks = [];
    for (var i = 0; i < str.length; i += CHUNK_SIZE) {
      chunks.push(str.slice(i, i + CHUNK_SIZE));
    }

    console.log('[SBC] Payload kompakt:', str.length, 'Zeichen →', chunks.length, 'Chunks');

    return { chunks: chunks, summary: compactObjects, filteredObjects: filteredObjects };
  }

  function normalizeCartLineProperties(properties) {
    if (!properties) return {};
    if (!Array.isArray(properties)) return properties;

    return properties.reduce(function (acc, prop) {
      if (!prop) return acc;
      var key = prop.name || prop.key;
      if (!key) return acc;
      acc[key] = prop.value;
      return acc;
    }, {});
  }

  function cartPropertiesIncludeDesignId(properties, keys, expectedDesignId) {
    if (!expectedDesignId) return true;
    var props = normalizeCartLineProperties(properties);
    return keys.some(function (key) {
      return String(props[key] || '').trim() === String(expectedDesignId).trim();
    });
  }

  async function verifyCartContainsDesign(idFront, idBack) {
    try {
      var res = await fetch(getShopifyCartEndpoint('cart.js'), {
        headers: { 'Accept': 'application/json' },
        cache: 'no-store'
      });

      if (!res.ok) {
        return { ok: false, reason: 'cart_fetch_http_' + res.status, itemCount: 0 };
      }

      var cart = await res.json();
      var items = Array.isArray(cart && cart.items) ? cart.items : [];
      var matchingItem = items.find(function (item) {
        var props = item && item.properties;
        var hasFront = cartPropertiesIncludeDesignId(props, ['_Design_ID', 'Design-ID'], idFront);
        var hasBack = !idBack || cartPropertiesIncludeDesignId(props, ['_Design_ID_Rückseite', 'Design-ID Rückseite'], idBack);
        return hasFront && hasBack;
      });

      return {
        ok: !!matchingItem,
        reason: matchingItem ? 'ok' : 'missing_design_properties',
        itemCount: items.length
      };
    } catch (err) {
      console.warn('[SBC] Cart-Verifikation fehlgeschlagen:', err);
      return {
        ok: false,
        reason: err && err.message ? 'cart_verify_error: ' + err.message : 'cart_verify_error',
        itemCount: 0
      };
    }
  }

  async function shopifyAddToCart(idFront, previewFront, idBack, previewBack, accessoryItems, prepareOnly) {
    var isTwoSides = (selectedMounting !== 'wall' && selectedMountingSides === 2);

    if (!syncSelectedProductForSurface({ fallbackToBasic: false })) {
      throw new Error('Für diese Größe und Oberfläche ist noch kein Shopify-Produkt konfiguriert.');
    }

    // Variant-ID prüfen
    if (!selectedVariant || !selectedVariant.id) {
      throw new Error('Keine Farbvariante ausgewählt. Bitte gehe zurück und wähle eine Größe und Farbe.');
    }

    var cartVariantId = selectedVariant.id; // By default, use the board variant

    var items = [];
    var props = {};

    var dataF = preparePayload('front');
    var dataB = isTwoSides ? preparePayload('back') : null;

    props['_Cart_ID'] = Date.now().toString() + '_' + Math.random().toString(36).substr(2, 5);
    props['Konfigurator'] = isToolWallMode() ? 'Werkzeugwand' : 'Schattenwand';
    if (isToolWallMode() && selectedToolBrand) {
      props['Werkzeughersteller'] = getToolBrandLabel(selectedToolBrand);
    }
    props['Größe'] = getSizeLabel();
    var priceMultiplier = getBoardPriceMultiplier();
    if (selectedSizeIsCustom) {
      props['Größenart'] = 'Sondermaß';
      props['Preisgröße'] = getPriceSizeLabel();
      props['_SBC_Price_Size_Key'] = getEffectiveProductSizeKey(CFG.boardWidthMm, CFG.boardHeightMm);
      props['_SBC_Price_Multiplier'] = String(priceMultiplier);
      if (priceMultiplier > 1) props['Preisfaktor'] = priceMultiplier + '×';
    }
    props['Oberfläche'] = getSurfaceLabel();
    props['Menge'] = String(getSelectedQuantity());
    var quantityDiscount = getQuantityDiscountSnapshot();
    if (quantityDiscount) {
      props['Mengenrabatt'] = quantityDiscount.label + ' (' + quantityDiscount.percent + '% / -' + quantityDiscount.amountLabel + ')';
      if (quantityDiscount.discountCode) props['Rabattcode'] = quantityDiscount.discountCode;
    }
    props['Halterung'] = getSelectedHolderLabel();
    var finalizeAddonLabels = getSelectedFinalizeAddonProducts().map(getFinalizeProductLabel);
    if (finalizeAddonLabels.length > 0) {
      props['Wandmontage-Zubehör'] = finalizeAddonLabels.join(', ');
    }
    if (getSelectedFinalizeAddonKeys().indexOf('adhesive') !== -1) {
      props['Verarbeitung Wandmontage'] = 'Klebemontage (flach/gesenkt)';
    }
    if (isTwoSides) {
      props['Farbe Vorderseite'] = getBoardColorLabelForSide('front');
      props['Farbe Rückseite'] = getBoardColorLabelForSide('back');
    } else if (selectedColor) {
      props['Farbe'] = getColorMeta(selectedColor).label;
    }

    if (selectedMounting !== 'wall') {
      props['Montageart'] = getMountingLabel();
      props['Ausführung'] = isTwoSides ? 'Beidseitig gestaltet' : '1 Seite gestaltet';
    }

    var designPdfUrl = CFG.backendUrl
      ? CFG.backendUrl.replace(/\/+$/, '') + '/api/designs/' + idFront + '/pdf'
      : '';
    var designSvgUrl = CFG.backendUrl
      ? CFG.backendUrl.replace(/\/+$/, '') + '/api/designs/' + idFront + '/svg'
      : '';

    // FRONT properties
    props['_Design_ID'] = idFront;
    props['Design-ID'] = idFront;
    if (designPdfUrl) props['Druckdatei (PDF)'] = designPdfUrl;
    if (designSvgUrl) props['_SVG_URL'] = designSvgUrl;

    if (previewFront && CFG.backendUrl) {
      props['_Preview_Image'] = previewFront;
      props['Design-Vorschau'] = previewFront;
    }

    // BACK properties
    if (isTwoSides) {
      var backPdfUrl = CFG.backendUrl
        ? CFG.backendUrl.replace(/\/+$/, '') + '/api/designs/' + idBack + '/pdf'
        : '';
      props['_Design_ID_Rückseite'] = idBack;
      props['Design-ID Rückseite'] = idBack;
      if (backPdfUrl) props['PDF (Rückseite)'] = backPdfUrl;
      if (previewBack && CFG.backendUrl) {
        props['Vorschau (Rückseite)'] = previewBack;
      }
    }

    // JSON Chunks for local re-editing (only front to avoid exceeding 45 props)
    if (dataF.chunks.length <= 30) {
      dataF.chunks.forEach(function (chunk, i) { props['_json_p' + (i + 1)] = chunk; });
      props['_json_chunks'] = String(dataF.chunks.length);
    }

    // Front Preview Thumb
    var oldSide = currentSide;
    if (currentSide !== 'front') {
      switchSide('front');
    }

    var thumbDataUrl = generatePreviewDataUrl();
    if (thumbDataUrl && thumbDataUrl.length <= 950) {
      props['_preview'] = thumbDataUrl;
    } else if (thumbDataUrl) {
      var half = Math.ceil(thumbDataUrl.length / 2);
      props['_preview_1'] = thumbDataUrl.slice(0, half);
      props['_preview_2'] = thumbDataUrl.slice(half);
    }

    var largePreviewF = generateLargePreviewDataUrl();
    if (largePreviewF) {
      try {
        var previews = JSON.parse(localStorage.getItem('sbc_previews') || '{}');
        previews[props['_Cart_ID']] = largePreviewF;
        localStorage.setItem('sbc_previews', JSON.stringify(previews));
      } catch (e) { }
    }

    if (currentSide !== oldSide) {
      switchSide(oldSide);
    }

    // Configuration Summary
    var tools = 0, logos = 0, texts = 0;
    dataF.summary.forEach(function (item) {
      if (item.t === 'shadow-tool') tools++;
      else if (item.t === 'logo') logos++;
      else if (item.t === 'text' || item.t === 'custom-text') texts++;
    });
    if (dataB) {
      dataB.summary.forEach(function (item) {
        if (item.t === 'shadow-tool') tools++;
        else if (item.t === 'logo') logos++;
        else if (item.t === 'text' || item.t === 'custom-text') texts++;
      });
    }
    var parts = [];
    if (tools > 0) parts.push(tools + ' Werkzeug' + (tools > 1 ? 'e' : ''));
    if (logos > 0) parts.push(logos + ' Logo' + (logos > 1 ? 's' : ''));
    if (texts > 0) parts.push(texts + ' Text' + (texts > 1 ? 'e' : ''));
    props['Konfiguration'] = parts.join(', ') || 'Leere Schattenwand';

    // If a mounting is selected, use the matching mounting variant so the price is correct
    if (selectedMounting && selectedMounting !== 'wall') {
      var mountingEntry = getMountingEntry(selectedMounting, selectedMountingSides, selectedSurfaceType);
      if (!mountingEntry || !mountingEntry.variants || mountingEntry.variants.length === 0) {
        throw new Error('Für diese Montageart und Oberfläche ist noch kein Shopify-Produkt konfiguriert.');
      }
      cartVariantId = mountingEntry.variants[0].id;
    }

    var linePriceMultiplier = selectedMounting && selectedMounting !== 'wall' ? 1 : priceMultiplier;

    items.push({
      id: parseInt(cartVariantId),
      quantity: getSelectedQuantity() * linePriceMultiplier,
      properties: props
    });

    if (accessoryItems && accessoryItems.length > 0) {
      accessoryItems.forEach(function (item) {
        if (item && item.id && item.quantity > 0) {
          items.push(item);
        }
      });
    }

    items.forEach(function (item, index) {
      item.properties = Object.assign({}, item.properties, {
        '_SBC_Group_ID': props['_Cart_ID'],
        '_SBC_Group_Role': index === 0 ? 'board' : (/edelstahlhalter/i.test(String(item.properties && item.properties['Zusatzartikel'] || '')) ? 'holder' : 'product')
      });
    });

    if (prepareOnly === true) return items;

    var res = await fetch(getShopifyCartEndpoint('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    });

    if (!res.ok) {
      var cartError = await readShopifyErrorResponse(res);
      console.error('[SBC] Shopify cart response:', cartError.parsed || cartError.text);
      throw new Error('Shopify Warenkorb-Fehler ' + res.status + ': ' + cartError.message);
    }

    return res.json();
  }

  /* ==========================================
     TOAST NOTIFICATIONS
     ========================================== */

  function showCartBlockedToast(message) {
    toast(message || 'Bitte prüfe deine Konfiguration.', 'error', {
      duration: 5200,
      key: 'cart-blocked'
    });
  }

  function showProfessionalCheckPopup() {
    const container = dom.toastContainer();
    if (!container) return;

    $$('.sbc-professional-check[data-toast-key="finalize-professional-check"], .sbc-toast[data-toast-key="finalize-professional-check"]').forEach(function (existing) {
      existing.remove();
    });

    const duration = 8000;
    const el = document.createElement('div');
    el.className = 'sbc-professional-check';
    el.dataset.toastKey = 'finalize-professional-check';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-label', 'Profi-Check inklusive. Klicken oder hovern pausiert den Hinweis.');
    el.tabIndex = 0;
    el.style.setProperty('--sbc-progress-deg', '360deg');
    el.innerHTML =
      '<span class="sbc-professional-check__timer" aria-hidden="true"></span>' +
      '<div class="sbc-professional-check__header">' +
        '<span class="sbc-professional-check__check" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" focusable="false"><path d="M20 6 9 17l-5-5" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</span>' +
        '<div class="sbc-professional-check__copy">' +
          '<div class="sbc-professional-check__title-row">' +
            '<strong>Profi-Check inklusive</strong>' +
            '<span>Inklusive</span>' +
          '</div>' +
          '<p>Jede Gestaltung wird vor der Produktion von unserem Team geprüft.</p>' +
        '</div>' +
      '</div>' +
      '<div class="sbc-professional-check__divider" aria-hidden="true"></div>' +
      '<div class="sbc-professional-check__benefits" aria-hidden="true">' +
        '<div><span><svg viewBox="0 0 24 24" focusable="false"><path d="M20 21a8 8 0 0 0-16 0M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></span><strong>Persönliche<br>Prüfung</strong></div>' +
        '<div><span><svg viewBox="0 0 24 24" focusable="false"><path d="m12 3 2.6 5.2 5.8.8-4.2 4.1 1 5.8L12 16.2 6.8 19l1-5.8L3.6 9l5.8-.8L12 3Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M12 11.2v3.1M10.5 12.8h3" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></span><strong>Qualität & Funktion<br>im Fokus</strong></div>' +
        '<div><span><svg viewBox="0 0 24 24" focusable="false"><path d="M12 3 20 6v5.8c0 4.9-3.4 7.8-8 9.2-4.6-1.4-8-4.3-8-9.2V6l8-3Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="m8.8 12 2.1 2.1 4.4-4.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span><strong>Mehr Sicherheit<br>für dein Projekt</strong></div>' +
      '</div>';

    container.appendChild(el);

    let startedAt = performance.now();
    let pausedAt = 0;
    let pausedTotal = 0;
    let isPaused = false;
    let lockedPause = false;
    let removed = false;
    let frameId = 0;

    function setPaused(nextPaused, lock) {
      if (removed) return;
      const now = performance.now();

      if (lock === true) lockedPause = true;
      if (lock === false) lockedPause = false;

      if (nextPaused && !isPaused) {
        isPaused = true;
        pausedAt = now;
        el.dataset.paused = 'true';
      } else if (!nextPaused && isPaused) {
        pausedTotal += now - pausedAt;
        pausedAt = 0;
        isPaused = false;
        delete el.dataset.paused;
      }
    }

    function removePopup() {
      if (removed) return;
      removed = true;
      cancelAnimationFrame(frameId);
      el.classList.add('sbc-toast--exit');
      el.addEventListener('animationend', function () {
        el.remove();
      }, { once: true });
      setTimeout(function () {
        if (el.parentNode) el.remove();
      }, 320);
    }

    function tick(now) {
      if (removed) return;
      const effectivePaused = isPaused ? now - pausedAt : 0;
      const elapsed = Math.max(0, now - startedAt - pausedTotal - effectivePaused);
      const remaining = Math.max(0, duration - elapsed);
      el.style.setProperty('--sbc-progress-deg', (remaining / duration * 360).toFixed(2) + 'deg');

      if (remaining <= 0) {
        removePopup();
        return;
      }

      frameId = requestAnimationFrame(tick);
    }

    el.addEventListener('mouseenter', function () { setPaused(true); });
    el.addEventListener('mouseleave', function () {
      if (!lockedPause) setPaused(false);
    });
    el.addEventListener('focus', function () { setPaused(true); });
    el.addEventListener('blur', function () {
      if (!lockedPause) setPaused(false);
    });
    el.addEventListener('click', function () {
      if (lockedPause) {
        setPaused(false, false);
      } else {
        setPaused(true, true);
      }
    });

    frameId = requestAnimationFrame(tick);
  }

  function toast(msg, type, options) {
    options = options || {};
    const container = dom.toastContainer();
    if (!container) return;

    if (options.key) {
      $$('.sbc-toast[data-toast-key="' + options.key + '"]', container).forEach(function (existing) {
        existing.remove();
      });
    }

    const el = document.createElement('div');
    el.className = 'sbc-toast' + (type ? ' sbc-toast--' + type : '');
    el.textContent = msg;
    if (options.key) el.dataset.toastKey = options.key;
    container.appendChild(el);

    setTimeout(function () {
      el.classList.add('sbc-toast--exit');
      el.addEventListener('animationend', function () { el.remove(); });
    }, options.duration || 2500);
  }

  /* ==========================================
     CANVAS PREVIEW
     ========================================== */

  function generatePreviewDataUrl() {
    // Winziges Thumbnail generieren das in Shopify Cart Properties passt
    try {
      // Selektion entfernen damit keine blauen Handles im Bild landen
      canvas.discardActiveObject();
      clearSnapGuides(); // <-- Hides any active alignment grid/line
      canvas.renderAll(); // SYNCHRON – muss fertig sein bevor getElement()

      var ratio = canvas.height / canvas.width;
      // Sehr klein: ~60px breit → passt als Data-URL in ~800-900 Zeichen
      var pw = 60;
      var ph = Math.round(pw * ratio);

      var tempCanvas = document.createElement('canvas');
      tempCanvas.width = pw;
      tempCanvas.height = ph;
      var ctx = tempCanvas.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, pw, ph);

      var fabricEl = canvas.getElement();
      ctx.drawImage(fabricEl, 0, 0, pw, ph);

      // Sehr niedrige Qualität → kleiner Data-URL-String
      var dataUrl = tempCanvas.toDataURL('image/jpeg', 0.3);
      console.log('[SBC] Preview thumbnail:', dataUrl.length, 'Zeichen');
      return dataUrl;
    } catch (err) {
      console.warn('[SBC] Preview konnte nicht erstellt werden:', err);
      return null;
    }
  }

  function generateLargePreviewDataUrl() {
    // Hochwertiges Preview für localStorage – volle Canvas-Auflösung
    try {
      // Selektion entfernen damit keine blauen Handles im Bild landen
      canvas.discardActiveObject();
      clearSnapGuides(); // <-- Hides any active alignment grid/line
      canvas.renderAll(); // SYNCHRON – muss fertig sein bevor getElement()

      var fabricEl = canvas.getElement();
      var pw = Math.min(fabricEl.width, 1400);
      var ratio = canvas.height / canvas.width;
      var ph = Math.round(pw * ratio);

      var tempCanvas = document.createElement('canvas');
      tempCanvas.width = pw;
      tempCanvas.height = ph;
      var ctx = tempCanvas.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, pw, ph);
      ctx.drawImage(fabricEl, 0, 0, pw, ph);

      return tempCanvas.toDataURL('image/jpeg', 0.92);
    } catch (err) {
      return null;
    }
  }

  /* ==========================================
     UTILITIES
     ========================================== */

  function normalizeDesignIdForDraft(value) {
    var id = String(value || '').trim();
    return /^DES-[A-Z0-9]+$/i.test(id) ? id.toUpperCase() : null;
  }

  function setActiveDraftIdsFromRestore(state, options) {
    state = state || {};
    options = options || {};

    var draftId = normalizeDesignIdForDraft(options.draftId || state.draftId || state.id);
    var frontDraftId = normalizeDesignIdForDraft(options.frontDraftId || state.frontDraftId);
    var backDraftId = normalizeDesignIdForDraft(options.backDraftId || state.backDraftId);
    var restoredSide = String(options.loadedSide || options.draftSide || state.draftSide || state.side || '').toLowerCase();
    var hasDraftContext = options.isDraft === true || state.isDraft === true || draftId || frontDraftId || backDraftId;

    if (!hasDraftContext) {
      activeDraftIds.front = null;
      activeDraftIds.back = null;
      updateSaveAsNewDraftButton();
      return;
    }

    if (draftId) {
      if (restoredSide === 'back') backDraftId = backDraftId || draftId;
      else frontDraftId = frontDraftId || draftId;
    }

    activeDraftIds.front = frontDraftId || null;
    activeDraftIds.back = backDraftId || null;
    updateSaveAsNewDraftButton();
  }

  function getObjectImageSource(obj) {
    if (!obj) return '';
    return obj.imageData ||
      obj.src ||
      (obj.get && (obj.get('imageData') || obj.get('src'))) ||
      (obj._element && obj._element.src) ||
      '';
  }

  function uid() {
    return Math.random().toString(36).slice(2, 10);
  }

  function debounce(fn, ms) {
    let timer;
    return function () {
      clearTimeout(timer);
      const args = arguments;
      const ctx = this;
      timer = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  // ============ USER DESIGNS ============

  function loadUserDesigns() {
    if (!CFG.backendUrl || !CFG.customerId) return;

    fetch(CFG.backendUrl + '/api/designs/user/' + CFG.customerId)
      .then(r => r.json())
      .then(designs => {
        if (!designs || designs.length === 0) return;
        renderUserDesignsList(designs);
      })
      .catch(e => console.warn('[SBC] Kunde Designs Fehler:', e));
  }

  function renderUserDesignsList(designs) {
    // Insert "Meine Designs" section in Sidebar (e.g. before Footer or after Step 3)
    // We'll put it in a new panel at the bottom of the sidebar

    const sidebarInner = document.querySelector('.sbc-sidebar__inner');
    if (!sidebarInner) return;

    let container = document.getElementById('sbc-user-designs');
    if (!container) {
      container = document.createElement('div');
      container.id = 'sbc-user-designs';
      container.className = 'sbc-panel';
      container.style.marginTop = 'auto';
      container.style.borderTop = '1px solid #eee';

      const title = document.createElement('h3');
      title.style.margin = '16px 0 8px 0';
      title.style.fontSize = '14px';
      title.style.fontWeight = '600';
      title.textContent = 'Gespeicherte Designs';
      container.appendChild(title);

      const list = document.createElement('div');
      list.className = 'sbc-design-list';
      list.style.display = 'flex';
      list.style.flexDirection = 'column';
      list.style.gap = '8px';
      list.style.maxHeight = '200px';
      list.style.overflowY = 'auto';
      container.appendChild(list);

      sidebarInner.appendChild(container);
    }

    const list = container.querySelector('.sbc-design-list');
    list.innerHTML = '';

    designs.forEach(d => {
      const item = document.createElement('div');
      item.style.display = 'flex';
      item.style.alignItems = 'center';
      item.style.gap = '10px';
      item.style.padding = '8px';
      item.style.background = '#f9f9f9';
      item.style.borderRadius = '6px';
      item.style.cursor = 'pointer';

      const img = document.createElement('img');
      img.src = d.previewUrl;
      img.style.width = '40px';
      img.style.height = '40px';
      img.style.objectFit = 'contain';
      img.style.background = '#fff';
      img.style.borderRadius = '4px';

      const info = document.createElement('div');
      info.style.flex = '1';

      const date = new Date(d.updatedAt || d.createdAt).toLocaleDateString();
      const size = d.boardWidthMm + 'x' + d.boardHeightMm;

      info.innerHTML = `<div style="font-size:12px;font-weight:500">${size}mm</div><div style="font-size:10px;color:#666">${date}</div>`;

      item.appendChild(img);
      item.appendChild(info);

      item.addEventListener('click', () => loadDesign(d));

      list.appendChild(item);
    });
  }

  async function restoreDesignRecord(fullData, designData, toastMessage) {
    designData = designData || {};

    if (!fullData || !fullData.design) {
      throw new Error('Designdaten fehlen');
    }

    await restoreCompactDesign(fullData.design, {
      boardWidthMm: Number(designData.boardWidthMm) || Number(fullData.boardWidthMm) || fullData.design.bw || CFG.boardWidthMm,
      boardHeightMm: Number(designData.boardHeightMm) || Number(fullData.boardHeightMm) || fullData.design.bh || CFG.boardHeightMm,
      customSize: fullData.design.customSize === true || fullData.design.cs === true,
      configuratorMode: fullData.design.configuratorMode || fullData.design.cm,
      toolBrand: fullData.design.toolBrand || fullData.design.tb,
      boardColor: fullData.design.boardColor,
      frontColor: fullData.design.frontColor,
      bg: fullData.design.bg,
      backColor: fullData.design.backColor || fullData.design.boardBackColor,
      mounting: fullData.design.m,
      mountingSides: fullData.design.ms,
      surfaceType: fullData.design.surfaceType,
      quantity: fullData.design.quantity,
      holderType: fullData.design.holderType,
      mountingAddons: fullData.design.mountingAddons,
      specialInfo: fullData.specialInfo || fullData.design.specialInfo || designData.specialInfo || '',
      isDraft: fullData.isDraft === true,
      draftId: fullData.isDraft === true ? fullData.id : null,
      frontDraftId: fullData.isDraft === true && fullData.design.side !== 'back' ? fullData.id : fullData.design.siblingId,
      backDraftId: fullData.isDraft === true && fullData.design.side === 'back' ? fullData.id : null,
      loadedSide: fullData.design.side,
      toastMessage: toastMessage || 'Design geladen'
    });
    planningDraftName = fullData.name || designData.name || '';
    planningSavedAt = fullData.isDraft === true ? (fullData.updatedAt || fullData.createdAt || '') : '';
    planningSavedSignature = fullData.isDraft === true ? planningSignature() : null;
    refreshPlanningStatus();
  }

  async function fetchDesignRecordById(id, designData) {
    var safeId = normalizeDesignIdForDraft(id);
    if (!safeId || !CFG.backendUrl) {
      throw new Error('Design-URL fehlt');
    }

    var designUrl = (designData && designData.jsonUrl) || (CFG.backendUrl.replace(/\/+$/, '') + '/api/designs/' + encodeURIComponent(safeId));
    var response = await fetch(designUrl);
    if (!response.ok) {
      throw new Error('HTTP ' + response.status);
    }

    return response.json();
  }

  async function loadDesign(designData) {
    if (!confirm('Möchtest du dieses gespeicherte Design laden? Das aktuelle Design geht verloren.')) return;

    try {
      var fullData = await fetchDesignRecordById(designData && designData.id, designData);
      await restoreDesignRecord(fullData, designData, 'Design geladen');
    } catch (err) {
      console.error('[SBC] Fehler beim Laden des Designs:', err);
      toast('Gespeichertes Design konnte nicht geladen werden', 'error');
      alert('Gespeichertes Design konnte nicht geladen werden:\n' + err.message);
    }
  }

  function applyRestoredSelections(config) {
    var restoredConfiguratorMode = config.configuratorMode || config.cm || 'shadow-board';
    var restoredToolBrand = config.toolBrand || config.tb || '';
    setConfiguratorModeState(restoredConfiguratorMode, restoredToolBrand);

    var widthMm = Number(config.boardWidthMm) || CFG.boardWidthMm;
    var heightMm = Number(config.boardHeightMm) || CFG.boardHeightMm;
    var boardColor = resolveRestoredBoardColor(
      config.boardColor || config.frontColor || config.color || config.c,
      config.bg,
      selectedColor || 'white'
    );
    var backColor = normalizeBoardColorKey(
      config.backColor || config.boardBackColor || config.bc,
      boardColor
    );
    var mounting = isToolWallMode() ? 'wall' : (config.mounting || 'wall');
    var mountingSides = isToolWallMode() ? 1 : (Number(config.mountingSides) || 1);
    selectedSurfaceType = config.surfaceType === 'basic' ? 'basic' : 'premium';
    configuratorDefaultsApplied = true;
    selectedColor = boardColor;
    selectedBackColor = backColor;
    selectedBackColorCustomized = backColor !== boardColor;
    activeColorSide = 'front';
    setSelectedQuantity(config.quantity || 1);
    selectedHolderType = config.holderType || selectedHolderType || 'stainless';
    selectedFinalizeAddons = { dowels: false, adhesive: false, spacers: false, magnets: false, silicone: false };
    (Array.isArray(config.mountingAddons) ? config.mountingAddons : []).forEach(function (key) {
      if (key) selectedFinalizeAddons[key] = true;
    });
    normalizeFinalizeSelection();

    var restoredCustomSize = isToolWallMode() || config.customSize === true || config.cs === true;
    if (!restoredCustomSize && !getSizeOptionMeta(widthMm, heightMm) && !getFixedSizeButton(widthMm, heightMm)) {
      restoredCustomSize = true;
    }

    selectedSizeIsCustom = restoredCustomSize;
    var sizeBtn = restoredCustomSize ? null : getFixedSizeButton(widthMm, heightMm);

    if (sizeBtn) {
      sizeBtn.click();
    } else {
      $$('.sbc-size-option').forEach(function (btn) { btn.classList.remove('sbc-size-option--selected'); });
      if (restoredCustomSize) setCustomSizeCard(widthMm, heightMm, true);
      selectedSize = { w: widthMm, h: heightMm, custom: restoredCustomSize };
      CFG.boardWidthMm = widthMm;
      CFG.boardHeightMm = heightMm;
      resizeCanvas();
      applyBackgroundForCurrentSize();
    }

    var restoredSurfaceProduct = getProductForSizeSurface(widthMm, heightMm, selectedSurfaceType);
    selectedProduct = restoredSurfaceProduct
      || getProductForSizeSurface(widthMm, heightMm, 'basic')
      || getConfiguredProductForSize(widthMm, heightMm)
      || selectedProduct
      || (!selectedSizeIsCustom ? PRODUCTS[0] : null)
      || null;
    if (!restoredSurfaceProduct && selectedProduct) {
      selectedSurfaceType = selectedProduct.surfaceType === 'premium' ? 'premium' : 'basic';
    }

    var mountingBtn = document.querySelector('.sbc-mounting-option[data-mounting="' + mounting + '"]');
    if (mountingBtn) {
      mountingBtn.click();
    } else {
      selectedMounting = mounting;
      selectedMountingSides = mounting === 'wall' ? 1 : mountingSides;
    }

    if (mounting !== 'wall') {
      var sidesBtn = document.querySelector('.sbc-stand-option[data-sides="' + (mountingSides === 2 ? '2' : '1') + '"]');
      if (sidesBtn) {
        sidesBtn.click();
      } else {
        selectedMountingSides = mountingSides;
      }
    } else {
      selectedMountingSides = 1;
    }

    goToStep(3);
    renderColorOptions();

    var colorBtn = Array.from($$('.sbc-board-color-option')).find(function (btn) {
      return btn.dataset.backendColor === boardColor;
    });

    if (colorBtn) {
      colorBtn.click();
    } else {
      selectedColor = boardColor;
      selectedVariant = resolveVariantForColor(boardColor) || selectedVariant;
      applyBackgroundForCurrentSize();
    }

    // Einige UI-Handler setzen beim Wiederherstellen anhand der verfügbaren Varianten
    // einen Fallback. Danach die gespeicherten Farben erneut als Quelle der Wahrheit setzen.
    var restoredVariant = findProductVariantForColor(selectedProduct, boardColor);
    selectedColor = boardColor;
    selectedBackColor = backColor;
    selectedBackColorCustomized = backColor !== boardColor;
    selectedVariant = restoredVariant || selectedVariant;
    activeColorSide = 'front';
    renderColorOptions();
    selectedColor = boardColor;
    selectedBackColor = backColor;
    selectedBackColorCustomized = backColor !== boardColor;
    selectedVariant = restoredVariant || selectedVariant;
    $$('.sbc-board-color-option').forEach(function (btn) {
      btn.classList.toggle('sbc-board-color-option--selected', btn.dataset.backendColor === boardColor);
    });
    applyBackgroundForCurrentSize();

    goToStep(5);
    updateFinalizeStepUi();
    updateTotalPrice();
  }

  async function restoreCompactDesign(design, options) {
    options = options || {};
    isHydratingDesign = true;

    try {
      if (!design) {
        throw new Error('Leere Designdaten');
      }

      canvas.clear();
      customBoardBrandMark = null;
      customBoardBrandVariant = '';
      var restoredFrontColor = getRestoredFrontColorFromDesign(design, options);
      var restoredBackColor = getRestoredBackColorFromDesign(design, options, restoredFrontColor);
      loadedDraftSpecialInfo = String(options.specialInfo || design.specialInfo || '').slice(0, 2000);
      setActiveDraftIdsFromRestore(design, options);

      applyRestoredSelections({
        boardWidthMm: options.boardWidthMm || design.bw || CFG.boardWidthMm,
        boardHeightMm: options.boardHeightMm || design.bh || CFG.boardHeightMm,
        customSize: options.customSize === true || design.customSize === true || design.cs === true,
        configuratorMode: options.configuratorMode || design.configuratorMode || design.cm,
        toolBrand: options.toolBrand || design.toolBrand || design.tb,
        boardColor: restoredFrontColor,
        backColor: restoredBackColor,
        mounting: options.mounting || design.m || selectedMounting,
        mountingSides: options.mountingSides || design.ms || selectedMountingSides,
        surfaceType: options.surfaceType || design.surfaceType || 'premium',
        quantity: options.quantity || design.quantity || 1,
        holderType: options.holderType || design.holderType || 'stainless',
        mountingAddons: options.mountingAddons || design.mountingAddons || []
      });

      await ensureToolsLoaded();
      await hydrateCompactDesign(design, {
        deferFinalize: true,
        sourceCanvasWidth: design.cw || design.canvasWidth,
        sourceCanvasHeight: design.ch || design.canvasHeight
      });

      var finalSide = (options.loadedSide === 'back' && selectedMounting !== 'wall' && selectedMountingSides === 2) ? 'back' : 'front';
      switchSide(finalSide);
      normalizeCanvasObjects();
      syncCanvasUi();
      saveState(true);

      if (options.toastMessage) {
        toast(options.toastMessage);
      }
      return true;
    } finally {
      isHydratingDesign = false;
    }
  }

  // Stellt eine zweiseitig gestaltete Wand aus zwei Server-Design-Records wieder
  // her (Vorderseite + Rückseite), z.B. beim Öffnen über den Kauf-Link.
  async function restoreCompactDesignTwoSided(frontDesign, backDesign, options) {
    options = options || {};
    isHydratingDesign = true;

    try {
      if (!frontDesign) {
        throw new Error('Leere Designdaten');
      }

      canvas.clear();
      customBoardBrandMark = null;
      customBoardBrandVariant = '';
      var restoredFrontColor = getRestoredFrontColorFromDesign(frontDesign, options);
      var restoredBackColor = getRestoredBackColorFromDesign(frontDesign, options, restoredFrontColor);
      loadedDraftSpecialInfo = String(options.specialInfo || frontDesign.specialInfo || '').slice(0, 2000);
      setActiveDraftIdsFromRestore(frontDesign, options);

      applyRestoredSelections({
        boardWidthMm: options.boardWidthMm || frontDesign.bw || CFG.boardWidthMm,
        boardHeightMm: options.boardHeightMm || frontDesign.bh || CFG.boardHeightMm,
        customSize: options.customSize === true || frontDesign.customSize === true || frontDesign.cs === true,
        configuratorMode: options.configuratorMode || frontDesign.configuratorMode || frontDesign.cm,
        toolBrand: options.toolBrand || frontDesign.toolBrand || frontDesign.tb,
        boardColor: restoredFrontColor,
        backColor: restoredBackColor,
        mounting: options.mounting || frontDesign.m || selectedMounting,
        mountingSides: backDesign ? 2 : (options.mountingSides || frontDesign.ms || 1),
        surfaceType: options.surfaceType || frontDesign.surfaceType || 'premium',
        quantity: options.quantity || frontDesign.quantity || 1,
        holderType: options.holderType || frontDesign.holderType || 'stainless',
        mountingAddons: options.mountingAddons || frontDesign.mountingAddons || []
      });

      await ensureToolsLoaded();

      switchSide('front');
      await hydrateCompactDesign(Object.assign({}, frontDesign, { side: 'front' }), {
        deferFinalize: true,
        sourceCanvasWidth: frontDesign.cw || frontDesign.canvasWidth,
        sourceCanvasHeight: frontDesign.ch || frontDesign.canvasHeight
      });

      if (backDesign && Array.isArray(backDesign.o) && backDesign.o.length > 0) {
        switchSide('back');
        await hydrateCompactDesign(Object.assign({}, backDesign, { side: 'back' }), {
          deferFinalize: true,
          sourceCanvasWidth: backDesign.cw || backDesign.canvasWidth,
          sourceCanvasHeight: backDesign.ch || backDesign.canvasHeight
        });
      }

      switchSide('front');
      normalizeCanvasObjects();
      syncCanvasUi();
      saveState(true);

      if (options.toastMessage) {
        toast(options.toastMessage);
      }
      return true;
    } finally {
      isHydratingDesign = false;
    }
  }

  function hydrateCompactDesign(design, options) {
    options = options || {};
    const objects = design.o || [];
    const designSide = design.side || 'front';
    const sourceCanvasWidth = options.sourceCanvasWidth || design.cw || design.canvasWidth;
    const sourceCanvasHeight = options.sourceCanvasHeight || design.ch || design.canvasHeight;

    // Async loading queue
    const tasks = objects.map(rawObj => {
      return new Promise((resolve) => {
        const obj = scaleSavedCanvasObject(rawObj, sourceCanvasWidth, sourceCanvasHeight);
        if (obj.t === 'shadow-tool' && obj.id) {
          restoreShadowToolObject(Object.assign({}, obj, {
            toolCategory: obj.cat || obj.toolCategory || '',
            sbcScalable: obj.sc === true || obj.sbcScalable === true
          }), obj.sbcSide || designSide).then(resolve);
        } else if (obj.t === 'logo' && obj.src) {
          const isSvg = isSvgUrl(obj.src);
          if (isSvg) {
            normalizeSvgLogoSource(obj.src).then(function (normalizedLogo) {
              var logoSource = obj.src;
              return createTrimmedSvgLogoPreview(logoSource).then(function (preview) {
                return { normalizedLogo: normalizedLogo, logoSource: logoSource, preview: preview };
              });
            }).then(function (logoData) {
              var logoSource = logoData.logoSource;
              var previewUrl = logoData.preview && logoData.preview.dataUrl ? logoData.preview.dataUrl : logoSource;
              fabric.Image.fromURL(previewUrl, function (img) {
                if (!img) return resolve();
                var imgWidth = img.width || (img._element && img._element.naturalWidth) || 1;
                var imgHeight = img.height || (img._element && img._element.naturalHeight) || 1;
                var placement = getRestoredLogoPlacement(obj, logoData.normalizedLogo, imgWidth, imgHeight);
                var logoTrim = getLogoTrimFromRestoreData(obj, logoData);
                img.set({
                  objectType: 'logo',
                  sbcSide: obj.sbcSide || designSide,
                  left: placement.left,
                  top: placement.top,
                  angle: obj.a,
                  originX: 'center',
                  originY: 'center',
                  src: previewUrl,
                  imageData: logoSource,
                  logoTrim: logoTrim,
                  sbcLogoTrim: logoTrim
                });
                img.logoTrim = logoTrim;
                img.sbcLogoTrim = logoTrim;
                img.set({ scaleX: placement.scaleX, scaleY: placement.scaleY });
                applyCrispRendering(img);
                canvas.add(img);
                resolve();
              }, getFabricImageLoadOptions(previewUrl));
            });
          } else {
            fabric.Image.fromURL(obj.src, img => {
              if (!img) return resolve();
              img.set({
                objectType: 'logo',
                sbcSide: obj.sbcSide || designSide,
                left: obj.x,
                top: obj.y,
                angle: obj.a,
                originX: 'center',
                originY: 'center',
                src: obj.src,
                imageData: obj.src
              });
              const scaleX = obj.w / img.width;
              const scaleY = obj.h / img.height;
              img.set({ scaleX: scaleX, scaleY: scaleY });
              canvas.add(img);
              resolve();
            }, { crossOrigin: 'anonymous' });
          }
        } else if (obj.t === 'text' || obj.t === 'custom-text') {
          // Sofort erstellen
          var font = obj.fontId ? findFontById(obj.fontId) : null;
          var fontFamily = obj.ff || obj.fontFamily || (font && font.family) || 'Inter, sans-serif';
          if (obj.fontUrl && fontFamily) {
            installFontFace({ type: 'custom', url: obj.fontUrl, family: fontFamily });
          }
	          const text = new fabric.IText(obj.txt || '', {
	            objectType: 'custom-text',
	            sbcSide: obj.sbcSide || designSide,
	            left: obj.x,
	            top: obj.y,
            fontSize: getRestoredTextFontSize(obj),
            fontFamily: fontFamily,
            fontId: obj.fontId || (font && font.id) || '',
            fontUrl: obj.fontUrl || (font && font.url) || '',
            fill: obj.fc,
            textColorKey: obj.fckey || obj.textColorKey || '',
            textColorLabel: obj.fclabel || obj.textColorLabel || '',
            textColorCmyk: obj.fcmyk || obj.textColorCmyk || null,
            angle: obj.a,
            scaleX: obj.sx || 1,
            scaleY: obj.sy || 1,
            editable: true,
            fontWeight: obj.fw || obj.fontWeight || '400',
            fontStyle: obj.fst || obj.fontStyle || 'normal',
	            underline: obj.ul === true || obj.underline === true,
	            lineHeight: obj.lh || obj.lineHeight || 1.16,
	            textAlign: normalizeTextAlignment(obj.ta || obj.textAlign || 'left'),
	            originX: obj.originX || 'left',
	            originY: obj.originY || 'top'
	          });
	          applyRestoredTextPointSize(text, obj);
	          text._sbcPreserveLineBreaks = true;
	          bindTextObjectEvents(text);
	          canvas.add(text);

	          // Font nachladen triggers render
	          const fs = text.fontSize || obj.fs || 40;
	          waitForTextFont(text, fs).then(() => {
	            text.set('dirty', true);
	            fitTextObject(text);
	            canvas.requestRenderAll();
	            resolve();
	          }).catch(e => {
	            console.warn(e);
	            resolve();
	          });

	          // Apply Curvature if present
	          if (obj.c) {
	            applyTextCurvature(text, obj.c);
	          }
	          refreshTextDimensions(text);
	          canvas.requestRenderAll();
	        } else {
	          resolve();
	        }
      });
    });

    return Promise.all(tasks).then(() => {
      normalizeCanvasObjects();
      canvas.requestRenderAll();
      if (!options.deferFinalize) {
        syncCanvasUi();
        saveState(true);
        toast('Design geladen');
      }
    });
  }

  /* ==========================================
     SAVE / LOAD (URL & LOCALSTORAGE)
     ========================================== */

  function encodeDesignSaveState(state) {
    return btoa(unescape(encodeURIComponent(JSON.stringify(state))));
  }

  function buildDesignSaveState(frontSummary, backSummary, isTwoSides) {
    return {
      w: CFG.boardWidthMm,
      h: CFG.boardHeightMm,
      cw: canvas ? canvas.width : null,
      ch: canvas ? canvas.height : null,
      cs: selectedSizeIsCustom === true,
      cm: configuratorMode,
      configuratorMode: configuratorMode,
      tb: selectedToolBrand || null,
      toolBrand: selectedToolBrand || null,
      c: selectedColor,
      boardColor: selectedColor,
      frontColor: selectedColor,
      bc: selectedBackColor,
      backColor: selectedBackColor,
      m: selectedMounting,
      ms: selectedMountingSides,
      st: selectedSurfaceType,
      q: getSelectedQuantity(),
      fh: selectedHolderType,
      fa: getSelectedFinalizeAddonKeys(),
      specialInfo: loadedDraftSpecialInfo || '',
      draftId: activeDraftIds.front || null,
      frontDraftId: activeDraftIds.front || null,
      backDraftId: activeDraftIds.back || null,
      f: frontSummary || [],
      b: isTwoSides ? (backSummary || []) : null
    };
  }

  function collectCurrentSavePayloads() {
    var isTwoSides = (selectedMounting !== 'wall' && selectedMountingSides === 2);
    var dataF = { summary: [], filteredObjects: [] };
    var dataB = { summary: [], filteredObjects: [] };

    try {
      // Workaround: If sizes are totally unset, do not fail
      if (CFG.boardWidthMm > 0) {
        var oldSide = currentSide;
        if (currentSide !== 'front') switchSide('front');
        dataF = preparePayload('front');

        if (isTwoSides) {
          switchSide('back');
          dataB = preparePayload('back');
        }
        if (currentSide !== oldSide) switchSide(oldSide);
      }
    } catch (e) {
      console.warn(e);
    }

    return { isTwoSides: isTwoSides, dataF: dataF, dataB: dataB };
  }

  function cloneSummaryWithAvailableSources(payload) {
    payload = payload || {};
    var summary = JSON.parse(JSON.stringify(payload.summary || []));
    var objects = payload.filteredObjects || [];

    for (var idx = 0; idx < objects.length; idx++) {
      var item = summary[idx];
      var obj = objects[idx];
      if (!item || !obj) continue;

      if (item.t === 'shadow-tool') {
        item.src = obj.src || obj.imageData || (toolsById[item.id] && toolsById[item.id].imageUrl) || '';
      }

      if (item.t === 'logo') {
        var logoSrc = getObjectImageSource(obj);
        if (logoSrc) item.src = logoSrc;
      }
    }

    return summary;
  }

  async function generateSaveStringAsync() {
    var payloads = collectCurrentSavePayloads();
    var isTwoSides = payloads.isTwoSides;
    var dataF = payloads.dataF;
    var dataB = payloads.dataB;

    // Logos mit Data-URLs anreichern (preparePayload strippt sie absichtlich für Cart)
    var fSummary = JSON.parse(JSON.stringify(dataF.summary));
    var bSummary = JSON.parse(JSON.stringify(dataB.summary));

    for (var idx = 0; idx < dataF.filteredObjects.length; idx++) {
      if (fSummary[idx].t === 'shadow-tool') {
        fSummary[idx].src = dataF.filteredObjects[idx].src || dataF.filteredObjects[idx].imageData ||
          (toolsById[fSummary[idx].id] && toolsById[fSummary[idx].id].imageUrl) || '';
      }
      if (fSummary[idx].t === 'logo') {
        var logoDataUrl = await getLogoDataUrl(dataF.filteredObjects[idx]);
        var logoSource = logoDataUrl || getObjectImageSource(dataF.filteredObjects[idx]);
        if (logoSource) fSummary[idx].src = logoSource;
      }
    }

    if (isTwoSides && dataB.filteredObjects) {
      for (var idx = 0; idx < dataB.filteredObjects.length; idx++) {
        if (bSummary[idx].t === 'shadow-tool') {
          bSummary[idx].src = dataB.filteredObjects[idx].src || dataB.filteredObjects[idx].imageData ||
            (toolsById[bSummary[idx].id] && toolsById[bSummary[idx].id].imageUrl) || '';
        }
        if (bSummary[idx].t === 'logo') {
          var logoDataUrl = await getLogoDataUrl(dataB.filteredObjects[idx]);
          var logoSource = logoDataUrl || getObjectImageSource(dataB.filteredObjects[idx]);
          if (logoSource) bSummary[idx].src = logoSource;
        }
      }
    }

    return encodeDesignSaveState(buildDesignSaveState(fSummary, bSummary, isTwoSides));
  }

  function generateSaveString() {
    var payloads = collectCurrentSavePayloads();
    var fSummary = cloneSummaryWithAvailableSources(payloads.dataF);
    var bSummary = cloneSummaryWithAvailableSources(payloads.dataB);
    return encodeDesignSaveState(buildDesignSaveState(fSummary, bSummary, payloads.isTwoSides));
  }

  function setDraftSaveButtonLoading(loading, buttonId) {
    var btnSave = document.getElementById(buttonId || 'btn-save');
    if (!btnSave) return null;

    var label = btnSave.querySelector('.sbc-btn__label');
    var spinner = btnSave.querySelector('.sbc-btn__spinner');
    if (label) label.style.display = loading ? 'none' : 'flex';
    if (spinner) spinner.style.display = loading ? 'inline-block' : 'none';
    ['btn-save', 'btn-save-as-new-draft'].forEach(function (id) {
      var btn = document.getElementById(id);
      if (btn) btn.disabled = !!loading;
    });
    return btnSave;
  }

  async function saveDraftToBackend(options) {
    options = options || {};

    if (!CFG.customerId) {
      toast('Bitte einloggen, damit der Entwurf gespeichert werden kann.', 'error');
      return false;
    }

    if (!CFG.backendUrl) {
      toast('Fehler: Backend-URL fehlt', 'error');
      return false;
    }

    try {
      var buttonId = options.buttonId || 'btn-save';
      var requestedSignature = planningSignature();
      planningSaveInProgress = true;
      publishPlanningStatus('saving');
      setDraftSaveButtonLoading(true, buttonId);
      var savedResult = await persistCurrentDesigns({
        isDraft: true,
        createNewDraft: options.createNewDraft === true
      });

      planningSavedSignature = requestedSignature;
      planningSavedAt = savedResult.front && savedResult.front.updatedAt || new Date().toISOString();
      planningSaveInProgress = false;
      refreshPlanningStatus();
      toast(options.successMessage || 'Änderungen im Kundenkonto gespeichert.', 'success');
      updateSaveAsNewDraftButton();

      // Liste sofort neu laden, damit das neue Design in der Sidebar erscheint
      if (typeof loadUserDesigns === 'function') {
        loadUserDesigns();
      }

      return true;
    } catch (err) {
      console.error('[SBC] Fehler beim Entwurf-Speichern', err);
      planningSaveInProgress = false;
      publishPlanningStatus('error');
      toast('Deine Änderungen konnten nicht im Kundenkonto gespeichert werden. Bitte erneut versuchen.', 'error');
      return false;
    } finally {
      planningSaveInProgress = false;
      setDraftSaveButtonLoading(false, options.buttonId || 'btn-save');
    }
  }

  function bindSaveDraft() {
    var btnSave = document.getElementById('btn-save');
    var btnSaveAsNew = document.getElementById('btn-save-as-new-draft');

    if (!btnSave && !btnSaveAsNew) return;

    async function handleDraftSaveClick(btn, saveOptions) {
      if (!btn || btn.disabled) return;

      // 1. Prüfen ob eingeloggt (strikt über Shopify Customer ID)
      if (!CFG.customerId) {
        var saveStr = await generateSaveStringAsync();

        // Nicht eingeloggt -> Payload im LocalStorage zwischenparken (um Shopify URL Filter zu umgehen)
        if (!storePendingLoginSavePayload(saveStr)) {
          clearPendingLoginSaveState(true);
          toast('Der Entwurf konnte nicht für den Login zwischengespeichert werden. Bitte versuche es erneut.', 'error');
          return;
        }

        // Sauberer Redirect ohne riesigen Base64 String; die Rueckkehr markiert den Auto-Speicherfall.
        var returnUrl = new URL(window.location.href);
        ['draft', 'sbc_draft', 'designId', 'save'].forEach(function (param) {
          returnUrl.searchParams.delete(param);
        });
        returnUrl.searchParams.set('sbc_auto_save', '1');
        var loginUrl = '/account/login?checkout_url=' + encodeURIComponent(returnUrl.pathname + returnUrl.search + returnUrl.hash);
        window.location.href = loginUrl;
        return;
      }

      // 2. Eingeloggt -> Backend Request senden
      await saveDraftToBackend(saveOptions || {});
    }

    if (btnSave) {
      btnSave.addEventListener('click', function () {
        handleDraftSaveClick(btnSave);
      });
    }

    if (btnSaveAsNew) {
      btnSaveAsNew.addEventListener('click', function () {
        if (btnSaveAsNew.disabled) return;
        startNewWallDesign();
      });
    }
  }

  function restoreDesignStateFromSaveString(saveStr, options) {
    var state = parseSaveString(saveStr);
    if (!state) {
      if (options && options.source === 'autosave') {
        clearStoredDraftSaveString();
      }
      return Promise.resolve(false);
    }
    return restoreDesignState(state, options);
  }

  function restorePendingLoginSaveAndAutoSave(saveStr) {
    if (!saveStr || !parseSaveString(saveStr)) {
      clearPendingLoginSaveState(true);
      return { loaded: false };
    }

    lastDraftSaveStr = saveStr;
    restoreDesignStateFromSaveString(saveStr, {}).then(async function (restored) {
      if (!restored) {
        clearPendingLoginSaveState(true);
        return;
      }

      if (!CFG.customerId) {
        toast('Design wurde wiederhergestellt. Bitte einloggen, damit der Entwurf gespeichert werden kann.', 'error');
        return;
      }

      var saved = await saveDraftToBackend({
        successMessage: 'Entwurf wurde nach dem Login automatisch gespeichert.'
      });
      if (saved) {
        clearPendingLoginSaveState(true);
        clearStoredDraftSaveString();
      }
    });

    return { loaded: true, pendingSave: true };
  }

  function clearUrlRestoreParams(paramNames) {
    try {
      var url = new URL(window.location.href);
      (paramNames || []).forEach(function (name) {
        url.searchParams.delete(name);
      });
      window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
    } catch (e) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }

  async function restoreDesignFromShortUrlId(draftId, backDraftId) {
    try {
      var safeId = normalizeDesignIdForDraft(draftId);
      if (!safeId) {
        throw new Error('Ungültige Design-ID');
      }

      var safeBackId = backDraftId ? normalizeDesignIdForDraft(backDraftId) : null;
      var fullData = await fetchDesignRecordById(safeId, { id: safeId });
      var toastMessage = fullData.isDraft === true ? 'Entwurf geladen' : 'Design geladen';

      if (safeBackId && safeBackId !== safeId) {
        var backData = null;
        try {
          backData = await fetchDesignRecordById(safeBackId, { id: safeBackId });
        } catch (backErr) {
          console.warn('[SBC] Rückseite konnte nicht geladen werden, lade nur Vorderseite:', backErr.message);
        }

        if (backData && backData.design) {
          await restoreCompactDesignTwoSided(fullData.design, backData.design, {
            boardWidthMm: fullData.boardWidthMm,
            boardHeightMm: fullData.boardHeightMm,
            specialInfo: fullData.specialInfo || '',
            toastMessage: toastMessage
          });
          clearUrlRestoreParams(['draft', 'sbc_draft', 'designId', 'backDesignId', 'back']);
          return;
        }
      }

      await restoreDesignRecord(fullData, {
        id: safeId,
        boardWidthMm: fullData.boardWidthMm,
        boardHeightMm: fullData.boardHeightMm,
        specialInfo: fullData.specialInfo || ''
      }, toastMessage);
      clearUrlRestoreParams(['draft', 'sbc_draft', 'designId', 'backDesignId', 'back']);
    } catch (err) {
      console.error('[SBC] Fehler beim Laden des Entwurfs aus der URL:', err);
      toast('Entwurf konnte nicht geladen werden', 'error');
      alert('Entwurf konnte nicht geladen werden:\n' + err.message);
      clearUrlRestoreParams(['draft', 'sbc_draft', 'designId', 'backDesignId', 'back']);
    }
  }

  async function restoreDesignState(state, options) {
    options = options || {};
    isHydratingDesign = true;

    try {
      var widthMm = Number(options.boardWidthMm || state.w);
      var heightMm = Number(options.boardHeightMm || state.h);

      if (!(widthMm > 0) || !(heightMm > 0)) {
        throw new Error('Ungültige Board-Größe im gespeicherten Entwurf');
      }

      canvas.clear();
      customBoardBrandMark = null;
      customBoardBrandVariant = '';
      var restoredFrontColor = resolveRestoredBoardColor(
        options.boardColor || options.frontColor || state.c || state.boardColor || state.frontColor,
        options.bg || state.bg,
        selectedColor || 'white'
      );
      var restoredBackColor = normalizeBoardColorKey(
        options.backColor || state.bc || state.backColor || state.boardBackColor,
        restoredFrontColor
      );
      loadedDraftSpecialInfo = String(options.specialInfo || state.specialInfo || state.si || '').slice(0, 2000);
      setActiveDraftIdsFromRestore(state, options);

      applyRestoredSelections({
        boardWidthMm: widthMm,
        boardHeightMm: heightMm,
        customSize: options.customSize === true || state.cs === true || state.customSize === true,
        configuratorMode: options.configuratorMode || state.configuratorMode || state.cm,
        toolBrand: options.toolBrand || state.toolBrand || state.tb,
        boardColor: restoredFrontColor,
        backColor: restoredBackColor,
        mounting: options.mounting || state.m || 'wall',
        mountingSides: options.mountingSides || state.ms || 1,
        surfaceType: options.surfaceType || state.st || state.surfaceType || 'premium',
        quantity: options.quantity || state.q || state.quantity || 1,
        holderType: options.holderType || state.fh || state.holderType || 'stainless',
        mountingAddons: options.mountingAddons || state.fa || state.mountingAddons || []
      });

      await ensureToolsLoaded();

      switchSide('front');
      if (Array.isArray(state.f) && state.f.length > 0) {
        await loadDesignFromJson(state.f, 0, {
          deferFinalize: true,
          targetSide: 'front',
          sourceCanvasWidth: state.cw || state.canvasWidth,
          sourceCanvasHeight: state.ch || state.canvasHeight
        });
      }

      if (Array.isArray(state.b) && state.b.length > 0) {
        switchSide('back');
        await loadDesignFromJson(state.b, 0, {
          deferFinalize: true,
          targetSide: 'back',
          sourceCanvasWidth: state.cw || state.canvasWidth,
          sourceCanvasHeight: state.ch || state.canvasHeight
        });
      }

      switchSide('front');
      normalizeCanvasObjects();
      syncCanvasUi();
      saveState(true);

      if (options.clearUrlSaveParam) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
      if (options.toastMessage) {
        toast(options.toastMessage);
      }
      return true;
    } catch (e) {
      console.warn('[SBC] Fehler beim Wiederherstellen des Entwurfs', e);
      toast('Entwurf konnte nicht wiederhergestellt werden', 'error');
      return false;
    } finally {
      isHydratingDesign = false;
    }
  }

  async function loadDesignFromJson(objects, retryCount, options) {
    options = options || {};
    if (!objects || !Array.isArray(objects)) return;

    retryCount = retryCount || 0;
    var targetSide = options.targetSide || null;

    while ((!allToolsCacheConfigurator || allToolsCacheConfigurator.length === 0) && retryCount < 10) {
      console.log('[SBC] Tools not yet loaded. Waiting to hydrate design...', retryCount);
      await new Promise(function (resolve) { setTimeout(resolve, 500); });
      retryCount++;
    }

    var tasks = objects.map(function (objData) {
      return new Promise(function (resolve) {
        objData = scaleSavedCanvasObject(objData, options.sourceCanvasWidth, options.sourceCanvasHeight);
        var objectType = objData.t || objData.objectType;
        var toolId = objData.id || objData.toolId;
        var left = objData.x !== undefined ? objData.x : objData.left;
        var top = objData.y !== undefined ? objData.y : objData.top;
        var angle = objData.a !== undefined ? objData.a : objData.angle;
        var sbcSide = objData.sbcSide || targetSide || 'front';

        if (objectType === 'shadow-tool') {
          restoreShadowToolObject({
            id: toolId,
            toolId: toolId,
            bristle: objData.bristle || objData.sbcBristle || '',
            src: objData.src,
            x: left,
            y: top,
            left: left,
            top: top,
            a: angle,
            angle: angle,
            w: objData.w,
            h: objData.h,
            scaleX: objData.scaleX,
            scaleY: objData.scaleY,
            originX: objData.originX,
            originY: objData.originY,
            toolCategory: objData.cat || objData.toolCategory || '',
            sbcScalable: objData.sc === true || objData.sbcScalable === true,
            sbcSide: sbcSide
          }, sbcSide).then(resolve);
          return;
        }

        if (objectType === 'logo') {
          var logoUrl = objData.imageData || objData.src;
          if (!logoUrl) return resolve();

          if (isSvgUrl(logoUrl)) {
            normalizeSvgLogoSource(logoUrl).then(function (normalizedLogo) {
              var logoSource = logoUrl;
              return createTrimmedSvgLogoPreview(logoSource).then(function (preview) {
                return { normalizedLogo: normalizedLogo, logoSource: logoSource, preview: preview };
              });
            }).then(function (logoData) {
              var logoSource = logoData.logoSource;
              var previewUrl = logoData.preview && logoData.preview.dataUrl ? logoData.preview.dataUrl : logoSource;
              fabric.Image.fromURL(previewUrl, function (img) {
                if (!img) return resolve();
                var imgWidth = img.width || (img._element && img._element.naturalWidth) || 1;
                var imgHeight = img.height || (img._element && img._element.naturalHeight) || 1;
                var placement = getRestoredLogoPlacement(objData, logoData.normalizedLogo, imgWidth, imgHeight);
                var logoTrim = getLogoTrimFromRestoreData(objData, logoData);

                img.set({
                  objectType: 'logo',
                  sbcSide: sbcSide,
                  left: placement.left,
                  top: placement.top,
                  scaleX: placement.scaleX,
                  scaleY: placement.scaleY,
                  angle: angle,
                  originX: objData.originX || 'center',
                  originY: objData.originY || 'center',
                  imageData: logoSource,
                  src: previewUrl,
                  logoTrim: logoTrim,
                  sbcLogoTrim: logoTrim,
                  visible: sbcSide === currentSide
                });
                img.logoTrim = logoTrim;
                img.sbcLogoTrim = logoTrim;
                applyCrispRendering(img);
                canvas.add(img);
                resolve();
              }, getFabricImageLoadOptions(previewUrl));
            });
            return;
          }

          fabric.Image.fromURL(logoUrl, function (img) {
            if (!img) return resolve();
            var scaleX = objData.w ? (objData.w / img.width) : objData.scaleX;
            var scaleY = objData.h ? (objData.h / img.height) : objData.scaleY;

            img.set({
              objectType: 'logo',
              sbcSide: sbcSide,
              left: left,
              top: top,
              scaleX: scaleX,
              scaleY: scaleY,
              angle: angle,
              originX: objData.originX || 'center',
              originY: objData.originY || 'center',
              imageData: logoUrl,
              src: logoUrl,
              visible: sbcSide === currentSide
            });
            canvas.add(img);
            resolve();
          }, { crossOrigin: 'anonymous' });
          return;
        }

        if (objectType === 'custom-text' || objectType === 'text' || objectType === 'i-text') {
          var font = objData.fontId ? findFontById(objData.fontId) : null;
          var restoredFontFamily = objData.ff || objData.fontFamily || (font && font.family) || 'Inter, sans-serif';
          if (objData.fontUrl && restoredFontFamily) {
            installFontFace({ type: 'custom', url: objData.fontUrl, family: restoredFontFamily });
          }
          var textProps = {
            objectType: 'custom-text',
            sbcSide: sbcSide,
            left: left,
            top: top,
            scaleX: objData.sx || objData.scaleX || (objData.w ? (objData.w / 100) : 1),
            scaleY: objData.sy || objData.scaleY || (objData.h ? (objData.h / 100) : 1),
            angle: angle,
            fill: objData.fc || objData.fill || '#000000',
            textColorKey: objData.fckey || objData.textColorKey || '',
            textColorLabel: objData.fclabel || objData.textColorLabel || '',
            textColorCmyk: objData.fcmyk || objData.textColorCmyk || null,
            fontFamily: restoredFontFamily,
            fontId: objData.fontId || (font && font.id) || '',
            fontUrl: objData.fontUrl || (font && font.url) || '',
            fontSize: getRestoredTextFontSize(objData),
            fontWeight: objData.fw || objData.fontWeight || '400',
            fontStyle: objData.fst || objData.fontStyle || 'normal',
            underline: objData.ul === true || objData.underline === true,
	            lineHeight: objData.lh || objData.lineHeight || 1.16,
	            textAlign: normalizeTextAlignment(objData.ta || objData.textAlign || 'left'),
	            originX: objData.originX || 'left',
	            originY: objData.originY || 'top',
	            visible: sbcSide === currentSide,
	            editable: true
	          };

          if (objData.fs || objData.fpt || objData.fontPt) {
            textProps.scaleX = 1;
            textProps.scaleY = 1;
          }

	          var text = new fabric.IText(objData.txt || objData.text || '', textProps);
	          applyRestoredTextPointSize(text, objData);
	          text._sbcPreserveLineBreaks = true;
	          bindTextObjectEvents(text);

          if (objData.c || objData.curvature) {
            applyTextCurvature(text, objData.c || objData.curvature);
          }

	          canvas.add(text);
	          refreshTextDimensions(text);
	          canvas.requestRenderAll();
	          waitForTextFont(text, text.fontSize || 36).then(function () {
	            fitTextObject(text);
	            resolve();
	          }).catch(function () {
	            resolve();
	          });
	          return;
	        }

        resolve();
      });
    });

    await Promise.all(tasks);
    normalizeCanvasObjects();
    canvas.requestRenderAll();

    if (!options.deferFinalize) {
      syncCanvasUi();
      saveState(true);
    }
  }

  function loadFromSaveHash() {
    var urlParams = new URLSearchParams(window.sbcBulkContext || window.location.search);
    var autoSaveAfterLogin = urlParams.get('sbc_auto_save') === '1';
    if (autoSaveAfterLogin) {
      clearUrlRestoreParams(['sbc_auto_save']);
      var autoSavePayload = getPendingLoginSavePayload() || getStoredDraftSaveString();
      if (autoSavePayload) {
        return restorePendingLoginSaveAndAutoSave(autoSavePayload);
      }
      clearPendingLoginSaveState(true);
    }

    var urlDraftId = urlParams.get('draft') || urlParams.get('sbc_draft') || urlParams.get('designId');
    if (urlDraftId) {
      var urlBackId = urlParams.get('backDesignId') || urlParams.get('back');
      var bulkRequest = urlParams.get('sbc_bulk_request');
      if (bulkRequest && window.parent !== window) prepareSbcBulkDraftCart(urlDraftId, bulkRequest);
      else restoreDesignFromShortUrlId(urlDraftId, urlBackId);
      return { loaded: true, pendingSave: false };
    }

    var urlSave = urlParams.get('save');
    if (urlSave) {
      if (!parseSaveString(urlSave)) return { loaded: false };
      restoreDesignStateFromSaveString(urlSave, { clearUrlSaveParam: true });
      return { loaded: true, pendingSave: false };
    }

    var pendingLoginSave = getPendingLoginSaveIntent();
    var pendingSave = getPendingLoginSavePayload();
    if (pendingLoginSave && pendingSave) {
      return restorePendingLoginSaveAndAutoSave(pendingSave);
    }

    var autosave = getStoredDraftSaveString();
    if (pendingLoginSave && autosave) {
      return restorePendingLoginSaveAndAutoSave(autosave);
    }

    if (pendingSave) {
      pendingRestoreSaveStr = pendingSave;
      lastDraftSaveStr = pendingSave;
      return { loaded: true, awaitingRestore: true, pendingSave: false };
    }

    if (!autosave) {
      if (pendingLoginSave) clearPendingLoginSaveState(true);
      return { loaded: false };
    }

    pendingRestoreSaveStr = autosave;
    lastDraftSaveStr = autosave;
    return { loaded: true, awaitingRestore: true, pendingSave: false };
  }

  /* ==========================================
     BOOT
     ========================================== */

  async function buildSbcBulkAccessoryItems() {
    var selections = getPlacedShadowToolSelections();
    var recommendations = [];
    for (var selection of selections) {
      var toolId = selection.toolId;
      var tool = getToolById(toolId);
      var entries = await getSelectedToolPurchaseEntries(tool, selection.bristle);
      if (!tool || !entries.length) throw new Error('Für „' + (tool && tool.name || 'ein Reinigungsgerät') + '“ ist noch kein eindeutiger Shop-Artikel hinterlegt. Bitte den Entwurf prüfen oder ohne Reinigungsgeräte übernehmen.');
      for (var entry of entries) {
        var variant = await fetchShopifyVariant(entry.variantId);
        if (!variant || variant.available === false) throw new Error('„' + (tool.name || 'Ein Reinigungsgerät') + '“ ist nicht verfügbar. Bitte ohne Reinigungsgeräte übernehmen oder die Auswahl im Konfigurator ändern.');
        var color = normalizeBoardColorKey(tool.boardColor, 'all');
        if (color === 'all') color = selectedColor;
        var colors = (variant.options || [variant.option1 || variant.public_title || variant.title]).map(function(value) { return normalizeBoardColorKey(value, ''); }).filter(function(value) { return ['white','black','blue','red','green','yellow','orange','purple','pink','brown','gray','grey'].indexOf(value) !== -1; });
        if (colors.length && colors.indexOf(color) === -1) throw new Error('Die Shop-Verknüpfung für „' + tool.name + '“ hat eine andere Farbe. Bitte den Entwurf prüfen oder ohne Reinigungsgeräte übernehmen.');
        recommendations.push({ toolId: toolId, bristle: entry === entries[0] ? selection.bristle : '', variantId: entry.variantId, quantity: selection.quantity * getSelectedQuantity(), shadowName: tool.name, name: getVariantDisplayName(variant, tool.name), colorLabel: getColorMeta(color).label });
      }
    }
    return buildAccessoryCartItems(recommendations);
  }

  async function prepareSbcBulkDraftCart(draftId, requestId) {
    var response = { type: 'sbc-bulk-cart-result', requestId: requestId, draftId: draftId };
    try {
      if (window.parent === window || !/^\/account\/?$/.test(window.parent.location.pathname) || !CFG.customerId) return;
      var record = await fetchDesignRecordById(draftId, { id: draftId });
      if (!record || record.isDraft !== true || String(record.customerId) !== String(CFG.customerId)) throw new Error('Dieser Entwurf gehört nicht zum angemeldeten Kundenkonto.');
      await restoreDesignRecord(record, { id: draftId }, 'Entwurf geladen');
      var validation = getDesignValidationMessage() || getFinalizationValidationMessage();
      if (validation) throw new Error(validation + ' Bitte den Entwurf öffnen und prüfen.');
      var twoSides = selectedMounting !== 'wall' && selectedMountingSides === 2;
      if (twoSides && (!activeDraftIds.front || !activeDraftIds.back)) throw new Error('Bitte Vorder- und Rückseite im Konfigurator prüfen und speichern.');
      var includeTools = new URLSearchParams(window.sbcBulkContext || window.location.search).get('sbc_bulk_tools') === '1';
      var accessories = includeTools ? await buildSbcBulkAccessoryItems() : [];
      var persisted = await persistCurrentDesigns({ isDraft: false });
      if (!persisted.front || !persisted.front.designId || (twoSides && (!persisted.back || !persisted.back.designId))) throw new Error('Die Druckdateien konnten nicht vollständig vorbereitet werden.');
      var items = await shopifyAddToCart(persisted.front.designId, persisted.front.previewUrl, persisted.back && persisted.back.designId, persisted.back && persisted.back.previewUrl, accessories.concat(buildFinalizeCartItems()), true);
      items.forEach(function(item) {
        item.properties = Object.assign({}, item.properties, { '_SBC_Source_Draft': draftId, 'Entwurf': record.name || 'Schattenwand' });
      });
      var discount = getQuantityDiscountSnapshot();
      if (discount && !discount.discountCode) throw new Error('Der Mengenrabatt ist noch nicht vollständig eingerichtet. Bitte den Entwurf öffnen.');
      response.items = items;
      response.discountCode = discount && discount.discountCode || '';
    } catch (error) {
      response.error = error.message || 'Der Entwurf konnte nicht vorbereitet werden.';
    }
    window.parent.postMessage(response, window.parent.location.origin);
  }

  function boot() {
    // FIX: Fabric.js warning "alphabetical"
    if (fabric.Text) fabric.Text.prototype.textBaseline = 'alphabetic';
    if (fabric.IText) fabric.IText.prototype.textBaseline = 'alphabetic';
    init();
    bindTextProperties();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
